function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const colors = {
  error: "var(--error)",
  warning: "var(--warning)",
  information: "var(--info)",
  info: "var(--info)",
  success: "var(--success)",
  text: "var(--icon-secondary)",
  disabled: "var(--icon-primary-disabled)",
  "on-color": "var(--icon-on-color)"
};
const resolveParams = (color, size, style) => {
  const colorResolved = colors[color];
  let result = {
    ...style
  };
  if (colorResolved) {
    result["--icon-primary"] = colorResolved;
  }
  if (size) {
    result.height = size;
    result.width = size;
  }
  return result;
};
export const ArrowCircleIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "External-link",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.5 -0.5 25 25"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "External-link"
}, "External link"), /*#__PURE__*/React.createElement("circle", {
  className: "primary-stroke",
  cx: 12,
  cy: 12,
  r: 11.5,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M17.4 13.5V7.7h-5.8v1.4h3.5l-6.9 6.8 1 1L16 10v3.5z"
}));
export const BackArrowIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Arrow-left",
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 17,
  viewBox: "0 0 11 17"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Arrow-left"
}, "Arrow left"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M4.13 8.5L11 15.035 8.935 17 0 8.5 8.935 0 11 1.965z"
}));
export const BarChartIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Bar-chart",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-1 -1 17 18"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Bar-chart"
}, " Bar chart"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M0 6h3v10H0V6zm6-6h3v16H6V0zm6 9h3v7h-3V9z"
}));
export const BulletChevronIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 13,
  viewBox: "0 0 7 13"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#2C5E9C",
  d: "M4.372 6.5L0 11.498 1.314 13 7 6.5 1.314 0 0 1.502z"
}));
export const DownloadIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Download",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "var(--icon-primary)",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Download"
}, " Download"), /*#__PURE__*/React.createElement("path", {
  d: "M10.5101 14.6868C10.3662 14.8105 10.1847 14.8818 9.99508 14.8893C9.80336 14.8927 9.61812 14.8191 9.48008 14.686L5.23508 10.691C5.09723 10.5456 5.01532 10.3562 5.00388 10.1562C4.99244 9.95617 5.05221 9.75859 5.17258 9.59847C5.32438 9.46639 5.51921 9.39435 5.72041 9.39588C5.92162 9.39742 6.11532 9.47243 6.26508 9.6068L9.24425 12.416V2.51514C9.24425 2.31622 9.32327 2.12546 9.46392 1.98481C9.60457 1.84415 9.79534 1.76514 9.99425 1.76514C10.1932 1.76514 10.3839 1.84415 10.5246 1.98481C10.6652 2.12546 10.7443 2.31622 10.7443 2.51514V12.416L13.7251 9.6068C13.87 9.46162 14.0662 9.37933 14.2713 9.37777C14.4764 9.37621 14.6739 9.4555 14.8209 9.59847C14.9389 9.7599 14.9968 9.95742 14.9848 10.157C14.9728 10.3566 14.8916 10.5457 14.7551 10.6918L10.5101 14.6868Z",
  fill: "var(--icon-primary)",
  className: "primary-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.08333 17.0834C1.6231 17.0834 1.25 17.4565 1.25 17.9168C1.25 18.377 1.6231 18.7501 2.08333 18.7501H17.9167C18.3769 18.7501 18.75 18.377 18.75 17.9168C18.75 17.4565 18.3769 17.0834 17.9167 17.0834H2.08333Z",
  fill: "var(--icon-primary)",
  className: "primary-fill"
}));
export const EditPencilIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Edit",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Edit"
}, "Edit"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M5 15.1L16 4 12.1.1l-11 11.1zM.5 11.8L0 16l4.4-.2z"
}));
export const AccountAdminIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Account-admin",
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 13,
  viewBox: "0 0 12 13"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Account-admin"
}, " Account admin"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#3C90D7",
  fillRule: "evenodd",
  d: "M11.117 8.885c.347.173.595.52.655.908.188 1.195.228 3.197.228 3.197H7.156l-.645-4.626.695-.95h.218s2.541.878 3.693 1.47zM8.248 4.657c-.208 1.103-1.151 1.91-2.243 1.91-1.092 0-2.035-.807-2.243-1.91l-.348-1.849C3.216 1.328 4.337 0 5.797 0h.416c1.46 0 2.581 1.317 2.383 2.808l-.348 1.849zM4.586 7.414v.01h.208l.695.95L4.844 13H0s.03-2.012.228-3.196c.07-.399.318-.736.665-.92 1.162-.592 3.693-1.47 3.693-1.47z"
}));
export const AddBlueIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Add",
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 19
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Add"
}, " Add"), /*#__PURE__*/React.createElement("path", {
  fill: "#2C5E9C",
  d: "M10.45 8.55v-3.8h-1.9v3.8h-3.8v1.9h3.8v3.8h1.9v-3.8h3.8v-1.9h-3.8zM9.5 19A9.5 9.5 0 0 1 0 9.5 9.5 9.5 0 0 1 9.5 0 9.5 9.5 0 0 1 19 9.5 9.5 9.5 0 0 1 9.5 19z"
}));
export const AddCloudIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Add-cloud",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.0003429572388995439 -0.000029337923479033634 37.70411682128906 25.953027725219727"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Add-cloud"
}, " Add cloud"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill primary-stroke",
  fillRule: "evenodd",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.793 11.734a7.41 7.41 0 00-4.31-2.302 10.72 10.72 0 00-3.509-6.626A11.036 11.036 0 0020.596 0c-2.253 0-4.348.67-6.093 1.819a10.891 10.891 0 00-3.91 4.537 9.128 9.128 0 00-1.615-.145c-2.48 0-4.724.989-6.349 2.588a8.744 8.744 0 00-2.425 8.126c.136.618.34 1.217.604 1.786a5.125 5.125 0 001.91 2.197c.818.517 1.785.8 2.825.8h5.23v-.859h-5.23a4.36 4.36 0 01-2.354-.663 4.255 4.255 0 01-1.59-1.831 7.884 7.884 0 01-.726-3.308c0-2.203.907-4.198 2.374-5.641a8.143 8.143 0 015.731-2.337 8.416 8.416 0 011.78.191.436.436 0 00.496-.255h0a10.026 10.026 0 013.734-4.477 10.175 10.175 0 015.608-1.67c2.616 0 5 .978 6.793 2.58 1.811 1.622 3.024 3.88 3.269 6.414a.43.43 0 00.384.384v.001a6.54 6.54 0 014.108 2.07 6.333 6.333 0 011.684 4.223 4.187 4.187 0 01-.302 1.655 4.241 4.241 0 01-.95 1.398 4.318 4.318 0 01-1.406.95 4.381 4.381 0 01-1.677.316H27.31v.86h5.19a5.24 5.24 0 002.01-.384 5.174 5.174 0 001.693-1.142 5.08 5.08 0 001.137-1.678c.25-.612.373-1.275.364-1.985a7.177 7.177 0 00-1.91-4.786"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.014 25.094c-3.238 0-5.872-2.594-5.872-5.78 0-3.188 2.634-5.781 5.872-5.781s5.872 2.593 5.872 5.78c0 3.187-2.634 5.78-5.872 5.78m0-12.419c-3.719 0-6.745 2.979-6.745 6.64 0 3.66 3.026 6.639 6.745 6.639 3.72 0 6.745-2.979 6.745-6.64 0-3.66-3.026-6.639-6.745-6.639"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.386 15.69h-.743v3.258h-3.31v.731h3.31v3.258h.743v-3.258h3.31v-.731h-3.31z"
})));
export const AddItemIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Add-item",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Add-item"
}, " Add item"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.4,
  d: "M10.508 1C15.745 1 20 5.259 20 10.5S15.745 20 10.508 20C5.255 20 1 15.741 1 10.5S5.271 1 10.508 1zm0 17.673c4.5 0 8.166-3.669 8.166-8.173s-3.665-8.173-8.166-8.173c-4.5 0-8.166 3.669-8.166 8.173s3.666 8.173 8.166 8.173zm4.37-8.926c.376 0 .67.278.67.655 0 .376-.294.671-.67.671h-3.699v3.702c0 .377-.294.672-.67.672-.377 0-.672-.295-.672-.672v-3.702H6.14c-.377 0-.671-.295-.671-.671 0-.377.294-.672.67-.672h3.7V6.028c0-.376.294-.671.67-.671.377 0 .671.295.671.671v3.719h3.699z"
}));
export const AddWeCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Add-working-environment",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 85.400390625 85.4000015258789",
  xmlSpace: "preserve"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Add-working-environment"
}, " Add working environment"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M61.4 35.9c-.6-3.6-2.4-6.9-5.1-9.4-3-2.8-7-4.3-11-4.3-3.3 0-6.4 1-9.1 2.8-2.3 1.6-4.2 3.7-5.5 6.2h-.2c-4.3-.5-8.2 1-11.1 3.9-2.6 2.6-4 6-4 9.6 0 1 .1 1.9.3 2.9.2.9.5 1.9.9 2.8.7 1.5 1.7 2.7 3.1 3.6 1.3.9 2.9 1.3 4.5 1.3h6.4V52H24c-1 0-2-.3-2.8-.8-.8-.5-1.4-1.3-1.9-2.2-.3-.7-.5-1.4-.7-2.1-.2-.7-.2-1.5-.2-2.2 0-2.8 1.1-5.4 3-7.3 2-2 4.6-3 7.4-3 .4 0 .8 0 1.1.1.4 0 .8.1 1.1.2.8.2 1.5-.2 1.8-1 1-2.4 2.7-4.5 4.9-5.9 2.2-1.5 4.7-2.2 7.3-2.2 3.3 0 6.4 1.2 8.9 3.4 2.4 2.2 4 5.2 4.3 8.5.1.8.7 1.4 1.4 1.5 2 .2 3.8 1.2 5.1 2.6 1.3 1.5 2.1 3.4 2.1 5.4 0 .7-.1 1.4-.4 2-.2.6-.6 1.2-1.1 1.7-.5.5-1.1.9-1.7 1.1-.6.2-1.3.4-2 .4h-6.3v3.2h6.3c1.1 0 2.2-.2 3.2-.6 1-.4 1.9-1 2.7-1.8.8-.8 1.4-1.7 1.8-2.7.4-1 .6-2.1.6-3.2 0-2.8-1.1-5.4-2.9-7.5-1.3-2-3.4-3.2-5.6-3.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M43.1 43C37.6 43 33 47.6 33 53.1c0 5.6 4.5 10.1 10.1 10.1s10.1-4.5 10.1-10.1c0-5.5-4.5-10.1-10.1-10.1zm0 18c-4.4 0-7.9-3.5-7.9-7.9s3.5-7.9 7.9-7.9 7.9 3.5 7.9 7.9-3.5 7.9-7.9 7.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M44 48.4h-1.8v3.8h-3.8V54h3.8v3.8H44V54h3.8v-1.8H44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M42.7 0C19.2 0 0 19.2 0 42.7c0 23.6 19.2 42.7 42.7 42.7s42.7-19.2 42.7-42.7C85.5 19.2 66.3 0 42.7 0zm0 82C21.1 82 3.5 64.4 3.5 42.7c0-21.6 17.6-39.3 39.3-39.3S82 21.1 82 42.7C82 64.4 64.4 82 42.7 82z"
}));
export const AgentIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Agent",
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 19
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Agent"
}, " Agent"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#434957",
  d: "M10.875 10.2V9H3.021C1.355 9 0 7.654 0 6V3.6c0-1.654 1.355-3 3.02-3h22.96C27.644.6 29 1.946 29 3.6V6c0 1.654-1.355 3-3.02 3H12.082v1.2H25.98c1.666 0 3.021 1.346 3.021 3v2.4c0 1.654-1.355 3-3.02 3H3.02c-1.665 0-3.02-1.346-3.02-3v-2.4c0-1.654 1.355-3 3.02-3h7.855zm-7.854 1.2c-1 0-1.813.808-1.813 1.8v2.4c0 .992.814 1.8 1.813 1.8h22.958c1 0 1.813-.808 1.813-1.8v-2.4c0-.992-.814-1.8-1.813-1.8H3.021zm1.208 4.8c-1 0-1.812-.808-1.812-1.8s.813-1.8 1.812-1.8c1 0 1.813.808 1.813 1.8s-.814 1.8-1.813 1.8zm0-2.4a.603.603 0 0 0-.604.6.603.603 0 1 0 1.208 0c0-.331-.272-.6-.604-.6zm20.542 2.4a.602.602 0 0 1-.604-.6v-2.4c0-.331.27-.6.604-.6.333 0 .604.269.604.6v2.4c0 .331-.27.6-.604.6zm-2.417 0a.602.602 0 0 1-.604-.6v-2.4c0-.331.27-.6.604-.6.334 0 .604.269.604.6v2.4c0 .331-.27.6-.604.6zm-2.416 0a.602.602 0 0 1-.605-.6v-2.4c0-.331.271-.6.605-.6.333 0 .604.269.604.6v2.4c0 .331-.271.6-.605.6zm-2.417 0a.602.602 0 0 1-.604-.6v-2.4c0-.331.27-.6.604-.6.333 0 .604.269.604.6v2.4c0 .331-.27.6-.604.6zM3.02 1.8c-1 0-1.813.808-1.813 1.8V6c0 .992.814 1.8 1.813 1.8h22.958c1 0 1.813-.808 1.813-1.8V3.6c0-.992-.814-1.8-1.813-1.8H3.021zm1.208 4.8c-1 0-1.812-.808-1.812-1.8S3.23 3 4.229 3c1 0 1.813.808 1.813 1.8s-.814 1.8-1.813 1.8zm0-2.4a.603.603 0 0 0-.604.6.603.603 0 1 0 1.208 0c0-.331-.272-.6-.604-.6zM24.77 6.6a.602.602 0 0 1-.604-.6V3.6c0-.331.27-.6.604-.6.333 0 .604.269.604.6V6c0 .331-.27.6-.604.6zm-2.417 0a.602.602 0 0 1-.604-.6V3.6c0-.331.27-.6.604-.6.334 0 .604.269.604.6V6c0 .331-.27.6-.604.6zm-2.416 0a.602.602 0 0 1-.605-.6V3.6c0-.331.271-.6.605-.6.333 0 .604.269.604.6V6c0 .331-.271.6-.605.6zm-2.417 0a.602.602 0 0 1-.604-.6V3.6c0-.331.27-.6.604-.6.333 0 .604.269.604.6V6c0 .331-.27.6-.604.6z"
}));
export const AggregateMonochromeIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.6326143026351929 0.6287322521209717 39.23638381958008 29.900267028808592"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke primary-fill",
  strokeWidth: 0.7,
  d: "M28.001 2.977v25.208a1.685 1.685 0 0 0 1.642 1.644c5.418-.029 4.737-.008 7.884 0a1.685 1.685 0 0 0 1.642-1.644V2.977a1.685 1.685 0 0 0-1.642-1.648h-7.884a1.613 1.613 0 0 0-1.642 1.648zm9.635-.548a.517.517 0 0 1 .547.548v25.208a.517.517 0 0 1-.547.544h-7.993a.517.517 0 0 1-.547-.548V2.977a.517.517 0 0 1 .547-.548z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke primary-fill",
  strokeWidth: 0.7,
  d: "M14.667 2.977v25.208a1.685 1.685 0 0 0 1.642 1.644c5.418-.029 4.737-.008 7.884 0a1.685 1.685 0 0 0 1.642-1.644V2.977a1.685 1.685 0 0 0-1.642-1.648h-7.884a1.613 1.613 0 0 0-1.642 1.648zm9.635-.548a.517.517 0 0 1 .547.548v25.208a.517.517 0 0 1-.547.544h-7.993a.517.517 0 0 1-.547-.548V2.977a.517.517 0 0 1 .547-.548zm-22.969.548v25.208a1.685 1.685 0 0 0 1.642 1.644c5.418-.029 4.737-.008 7.884 0a1.685 1.685 0 0 0 1.642-1.644V2.977a1.685 1.685 0 0 0-1.642-1.648H2.975a1.613 1.613 0 0 0-1.642 1.648zm9.635-.548a.517.517 0 0 1 .547.548v25.208a.517.517 0 0 1-.547.544H2.975a.517.517 0 0 1-.547-.548V2.977a.517.517 0 0 1 .547-.548z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  fill: "none",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M33.583 6.248v9.333"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  fill: "none",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M20.25 6.249v9.333"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  fill: "none",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6.917 6.248v9.333"
}));
export const AppIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-App",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-App"
}, " App"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.59612 12.964C9.81899 12.9704 10.0394 13.0123 10.2491 13.088C10.5202 13.189 10.7671 13.3458 10.9738 13.5482C11.1805 13.7506 11.3424 13.9941 11.4491 14.263C11.5355 14.4866 11.5832 14.7234 11.5901 14.963C11.6141 16.823 11.6141 18.6827 11.5901 20.542C11.5832 20.7816 11.5355 21.0184 11.4491 21.242C11.3424 21.5109 11.1805 21.7544 10.9738 21.9568C10.7671 22.1592 10.5202 22.316 10.2491 22.417C10.0394 22.4927 9.81899 22.5346 9.59612 22.541C7.73612 22.565 5.87645 22.565 4.01712 22.541C3.77747 22.5341 3.54075 22.4864 3.31712 22.4C3.04835 22.2931 2.80495 22.1311 2.60258 21.9244C2.40021 21.7177 2.24336 21.471 2.14212 21.2C2.06663 20.9902 2.02478 20.7698 2.01812 20.547C1.99412 18.687 1.99412 16.8273 2.01812 14.968C2.02478 14.7452 2.06663 14.5248 2.14212 14.315C2.24336 14.044 2.40021 13.7973 2.60258 13.5906C2.80495 13.3839 3.04835 13.2219 3.31712 13.115C3.54075 13.0286 3.77747 12.9809 4.01712 12.974C5.87712 12.95 7.73678 12.95 9.59612 12.974V12.964ZM20.5421 12.964C20.7818 12.9709 21.0185 13.0186 21.2421 13.105C21.511 13.2117 21.7545 13.3736 21.9569 13.5803C22.1593 13.7871 22.3161 14.0339 22.4171 14.305C22.4929 14.5147 22.5347 14.7351 22.5411 14.958C22.5651 16.818 22.5651 18.6777 22.5411 20.537C22.5342 20.7766 22.4865 21.0134 22.4001 21.237C22.2934 21.5059 22.1315 21.7494 21.9248 21.9518C21.7181 22.1542 21.4712 22.311 21.2001 22.412C20.9904 22.4877 20.77 22.5296 20.5471 22.536C18.6871 22.56 16.8274 22.56 14.9681 22.536C14.7452 22.5296 14.5248 22.4877 14.3151 22.412C14.044 22.311 13.7972 22.1542 13.5905 21.9518C13.3838 21.7494 13.2218 21.5059 13.1151 21.237C13.0287 21.0134 12.981 20.7766 12.9741 20.537C12.9501 18.677 12.9501 16.8173 12.9741 14.958C12.9805 14.7351 13.0224 14.5147 13.0981 14.305C13.1991 14.0339 13.3559 13.7871 13.5583 13.5803C13.7607 13.3736 14.0042 13.2117 14.2731 13.105C14.4968 13.0186 14.7335 12.9709 14.9731 12.964C16.8331 12.94 18.6928 12.94 20.5521 12.964H20.5421ZM15.0201 14.331C14.9387 14.3313 14.858 14.3452 14.7811 14.372C14.688 14.4071 14.6035 14.4617 14.5331 14.532C14.4628 14.6024 14.4082 14.6869 14.3731 14.78C14.3484 14.8498 14.3345 14.923 14.3321 14.997C14.3091 16.839 14.2631 18.683 14.3321 20.524C14.3404 20.6929 14.4112 20.8528 14.5308 20.9723C14.6504 21.0919 14.8102 21.1628 14.9791 21.171C16.8264 21.241 18.6748 21.241 20.5241 21.171C20.693 21.1628 20.8529 21.0919 20.9725 20.9723C21.0921 20.8528 21.1629 20.6929 21.1711 20.524C21.2411 18.6767 21.2411 16.8283 21.1711 14.979C21.1629 14.8101 21.0921 14.6502 20.9725 14.5307C20.8529 14.4111 20.693 14.3402 20.5241 14.332C18.6911 14.263 16.8541 14.332 15.0241 14.332L15.0201 14.331ZM4.07412 14.331C3.99273 14.3313 3.91196 14.3452 3.83512 14.372C3.74202 14.4071 3.65748 14.4617 3.58712 14.532C3.51677 14.6024 3.46222 14.6869 3.42712 14.78C3.40236 14.8498 3.38853 14.923 3.38612 14.997C3.36312 16.839 3.31812 18.683 3.38612 20.524C3.38987 20.5922 3.40333 20.6596 3.42612 20.724C3.45997 20.8143 3.51234 20.8965 3.57984 20.9654C3.64735 21.0343 3.72851 21.0883 3.81812 21.124C3.8927 21.1523 3.97141 21.1681 4.05112 21.171C5.89312 21.194 7.73712 21.24 9.57812 21.171C9.74705 21.1628 9.90687 21.0919 10.0265 20.9723C10.1461 20.8528 10.2169 20.6929 10.2251 20.524C10.2951 18.6767 10.2951 16.8283 10.2251 14.979C10.2185 14.848 10.1743 14.7217 10.0976 14.6153C10.021 14.5088 9.91526 14.4268 9.79312 14.379C9.71853 14.3507 9.63983 14.3349 9.56012 14.332C7.73112 14.309 5.90212 14.332 4.07312 14.332L4.07412 14.331ZM9.59612 2.018C9.81896 2.02466 10.0393 2.06651 10.2491 2.142C10.5201 2.24324 10.7668 2.4001 10.9735 2.60247C11.1802 2.80484 11.3422 3.04823 11.4491 3.317C11.5355 3.54063 11.5832 3.77735 11.5901 4.017C11.6141 5.877 11.6141 7.73667 11.5901 9.596C11.5837 9.81887 11.5419 10.0393 11.4661 10.249C11.3651 10.5201 11.2083 10.7669 11.0059 10.9736C10.8035 11.1804 10.56 11.3423 10.2911 11.449C10.0675 11.5354 9.83076 11.5831 9.59112 11.59C7.73112 11.614 5.87145 11.614 4.01212 11.59C3.77247 11.5831 3.53575 11.5354 3.31212 11.449C3.04335 11.3421 2.79995 11.1801 2.59758 10.9734C2.39521 10.7667 2.23836 10.52 2.13712 10.249C2.06163 10.0392 2.01978 9.81884 2.01312 9.596C1.98912 7.736 1.98912 5.87633 2.01312 4.017C2.01978 3.79416 2.06163 3.57377 2.13712 3.364C2.24093 3.08376 2.4043 2.82938 2.61597 2.61841C2.82763 2.40744 3.08254 2.2449 3.36312 2.142C3.57289 2.06651 3.79328 2.02466 4.01612 2.018C5.87612 1.994 7.73678 1.994 9.59612 2.018ZM20.5421 2.018C20.765 2.02466 20.9853 2.06651 21.1951 2.142C21.4661 2.24324 21.7128 2.4001 21.9195 2.60247C22.1262 2.80484 22.2882 3.04823 22.3951 3.317C22.4815 3.54063 22.5292 3.77735 22.5361 4.017C22.5601 5.877 22.5601 7.73667 22.5361 9.596C22.5297 9.81887 22.4879 10.0393 22.4121 10.249C22.3111 10.5201 22.1543 10.7669 21.9519 10.9736C21.7495 11.1804 21.506 11.3423 21.2371 11.449C21.0135 11.5354 20.7768 11.5831 20.5371 11.59C18.6771 11.614 16.8174 11.614 14.9581 11.59C14.7185 11.5831 14.4818 11.5354 14.2581 11.449C13.9892 11.3423 13.7457 11.1804 13.5433 10.9736C13.3409 10.7669 13.1841 10.5201 13.0831 10.249C13.0074 10.0393 12.9655 9.81887 12.9591 9.596C12.9351 7.736 12.9351 5.87633 12.9591 4.017C12.966 3.77735 13.0137 3.54063 13.1001 3.317C13.207 3.04823 13.3691 2.80484 13.5757 2.60247C13.7824 2.4001 14.0292 2.24324 14.3001 2.142C14.5099 2.06651 14.7303 2.02466 14.9531 2.018C16.8131 1.994 18.6728 1.994 20.5321 2.018H20.5421ZM15.0201 3.385C14.9387 3.3854 14.858 3.39925 14.7811 3.426C14.688 3.4611 14.6035 3.51565 14.5331 3.58601C14.4628 3.65636 14.4082 3.7409 14.3731 3.834C14.3484 3.90379 14.3345 3.97699 14.3321 4.051C14.3091 5.893 14.2631 7.737 14.3321 9.578C14.3404 9.74693 14.4112 9.90675 14.5308 10.0263C14.6504 10.1459 14.8102 10.2168 14.9791 10.225C16.8264 10.295 18.6748 10.295 20.5241 10.225C20.6551 10.2184 20.7814 10.1741 20.8878 10.0975C20.9943 10.0209 21.0763 9.91514 21.1241 9.793C21.1524 9.71841 21.1682 9.63971 21.1711 9.56C21.1941 7.718 21.2401 5.874 21.1711 4.033C21.1629 3.86407 21.0921 3.70425 20.9725 3.58465C20.8529 3.46506 20.693 3.39424 20.5241 3.386C18.6911 3.318 16.8541 3.386 15.0241 3.386L15.0201 3.385ZM4.07412 3.385C3.99273 3.3854 3.91198 3.39925 3.83512 3.426C3.74202 3.4611 3.65748 3.51565 3.58712 3.58601C3.51677 3.65636 3.46222 3.7409 3.42712 3.834C3.40236 3.90379 3.38853 3.97699 3.38612 4.051C3.36312 5.893 3.31812 7.737 3.38612 9.578C3.38987 9.64623 3.40333 9.71358 3.42612 9.778C3.46003 9.86844 3.51253 9.95076 3.58022 10.0197C3.64791 10.0886 3.72929 10.1425 3.81912 10.178C3.89365 10.2064 3.97239 10.2223 4.05212 10.225C5.89412 10.248 7.73812 10.294 9.57912 10.225C9.6528 10.2214 9.7254 10.2058 9.79412 10.179C9.88155 10.1442 9.96096 10.0919 10.0275 10.0254C10.094 9.95884 10.1463 9.87943 10.1811 9.792C10.2095 9.71746 10.2254 9.63873 10.2281 9.559C10.2511 7.717 10.2971 5.873 10.2281 4.032C10.2245 3.95832 10.2089 3.88572 10.1821 3.817C10.1473 3.72957 10.095 3.65016 10.0285 3.58361C9.96196 3.51707 9.88255 3.4648 9.79512 3.43C9.7264 3.40317 9.6538 3.38764 9.58012 3.384C7.74712 3.316 5.91012 3.384 4.08012 3.384L4.07412 3.385Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.2
}));
export const ArrowBackIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Arrow-left",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.0010960102081298828 -0.0013176918728277087 11.985095977783203 9.119600296020508"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Arrow-left"
}, "Arrow left"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M-.001 4.561a.768.768 0 00.185.47l3.649 3.877a.784.784 0 001 .057.712.712 0 00-.007-1l-2.568-2.72H11.3a.684.684 0 100-1.368H2.258l2.565-2.722a.753.753 0 00.007-1 .774.774 0 00-1 .057L.184 4.091a.661.661 0 00-.185.47z"
}));
export const ArrowDropdownIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Expand",
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 4,
  viewBox: "0 0 9 4"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Expand"
}, "Expand"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fillRule: "evenodd",
  d: "M5.098 3.469L9 0H0l3.902 3.469c.341.303.855.303 1.196 0z"
}));
export const ArrowNoCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Arrow-left",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Arrow-left"
}, "Arrow left"), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.1,
  d: "M3.999 11.993a1.009 1.009 0 00.243.618l4.794 5.094a1.031 1.031 0 001.312.079.936.936 0 00-.01-1.315l-3.371-3.577h11.881a.9.9 0 100-1.8H6.967l3.371-3.575a.99.99 0 00.01-1.311 1.017 1.017 0 00-1.311.075l-4.794 5.094a.868.868 0 00-.243.618z",
  className: "primary-fill primary-stroke"
}));
export const ArrowRightIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Arrow-right",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Arrow-right"
}, " Arrow right"), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.1,
  d: "M11.0732 0.953371C10.8221 0.938252 10.5736 1.01118 10.3705 1.15959L10.3642 1.1651C10.1834 1.35101 10.0832 1.60062 10.0852 1.85989C10.0871 2.1189 10.191 2.36672 10.3742 2.54981L13.6652 6.04196H1.90001C1.64806 6.04196 1.40642 6.14205 1.22826 6.32021C1.0501 6.49837 0.950012 6.74 0.950012 6.99196C0.950012 7.24391 1.0501 7.48555 1.22826 7.66371C1.40642 7.84187 1.64806 7.94196 1.90001 7.94196H13.6651L10.3736 11.4326L10.3728 11.4336C10.2034 11.6224 10.1088 11.8665 10.1069 12.1202C10.105 12.3738 10.1958 12.6194 10.3623 12.8108L10.3614 12.8115L10.37 12.8179C10.5716 12.9695 10.8203 13.0447 11.0721 13.0303C11.3239 13.0159 11.5625 12.9128 11.7455 12.7393L16.5412 7.64345C16.7099 7.46839 16.8034 7.23343 16.799 6.99006L16.799 6.98899C16.7896 6.7502 16.6997 6.52157 16.544 6.34033L11.7485 1.24462L11.7461 1.24242C11.5623 1.07071 11.3243 0.968491 11.0732 0.953371Z",
  fill: "var(--icon-primary)",
  className: "primary-fill primary-stroke"
}));
export const ArrowTopRightIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "External-link",
  width: "9px",
  height: "8px",
  viewBox: "0 0 9 8",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "External-link"
}, "External link"), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1567.000000, -637.000000)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1328.000000, 339.000000)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-primary)",
  className: "primary-fill",
  d: "M243.99904,297.226042 C243.75027,296.94389 243.326544,296.923036 243.052857,297.1795 C243.03705,297.194278 243.022046,297.209884 243.007712,297.226042 L240.17439,300.439788 C239.925352,300.72194 239.945446,301.15891 240.219267,301.415513 C240.492954,301.672253 240.91668,301.651399 241.165717,301.369247 L242.83356,299.470278 L242.83356,306.309466 C242.83356,306.690641 243.133503,307 243.503376,307 C243.873382,307 244.173192,306.690641 244.173192,306.309466 L244.173192,299.484089 L245.834336,301.369247 C246.083373,301.651399 246.507099,301.672253 246.780786,301.415513 C247.054607,301.15891 247.074567,300.72194 246.825664,300.439788 L243.99904,297.226042 Z",
  transform: "translate(243.500000, 302.000000) rotate(-315.000000) translate(-243.500000, -302.000000) "
}))));
export const BackIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Back",
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Back"
}, " Back"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.589 10.781l1.406 1.407 3.515-3.543v11.068h1.98V8.645l3.515 3.543 1.406-1.407L12.5 4.896z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.13 12.5c0 6.823 5.547 12.37 12.37 12.37 6.823 0 12.37-5.547 12.37-12.37C24.87 5.677 19.323.13 12.5.13 5.677.13.13 5.677.13 12.5zm22.787 0c0 5.73-4.688 10.417-10.417 10.417-5.73 0-10.417-4.688-10.417-10.417 0-5.73 4.688-10.417 10.417-10.417 5.73 0 10.417 4.688 10.417 10.417z"
})));
export const BackupListIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Backup-list",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.119 0.9 20.381 16.7"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Backup-list"
}, " Backup list"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.6 10.2c-.1 0-.3-.1-.4-.2L.6 7.7C.4 7.5.5 7.2.7 7c.1-.1.2-.1.3-.1.2 0 .3.1.4.2l1.1 1.5C3 6.2 4.8 4.2 7.1 3.5v1c-1.9.7-3.3 2.4-3.8 4.4l1.8-.8h.2c.2 0 .3.1.4.3.1.1.1.2 0 .4 0 .1-.1.2-.2.2l-2.6 1.1c-.1 0-.2.1-.3.1m6.7 7c-2.1 0-4-.9-5.4-2.4-.1-.1-.1-.2-.1-.4 0-.1.1-.2.2-.3.1-.1.2-.1.3-.1.1 0 .3.1.4.2 2.2 2.6 6.1 2.9 8.6.7.4-.4.8-.8 1.1-1.3h1.1c-1.2 2.2-3.6 3.6-6.2 3.6",
  className: "primary-fill",
  fill: "var(--icon-primary)",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 8.9c.1-.2.1-.4 0-.6-.1-.3-.4-.5-.7-.5-.1 0-.2 0-.3.1l-1.2.4c.6-1.6 1.8-2.9 3.4-3.5l.2-.1V3l-.4.2c-2.2.7-4 2.4-4.7 4.6l-.7-.9c-.1-.2-.4-.3-.7-.3-.2 0-.3.1-.5.2-.3.2-.4.7-.1 1.1L2 10.2c.1.2.4.3.7.3.1 0 .2 0 .3-.1l2.6-1.1c.2-.1.4-.2.4-.4zm8.2 4.3l-.1.2c-.3.4-.7.9-1.1 1.2-1.2 1-2.7 1.5-4.2 1.4-1.5-.1-2.9-.8-3.9-2-.2-.2-.4-.3-.6-.3-.2 0-.4.1-.5.2-.2.1-.3.3-.3.5s0 .4.2.6c1.4 1.6 3.5 2.6 5.6 2.6 2.7 0 5.2-1.5 6.5-3.9l.3-.5h-1.9z",
  className: "primary-fill",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.5 2.5h-9.3c-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8h9.3c.4 0 .8.3.8.8 0 .4-.3.8-.8.8m.2 4h-9.3c-.4 0-.8-.3-.8-.8s.4-.7.8-.7h9.3c.4 0 .8.3.8.8s-.4.7-.8.7m0 4.1h-9.3c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h9.3c.4 0 .8.4.8.8s-.4.8-.8.8",
  className: "primary-fill",
  fill: "var(--icon-primary)",
  clipRule: "evenodd"
}));
export const BackupSettingsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Backup-settings",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "3.001438856124878 3.9989986419677734 18.826900482177734 16.593008041381836"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Backup-settings"
}, " Backup settings"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill primary-stroke",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.908 20.592a6.357 6.357 0 01-4.815-2.2.433.433 0 01-.1-.32.4.4 0 01.148-.274.447.447 0 01.28-.1.411.411 0 01.319.15 5.508 5.508 0 008.779-.563h.973a6.348 6.348 0 01-5.584 3.307zm-5.99-6.315a.4.4 0 01-.334-.171l-1.496-2.063a.442.442 0 01.082-.61.493.493 0 01.249-.083.432.432 0 01.349.182l.963 1.32a6.361 6.361 0 014.247-4.567v.907a5.473 5.473 0 00-3.448 3.957l1.61-.677a.414.414 0 01.172-.038.418.418 0 01.376.253.4.4 0 01.009.324.392.392 0 01-.225.22L5.1 14.239a.44.44 0 01-.182.038z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.296 10.348l-.5-.378c0-.079.007-.158.007-.237s0-.158-.007-.237l.5-.378a1.342 1.342 0 00.346-1.747l-.627-1.042a1.369 1.369 0 00-1.648-.557l-.633.244a4.751 4.751 0 00-.488-.272l-.09-.6a1.353 1.353 0 00-1.33-1.145h-1.253a1.351 1.351 0 00-1.332 1.144l-.09.6a4.608 4.608 0 00-.488.273l-.632-.244a1.367 1.367 0 00-1.648.558l-.626 1.04a1.343 1.343 0 00.346 1.747l.5.379q-.006.118-.006.237t.006.237l-.5.378a1.343 1.343 0 00-.346 1.751l.628 1.042a1.368 1.368 0 001.647.557l.633-.244a4.521 4.521 0 00.488.273l.09.6a1.351 1.351 0 001.33 1.14h1.254a1.355 1.355 0 001.332-1.144l.089-.6a4.658 4.658 0 00.488-.272l.633.243a1.365 1.365 0 001.648-.557l.626-1.039a1.343 1.343 0 00-.345-1.75zm-1.539-.615a3.278 3.278 0 01-.076.7l.989.744a.293.293 0 01.079.377l-.627 1.045a.321.321 0 01-.38.122l-1.169-.448a3.6 3.6 0 01-1.271.7l-.178 1.193a.31.31 0 01-.3.255h-1.251a.31.31 0 01-.3-.255l-.178-1.193a3.6 3.6 0 01-1.271-.7l-1.166.448a.321.321 0 01-.385-.122l-.627-1.041a.293.293 0 01.08-.377l.988-.744a3.307 3.307 0 010-1.408l-.988-.744a.293.293 0 01-.08-.377l.627-1.041a.321.321 0 01.38-.122l1.166.449a3.6 3.6 0 011.271-.7l.183-1.195a.31.31 0 01.3-.255h1.254a.31.31 0 01.3.255l.178 1.193a3.593 3.593 0 011.271.7l1.167-.449a.321.321 0 01.38.122l.627 1.041a.293.293 0 01-.079.377l-.989.744a3.286 3.286 0 01.074.706zm-3.61-2.085a2.085 2.085 0 102.085 2.085 2.085 2.085 0 00-2.085-2.085zm0 3.127a1.042 1.042 0 111.042-1.042 1.044 1.044 0 01-1.042 1.042"
})));
export const BackupIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Backup",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "4.505748271942139 5.499981880187988 14.688520431518555 13.048001289367676"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Backup"
}, " Backup"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  d: "M4.596 9.685l1.536 2.127a.429.429 0 00.531.136l2.449-1.038a.411.411 0 00.223-.562.421.421 0 00-.565-.221l-1.661.7a5.676 5.676 0 0111.215 1.19 5.667 5.667 0 01-9.966 3.658.437.437 0 00-.617-.051.431.431 0 00-.052.613A6.524 6.524 0 1012.655 5.5a6.551 6.551 0 00-6.369 5.02l-.99-1.362a.448.448 0 00-.36-.187.51.51 0 00-.257.085.458.458 0 00-.085.629z"
}));
export const BellIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Notification",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20.700000762939453 26.043142318725586"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Notification"
}, "Notification"), /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-primary)",
  className: "primary-fill",
  d: "M20.2 19.6l-1.9-1.9s-.1-.1-.1-.2v-7.2c0-4.1-3.1-7.5-7.1-7.9V.8c0-.4-.3-.8-.7-.8-.4 0-.8.3-.8.7v1.8c-4 .4-7.1 3.8-7.1 7.9v7.2c0 .1 0 .1-.1.2L.5 19.7c-.3.3-.5.7-.5 1.2v.6c0 1 .8 1.7 1.7 1.7H7c.3 1.8 2.1 3.1 3.9 2.8 1.4-.2 2.5-1.4 2.8-2.8H19c1 0 1.7-.8 1.7-1.7v-.6c0-.5-.2-.9-.5-1.3zm-9.8 4.9c-.8 0-1.5-.5-1.8-1.3h3.6c-.3.8-1 1.3-1.8 1.3zm8.8-3.1c0 .1-.1.2-.2.2H1.7c-.1 0-.2-.1-.2-.2v-.6c0-.1 0-.1.1-.2l1.9-1.9c.3-.2.5-.7.5-1.1v-7.2C4 6.8 6.8 4 10.4 4c3.5 0 6.4 2.9 6.4 6.4v7.2c0 .5.2.9.5 1.2l1.9 1.9s.1.1.1.2l-.1.5z"
}));
export const BubbleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  width: "55px",
  height: "33px",
  viewBox: "0 0 55 33",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1704.000000, -551.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1704.000000, 551.000000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.2,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke primary-fill",
  d: "M27.5,0.371621622 C18.0466892,0.371621622 9.41540541,3.21683108 4.41560811,7.98391892 C1.7707027,10.5068581 0.371324324,13.3985946 0.371324324,16.3513514 C0.371324324,18.2472162 0.934561486,20.1024257 2.04941892,21.8618311 C2.90006081,23.2205541 4.06427703,24.5009392 5.51010811,25.6709527 C5.63785676,25.775475 5.72785608,25.9177318 5.76559797,26.0774176 C5.875925,26.5506554 5.93398716,27.0326338 5.93398716,27.5116541 C5.93398716,29.2159108 5.26332905,30.7982014 4.0903723,31.9653162 C5.05428446,32.2091966 6.05008176,32.3311487 7.06044662,32.3311487 C9.42373716,32.3311487 11.7115142,31.6575689 13.6799196,30.3830182 C13.8018561,30.3046284 13.9412142,30.2639804 14.0834784,30.2639804 C14.1618682,30.2639804 14.2402581,30.2755936 14.3157419,30.301723 C18.3280662,31.6285609 22.8860797,32.3311487 27.4993905,32.3311487 C42.4571608,32.3311487 54.6277689,25.1629393 54.6277689,16.351419 C54.6277689,7.53989872 42.4571608,0.371621622 27.4993905,0.371621622 L27.5,0.371621622 Z",
  fillRule: "nonzero"
}))))));
export const BucketIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Bucket",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Bucket"
}, " Bucket"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_727_35241)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  d: "M13.9804 2.76924L13.9856 2.76592L14.0116 2.75434L13.9837 2.77409L13.9831 2.77311L13.9819 2.77088L13.9813 2.76956L13.9804 2.76924Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.8436 0.824472C4.03586 0.399992 5.76352 0.0667267 7.99968 0.0667267C10.2364 0.0667267 11.96 0.400011 13.1503 0.824593C13.7431 1.03607 14.2195 1.27584 14.5638 1.52035C14.7353 1.64216 14.8886 1.77548 15.0075 1.91981C15.0739 2.00052 15.1453 2.1037 15.1964 2.22613L15.2239 2.29192L15.2409 2.28344L15.233 2.32921L15.2369 2.34348C15.2501 2.39206 15.2597 2.44302 15.2644 2.49626L15.2667 2.52265V2.68447L15.2518 2.75009C15.2237 2.8739 15.1709 2.98457 15.1087 3.08108L15.1013 3.0925L13.2443 13.8552L13.2438 13.8587C13.1605 14.5585 12.6822 15.147 12.013 15.3543L12.0086 15.3556L12.0075 15.356L12.0032 15.3572C10.6866 15.7407 9.34962 15.9334 8.013 15.9334C6.67652 15.9334 5.3432 15.7407 4.03396 15.3569L4.02566 15.3545C3.35461 15.1476 2.8778 14.5582 2.79409 13.8588L0.949453 3.16574L0.939963 3.15297C0.855514 3.03938 0.778762 2.89988 0.74554 2.73726L0.733398 2.67783V2.53162L0.734421 2.51413C0.739607 2.4254 0.758466 2.34281 0.785638 2.26694L0.791555 2.25042L0.791303 2.24897L0.80823 2.2096C0.857223 2.09565 0.923226 1.99927 0.984665 1.92345C1.10319 1.77718 1.25701 1.64286 1.42833 1.52082C1.77241 1.27573 2.2499 1.03585 2.8436 0.824472ZM7.99968 1.26673C5.87731 1.26673 4.28883 1.58371 3.24609 1.95496C2.72228 2.14145 2.35226 2.33601 2.12425 2.49842L2.03224 2.5647L2.10723 2.61881C2.12335 2.63045 2.14052 2.64247 2.15875 2.65486C2.39963 2.81844 2.77661 3.01025 3.2997 3.19289C4.3421 3.55687 5.9108 3.86557 7.99968 3.86557C10.0811 3.86557 11.6459 3.56108 12.6884 3.19915C13.2115 3.01756 13.5895 2.82624 13.8324 2.66179C13.8528 2.64798 13.8719 2.6346 13.8897 2.62167L13.9645 2.56751L13.8689 2.49869C13.6394 2.33569 13.2696 2.14123 12.7471 1.95484C11.7066 1.58369 10.1224 1.26673 7.99968 1.26673ZM14.0925 2.6972L13.9856 2.76592L13.9808 2.76848L13.9804 2.76924C13.9824 2.7726 13.9842 2.77541 13.9857 2.77765L13.9879 2.78059L13.9887 2.78175L13.9895 2.78269L14.1024 2.71392L14.1021 2.71325L14.1018 2.71248L14.101 2.71091L14.0993 2.7077C14.0981 2.70552 14.0967 2.70325 14.0951 2.70091L14.0956 2.70214L14.0757 2.71374L14.0938 2.69962L14.0944 2.69993L14.0925 2.6972ZM12.0552 13.6894L13.6711 4.3239L13.565 4.35981C11.9635 4.90177 9.97664 5.16515 8.03615 5.16515C6.06919 5.16515 4.07616 4.90229 2.4731 4.36L2.367 4.32411L3.98255 13.6892L3.98459 13.7083C4.01108 13.9555 4.17276 14.1423 4.37541 14.2065L4.37682 14.2069C5.57662 14.5581 6.79455 14.7334 8.013 14.7334C9.2312 14.7334 10.453 14.5582 11.661 14.2071L11.6627 14.2065C11.866 14.1414 12.0271 13.9538 12.0532 13.7088L12.0552 13.6894Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_727_35241"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "none"
}))));
export const ByolByCapacityIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Bring-your-own-license-",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-1.0001917233603308 -1 33.466196060180664 37.99900436401367"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Bring-your-own-license-"
}, " Bring your own license "), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h26.546v31.999H0z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M14.572 24.721a.466.466 0 00-.41-.051H4.217c-.429 0-.74.27-.737.67.08.363.363.612.68.612l.057-.002h9.962c.435 0 .74-.262.736-.669-.056-.256-.177-.456-.343-.56m7.977-8.814a.9.9 0 00-.837-.599H4.322c-.49 0-.845.269-.841.67a.804.804 0 00.841.609h17.39a.897.897 0 00.837-.598l.016-.041-.016-.041zm-7.977 4.183a.47.47 0 00-.41-.05H4.217c-.429 0-.74.27-.737.67.08.363.363.612.68.612.017 0 .037 0 .057-.003h9.962c.435 0 .74-.26.736-.668-.056-.256-.177-.457-.343-.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M17.196 30.56H1.337V1.337h11.937v9.775c0 .206.103.309.206.515.14.128.323.2.514.205.103 0 .31-.102.411-.102l3.293-2.675 3.087 2.572a.65.65 0 00.916-.092l.01-.011a.773.773 0 00.205-.412V1.337h3.294l-.065 18.348c.481.055.95.15 1.401.29V.72a.865.865 0 00-.72-.72H.721C.515 0 .412.103.206.205A.778.778 0 000 .72v30.559c-.009.388.3.71.687.719h17.361a7.716 7.716 0 01-.852-1.438zM14.713 1.337h5.764v8.335L18.11 7.614a.627.627 0 00-.824 0l-2.572 2.058V1.337z",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M29.919 21.653c-.38.256-.796.448-1.234.572a15.891 15.891 0 01-4.542.592 15.839 15.839 0 01-4.538-.591 4.3 4.3 0 01-1.226-.566c-.197-.148-.268-.266-.268-.322 0-.023.012-.143.24-.325a3.914 3.914 0 011.155-.57 13.904 13.904 0 014.246-.584h.793c1.453-.022 2.866.17 4.244.583.413.125.799.316 1.139.563.23.183.255.294.255.333 0 .034-.028.133-.264.315zm.264 3.719c0 .042-.058.158-.264.315a4.313 4.313 0 01-1.234.573 15.92 15.92 0 01-4.54.59 15.911 15.911 0 01-4.54-.59 4.294 4.294 0 01-1.223-.566c-.197-.147-.268-.266-.268-.358v-2.354c.355.192.729.345 1.117.457 1.602.456 3.26.682 4.914.647 1.64.028 3.313-.19 4.916-.647a5.712 5.712 0 001.122-.462v2.395zm0 3.843c0 .01-.008.119-.264.315-.38.255-.795.448-1.233.573-1.477.415-3 .604-4.541.59a16.013 16.013 0 01-4.54-.59 4.311 4.311 0 01-1.222-.566c-.198-.15-.27-.267-.27-.36v-2.161c.356.192.73.345 1.118.457 1.602.456 3.26.682 4.914.647 1.64.033 3.313-.191 4.916-.647a5.712 5.712 0 001.122-.462v2.204zm-1.126 2.1a5.673 5.673 0 001.126-.462v2.396c0 .03-.02.143-.246.326-.35.253-.735.444-1.147.569-1.38.412-2.824.595-4.25.583h-.788a14.148 14.148 0 01-4.245-.583 3.908 3.908 0 01-1.146-.562c-.161-.13-.25-.247-.25-.333v-2.391c.356.19.73.345 1.119.457a16.62 16.62 0 004.913.647 16.764 16.764 0 004.914-.647zm2.403-10.106l-.008-.017a1.765 1.765 0 00-.726-1.181 5.113 5.113 0 00-1.543-.776 15.286 15.286 0 00-4.642-.645h-.783c-1.58-.027-3.143.19-4.653.648a5.044 5.044 0 00-1.54.773c-.41.29-.676.742-.73 1.263l-.008.043v11.95c.033.532.302 1.01.734 1.309.467.347.987.607 1.544.776 1.419.43 2.888.647 4.366.647l.285-.003h.78c1.572.03 3.14-.19 4.65-.648a5.063 5.063 0 001.536-.771c.439-.303.71-.781.744-1.328v-11.95l-.006-.09z"
})));
export const CardSelectedIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Card-selected",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Card-selected"
}, " Card selected"), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.2427 7.75749C19.6527 8.16754 19.6527 8.83236 19.2427 9.24241L11.2427 17.2424C10.8326 17.6525 10.1678 17.6525 9.75773 17.2424L5.75773 13.2424C5.34768 12.8324 5.34768 12.1675 5.75773 11.7575C6.16778 11.3474 6.83261 11.3474 7.24266 11.7575L10.5002 15.015L17.7577 7.75749C18.1678 7.34744 18.8326 7.34744 19.2427 7.75749Z",
  fill: "var(--white-fg)"
}));
export const CaretDownIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Expand",
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 4,
  viewBox: "0 0 6 4"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Expand"
}, "Expand"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#7B7B7B",
  fillRule: "evenodd",
  d: "M3 4L0 0h6z"
}));
export const ChainsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Chains",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "3.891904830932617 3.8913846015930176 16.11488914489746 16.123376846313477"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Chains"
}, " Chains"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  d: "M19.335 18.463l-.98-.98a2.178 2.178 0 00-.375-2.614 2.205 2.205 0 00-2.613-.373l-1.494-1.494a2.178 2.178 0 00-.374-2.614 2.205 2.205 0 00-2.614-.374L9.392 8.521a2.178 2.178 0 00-.374-2.615 2.205 2.205 0 00-2.613-.372l-.979-.979a.616.616 0 00-.87.871l.978.979a2.178 2.178 0 00.375 2.616 2.205 2.205 0 002.614.373l1.494 1.494a2.178 2.178 0 00.373 2.614 2.205 2.205 0 002.614.373l1.493 1.493a2.178 2.178 0 00.374 2.614 2.205 2.205 0 002.613.373l.98.98a.615.615 0 00.87-.001.635.635 0 00-.003-.874zM6.765 8.164a.968.968 0 111.368 0 .948.948 0 01-1.369 0zm4.48 4.48a.968.968 0 111.368 0 .976.976 0 01-1.368 0zm4.48 4.48a.968.968 0 111.369 0 .976.976 0 01-1.369.001z"
}));
export const CheckCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Check",
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Check"
}, " Check"), /*#__PURE__*/React.createElement("path", {
  d: "M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0zM9.783 15.86l-4.372-4.375 1.945-1.946 2.43 2.43 4.861-4.857 1.946 1.946-6.81 6.803z"
}));
export const CheckIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Check",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Check"
}, " Check"), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  className: "primary-fill",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-on-color)",
  d: "M16.789 8.745a1.187 1.187 0 00-1.672 0l-4.256 4.256-1.842-1.841a1.182 1.182 0 10-1.673 1.667l2.678 2.678a1.183 1.183 0 001.672 0l5.091-5.093a1.183 1.183 0 000-1.672z"
}));
export const ChevronIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Chevron-right",
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 13,
  viewBox: "0 0 7 13"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Chevron-right"
}, " Chevron right"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M4.372 6.5L0 11.498 1.314 13 7 6.5 1.314 0 0 1.502z"
}));
export const CircleRemoveIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Remove",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "3.80029182434082 4.272000122070312 16.39627685546875 16.40000190734863"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Remove"
}, " Remove"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  fillRule: "evenodd",
  d: "M15.291 12.429c0 .4-.51.727-.926.727H9.551a.845.845 0 01-.926-.727c0-.402.511-.728.926-.728h4.814a.845.845 0 01.926.728z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.2,
  d: "M17.657 6.815a8 8 0 100 11.314 8.009 8.009 0 000-11.314zm-.87.87a6.769 6.769 0 11-9.573 0 6.759 6.759 0 019.573 0z"
}));
export const CircleTooltipIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Info",
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Info"
}, "Info"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M8 0a8 8 0 1 1-8 8 8 8 0 0 1 8-8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#fff",
  d: "M47.483 41.91a.928.928 0 0 1 .893.834v4.332a.865.865 0 0 1-.893.834.928.928 0 0 1-.893-.834v-4.332a.865.865 0 0 1 .893-.834z",
  transform: "translate(-39.492 -35.577)"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#fff",
  d: "M47.453 28.272a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
  transform: "translate(-38.453 -23.939)"
}));
export const CloseCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Close",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  overflow: "visible"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Close"
}, " Close"), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  className: "secondary-fill",
  stroke: "none",
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.5,
  className: "primary-stroke",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.666 15.975a.715.715 0 01-.506-1.222l2.79-2.791-2.79-2.79a.717.717 0 011.012-1.013l2.79 2.79 2.79-2.79a.716.716 0 111.013 1.013l-2.79 2.79 2.789 2.79a.708.708 0 010 1.012.71.71 0 01-1.012 0l-2.79-2.79-2.79 2.79a.71.71 0 01-.506.21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.666 15.924c.17 0 .34-.065.47-.195l2.826-2.826 2.826 2.826a.663.663 0 00.94 0 .663.663 0 000-.941l-2.824-2.826 2.826-2.825a.667.667 0 00-.942-.943l-2.826 2.826-2.825-2.826a.664.664 0 00-.943 0 .667.667 0 000 .943l2.826 2.825-2.826 2.826a.665.665 0 00.472 1.136m0 .1a.766.766 0 01-.542-1.308l2.754-2.754-2.754-2.754a.767.767 0 011.084-1.084l2.754 2.754 2.755-2.754a.763.763 0 011.083 0c.3.298.3.785 0 1.084l-2.755 2.754 2.754 2.755a.76.76 0 010 1.082.76.76 0 01-1.082 0l-2.755-2.754-2.754 2.754a.76.76 0 01-.542.225z"
})));
export const CloseMonochromeIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  overflow: "visible"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-primary)",
  className: "primary-fill",
  d: "M25.129 24l3.629-3.6a.834.834 0 0 0 .242-.594.773.773 0 0 0-.242-.537.828.828 0 0 0-1.129 0L24 22.871l-3.6-3.629a.834.834 0 0 0-.594-.242.773.773 0 0 0-.537.242.869.869 0 0 0-.215.565.694.694 0 0 0 .242.565L22.871 24l-3.629 3.6a.834.834 0 0 0-.242.592.773.773 0 0 0 .242.537.869.869 0 0 0 .565.215.732.732 0 0 0 .565-.242L24 25.129l3.6 3.629a.774.774 0 0 0 .565.242h.027a.773.773 0 0 0 .537-.242.86.86 0 0 0 .027-1.129z",
  transform: "translate(-19 -19)"
}));
export const CloudBackupIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Cloud-backup",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.549999976158142 -0.5482296586036681 28.799000549316407 25.718230056762696"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cloud-backup"
}, " Cloud backup"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeWidth: 1.7
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  d: "M19.502 23.77a5.324 5.324 0 0 0 5.248-5.4 5.324 5.324 0 0 0-5.248-5.393 5.324 5.324 0 0 0-5.248 5.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  d: "m11.993 17.718 2.2 2.261 2.326-2.1m-8.427 1.035Q.85 19.316.85 13.352c.055-.028-.185-4.167 4.768-4.907-.013.042 1.101-7.573 7.627-7.573-.02.038 7.482-.981 8.615 7.573a6.86 6.86 0 0 1 4.989 2.565"
})));
export const CloudFailedIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Cloud-failed",
  width: 24,
  height: 17,
  viewBox: "0 0 24 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cloud-failed"
}, " Cloud failed"), /*#__PURE__*/React.createElement("path", {
  d: "M12.1801 5.7186V9.10836C12.1801 9.34484 12.0896 9.57163 11.9286 9.73885C11.7675 9.90606 11.5491 10 11.3213 10C11.0935 10 10.8751 9.90606 10.714 9.73885C10.553 9.57163 10.4625 9.34484 10.4625 9.10836V5.7186C10.4625 5.48212 10.553 5.25533 10.714 5.08811C10.8751 4.9209 11.0935 4.82696 11.3213 4.82696C11.5491 4.82696 11.7675 4.9209 11.9286 5.08811C12.0896 5.25533 12.1801 5.48212 12.1801 5.7186Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3217 11.2421C11.5604 11.2422 11.7918 11.3283 11.9762 11.4857C12.1607 11.6431 12.2869 11.862 12.3334 12.1052C12.3798 12.3484 12.3436 12.6007 12.2309 12.8193C12.1183 13.0379 11.9361 13.2091 11.7154 13.3038C11.4948 13.3986 11.2493 13.411 11.0209 13.3389C10.7924 13.2668 10.5951 13.1147 10.4625 12.9085C10.33 12.7023 10.2704 12.4548 10.2939 12.2081C10.3174 11.9614 10.4226 11.7308 10.5915 11.5556C10.6874 11.4561 10.8013 11.3772 10.9266 11.3234C11.0518 11.2696 11.1861 11.242 11.3217 11.2421Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.1378 6.88299H18.2335C19.5038 6.90074 20.716 7.41418 21.608 8.31228C22.4999 9.21038 23 10.421 23 11.6822C23 12.9435 22.4999 14.1541 21.608 15.0522C20.716 15.9503 19.5038 16.4637 18.2335 16.4815H5.79558C4.68523 16.4715 3.6121 16.0828 2.75622 15.3804C1.90033 14.6781 1.31377 13.7049 1.09493 12.6241C0.87608 11.5433 1.03826 10.4207 1.55427 9.44455C2.07028 8.46841 2.90872 7.69813 3.92894 7.26294C4.13934 5.5675 4.95542 4.00326 6.22888 2.85447C7.50234 1.70568 9.14867 1.04858 10.8687 1.00259C12.5887 0.956595 14.2683 1.52475 15.6022 2.60382C16.9361 3.68289 17.8358 5.20125 18.1378 6.88299ZM5.79558 15.2818H18.2335V15.2856C19.1816 15.2703 20.0856 14.8856 20.7507 14.2145C21.4157 13.5435 21.7884 12.6398 21.7884 11.6984C21.7884 10.757 21.4157 9.8533 20.7507 9.18224C20.0856 8.51117 19.1816 8.1265 18.2335 8.11118H17.6116C17.4603 8.11066 17.3147 8.05359 17.2039 7.95131C17.0931 7.84904 17.0252 7.70908 17.0136 7.5593C16.8569 6.08105 16.1484 4.7146 15.0277 3.72896C13.907 2.74332 12.4553 2.2099 10.9583 2.23373C9.46128 2.25756 8.02749 2.8369 6.93919 3.8577C5.85088 4.8785 5.18692 6.2668 5.07801 7.74928C5.07546 7.86854 5.03466 7.98388 4.96152 8.07852C4.88839 8.17317 4.78675 8.24218 4.67139 8.27551C3.86057 8.54786 3.17301 9.09633 2.73051 9.82377C2.28801 10.5512 2.11914 11.4107 2.25379 12.2499C2.38845 13.0891 2.81795 13.8539 3.46622 14.4089C4.11448 14.9638 4.93966 15.273 5.79558 15.2818Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1801 5.7186V9.10836C12.1801 9.34484 12.0896 9.57163 11.9286 9.73885C11.7675 9.90606 11.5491 10 11.3213 10C11.0935 10 10.8751 9.90606 10.714 9.73885C10.553 9.57163 10.4625 9.34484 10.4625 9.10836V5.7186C10.4625 5.48212 10.553 5.25533 10.714 5.08811C10.8751 4.9209 11.0935 4.82696 11.3213 4.82696C11.5491 4.82696 11.7675 4.9209 11.9286 5.08811C12.0896 5.25533 12.1801 5.48212 12.1801 5.7186Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3217 11.2421C11.5604 11.2422 11.7918 11.3283 11.9762 11.4857C12.1607 11.6431 12.2869 11.862 12.3334 12.1052C12.3798 12.3484 12.3436 12.6007 12.2309 12.8193C12.1183 13.0379 11.9361 13.2091 11.7154 13.3038C11.4948 13.3986 11.2493 13.411 11.0209 13.3389C10.7924 13.2668 10.5951 13.1147 10.4625 12.9085C10.33 12.7023 10.2704 12.4548 10.2939 12.2081C10.3174 11.9614 10.4226 11.7308 10.5915 11.5556C10.6874 11.4561 10.8013 11.3772 10.9266 11.3234C11.0518 11.2696 11.1861 11.242 11.3217 11.2421Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.1378 6.88299H18.2335C19.5038 6.90074 20.716 7.41418 21.608 8.31228C22.4999 9.21038 23 10.421 23 11.6822C23 12.9435 22.4999 14.1541 21.608 15.0522C20.716 15.9503 19.5038 16.4637 18.2335 16.4815H5.79558C4.68523 16.4715 3.6121 16.0828 2.75622 15.3804C1.90033 14.6781 1.31377 13.7049 1.09493 12.6241C0.87608 11.5433 1.03826 10.4207 1.55427 9.44455C2.07028 8.46841 2.90872 7.69813 3.92894 7.26294C4.13934 5.5675 4.95542 4.00326 6.22888 2.85447C7.50234 1.70568 9.14867 1.04858 10.8687 1.00259C12.5887 0.956595 14.2683 1.52475 15.6022 2.60382C16.9361 3.68289 17.8358 5.20125 18.1378 6.88299ZM5.79558 15.2818H18.2335V15.2856C19.1816 15.2703 20.0856 14.8856 20.7507 14.2145C21.4157 13.5435 21.7884 12.6398 21.7884 11.6984C21.7884 10.757 21.4157 9.8533 20.7507 9.18224C20.0856 8.51117 19.1816 8.1265 18.2335 8.11118H17.6116C17.4603 8.11066 17.3147 8.05359 17.2039 7.95131C17.0931 7.84904 17.0252 7.70908 17.0136 7.5593C16.8569 6.08105 16.1484 4.7146 15.0277 3.72896C13.907 2.74332 12.4553 2.2099 10.9583 2.23373C9.46128 2.25756 8.02749 2.8369 6.93919 3.8577C5.85088 4.8785 5.18692 6.2668 5.07801 7.74928C5.07546 7.86854 5.03466 7.98388 4.96152 8.07852C4.88839 8.17317 4.78675 8.24218 4.67139 8.27551C3.86057 8.54786 3.17301 9.09633 2.73051 9.82377C2.28801 10.5512 2.11914 11.4107 2.25379 12.2499C2.38845 13.0891 2.81795 13.8539 3.46622 14.4089C4.11448 14.9638 4.93966 15.273 5.79558 15.2818Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3,
  strokeLinecap: "round"
}));
export const CloudReplicationIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Cloud-replication",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.20491717755794525 0.19900000095367432 28.006528854370117 24.210100173950195"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cloud-replication"
}, " Cloud replication"), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke primary-fill",
  strokeWidth: 0.4,
  d: "M12.609.199a7.05 7.05 0 0 0-6.9 5.85 6.117 6.117 0 0 0-.229 12.145c.167.021-.114.038.229.049a.708.708 0 0 0 .388-.576c.015-.355-.26-.715-.388-.713-.341-.014-.057-.033-.222-.059a4.839 4.839 0 0 1 .758-9.607.64.64 0 0 0 .641-.584 5.781 5.781 0 0 1 5.727-5.216 5.364 5.364 0 0 1 4 1.732.631.631 0 0 0 .686.151 5.075 5.075 0 0 1 1.68-.272 4.484 4.484 0 0 1 4.455 3.937.643.643 0 0 0 .418.534 4.873 4.873 0 0 1-.752 9.293c-.2.04-.026 0-.213.021-.122 0-.4.372-.4.713a.66.66 0 0 0 .4.576c.178-.016 0 .031.2 0a6.132 6.132 0 0 0 1.554-11.62 5.769 5.769 0 0 0-5.658-4.743 6.357 6.357 0 0 0-1.75.262A6.652 6.652 0 0 0 12.609.199z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  stroke: "#fff",
  strokeWidth: 0.5,
  d: "M16.633 24.409H9.545a1.508 1.508 0 0 1-1.522-1.49v-8.531a1.507 1.507 0 0 1 1.522-1.489h1.2v-1.178a1.507 1.507 0 0 1 1.526-1.489h7.087a1.508 1.508 0 0 1 1.523 1.489v8.534a1.507 1.507 0 0 1-1.523 1.488h-1.2v1.177a1.508 1.508 0 0 1-1.525 1.489zm-6.5-9.444a.1.1 0 0 0-.095.095v7.285a.1.1 0 0 0 .095.1h5.89a.1.1 0 0 0 .095-.1v-1.006h-3.721a1.269 1.269 0 0 1-1.266-1.27v-5.1zm3.077-2.7a.088.088 0 0 0-.089.089v6.794a.09.09 0 0 0 .087.084h5.607a.09.09 0 0 0 .09-.088v-6.791a.09.09 0 0 0-.09-.089z",
  "data-name": "Fill 3"
}));
export const CloudIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Cloud",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "1.159355640411377 1.0999996662139893 29.54315757751465 18.899999618530273"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cloud"
}, " Cloud"), /*#__PURE__*/React.createElement("path", {
  d: "M14.1 1.1c-3.6 0-6.6 2.6-7.2 6.1-3.5.4-6.1 3.5-5.7 7 .3 3.2 3 5.7 6.3 5.8h14.6v-1.2l-14.6-.1c-2.8-.1-5-2.5-4.9-5.3.1-2.6 2.2-4.7 4.9-4.9.3 0 .6-.3.7-.6.3-3.1 2.9-5.5 6-5.5 1.6 0 3.1.6 4.2 1.8.2.2.5.3.7.2.6-.2 1.2-.3 1.8-.3 2.4 0 4.4 1.8 4.7 4.1 0 .3.2.5.4.6 2.6 1 3.9 4 2.9 6.6-.8 1.9-2.6 3.2-4.6 3.2l-2.1.2V20h2.1c3.5 0 6.4-3 6.3-6.5 0-2.5-1.5-4.7-3.7-5.8-.5-2.9-3-5-5.9-5-.6 0-1.2.1-1.8.3-1.5-1.2-3.2-1.9-5.1-1.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  d: "M26.8 7.8c-.5-2.9-3-5-5.9-5-.6 0-1.2.1-1.8.3-1.3-1.3-3-2-4.8-2-3.6 0-6.6 2.6-7.2 6.1-3.5.4-6.1 3.5-5.7 7 .3 3.2 3 5.7 6.3 5.8h16.7c3.5 0 6.4-3 6.3-6.5-.2-2.4-1.7-4.7-3.9-5.7zm-2.6 10.9l-2.1.2-14.6-.2c-2.8-.1-5-2.5-4.9-5.3.1-2.6 2.2-4.7 4.9-4.9.3 0 .6-.3.7-.6.3-3.1 2.9-5.5 6-5.5 1.6 0 3.1.6 4.2 1.8.2.2.5.3.7.2.6-.2 1.2-.3 1.8-.3 2.4 0 4.4 1.8 4.7 4.1 0 .3.2.5.4.6 2.6 1 3.9 4 2.9 6.6-.8 2-2.7 3.3-4.7 3.3z"
}));
export const Cluster2Icon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Cluster",
  width: 39,
  height: 34,
  viewBox: "0 0 39 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cluster"
}, " Cluster"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.4792 3.99314C29.3517 3.99314 27.6576 5.74081 27.6576 7.84923C27.6576 9.95764 29.3517 11.7053 31.4792 11.7053C33.6066 11.7053 35.3008 9.95764 35.3008 7.84923C35.3008 5.74081 33.6066 3.99314 31.4792 3.99314ZM30.4909 7.84923C30.4909 7.26745 30.9545 6.82648 31.4792 6.82648C32.0039 6.82648 32.4675 7.26745 32.4675 7.84923C32.4675 8.43101 32.0039 8.87198 31.4792 8.87198C30.9545 8.87198 30.4909 8.43101 30.4909 7.84923Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.24745 0.333008C2.35282 0.333008 0.00012207 2.6857 0.00012207 5.58033V10.1161C0.00012207 13.0107 2.35282 15.3634 5.24745 15.3634H33.6619C36.5565 15.3634 38.9092 13.0107 38.9092 10.1161V5.58033C38.9092 2.6857 36.5565 0.333008 33.6619 0.333008H5.24745ZM2.83346 5.58033C2.83346 4.25051 3.91763 3.16634 5.24745 3.16634H33.6619C34.9917 3.16634 36.0759 4.25051 36.0759 5.58033V10.1161C36.0759 11.4459 34.9917 12.5301 33.6619 12.5301H5.24745C3.91763 12.5301 2.83346 11.4459 2.83346 10.1161V5.58033Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.4792 22.4449C29.3518 22.4449 27.6576 24.1926 27.6576 26.301C27.6576 28.4094 29.3518 30.1571 31.4792 30.1571C33.6067 30.1571 35.3008 28.4094 35.3008 26.301C35.3008 24.1926 33.6067 22.4449 31.4792 22.4449ZM30.4909 26.301C30.4909 25.7192 30.9545 25.2783 31.4792 25.2783C32.004 25.2783 32.4675 25.7192 32.4675 26.301C32.4675 26.8828 32.004 27.3238 31.4792 27.3238C30.9545 27.3238 30.4909 26.8828 30.4909 26.301Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.24745 18.7865C2.35282 18.7865 0.00012207 21.1392 0.00012207 24.0338V28.5696C0.00012207 31.4642 2.35282 33.8169 5.24745 33.8169H33.6619C36.5565 33.8169 38.9092 31.4642 38.9092 28.5696V24.0338C38.9092 21.1392 36.5565 18.7865 33.6619 18.7865H5.24745ZM2.83346 24.0338C2.83346 22.704 3.91763 21.6198 5.24745 21.6198H33.6619C34.9917 21.6198 36.0759 22.704 36.0759 24.0338V28.5696C36.0759 29.8994 34.9917 30.9836 33.6619 30.9836H5.24745C3.91763 30.9836 2.83346 29.8994 2.83346 28.5696V24.0338Z",
  fill: "var(--icon-primary)"
}));
export const ClusterIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Cluster",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "3.5 5.999000072479248 17.35300064086914 12.496000289916992"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cluster"
}, " Cluster"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  d: "M4.368 6a.875.875 0 00-.868.867v3.468a.875.875 0 00.868.867h15.617a.875.875 0 00.868-.867V6.866a.875.875 0 00-.868-.867H17.6a.434.434 0 100 .868h2.386v3.469H4.368V6.867H18.23a.434.434 0 100-.868zm9.268 1.951a.651.651 0 10.651.651.658.658 0 00-.652-.651zm2.169 0a.651.651 0 10.651.651.658.658 0 00-.656-.651zm2.169 0a.651.651 0 10.651.651.658.658 0 00-.652-.651zM4.368 12.206a.875.875 0 00-.868.867v3.469a.876.876 0 00.868.868h1.3v.651a.434.434 0 10.868 0v-.651h11.28v.651a.434.434 0 10.868 0v-.651h1.3a.875.875 0 00.868-.868v-3.469a.875.875 0 00-.868-.867zm0 .867h15.617v3.469H4.368zm9.268 1.084a.651.651 0 10.651.651.658.658 0 00-.652-.652zm2.169 0a.651.651 0 10.651.651.658.658 0 00-.656-.652zm2.169 0a.651.651 0 10.651.651.658.658 0 00-.652-.652z"
}));
export const CommunitiesNoCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Communities",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Communities"
}, " Communities"), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  d: "M12.1034 2.72535L12.1328 3.20403L12.1847 3.22428L11.8718 3.82662C11.5197 4.50411 10.813 4.96409 10.0003 4.96409C9.18707 4.96409 8.48054 4.50401 8.12876 3.82657L7.81589 3.22406L7.8679 3.20379L7.89728 2.7251C7.96492 1.62295 8.88054 0.75 10.0003 0.75C11.1196 0.75 12.0359 1.62318 12.1034 2.72535ZM12.837 3.48493L12.7693 3.45538C14.6886 4.26866 16.1768 5.90244 16.7936 7.91478L16.7709 7.84357C16.1478 5.88554 14.7007 4.2975 12.837 3.48493ZM16.3417 8.76454L16.9616 8.50938L16.9753 8.55847L17.4568 8.63012C18.4716 8.78113 19.2501 9.65761 19.2501 10.714C19.2501 11.8781 18.3071 12.8211 17.1431 12.8211C17.1072 12.8211 17.0716 12.8202 17.0363 12.8185L16.5519 12.7945L16.5289 12.8395L15.9717 12.4661C15.4059 12.0869 15.036 11.4438 15.036 10.714C15.036 9.83556 15.574 9.08055 16.3417 8.76454ZM16.2093 13.4543L16.2401 13.399C15.4745 14.8012 14.2498 15.9172 12.7693 16.5445L12.837 16.515C14.269 15.8906 15.4543 14.8089 16.2093 13.4543ZM11.8718 16.1733L12.1848 16.7756L12.1328 16.7959L12.1034 17.2745C12.0357 18.3765 11.1194 19.2496 10.0003 19.2496C8.88068 19.2496 7.96509 18.3768 7.8973 17.2747L7.86786 16.7961L7.81588 16.7758L8.12875 16.1734C8.48063 15.4958 9.18725 15.0355 10.0003 15.0355C10.8128 15.0355 11.5197 15.4957 11.8718 16.1733ZM7.16347 16.5152L7.23107 16.5447C5.75047 15.9174 4.52561 14.8015 3.75992 13.3992L3.79075 13.4545C4.54589 14.8092 5.73128 15.8909 7.16347 16.5152ZM4.0284 12.4662L3.47111 12.8396L3.44813 12.7946L2.9638 12.8185C2.92866 12.8202 2.89325 12.8211 2.85759 12.8211C1.69351 12.8211 0.750488 11.8781 0.750488 10.714C0.750488 9.65785 1.5287 8.78146 2.5433 8.63021L3.02468 8.55844L3.03836 8.50929L3.65831 8.76443C4.42623 9.08046 4.96469 9.83568 4.96469 10.714C4.96469 11.4436 4.59453 12.0869 4.0284 12.4662ZM3.22906 7.84342L3.20633 7.91485C3.82324 5.90223 5.31167 4.26825 7.2314 3.45506L7.16346 3.48468C5.29957 4.29716 3.85224 5.88527 3.22906 7.84342Z",
  stroke: "#838383",
  strokeWidth: 1.5
}));
export const CommunitiesIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Communities",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Communities"
}, " Communities"), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 1.5,
  d: "M18.103 8.725l.03.48.052.02-.313.602a2.107 2.107 0 01-3.743 0l-.313-.603.052-.02.03-.479a2.107 2.107 0 014.205 0zm.734.76l-.068-.03a7.126 7.126 0 014.025 4.46l-.023-.071a7.122 7.122 0 00-3.934-4.359zm3.505 5.28l.62-.256.013.05.482.071a2.108 2.108 0 01-.42 4.189l-.485-.024-.023.045-.557-.374a2.108 2.108 0 01.37-3.702zm-.133 4.69l.031-.056a7.135 7.135 0 01-3.47 3.146l.067-.03a7.13 7.13 0 003.372-3.06zm-4.337 2.718l.313.603-.052.02-.03.479a2.107 2.107 0 01-4.206 0l-.03-.479-.051-.02.313-.602a2.107 2.107 0 013.743 0zm-4.708.342l.067.03a7.135 7.135 0 01-3.471-3.146l.03.056a7.13 7.13 0 003.374 3.06zm-3.136-4.049l-.557.374-.023-.045-.484.024-.106.002a2.107 2.107 0 01-.315-4.19l.482-.072.013-.05.62.255a2.109 2.109 0 01.37 3.702zm-.799-4.623l-.023.072a7.126 7.126 0 014.025-4.46l-.067.03a7.123 7.123 0 00-3.935 4.359z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 2,
  d: "M31 16c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15z"
}));
export const ConnectIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Connect",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "4.471852779388428 4.524240493774414 15.50390625 15.50390625"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Connect"
}, " Connect"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  d: "M10.751 18.929a3.663 3.663 0 11-5.18-5.18l2.726-2.726a3.668 3.668 0 015.18 0 .578.578 0 11-.818.818 2.488 2.488 0 00-3.544 0l-2.726 2.726a2.506 2.506 0 003.544 3.544l2.726-2.726a.578.578 0 11.818.818l-2.726 2.726zm5.452-5.452a3.668 3.668 0 01-5.18 0 .578.578 0 11.818-.818 2.488 2.488 0 003.544 0l2.726-2.726a2.506 2.506 0 00-3.544-3.544l-2.726 2.726a.578.578 0 11-.818-.818l2.726-2.726a3.663 3.663 0 015.18 5.18z"
}));
export const ConnectorNoCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Connector",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.34580814838409424 0.3500000238418579 55.00518798828125 28.363000869750977"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Connector"
}, " Connector"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#006dc9",
  stroke: "#006dc9",
  strokeWidth: 0.5,
  d: "M29.985 5.819h-1.146a.6.6 0 0 0-.637.636V7.6a.6.6 0 0 0 .637.636h1.146a.6.6 0 0 0 .637-.636V6.455c-.128-.381-.382-.636-.637-.636z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#006dc9",
  stroke: "#006dc9",
  strokeWidth: 0.5,
  d: "M34.774 5.819h-1.271a.6.6 0 0 0-.637.636V7.6a.6.6 0 0 0 .637.636h1.273a.6.6 0 0 0 .637-.636V6.455c-.129-.381-.384-.636-.639-.636zm4.789 0h-1.146a.6.6 0 0 0-.637.636V7.6a.6.6 0 0 0 .637.636h1.146a.6.6 0 0 0 .64-.636V6.455c-.131-.381-.385-.636-.64-.636z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#006dc9",
  stroke: "#006dc9",
  strokeWidth: 0.7,
  d: "m55.223 6.455-3.565-3.821a.775.775 0 0 0-1.019 0 .773.773 0 0 0 0 1.018l2.546 2.671h-8.53V2.257A1.957 1.957 0 0 0 42.746.35H13.463a1.957 1.957 0 0 0-1.91 1.908v9.285a1.957 1.957 0 0 0 1.91 1.908h29.283a1.957 1.957 0 0 0 1.91-1.908V7.599h8.53L50.64 10.27a.773.773 0 0 0 0 1.018c.255.254.764.127 1.019 0l3.565-3.816c.127-.127.127-.254.127-.509s-.001-.381-.128-.508zm-12.477 5.723H13.463a.6.6 0 0 1-.637-.636V2.257a.6.6 0 0 1 .637-.636h29.283a.6.6 0 0 1 .637.636v9.156c-.001.511-.255.765-.637.765z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#006dc9",
  stroke: "#006dc9",
  strokeWidth: 0.5,
  d: "M29.985 21.209h-1.146a.6.6 0 0 0-.637.636v1.145a.6.6 0 0 0 .637.636h1.146a.6.6 0 0 0 .637-.636v-1.145c-.128-.382-.382-.636-.637-.636zm4.789 0h-1.271a.6.6 0 0 0-.637.636v1.145a.6.6 0 0 0 .637.636h1.273a.6.6 0 0 0 .637-.636v-1.145c-.129-.382-.384-.636-.639-.636zm4.789 0h-1.146a.6.6 0 0 0-.637.636v1.145a.6.6 0 0 0 .637.636h1.146a.6.6 0 0 0 .64-.637v-1.144c-.131-.382-.385-.636-.64-.636z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#006dc9",
  stroke: "#006dc9",
  strokeWidth: 0.7,
  d: "M42.75 15.74H13.463a1.957 1.957 0 0 0-1.913 1.912v3.943H2.514l2.546-2.671a.773.773 0 0 0 0-1.018c-.255-.254-.764-.127-1.019 0L.477 21.718a.764.764 0 0 0-.127.508c0 .127.127.382.127.509l3.565 3.817a.775.775 0 0 0 1.019 0 .773.773 0 0 0 0-1.018l-2.547-2.672h9.036v3.943a1.957 1.957 0 0 0 1.91 1.908h29.29a1.957 1.957 0 0 0 1.91-1.908v-9.153a1.874 1.874 0 0 0-1.91-1.912zm.637 11.193a.6.6 0 0 1-.637.636H13.463a.6.6 0 0 1-.637-.636v-9.281a.6.6 0 0 1 .637-.636H42.75a.6.6 0 0 1 .637.636z"
}));
export const ConnectorIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Connector",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 62 62"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Connector"
}, " Connector"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  className: "primary-stroke",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 30,
  cy: 29.97,
  strokeWidth: 2,
  rx: 30,
  ry: 29.97
}), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fillRule: "nonzero",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.21 4.883h-.937c-.312 0-.52.208-.52.52v.935c0 .312.208.52.52.52h.937c.312 0 .52-.208.52-.52v-.935c-.104-.312-.312-.52-.52-.52zM29.122 4.883h-1.04c-.312 0-.52.208-.52.52v.935c0 .312.208.52.52.52h1.04c.312 0 .52-.208.52-.52v-.935c-.104-.312-.312-.52-.52-.52zM32.034 4.883h-.936c-.312 0-.52.208-.52.52v.935c0 .312.208.52.52.52h.936c.312 0 .52-.208.52-.52v-.935c-.104-.312-.312-.52-.52-.52z",
  transform: "translate(8 17.982)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.827 5.403l-2.913-3.117c-.208-.208-.624-.208-.832 0-.208.208-.208.623 0 .831l2.08 2.182h-6.968V1.974c0-.831-.728-1.558-1.56-1.558H10.713c-.832 0-1.56.727-1.56 1.558V9.56c0 .831.728 1.559 1.56 1.559h23.921c.832 0 1.56-.728 1.56-1.559V6.338h6.969l-2.08 2.182c-.209.208-.209.623 0 .831.207.208.623.104.831 0l2.913-3.117c.104-.104.104-.208.104-.415 0-.208 0-.312-.104-.416zm-10.193 4.676H10.713c-.312 0-.52-.208-.52-.52V1.974c0-.312.208-.52.52-.52h23.921c.312 0 .52.208.52.52v3.74s0 0 0 0 0 0 0 0v3.741c0 .416-.208.624-.52.624zM26.21 17.456h-.937c-.312 0-.52.207-.52.52v.934c0 .312.208.52.52.52h.937c.312 0 .52-.208.52-.52v-.935c-.104-.312-.312-.52-.52-.52zM29.122 17.456h-1.04c-.312 0-.52.207-.52.52v.934c0 .312.208.52.52.52h1.04c.312 0 .52-.208.52-.52v-.935c-.104-.312-.312-.52-.52-.52zM32.034 17.456h-.936c-.312 0-.52.207-.52.52v.934c0 .312.208.52.52.52h.936c.312 0 .52-.208.52-.52v-.935c-.104-.312-.312-.52-.52-.52z",
  transform: "translate(8 17.982)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.634 12.988H10.713c-.832 0-1.56.727-1.56 1.558v3.221H1.768l2.08-2.182c.208-.207.208-.623 0-.83-.208-.209-.624-.105-.832 0L.104 17.87C0 17.975 0 18.183 0 18.287c0 .104.104.312.104.415l2.912 3.117c.208.208.624.208.832 0 .208-.207.208-.623 0-.83l-2.08-2.183h7.385v3.221c0 .831.728 1.559 1.56 1.559h23.921c.832 0 1.56-.728 1.56-1.559v-7.48c0-.936-.728-1.56-1.56-1.56zm.52 9.143c0 .312-.208.52-.52.52H10.713c-.312 0-.52-.208-.52-.52v-7.585c0-.311.208-.52.52-.52h23.921c.312 0 .52.209.52.52v7.585z",
  transform: "translate(8 17.982)"
}))));
export const CostIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Cost",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "8.196030616760254 4.496500015258789 7.660719871520996 15.996725082397461"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cost"
}, " Cost"), /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-primary)",
  strokeWidth: 0.5,
  d: "M15.848 14.82a3.679 3.679 0 01-.963 2.56 3.124 3.124 0 01-1.8.931v.926a1.255 1.255 0 11-2.51 0v-1.022a3.477 3.477 0 01-2.349-2.714.983.983 0 01.837-1.217.956.956 0 011.037.646 2.436 2.436 0 00.476.88 1.812 1.812 0 001.444.611 2.169 2.169 0 001.083-.246 1.553 1.553 0 00.3-.211 1.421 1.421 0 00.5-.943 1.336 1.336 0 00-.16-.869 1.29 1.29 0 00-.533-.457l-.1-.051c-.281-.12-.831-.3-1.65-.571a10.51 10.51 0 01-.882-.309 4.023 4.023 0 01-.928-.5 3.106 3.106 0 01-.917-1.143 3.587 3.587 0 01-.338-1.537A3.372 3.372 0 018.83 7.87a2.756 2.756 0 011.2-1.143 3.111 3.111 0 01.544-.217v-.747a1.266 1.266 0 012.533 0v.709a3.176 3.176 0 011.462.778 3.125 3.125 0 01.831 1.451.988.988 0 01-.894 1.223h-.069a.946.946 0 01-.968-.634 1.5 1.5 0 00-.367-.611h-.029a1.776 1.776 0 00-1.2-.371 1.95 1.95 0 00-1.209.326.651.651 0 00-.092.08.946.946 0 00-.332.731 1.022 1.022 0 00.332.754l.052.046a5.435 5.435 0 001.771.714c.258.074.493.149.711.229a5.42 5.42 0 011.4.663 3 3 0 011 1.2 4.229 4.229 0 01.35 1.766z"
}));
export const CreateCopyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Create-copy",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.4500000476837158 0.4500000476837158 15.52500057220459 15.5260009765625"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Create-copy"
}, " Create copy"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M14.271.95H5.306A1.207 1.207 0 004.1 2.156V4.1H2.157A1.207 1.207 0 00.95 5.306v8.964a1.207 1.207 0 001.206 1.206h8.964a1.207 1.207 0 001.206-1.206v-1.943h1.943a1.207 1.207 0 001.206-1.206V2.156A1.207 1.207 0 0014.271.95zm-2.892 13.32a.258.258 0 01-.258.258H2.157a.258.258 0 01-.258-.258V5.306a.258.258 0 01.258-.258h8.964a.258.258 0 01.258.258zm3.15-3.15a.258.258 0 01-.258.258h-1.944V5.306A1.207 1.207 0 0011.121 4.1H5.05V2.156a.258.258 0 01.258-.258h8.964a.258.258 0 01.258.258z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.7,
  d: "M6.984 10.013l2.045.007a.333.333 0 00.239-.097.309.309 0 00.08-.222.331.331 0 00-.319-.319l-2.042-.007.005-2.042a.333.333 0 00-.097-.238.309.309 0 00-.222-.08.347.347 0 00-.218.095.277.277 0 00-.09.23l-.018 2.035-2.04-.006a.333.333 0 00-.238.096.309.309 0 00-.081.223.347.347 0 00.099.22.293.293 0 00.23.09l2.033.015-.01 2.043a.309.309 0 00.09.23l.007.008a.309.309 0 00.223.081.344.344 0 00.327-.312z"
}));
export const CreateSnapshotIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Create-snapshot",
  width: "27px",
  height: "27px",
  viewBox: "0 0 27 27",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Create-snapshot"
}, " Create snapshot"), /*#__PURE__*/React.createElement("title", null, "create-snapshot-ic"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-4.2%",
  y: "-9.3%",
  width: "109.0%",
  height: "120.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  x: "-2.7%",
  y: "-5.9%",
  width: "106.0%",
  height: "113.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "047---CVS-AWS",
  transform: "translate(-355.000000, -564.000000)",
  className: "primary-stroke"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add-Volume-+-search",
  transform: "translate(320.000000, 373.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "vol-min",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Storage-Overview",
  filter: "url(#filter-2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "create-snapshot-ic",
  transform: "translate(36.000000, 192.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "create-snapshot-ic-(1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.744,17.78 C6.784,17.78 6,16.997 6,16.037 L6,10.329 C6,9.369 6.783,8.585 7.744,8.585 L9.434,8.585 L9.988,7.203 C10.0346362,7.08196682 10.1503021,7.00155523 10.28,7 L14.72,7 C14.85,7.001 14.965,7.082 15.012,7.203 L15.567,8.585 L17.257,8.585 C18.217,8.585 19,9.369 19,10.329 L19,16.037 C19,16.997 18.217,17.78 17.256,17.78 L7.744,17.78 L7.744,17.78 Z M7.744,17.146 L17.256,17.146 C17.5512086,17.1486961 17.8351106,17.032616 18.0438633,16.8238633 C18.252616,16.6151106 18.3686961,16.3312086 18.3660459,16.036 L18.3660459,10.33 C18.3686961,10.0347914 18.252616,9.75088936 18.0438633,9.54213667 C17.8351106,9.33338397 17.5512086,9.21730386 17.256,9.22 L15.354,9.22 C15.2251736,9.2196681 15.1093604,9.14140527 15.061,9.022 L14.506,7.635 L10.494,7.635 L9.939,9.022 C9.89095481,9.14179789 9.77507218,9.22050315 9.646,9.221 L7.744,9.221 C7.44879142,9.21830386 7.16488936,9.33438397 6.95613667,9.54313667 C6.74738397,9.75188936 6.63130386,10.0357914 6.63395406,10.331 L6.63395406,16.038 C6.63395406,16.658 7.124,17.148 7.744,17.148 L7.744,17.146 Z M12.5,16.196 C10.8372702,16.1932459 9.4902022,14.8457306 9.488,13.183 C9.4902022,11.5202694 10.8372702,10.1727541 12.5,10.17 C14.1623401,10.1727527 15.5092473,11.5196599 15.512,13.182 C15.5092473,14.8443401 14.1623401,16.1912473 12.5,16.194 L12.5,16.196 Z M12.5,15.5610053 C13.1310919,15.5623311 13.7367193,15.3122201 14.1829697,14.8659697 C14.6292201,14.4197193 14.8793311,13.8140919 14.8780053,13.183 C14.8793311,12.5519081 14.6292201,11.9462807 14.1829697,11.5000303 C13.7367193,11.0537799 13.1310919,10.8036689 12.5,10.8049947 C11.8689081,10.8036689 11.2632807,11.0537799 10.8170303,11.5000303 C10.3707799,11.9462807 10.1206689,12.5519081 10.1219947,13.183 C10.1209351,13.8139188 10.3711637,14.4192887 10.8173851,14.8653225 C11.2636066,15.3113563 11.8690817,15.5613303 12.5,15.56 L12.5,15.5610053 Z",
  id: "Shape",
  strokeWidth: 0.5,
  className: "primary-fill",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeWidth: 1.07,
  cx: 12.5,
  cy: 12.5,
  r: 12.5
})))))))));
export const DashboardIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Dashboard",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "3.7 4.198997211456299 16.18109474182129 16.18000373840332"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Dashboard"
}, " Dashboard"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  d: "M18.863 19.579H4.715a.215.215 0 01-.215-.215V5.213a.214.214 0 01.215-.214h14.15a.214.214 0 01.215.214v14.151a.212.212 0 010 .043.215.215 0 01-.21.171zm-.215-.432v-9.1H11.7v9.1zm-13.717 0h6.336V5.43H4.931zM11.7 9.613h6.952V5.43H11.7z"
}));
export const DeleteSnapshotIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Delete-snapshot",
  width: "27px",
  height: "27px",
  viewBox: "0 0 27 27",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Delete-snapshot"
}, " Delete snapshot"), /*#__PURE__*/React.createElement("title", null, "delete-snapshot-ic"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-4.2%",
  y: "-9.3%",
  width: "109.0%",
  height: "120.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "047---CVS-AWS",
  transform: "translate(-645.000000, -564.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add-Volume-+-search",
  transform: "translate(316.000000, 371.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "vol-min",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "delete-snapshot-ic",
  transform: "translate(330.000000, 194.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "create-snapshot-ic-(1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.744,17.78 C6.784,17.78 6,16.997 6,16.037 L6,10.329 C6,9.369 6.783,8.585 7.744,8.585 L9.434,8.585 L9.988,7.203 C10.0346362,7.08196682 10.1503021,7.00155523 10.28,7 L14.72,7 C14.85,7.001 14.965,7.082 15.012,7.203 L15.567,8.585 L17.257,8.585 C18.217,8.585 19,9.369 19,10.329 L19,16.037 C19,16.997 18.217,17.78 17.256,17.78 L7.744,17.78 L7.744,17.78 Z M7.744,17.146 L17.256,17.146 C17.5512086,17.1486961 17.8351106,17.032616 18.0438633,16.8238633 C18.252616,16.6151106 18.3686961,16.3312086 18.3660459,16.036 L18.3660459,10.33 C18.3686961,10.0347914 18.252616,9.75088936 18.0438633,9.54213667 C17.8351106,9.33338397 17.5512086,9.21730386 17.256,9.22 L15.354,9.22 C15.2251736,9.2196681 15.1093604,9.14140527 15.061,9.022 L14.506,7.635 L10.494,7.635 L9.939,9.022 C9.89095481,9.14179789 9.77507218,9.22050315 9.646,9.221 L7.744,9.221 C7.44879142,9.21830386 7.16488936,9.33438397 6.95613667,9.54313667 C6.74738397,9.75188936 6.63130386,10.0357914 6.63395406,10.331 L6.63395406,16.038 C6.63395406,16.658 7.124,17.148 7.744,17.148 L7.744,17.146 Z M12.5,16.196 C10.8372702,16.1932459 9.4902022,14.8457306 9.488,13.183 C9.4902022,11.5202694 10.8372702,10.1727541 12.5,10.17 C14.1623401,10.1727527 15.5092473,11.5196599 15.512,13.182 C15.5092473,14.8443401 14.1623401,16.1912473 12.5,16.194 L12.5,16.196 Z M12.5,15.5610053 C13.1310919,15.5623311 13.7367193,15.3122201 14.1829697,14.8659697 C14.6292201,14.4197193 14.8793311,13.8140919 14.8780053,13.183 C14.8793311,12.5519081 14.6292201,11.9462807 14.1829697,11.5000303 C13.7367193,11.0537799 13.1310919,10.8036689 12.5,10.8049947 C11.8689081,10.8036689 11.2632807,11.0537799 10.8170303,11.5000303 C10.3707799,11.9462807 10.1206689,12.5519081 10.1219947,13.183 C10.1209351,13.8139188 10.3711637,14.4192887 10.8173851,14.8653225 C11.2636066,15.3113563 11.8690817,15.5613303 12.5,15.56 L12.5,15.5610053 Z",
  id: "Shape",
  className: "primary-stroke primary-fill",
  strokeWidth: 0.5,
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  className: "primary-stroke",
  strokeWidth: 1.07,
  cx: 12.5,
  cy: 12.5,
  r: 12.5
}), /*#__PURE__*/React.createElement("g", {
  id: "cancel",
  transform: "translate(5.000000, 5.000000)",
  className: "primary-fill"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_cancel_152969"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fillRule: "nonzero",
  points: "14.1123333 0.0386666667 7.4 6.75066667 0.687666667 0.0386666667 0.0376666667 0.688666667 6.74966667 7.401 0.0376666667 14.113 0.687666667 14.7633333 7.4 8.051 14.1123333 14.7633333 14.7626667 14.113 8.05033333 7.401 14.7626667 0.688666667"
}))))))))));
export const DeleteVolumeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Delete-volume",
  width: "27px",
  height: "27px",
  viewBox: "0 0 27 27",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Delete-volume"
}, " Delete volume"), /*#__PURE__*/React.createElement("title", null, "Delete"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-4.2%",
  y: "-9.3%",
  width: "109.0%",
  height: "120.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "047---CVS-AWS",
  transform: "translate(-753.000000, -405.000000)",
  className: "primary-stroke"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add-Volume-+-search",
  transform: "translate(320.000000, 373.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "vol-min",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Delete",
  transform: "translate(434.000000, 33.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeWidth: 1.07,
  cx: 12.5,
  cy: 12.5,
  r: 12.5
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_Delete_1534868",
  transform: "translate(7.000000, 6.000000)",
  fillRule: "nonzero",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.01538462,1.81538462 L8.01538462,0.0769230769 L3.81538462,0.0769230769 L3.81538462,1.81538462 L0.0615384615,1.81538462 L0.0615384615,2.44615385 L1.16923077,2.44615385 L1.96923077,12.8615385 L9.87692308,12.8615385 L10.6769231,2.44615385 L11.9538462,2.44615385 L11.9538462,1.81538462 C11.9538462,1.81538462 8.01538462,1.81538462 8.01538462,1.81538462 Z M7.4,0.692307692 L7.4,1.8 L4.44615385,1.8 L4.44615385,0.692307692 C4.44615385,0.692307692 7.4,0.692307692 7.4,0.692307692 Z M10.0461538,2.41538462 L9.29230769,12.2 L2.53846154,12.2 L1.8,2.41538462 C1.8,2.41538462 10.0461538,2.41538462 10.0461538,2.41538462 Z",
  id: "Shape"
}))))))))));
export const DeleteIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Delete",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.5244618892669678 0.15000000000000002 17.063075256347656 17.7"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Delete"
}, " Delete"), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--icon-primary)",
  fill: "var(--icon-primary)",
  className: "primary-fill primary-stroke",
  strokeWidth: 0.6,
  d: "M5.19 17.25a1.573 1.573 0 01-1.538-1.521l-.7-11.545H1.564a.461.461 0 010-.921h4.021v-.9A1.568 1.568 0 017.125.75h3.865a1.567 1.567 0 011.535 1.614v.9h4.023a.461.461 0 010 .921h-1.383l-.7 11.545a1.576 1.576 0 01-1.54 1.52zm-.66-1.566a.666.666 0 00.659.644h7.736a.666.666 0 00.66-.644l.7-11.5H3.825zm1.934-13.32v.9h5.186v-.9a.664.664 0 00-.66-.692H7.125a.664.664 0 00-.661.692zm3.955 11.015V7.134a.44.44 0 11.878 0v6.245a.44.44 0 11-.878 0zm-3.6 0V7.134a.44.44 0 11.878 0v6.245a.439.439 0 11-.878 0z"
}));
export const DocumentBackupIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Backup",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30.33333396911621 34.859375"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Backup"
}, "Backup"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M29.8 24.4c-.6-1.7-1.8-3.1-3.3-4V.7c-.1-.4-.4-.7-.7-.7H.7C.5 0 .4.1.2.2.1.3 0 .5 0 .7v30.6c0 .4.3.7.7.7h15.7c.7.9 1.7 1.6 2.7 2.1 1.9.9 4 1 6 .3l.6-.3c1.7-.8 3-2.1 3.8-3.8 1-1.9 1.1-4 .3-5.9zM14.7 1.3h5.8v8.3l-2.4-2.1c-.2-.2-.6-.2-.8 0l-2.6 2.1V1.3zm13.6 27.9c-1.2 3.2-4.8 4.9-8 3.6-1.7-.6-3-2-3.6-3.7-.2-.4-.6-.6-1-.5-.2.1-.4.2-.5.4s-.1.4 0 .6c.1.3.2.6.4.9H1.3V1.3h11.9v9.8c0 .2.1.3.2.5.1.1.3.2.5.2.1 0 .3-.1.4-.1L17.6 9l3.1 2.6c.3.2.7.2.9-.1.1-.1.2-.3.2-.4V1.3h3.3L25 19.6c-3.2-1.2-6.8-.1-8.8 2.5l-.4-1.3c-.1-.2-.3-.5-.5-.6-.2 0-.3-.1-.5 0-.4.1-.7.6-.5 1l.8 2.9c.1.4.5.6.8.6l3-.1c.4 0 .8-.4.8-.8s-.4-.8-.8-.8l-1.5.1c.9-1.1 2.1-1.9 3.6-2.2 1.6-.4 3.3-.1 4.7.9 2.6 1.6 3.6 4.6 2.6 7.4zm-3-9.4s0-.1 0 0c0-.1 0-.1 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M3.3 16.6h17.5c.4 0 .7-.2.8-.6-.1-.4-.5-.6-.8-.6H3.3c-.5 0-.8.3-.8.7.1.2.4.5.8.5zm7.9 3.4h-8c-.4 0-.7.3-.7.7.1.4.4.6.7.6h8.1c.4 0 .7-.3.7-.7-.1-.3-.2-.5-.3-.6h-.5zm0 4.7h-8c-.4 0-.7.3-.7.7.1.3.3.6.7.6h8.1c.4 0 .7-.3.7-.7-.1-.3-.2-.5-.3-.6-.3-.1-.4-.1-.5 0z"
}));
export const DocumentByolIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "License",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26.500001907348633 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "License"
}, "License"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M25.8 0H.7C.5 0 .4.1.2.2.1.3 0 .5 0 .7v30.6c0 .4.3.7.7.7h25.1c.4 0 .7-.3.7-.7V.7c0-.3-.3-.6-.7-.7zM14.7 1.3h5.8v8.3l-2.4-2.1c-.2-.2-.6-.2-.8 0l-2.6 2.1V1.3zm10.4 29.3H1.3V1.3h11.9v9.8c0 .2.1.3.2.5.1.1.3.2.5.2.1 0 .3-.1.4-.1L17.6 9l3.1 2.6c.3.2.7.2.9-.1.1-.1.2-.3.2-.4V1.3h3.3v29.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M4.3 15.3c-.5 0-.8.3-.8.7.1.4.4.6.8.6h17.5c.4 0 .7-.2.8-.6-.1-.4-.5-.6-.8-.6H4.3zm0 6h17.5c.5 0 .8-.3.8-.7-.1-.3-.2-.5-.4-.6H4.3c-.5 0-.8.3-.8.7.1.4.4.6.8.6zm17.4 3.4H4.3c-.5 0-.8.3-.8.7.1.3.4.6.8.6h17.5c.5 0 .8-.3.8-.6-.2-.5-.5-.7-.9-.7z"
}));
export const DocumentDollarIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Pay-as-you-go",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 35.099998474121094"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Pay-as-you-go"
}, "Pay as you go"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M26.1 27.5c-.1-.3-.3-.5-.5-.7-.2-.2-.5-.3-.8-.4-.1 0-.2-.1-.4-.1-.3-.1-.7-.2-1-.4-.1-.1-.2-.3-.2-.4 0-.2.1-.3.2-.4.2-.1.4-.2.7-.2.2 0 .5.1.7.2.1.1.2.2.2.3.1.2.3.4.5.3h.1c.3-.1.5-.4.4-.7-.1-.3-.2-.6-.5-.8-.2-.2-.5-.4-.8-.4v-.4c0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7v.6c-.1 0-.2.1-.3.1-.3.1-.5.4-.7.6-.2.3-.2.6-.2.9 0 .3.1.6.2.8.1.2.3.5.5.6.2.1.3.2.5.3.1.1.3.1.5.2.4.1.7.2.9.3h.1c.1.1.2.1.3.2.1.1.1.3.1.5s-.1.4-.3.5c0 0-.1.1-.2.1-.2.1-.4.1-.6.1-.3 0-.6-.1-.8-.3-.1-.1-.2-.3-.3-.5-.1-.2-.3-.4-.6-.4h-.1c-.3.1-.5.4-.4.7.1.7.6 1.3 1.3 1.5v.6c0 .4.3.7.7.7.4 0 .7-.3.7-.7v-.5c.4-.1.7-.2 1-.5.3-.4.5-.9.5-1.4.2-.2.1-.6 0-.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M26.5 20V.7c-.1-.4-.3-.7-.7-.7H.7C.5 0 .4.1.2.2.1.3 0 .5 0 .7v30.6c0 .4.3.7.7.7H18c1.4 1.9 3.7 3.1 6.2 3.1 4.3 0 7.8-3.5 7.8-7.8 0-3.4-2.3-6.3-5.5-7.3zM14.7 1.3h5.8v8.3l-2.4-2.1c-.2-.2-.6-.2-.8 0l-2.6 2.1V1.3zM1.3 30.6V1.3h11.9v9.8c0 .2.1.3.2.5.1.1.3.2.5.2.1 0 .3-.1.4-.1L17.6 9l3.1 2.6c.3.2.7.2.9-.1.1-.1.2-.3.2-.4V1.3h3.3L25 19.6c-.3 0-.6-.1-.9-.1-4.3 0-7.8 3.5-7.8 7.8 0 1.1.3 2.2.7 3.2H1.3zm16.3.7zm6.7 2.3c-3.4 0-6.2-2.8-6.2-6.2 0-3.4 2.8-6.2 6.2-6.2s6.2 2.8 6.2 6.2c0 3.4-2.8 6.2-6.2 6.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M14.2 24.7h-10c-.4 0-.7.3-.7.7.1.3.3.6.7.6h10.1c.4 0 .7-.3.7-.7-.1-.3-.2-.5-.3-.6-.3-.1-.4-.1-.5 0zm-9.9-8.1h17.5c.4 0 .7-.2.8-.6-.1-.4-.5-.6-.8-.6H4.3c-.5 0-.8.3-.8.7.1.2.4.5.8.5zm9.9 3.4h-10c-.4 0-.7.3-.7.7.1.4.4.6.7.6h10.1c.4 0 .7-.3.7-.7-.1-.3-.2-.5-.3-.6h-.5z"
}));
export const DocumentMinusIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Remove",
  xmlns: "http://www.w3.org/2000/svg",
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 32 35.099998474121094",
  xmlSpace: "preserve"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Remove"
}, "Remove"), /*#__PURE__*/React.createElement("style", null, ".st0{fill-rule:evenodd;clip-rule:evenodd;}"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M26.5 20V.7c-.1-.4-.3-.7-.7-.7H.7C.5 0 .4.1.2.2.1.3 0 .5 0 .7v30.6c0 .4.3.7.7.7H18c1.4 1.9 3.7 3.1 6.2 3.1 4.3 0 7.8-3.5 7.8-7.8 0-3.4-2.3-6.3-5.5-7.3zM14.7 1.3h5.8v8.3l-2.4-2.1c-.2-.2-.6-.2-.8 0l-2.6 2.1V1.3zM1.3 30.6V1.3h11.9v9.8c0 .2.1.3.2.5.1.1.3.2.5.2.1 0 .3-.1.4-.1L17.6 9l3.1 2.6c.3.2.7.2.9-.1.1-.1.2-.3.2-.4V1.3h3.3L25 19.6c-.3 0-.6-.1-.9-.1-4.3 0-7.8 3.5-7.8 7.8 0 1.1.3 2.2.7 3.2H1.3zm16.3.7zm6.7 2.3c-3.4 0-6.2-2.8-6.2-6.2s2.8-6.2 6.2-6.2c3.4 0 6.2 2.8 6.2 6.2s-2.8 6.2-6.2 6.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M4.3 16.6h17.5c.4 0 .7-.2.8-.6-.1-.4-.5-.6-.8-.6H4.3c-.5 0-.8.3-.8.7.1.2.4.5.8.5zm9.9 3.4h-10c-.4 0-.7.3-.7.7.1.4.4.6.7.6h10.1c.4 0 .7-.3.7-.7-.1-.3-.2-.5-.3-.6h-.5zm13.3 6.7c-.2-.1-.4-.1-.6-.1h-5.5c-.3 0-.5.1-.7.3-.2.2-.2.4-.2.6v.1c.1.4.5.7.9.7H27c.3 0 .5-.1.7-.3.2-.2.2-.4.2-.6v-.1c-.1-.3-.2-.5-.4-.6zm-13.3-2h-10c-.4 0-.7.3-.7.7.1.3.3.6.7.6h10.1c.4 0 .7-.3.7-.7-.1-.3-.2-.5-.3-.6-.3-.1-.4-.1-.5 0z"
}));
export const DocumentSearchIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Search",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0.40000003576278687 34.51546859741211 37.499996185302734"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Search"
}, "Search"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M22.5 16.3c-.1-.4-.5-.7-.8-.7H4.3c-.5 0-.8.3-.8.7.1.4.4.6.8.6h17.5c.3 0 .6-.2.7-.6zm-7.9 4.1c-.1-.1-.3-.1-.4 0h-10c-.4 0-.7.3-.7.7.1.4.4.6.7.6h10.1c.4 0 .7-.3.7-.7-.1-.3-.3-.5-.4-.6zm-.4 4.6h-10c-.4 0-.7.3-.7.7.1.4.4.6.7.6h10.1c.4 0 .7-.3.7-.7-.1-.3-.2-.5-.3-.6h-.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M34.4 36.5l-4-4 .2-.2c1-1.3 1.5-3 1.5-4.6 0-2.1-.8-4-2.3-5.5-.9-.9-2-1.6-3.2-1.9V1.1c-.1-.4-.3-.7-.7-.7H.7C.5.4.4.5.2.6c-.1.1-.2.3-.2.5v30.6c0 .4.3.7.7.7H18c-.3-.4-.6-.9-.9-1.4H1.3V1.7h11.9v9.8c0 .2.1.3.2.5.1.1.3.2.5.2.1 0 .3-.1.4-.1l3.3-2.7 3.1 2.6c.3.2.7.2.9-.1.1-.1.2-.3.2-.4V1.7h3.3V20c-.3 0-.6-.1-.9-.1-2.1 0-4 .8-5.5 2.3-1.5 1.5-2.3 3.4-2.3 5.5s.8 4 2.3 5.5c1.5 1.5 3.4 2.2 5.5 2.2 1.7 0 3.2-.5 4.6-1.5l.2-.2 3.9 3.9c.2.2.4.3.6.3.2 0 .5-.1.6-.2.2-.2.3-.4.3-.7.2-.1.1-.3 0-.5zM20.5 10l-2.4-2.1c-.2-.2-.6-.2-.8 0L14.7 10V1.7h5.8V10zm8 21.9c-1.1 1.1-2.6 1.8-4.2 1.8-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6c0 1.6-.7 3.1-1.8 4.2z"
}));
export const DocumentTimeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Free-trial",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 35.099998474121094"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Free-trial"
}, "Free trial"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M25 26.4v-2.7c0-.4-.3-.7-.7-.7H24c-.3.1-.5.4-.5.7v3c0 .2.1.4.2.5l1.3 1.3.4.4c.1.1.3.2.5.2s.3-.1.5-.2c.1-.1.2-.3.2-.5s-.1-.4-.2-.5L25 26.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M26.5 20V.7c-.1-.4-.3-.7-.7-.7H.7C.5 0 .4.1.2.2.1.3 0 .5 0 .7v30.6c0 .4.3.7.7.7H18c1.4 1.9 3.7 3.1 6.2 3.1 4.3 0 7.8-3.5 7.8-7.8 0-3.4-2.3-6.3-5.5-7.3zM14.7 1.3h5.8v8.3l-2.4-2.1c-.2-.2-.6-.2-.8 0l-2.6 2.1V1.3zM1.3 30.6V1.3h11.9v9.8c0 .2.1.3.2.5.1.1.3.2.5.2.1 0 .3-.1.4-.1L17.6 9l3.1 2.6c.3.2.7.2.9-.1.1-.1.2-.3.2-.4V1.3h3.3L25 19.6c-.3 0-.6-.1-.9-.1-4.3 0-7.8 3.5-7.8 7.8 0 1.1.3 2.2.7 3.2H1.3zm16.3.7zm6.7 2.3c-3.4 0-6.2-2.8-6.2-6.2 0-3.4 2.8-6.2 6.2-6.2s6.2 2.8 6.2 6.2c0 3.4-2.8 6.2-6.2 6.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M4.3 16.6h17.5c.4 0 .7-.2.8-.6-.1-.4-.5-.6-.8-.6H4.3c-.5 0-.8.3-.8.7.1.2.4.5.8.5zm9.9 3.4h-10c-.4 0-.7.3-.7.7.1.4.4.6.7.6h10.1c.4 0 .7-.3.7-.7-.1-.3-.2-.5-.3-.6h-.5zm0 4.7h-10c-.4 0-.7.3-.7.7.1.3.3.6.7.6h10.1c.4 0 .7-.3.7-.7-.1-.3-.2-.5-.3-.6-.3-.1-.4-.1-.5 0z"
}));
export const DocumentationCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Documentation",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Documentation"
}, " Documentation"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fillRule: "evenodd",
  d: "M20.765 8h-5.624a.47.47 0 00-.361.176c-.103.126-1 1.039-1.792 1.844-1.927 1.96-2.755 2.814-2.898 3.022a.523.523 0 00-.09.295v9.354c0 .722.553 1.309 1.235 1.309h9.53c.681 0 1.235-.587 1.235-1.31V9.31C22 8.586 21.446 8 20.765 8zm-7.12 2.746c.636-.645 1.113-1.13 1.428-1.457v3.747c0 .236-.164.435-.357.435h-3.714c.439-.482 1.738-1.803 2.643-2.725zm7.405 11.945c0 .163-.13.302-.285.302h-9.53c-.154 0-.285-.139-.285-.302v-8.213h3.766c.72 0 1.306-.648 1.306-1.442V9.007h4.743c.154 0 .285.139.285.302v13.382z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M20.765 8l.186-.167-.075-.083h-.11V8zm-5.985.176l.193.16.001-.002-.194-.158zm-1.792 1.844l-.178-.176.178.176zm-2.898 3.022l.206.142-.206-.142zM20.765 8l-.186.167.075.083h.111V8zm-7.12 2.746h-.25v.61l.428-.434-.178-.176zm1.428-1.457h.25v-.62l-.43.446.18.174zm-4.071 4.182l-.185-.169-.382.419h.567v-.25zm2.643-2.725h.25v-.61l-.428.435.178.175zm7.405 11.945h.25-.25zm-10.1-8.213v-.25h-.25v.25h.25zm5.072-5.471v-.25h-.25v.25h.25zm5.028.302h-.25.25zm-.285-1.559h-5.624v.5h5.624v-.5zm-5.624 0a.72.72 0 00-.555.269l.388.315a.22.22 0 01.167-.084v-.5zm-.554.268a24.7 24.7 0 01-.624.65c-.335.345-.757.774-1.153 1.176l.356.351c.396-.402.819-.832 1.155-1.177.33-.338.592-.61.652-.683l-.386-.317zM12.81 9.844a288.75 288.75 0 00-2.12 2.17 32.25 32.25 0 00-.543.575 3.442 3.442 0 00-.264.312l.413.283c.024-.036.09-.116.22-.258.126-.137.302-.323.534-.565.465-.483 1.153-1.186 2.116-2.166l-.356-.35zm-2.927 3.057a.774.774 0 00-.133.436h.5a.27.27 0 01.046-.153l-.413-.283zm-.133.436v9.354h.5v-9.354h-.5zm0 9.354c0 .846.652 1.559 1.485 1.559v-.5c-.53 0-.985-.461-.985-1.06h-.5zm1.485 1.559h9.53v-.5h-9.53v.5zm9.53 0c.833 0 1.485-.713 1.485-1.56h-.5c0 .599-.456 1.06-.985 1.06v.5zm1.485-1.56V9.31h-.5v13.38h.5zm0-13.38c0-.847-.652-1.56-1.485-1.56v.5c.53 0 .985.461.985 1.06h.5zm-1.299-1.477l-.372.334.372-.334zm-7.128 3.089c.636-.645 1.114-1.132 1.43-1.46l-.36-.347c-.314.326-.79.81-1.426 1.456l.356.35zm1-1.633v3.747h.5V9.289h-.5zm0 3.747a.236.236 0 01-.05.147c-.027.034-.05.038-.057.038v.5c.375 0 .607-.36.607-.685h-.5zm-.107.185h-3.714v.5h3.714v-.5zm-3.53.418c.435-.477 1.73-1.793 2.638-2.717l-.357-.351c-.903.92-2.207 2.245-2.65 2.731l.37.337zm2.21-2.893h.5-.5zM20.8 22.691a.06.06 0 01-.016.04c-.01.012-.018.012-.019.012v.5a.548.548 0 00.535-.552h-.5zm-.035.052h-9.53v.5h9.53v-.5zm-9.53 0s-.008 0-.019-.011a.06.06 0 01-.016-.041h-.5c0 .288.229.552.535.552v-.5zm-.035-.052v-8.213h-.5v8.213h.5zm-.25-7.963h3.766v-.5H10.95v.5zm3.766 0c.88 0 1.556-.784 1.556-1.692h-.5c0 .68-.497 1.192-1.056 1.192v.5zm1.556-1.692V9.007h-.5v4.029h.5zm-.25-3.779h4.743v-.5h-4.743v.5zm4.743 0s.008 0 .019.011a.06.06 0 01.016.041h.5a.548.548 0 00-.535-.552v.5zm.035.052v13.382h.5V9.309h-.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 2,
  d: "M31 16c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15z"
}));
export const DollarDownIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  width: 22,
  height: 24,
  viewBox: "0 0 22 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.0407 19.4253C16.8132 19.4165 16.5954 19.3322 16.4227 19.1862L12.5757 15.7505C12.4128 15.5776 12.3162 15.3543 12.3025 15.119C12.2888 14.8837 12.3589 14.651 12.5007 14.461C12.6768 14.2933 12.9129 14.2003 13.158 14.2019C13.4032 14.2036 13.6379 14.2998 13.8117 14.4698L16.1417 16.5049V7.7705C16.1417 7.53572 16.2365 7.31055 16.4053 7.14454C16.5741 6.97852 16.803 6.88525 17.0417 6.88525C17.2804 6.88525 17.5093 6.97852 17.6781 7.14454C17.8469 7.31055 17.9417 7.53572 17.9417 7.7705V16.5069L20.2197 14.459C20.4 14.2997 20.6335 14.2111 20.8758 14.2098C21.1182 14.2085 21.3526 14.2948 21.5347 14.4521C21.6775 14.6413 21.7479 14.8739 21.7335 15.1091C21.719 15.3443 21.6207 15.5669 21.4557 15.7377L17.6557 19.1803C17.49 19.3374 17.2677 19.4234 17.0377 19.4194L17.0407 19.4253Z",
  fill: "var(--primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.31788 4.25007C7.07768 4.25007 8.50543 5.67782 8.50543 7.43763C8.50543 8.02468 8.9809 8.50014 9.56795 8.50014C10.155 8.50014 10.6305 8.02468 10.6305 7.43763C10.6305 6.21306 10.2081 5.02569 9.43382 4.07742C8.65952 3.12778 7.57973 2.47568 6.3804 2.23129V1.06252C6.3804 0.475464 5.90493 0 5.31788 0C4.73083 0 4.25536 0.475464 4.25536 1.06252V2.23129C2.51814 2.58459 1.07178 3.77991 0.398336 5.41884C-0.275046 7.0591 -0.0864437 8.92634 0.901715 10.3982C1.88851 11.8698 3.54472 12.7517 5.31771 12.7504C6.60735 12.7504 7.76946 13.5274 8.26223 14.7187C8.75629 15.9087 8.4827 17.2807 7.57161 18.1919C6.6605 19.103 5.28854 19.3766 4.09845 18.8825C2.9071 18.3898 2.13012 17.2276 2.13012 15.938C2.13012 15.3509 1.65466 14.8755 1.0676 14.8755C0.48055 14.8755 0.00508582 15.3509 0.00508582 15.938C0.00508582 17.1625 0.427441 18.3499 1.20174 19.2982C1.97603 20.2478 3.05582 20.8999 4.25516 21.1443V22.3131C4.25516 22.9001 4.73062 23.3756 5.31768 23.3756C5.90473 23.3756 6.38019 22.9001 6.38019 22.3131V21.1443C8.11742 20.791 9.56377 19.5957 10.2372 17.9568C10.9106 16.3165 10.722 14.4493 9.73384 12.9774C8.74704 11.5058 7.09084 10.6239 5.31785 10.6252C3.55804 10.6252 2.13029 9.19746 2.13029 7.43766C2.13029 5.67786 3.55808 4.25007 5.31788 4.25007Z",
  fill: "var(--primary)"
}));
export const DownloadIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Download",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "1 0.0009999275207519531 19 19.381000518798828"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Download"
}, " Download"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M10.494 15.75a1.009 1.009 0 00.618-.243l5.094-4.794a1.031 1.031 0 00.079-1.312.936.936 0 00-1.315.01l-3.577 3.371V.901a.9.9 0 10-1.8 0v11.881L6.018 9.411a.99.99 0 00-1.311-.01 1.017 1.017 0 00.075 1.311l5.094 4.794a.868.868 0 00.618.243z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  fill: "none",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M1 19.382h19"
}));
export const EditVolumeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Edit-volume",
  width: "27px",
  height: "27px",
  viewBox: "0 0 27 27",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Edit-volume"
}, " Edit volume"), /*#__PURE__*/React.createElement("title", null, "edit_icon"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-4.2%",
  y: "-9.3%",
  width: "109.0%",
  height: "120.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "047---CVS-AWS",
  transform: "translate(-360.000000, -464.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add-Volume-+-search",
  transform: "translate(320.000000, 373.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "vol-min",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "edit_icon",
  transform: "translate(41.000000, 92.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Info_icon"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Info"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  className: "primary-stroke",
  strokeWidth: 1.07,
  cx: 12.5,
  cy: 12.5,
  r: 12.5
}), /*#__PURE__*/React.createElement("g", {
  id: "np_edit_592766_000000",
  transform: "translate(6.500000, 7.000000)",
  className: "primary-fill",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.94942857,0.00342857143 C8.84800317,0.0155847597 8.75371219,0.0618236051 8.682,0.134571429 L0.882,7.93457143 C0.822149583,7.99386572 0.780002416,8.0686621 0.760285714,8.15057143 L0.0111428571,11.4497143 C-0.0234574917,11.6007098 0.0220388144,11.7588866 0.13157612,11.8684239 C0.241113425,11.9779612 0.399290157,12.0234575 0.550285714,11.9888571 L3.85028571,11.2388571 C3.93386463,11.2202437 4.01033025,11.1779943 4.07057143,11.1171429 L11.8705714,3.31714286 C12.0437728,3.1418533 12.0437728,2.85986099 11.8705714,2.68457143 L9.31971429,0.134571429 C9.22295865,0.0363374809 9.08644377,-0.0120115378 8.94942857,0.00342857143 L8.94942857,0.00342857143 Z M9.00085714,1.086 L10.9131429,3.00342857 L3.75085714,10.1657143 L1.83942857,8.25342857 L9.00085714,1.086 Z M1.458,9.14314286 L2.85514286,10.5402857 L1.05085714,10.9525714 L1.458,9.14314286 Z",
  id: "prefix__np_edit_592766_000000"
})))))))))));
export const EditIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Edit",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.046388099342584616 -0.04415740296244622 22.19668312072754 22.199544143676757"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Edit"
}, " Edit"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.1,
  d: "M16.462.056a.827.827 0 00-.49.241l-14.3 14.3a.832.832 0 00-.223.4l-1.375 6.05a.826.826 0 00.988.988l6.05-1.375a.819.819 0 00.4-.223l14.3-14.3a.825.825 0 000-1.16L17.137.302a.823.823 0 00-.679-.241zm.095 1.985l3.51 3.515L6.932 18.687l-3.506-3.506zM2.73 16.813l2.561 2.561-3.308.756z"
}));
export const EnableIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Enable",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Enable"
}, " Enable"), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "var(--icon-primary)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.1,
  d: "M6.5 12.5l4 4 8-8"
}));
export const ErrorCloudIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Cloud-error",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.30058292150497434 -0.2988718211650848 51.19873733520508 37.19987030029297"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Cloud-error"
}, "Cloud error"), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.3 .3)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeLinecap: "round",
  strokeWidth: 0.6,
  d: "M39.13 13.674h-.217a16.294 16.294 0 00-32.284.894A11.213 11.213 0 000 24.837a11.052 11.052 0 0010.869 11.164H39.13a11.167 11.167 0 000-22.326zm0 19.535H10.869a8.253 8.253 0 01-8.152-8.372 8.381 8.381 0 015.6-7.925 1.3 1.3 0 00.923-1.227 13.6 13.6 0 0127.118-.447 1.377 1.377 0 001.359 1.284h1.413a8.346 8.346 0 010 16.687z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.052 10.95)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "primary-fill",
  id: "Rectangle_552",
  width: 3,
  height: 12.416,
  rx: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "primary-fill",
  id: "Ellipse_182",
  cx: 1.5,
  cy: 1.479,
  rx: 1.5,
  ry: 1.479,
  transform: "translate(0 14.041)"
}))));
export const ErrorMonochromeIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  overflow: "visible"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.739,11.087,6.367,7.716,2.995,11.087A.953.953,0,1,1,1.647,9.739L5.018,6.366,1.647,2.994A.953.953,0,1,1,2.995,1.646L6.367,5.017,9.739,1.646a.953.953,0,1,1,1.348,1.348L7.716,6.366l3.371,3.372a.953.953,0,1,1-1.348,1.348Z",
  transform: "translate(5.633 5.633)",
  className: "primary-fill"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  className: "primary-stroke",
  fill: "none"
})));
export const ErrorNoFillIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Error",
  xmlns: "http://www.w3.org/2000/svg",
  width: 54,
  height: 54,
  viewBox: "0 0 54 54"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Error"
}, " Error"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  className: "primary-stroke",
  stroke: "#CA3652",
  strokeWidth: 2.2,
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.8,
  height: 18.8,
  x: 22.6,
  y: 11.1,
  rx: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 37.5,
  r: 2.4
})));
export const ExternalLinkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-External-link",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-External-link"
}, " External link"), /*#__PURE__*/React.createElement("path", {
  d: "M9.86 3.31414H11.4333L6.77333 7.97414C6.65333 8.09414 6.58667 8.26081 6.58667 8.42747C6.58667 8.59414 6.65333 8.76081 6.77333 8.88081C6.89333 9.00081 7.05333 9.06747 7.22667 9.06747C7.4 9.06747 7.56 9.00081 7.68 8.88081L12.3467 4.22081V5.79414C12.3467 6.14747 12.6333 6.44081 12.9867 6.44081C13.34 6.44081 13.6333 6.15414 13.6333 5.79414V2.67414C13.6333 2.67414 13.6333 2.61414 13.6333 2.58747C13.6333 2.54747 13.62 2.50747 13.6067 2.47414C13.5733 2.38081 13.52 2.28747 13.4467 2.21414C13.38 2.14747 13.3067 2.10081 13.22 2.06747C13.1467 2.04081 13.0667 2.02747 12.9867 2.02747H9.86C9.50667 2.02747 9.22 2.31414 9.22 2.67414C9.22 3.03414 9.50667 3.32081 9.86 3.32081V3.31414Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.0133 8.60081C12.66 8.60081 12.3733 8.88747 12.3733 9.24747V12.3741H3.28667V3.28747H6.42C6.77333 3.28747 7.06 3.00081 7.06 2.64081C7.06 2.28081 6.77333 1.99414 6.42 1.99414H2.64667C2.28667 2.00081 2 2.28747 2 2.64747V13.0208C2 13.3741 2.28667 13.6608 2.64667 13.6608H13.02C13.3733 13.6608 13.6667 13.3741 13.6667 13.0208V9.24747C13.6667 8.89414 13.38 8.60081 13.02 8.60081H13.0133Z",
  fill: "var(--icon-primary)"
}));
export const FeedbackSmileyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M12 18c1.333 1.556 5 3.5 8 0"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fillRule: "evenodd",
  d: "M13.25 15.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm6 0a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 7.25,
  className: "primary-stroke",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 2,
  d: "M31 16c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15z"
}));
export const FilesIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Files",
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 32,
  viewBox: "0 0 26 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Files"
}, " Files"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#3D84FF",
  d: "M17.875.002h-13v4.8H.001v27.195h21.124v-4.799h4.874V8.002l-8.124-8zm.812 3.063L22.888 7.2h-4.2V3.065zm.813 27.333H1.626V6.401h3.25v20.797H19.5v3.2zm4.874-4.8H6.5V1.603h10.562v7.199h7.312v16.798z"
}));
export const FilterIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Filter",
  width: "20px",
  height: "13px",
  viewBox: "0 0 20 13",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Filter"
}, " Filter"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-394.000000, -358.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(394.000000, 354.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M7.85714286,12.5 L12.1428571,12.5 L12.1428571,10.4166667 L7.85714286,10.4166667 L7.85714286,12.5 Z M0,0 L0,2.08333333 L20,2.08333333 L20,0 L0,0 Z M3.57142857,7.32555556 L16.4285714,7.32555556 L16.4285714,5.17451111 L3.57142857,5.17451111 L3.57142857,7.32555556 Z",
  id: "Shape"
}))))));
export const FlexgroupVolumeSsdIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Flexgroup-volume-ssd",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 -2.384185791015625e-7 32 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Flexgroup-volume-ssd"
}, " Flexgroup volume ssd"), /*#__PURE__*/React.createElement("path", {
  fill: "#006DC9",
  fillRule: "evenodd",
  d: "M26.997 19.6a1.82 1.82 0 0 0 .007-.167v-16.1C27.004 1.147 22.588 0 18.228 0 13.868 0 9.45 1.147 9.45 3.333v3.334C4.746 6.677 0 7.925 0 10.295V26.37c0 2.84 7.333 3.63 10.705 3.497 3.372-.134 0-1.448 0-1.448-4.705.248-9.346-1.266-9.346-2.05v-3.106c1.854 1.154 7.04 1.82 9.346 1.523v-1.45C6.667 24 1.36 22.13 1.36 21.182v-3.723c2.333 1.448 6.976 1.546 8.151 1.546 1.179 0 5.819-.099 8.152-1.546V19.6h1.358v-2.946c1.672-.052 4.939-.298 6.73-1.407v4.186a.292.292 0 0 1-.05.167h1.297ZM10.705 6.693V5.137c1.62 1.01 4.583 1.53 7.523 1.53 2.94 0 5.902-.53 7.522-1.53V8c0 .891-2.736 1.877-6.757 1.99-.356-1.99-4.19-3.114-8.288-3.297ZM17.535 10a.49.49 0 0 1 .127.295c0 .77-3.094 2.177-8.152 2.177-5.057 0-8.151-1.408-8.151-2.177 0-.77 3.094-2.177 8.151-2.177 4.449 0 7.379 1.09 8.02 1.875a.71.71 0 0 0-.05.005l.055.002Zm1.485 1.32c1.672-.052 4.939-.3 6.73-1.407v3.42c0 .89-2.724 1.873-6.73 1.989V11.32Zm-.792-9.987c-4.667 0-7.523 1.294-7.523 2 0 .707 2.856 2 7.523 2s7.522-1.293 7.522-2c0-.706-2.855-2-7.522-2Zm-.566 14.042c0 1.03-3.35 2.177-8.152 2.177-4.806 0-8.151-1.146-8.151-2.177v-3.117c1.756 1.089 4.965 1.666 8.151 1.666s6.396-.566 8.152-1.666v3.117Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006DC9",
  d: "M26.456 22.587c1.264 0 1.896.715 1.896 2.146 0 1.461-.68 2.192-2.041 2.192h-.607v-4.338h.752Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006DC9",
  fillRule: "evenodd",
  d: "M10.667 30.667V18.933c0-.736.597-1.333 1.333-1.333h18.667c.736 0 1.333.597 1.333 1.333v11.734c0 .736-.597 1.333-1.333 1.333H12a1.333 1.333 0 0 1-1.333-1.333Zm7.276-4.426c0 .602-.217 1.076-.651 1.422-.432.347-1.033.52-1.805.52-.711 0-1.34-.134-1.887-.401v-1.313c.45.2.83.342 1.14.424a3.4 3.4 0 0 0 .856.123c.31 0 .547-.059.711-.177.167-.119.25-.295.25-.53a.574.574 0 0 0-.108-.346 1.193 1.193 0 0 0-.324-.296c-.14-.094-.427-.244-.861-.45-.407-.192-.713-.376-.916-.552a2.071 2.071 0 0 1-.488-.616 1.756 1.756 0 0 1-.182-.82c0-.59.199-1.053.597-1.39.4-.337.954-.506 1.659-.506.346 0 .676.041.989.123.316.082.645.198.989.347l-.456 1.098a6.6 6.6 0 0 0-.884-.305 2.812 2.812 0 0 0-.684-.087c-.267 0-.472.062-.615.187a.616.616 0 0 0-.214.488c0 .124.029.233.086.328a1 1 0 0 0 .274.269c.127.085.426.24.897.464.623.298 1.05.597 1.281.898.23.298.346.664.346 1.098Zm5.141 0c0 .602-.217 1.076-.652 1.422-.431.347-1.033.52-1.804.52-.711 0-1.34-.134-1.887-.401v-1.313c.45.2.83.342 1.14.424a3.4 3.4 0 0 0 .856.123c.31 0 .547-.059.71-.177.168-.119.252-.295.252-.53a.574.574 0 0 0-.11-.346 1.193 1.193 0 0 0-.323-.296c-.14-.094-.427-.244-.862-.45-.407-.192-.712-.376-.916-.552a2.07 2.07 0 0 1-.487-.616 1.755 1.755 0 0 1-.183-.82c0-.59.2-1.053.597-1.39.401-.337.954-.506 1.66-.506.346 0 .675.041.988.123a6.8 6.8 0 0 1 .99.347l-.457 1.098a6.606 6.606 0 0 0-.884-.305 2.812 2.812 0 0 0-.683-.087c-.268 0-.473.062-.616.187a.616.616 0 0 0-.214.488c0 .124.03.233.087.328a1 1 0 0 0 .273.269c.128.085.427.24.898.464.623.298 1.05.597 1.28.898.232.298.347.664.347 1.098Zm5.797.976c.626-.583.939-1.424.939-2.52 0-1.03-.301-1.832-.903-2.407-.601-.574-1.446-.861-2.534-.861h-2.091v6.663h1.886c1.18 0 2.08-.292 2.703-.875Z",
  clipRule: "evenodd"
}));
export const FlexgroupVolumeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Flexgroup-volume",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Flexgroup-volume"
}, " Flexgroup volume"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5185 23.4267V28.4434C22.5185 31.1063 16.7131 31.7805 13.3213 31.947C12.9567 31.965 12.6201 31.977 12.3215 31.9849C11.8673 31.9971 11.5013 32 11.2593 32C10.877 32 10.1855 31.993 9.32617 31.9533C5.95479 31.7975 0 31.1402 0 28.4434V12.2C0 10.0501 4.52633 8.81419 9.48148 8.57591V3.66667C9.48148 1.26133 15.1474 0 20.7407 0C26.3341 0 32 1.26133 32 3.66667V19.91C32 22.5729 26.1946 23.2471 22.8027 23.4137C22.7059 23.4185 22.6112 23.4228 22.5185 23.4267ZM11.0899 8.53372C11.1463 8.53346 11.2028 8.53333 11.2593 8.53333C15.8162 8.53333 20.4213 9.37057 21.9714 10.9815C26.9907 10.8296 30.3916 9.76432 30.3916 8.8V5.65026C28.3126 6.76133 24.5125 7.33333 20.7407 7.33333C20.2692 7.33333 19.7974 7.32422 19.3284 7.30612C16.0459 7.17943 12.909 6.61276 11.0899 5.65026V8.53372ZM22.5185 12.4253V16.8277C27.2389 16.618 30.3916 15.5957 30.3916 14.6667V10.9047C28.3409 11.9908 24.7854 12.3251 22.5185 12.4253ZM22.5185 18.2924V21.9646C27.606 21.7569 30.3916 20.679 30.3916 19.91V16.7714C28.3414 17.8599 24.7849 18.193 22.5185 18.2924ZM20.7407 1.46667C26.7284 1.46667 30.3916 2.88932 30.3916 3.66667C30.3916 4.44401 26.7284 5.86667 20.7407 5.86667C14.7531 5.86667 11.0899 4.44401 11.0899 3.66667C11.0899 2.88932 14.7531 1.46667 20.7407 1.46667ZM9.48148 25.3611C4.76063 25.1514 1.60843 24.129 1.60843 23.2V19.438C4.37088 20.901 9.86798 21 11.2593 21C12.6546 21 18.1476 20.901 20.9101 19.438V23.2C20.9101 24.129 17.7574 25.1513 13.037 25.3611C12.4664 25.3865 11.8728 25.4 11.2593 25.4C10.646 25.4 10.0518 25.3865 9.48148 25.3611ZM11.2521 26.8667H11.2593C12.6505 26.8667 18.1476 26.7714 20.9101 25.3047V28.4434C20.9101 29.2124 18.1245 30.2902 13.037 30.4979C12.4726 30.521 11.8798 30.5333 11.2593 30.5333C10.6389 30.5333 10.0459 30.521 9.48148 30.4979C4.39381 30.2902 1.60843 29.2124 1.60843 28.4434V25.3047C4.36617 26.7689 9.84918 26.8663 11.2521 26.8667ZM11.2593 19.5333C16.9452 19.5333 20.9101 18.3746 20.9101 17.3333V14.1836C18.8312 15.2947 15.031 15.8667 11.2593 15.8667C10.7878 15.8667 10.3159 15.8576 9.84693 15.8395C6.56438 15.7128 3.42752 15.1461 1.60843 14.1836V17.3333C1.60843 18.3746 5.56944 19.5333 11.2593 19.5333ZM20.9101 12.2C20.9101 11.4227 17.2469 10 11.2593 10C5.27163 10 1.60843 11.4227 1.60843 12.2C1.60843 12.9773 5.27163 14.4 11.2593 14.4C17.2469 14.4 20.9101 12.9773 20.9101 12.2Z",
  fill: "#006DC9"
}));
export const FlexpsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 1.5,
  d: "M26 11h-2.597a4 4 0 01-2.499-.877L18.27 8.017a1.964 1.964 0 00-2.505.042l-4.597 3.94a1.592 1.592 0 00-.207 2.203v0c.566.708 1.608.8 2.29.204L16 12l5.945 5.52c.576.535.593 1.442.037 1.998v0a1.388 1.388 0 01-1.963 0L18 17.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 1.5,
  d: "M26 11h-2.597a4 4 0 01-2.499-.877L18.27 8.017a1.964 1.964 0 00-2.505.042l-4.597 3.94a1.592 1.592 0 00-.207 2.203v0c.566.708 1.608.8 2.29.204L16 12l5.945 5.52c.576.535.593 1.442.037 1.998v0a1.388 1.388 0 01-1.963 0L18 17.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 1.5,
  d: "M15.5 19l2.5 2.5a1.414 1.414 0 002 0v0a1.414 1.414 0 000-2L17.5 17"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 1.5,
  d: "M15.5 19l2.5 2.5a1.414 1.414 0 002 0v0a1.414 1.414 0 000-2L17.5 17"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 1.5,
  d: "M14 21.5l2 2a1.414 1.414 0 002 0v0a1.414 1.414 0 000-2l-2-2"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 1.5,
  d: "M14 21.5l2 2a1.414 1.414 0 002 0v0a1.414 1.414 0 000-2l-2-2"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 1.5,
  d: "M13.5 21l2 2a1.414 1.414 0 010 2v0a1.414 1.414 0 01-2 0L12 23.5l-1.414-1.414a2 2 0 00-1.414-.586H6"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 1.5,
  d: "M13.5 21l2 2a1.414 1.414 0 010 2v0a1.414 1.414 0 01-2 0L12 23.5l-1.414-1.414a2 2 0 00-1.414-.586H6"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 2,
  d: "M31 16c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15z"
}));
export const FpolicyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Fpolicy",
  width: 26,
  height: 26,
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Fpolicy"
}, " Fpolicy"), /*#__PURE__*/React.createElement("path", {
  d: "M12.9148 19.0721L12.915 19.0722C13.021 19.1022 13.1329 19.1022 13.2389 19.0722L13.2393 19.0721C13.3427 19.0422 14.5856 18.6765 15.8042 17.8354C17.0225 16.9945 18.2288 15.669 18.2288 13.7193V8.84812C18.2288 8.53524 17.9758 8.2803 17.6599 8.27314V8.27312L17.658 8.27312C16.1468 8.27745 14.6672 7.84846 13.3987 7.0401C13.2038 6.91288 12.9499 6.91288 12.7551 7.04011C11.4867 7.84909 10.007 8.27746 8.4958 8.27309L8.49372 8.27314C8.17877 8.28101 7.925 8.53504 7.925 8.84812V13.7193C7.925 15.669 9.13139 16.9947 10.3497 17.8357C11.5682 18.6768 12.8111 19.0425 12.9148 19.0721ZM14.5736 11.209V11.134H14.4986H12.1746H12.0996V11.209V15V15.075H12.1746H13.0253H13.1003V15V13.6221H14.406H14.481V13.5471V12.8071V12.7321H14.406H13.1003V12.0228H14.4986H14.5736V11.9478V11.209ZM13 0.925C6.33113 0.925 0.925 6.33113 0.925 13C0.925 19.6688 6.33113 25.075 13 25.075C19.6688 25.075 25.075 19.6688 25.075 13C25.075 6.33113 19.6688 0.925 13 0.925ZM2.14552 13C2.14552 7.00521 7.00521 2.14552 13 2.14552C18.9947 2.14552 23.8545 7.00521 23.8545 13C23.8545 18.9947 18.9947 23.8545 13 23.8545C7.00521 23.8545 2.14552 18.9947 2.14552 13ZM9.09038 9.3974C10.4968 9.3175 11.8644 8.90677 13.0769 8.19885C14.2894 8.90678 15.657 9.3175 17.0634 9.3974V13.7194C17.0634 15.0607 16.2527 16.0477 15.338 16.7349C14.4431 17.4073 13.4596 17.7839 13.0769 17.9152C12.6942 17.7842 11.7108 17.4076 10.8159 16.7352C9.90112 16.0478 9.09038 15.0606 9.09038 13.7194V9.3974Z",
  fill: "var(--primary-disabled)",
  stroke: "var(--primary-disabled)",
  strokeWidth: 0.15
}));
export const HelpFillIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Help",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Help"
}, " Help"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9139 0C6.28994 0 0.91394 5.376 0.91394 12C0.91394 18.624 6.28994 24 12.9139 24C19.5379 24 24.9139 18.624 24.9139 12C24.9139 5.376 19.5379 0 12.9139 0ZM14.1141 19.0501C14.1141 19.7956 13.5096 20.4 12.764 20.4C12.0185 20.4 11.4139 19.7956 11.4139 19.0501C11.4139 18.3046 12.0185 17.7002 12.764 17.7002C13.5096 17.7002 14.1141 18.3046 14.1141 19.0501ZM15.5181 12.204L16.5981 11.1C17.2821 10.416 17.7141 9.45601 17.7141 8.40001C17.7141 5.74801 15.5661 3.60001 12.9141 3.60001C10.4992 3.60001 8.5021 5.38123 8.16443 7.70222C8.10877 8.08479 8.42754 8.40001 8.81414 8.40001H10.0141C10.2903 8.40001 10.5087 8.17365 10.5661 7.90354C10.7964 6.81963 11.7642 6.00001 12.9141 6.00001C14.2341 6.00001 15.3141 7.08001 15.3141 8.40001C15.3141 9.06001 15.0501 9.66001 14.6061 10.092L13.1181 11.604C12.2541 12.48 11.7141 13.68 11.7141 15C11.7141 15.3314 11.9828 15.6 12.3141 15.6H13.6141C13.8903 15.6 14.1116 15.3756 14.1295 15.1C14.2233 13.6572 14.7389 12.994 15.5181 12.204Z",
  fill: "var(--icon-primary)"
}));
export const HelpIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Help",
  width: "23px",
  height: "23px",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Help"
}, " Help"), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "0002--Remove-Footer---Add-Help-Widget-to-the-Top-Header",
  transform: "translate(-1803.000000, -106.000000)",
  className: "primary-fill",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("g", {
  id: "Top-Header",
  transform: "translate(0.000000, 80.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Left-widgets",
  transform: "translate(1283.000000, 21.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Help",
  transform: "translate(520.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5,23 C8.44952533,23 5.52490667,21.7886667 3.36842667,19.6315733 C1.21121067,17.4753141 0,14.5504747 0,11.5 C0,8.44952533 1.21133333,5.52490667 3.36842667,3.36842667 C5.52468587,1.21121067 8.44952533,0 11.5,0 C14.5504747,0 17.4750933,1.21133333 19.6315733,3.36842667 C21.7887893,5.52468587 23,8.44952533 23,11.5 C23,14.5504747 21.7886667,17.4750933 19.6315733,19.6315733 C17.4753141,21.7887893 14.5504747,23 11.5,23 Z M11.5,1.53333333 C8.857024,1.53333333 6.32125867,2.5836544 4.45230933,4.45230933 C2.58355627,6.3210624 1.53333333,8.85677867 1.53333333,11.5 C1.53333333,14.1432213 2.5836544,16.6787413 4.45230933,18.5476907 C6.3210624,20.4164437 8.85677867,21.4666667 11.5,21.4666667 C14.1432213,21.4666667 16.6787413,20.4163456 18.5476907,18.5476907 C20.4164437,16.6789376 21.4666667,14.1432213 21.4666667,11.5 C21.4666667,8.85677867 20.4163456,6.32125867 18.5476907,4.45230933 C16.6789376,2.58355627 14.1432213,1.53333333 11.5,1.53333333 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.7620229,15.8123866 C11.3212966,15.8123866 10.9643455,15.4599502 10.9643455,15.024798 L10.9643455,13.1897293 C10.9693309,12.3253478 11.4878261,11.5456477 12.28849,11.1971429 C13.1789023,10.7944773 13.6664683,9.83462734 13.4610887,8.88952109 C13.2716396,7.97690129 12.4779416,7.30746362 11.5356867,7.26708868 C10.5924363,7.22574092 9.7419207,7.82331522 9.47270137,8.71625161 C9.41586589,8.92201006 9.27627361,9.09527702 9.08682968,9.19767613 C8.89738065,9.30006264 8.6740284,9.32270487 8.46862327,9.25969778 C8.26222518,9.1966907 8.09071559,9.05393933 7.99300329,8.86393769 C7.89528844,8.67393101 7.87933489,8.45340874 7.94912976,8.25158445 C8.33101944,7.08791922 9.28225938,6.19399992 10.4787756,5.87503286 C11.6752918,5.5560658 12.9525712,5.85632782 13.8759882,6.67345863 C14.7983075,7.48960198 15.2400294,8.71035162 15.0505778,9.91933154 C14.8611288,11.1282863 14.0644443,12.1600147 12.9347288,12.6621559 C12.710381,12.7556811 12.5628196,12.9722768 12.5598076,13.2134679 L12.5598076,15.0249215 C12.5598076,15.2336312 12.4760527,15.4344676 12.3264876,15.582131 C12.1769224,15.7298045 11.9735185,15.8125 11.7621403,15.8125 L11.7620229,15.8123866 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.21875,17.96875 C12.21875,18.9270833 10.78125,18.9270833 10.78125,17.96875 C10.78125,17.0104167 12.21875,17.0104167 12.21875,17.96875",
  id: "Path"
})))))));
export const InfoCircleThickIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Info",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Info"
}, " Info"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M10.647 17.249V10.75a1.3 1.3 0 011.34-1.25 1.391 1.391 0 011.338 1.25v6.5a1.3 1.3 0 01-1.338 1.25 1.391 1.391 0 01-1.34-1.251zM10.5 6.5a1.5 1.5 0 013 0A1.441 1.441 0 0112 8a1.441 1.441 0 01-1.5-1.5z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  className: "primary-stroke",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11
})));
export const InfoCircleThinIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Info",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  overflow: "visible"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Info"
}, " Info"), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  className: "secondary-fill",
  stroke: "none",
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.5,
  className: "primary-stroke",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2.321,
  height: 2.321,
  rx: 1.161,
  transform: "translate(10 5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2 8.512a1.089 1.089 0 011 1.161v6a1.089 1.089 0 01-1 1.16 1.089 1.089 0 01-1-1.161v-6a1.089 1.089 0 011-1.16z"
})));
export const InfoCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Info",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.29999988079071044 0.3 23.4 23.4"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Info"
}, " Info"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M12.011 10a1.134 1.134 0 011.091 1.019v5.3a1.057 1.057 0 01-1.091 1.019 1.134 1.134 0 01-1.091-1.019v-5.3A1.057 1.057 0 0112.011 10zm1.236-2.445a1.222 1.222 0 11-2.445 0 1.222 1.222 0 012.445 0"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.2,
  d: "M12 .5A11.5 11.5 0 1023.5 12 11.513 11.513 0 0012 .5zm0 1.769A9.731 9.731 0 112.269 12 9.716 9.716 0 0112 2.269z"
}));
export const InfoIIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Info",
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Info"
}, " Info"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM6.8 6.96v5.28a1.2 1.2 0 1 0 2.4 0V6.96a1.2 1.2 0 1 0-2.4 0zm1.2-2a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4z"
}));
export const InstanceIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Instance",
  width: 24,
  height: 24,
  viewBox: "0 0 24 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Instance"
}, " Instance"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7179 10C19.0005 10.0025 19.2682 10.1207 19.4641 10.3249C19.6597 10.5287 19.7687 10.8018 19.7713 11.085L19.7713 11.0877L19.7713 14.2435C19.7692 14.527 19.6604 14.8007 19.4648 15.0048C19.2688 15.2094 19.0008 15.3279 18.7179 15.3304L18.7152 15.3304H5.10332C4.82074 15.3279 4.55305 15.2097 4.35708 15.0055C4.1615 14.8017 4.05252 14.5286 4.04995 14.2454L4.04993 14.2427L4.04994 11.0861C4.05274 10.8031 4.16184 10.5302 4.3574 10.3266C4.55334 10.1227 4.8209 10.0046 5.10333 10.0021L5.10596 10.0021L16.6251 10.0001C16.6288 10 16.6326 10 16.6364 10H18.7179ZM5.40601 11.3884V13.942H18.4152V11.3884H5.40601ZM16.9657 11.7743C17.198 11.7767 17.4176 11.8741 17.5781 12.0413C17.7382 12.2081 17.8273 12.4311 17.8298 12.6619L17.8299 12.6652C17.8298 12.8386 17.7806 13.0092 17.687 13.1553C17.5933 13.3015 17.4589 13.4175 17.2992 13.4865C17.1393 13.5556 16.9626 13.5739 16.792 13.5386C16.6215 13.5033 16.4666 13.4165 16.3462 13.2911C16.226 13.1658 16.1453 13.0077 16.1127 12.8373C16.0801 12.667 16.0965 12.4903 16.1604 12.329C16.2244 12.1677 16.3335 12.0277 16.476 11.9282C16.6187 11.8286 16.7878 11.7745 16.9621 11.7742L16.9657 11.7743ZM11.7495 11.9277C11.8923 11.8282 12.0616 11.7742 12.2359 11.7742H12.2395C12.4717 11.777 12.691 11.8745 12.8513 12.0417C13.0112 12.2084 13.1001 12.4312 13.1026 12.6619L13.1026 12.6652C13.1026 12.8387 13.0533 13.0092 12.9597 13.1554C12.866 13.3016 12.7315 13.4176 12.5717 13.4866C12.4118 13.5557 12.2351 13.574 12.0644 13.5386C11.8939 13.5032 11.739 13.4162 11.6186 13.2907C11.4984 13.1654 11.4179 13.0072 11.3854 12.8367C11.3529 12.6663 11.3695 12.4896 11.4335 12.3283C11.4976 12.167 11.6069 12.0271 11.7495 11.9277ZM14.1677 11.9277C14.3105 11.8282 14.4798 11.7742 14.6541 11.7742H14.6576C14.8899 11.777 15.1092 11.8745 15.2694 12.0417C15.4293 12.2084 15.5183 12.4312 15.5208 12.6619L15.5208 12.6652C15.5208 12.8387 15.4715 13.0092 15.3779 13.1554C15.2842 13.3016 15.1497 13.4176 14.9899 13.4866C14.83 13.5557 14.6532 13.574 14.4826 13.5386C14.312 13.5032 14.1572 13.4162 14.0368 13.2907C13.9166 13.1654 13.8361 13.0072 13.8036 12.8367C13.7711 12.6663 13.7876 12.4896 13.8517 12.3283C13.9158 12.167 14.0251 12.0271 14.1677 11.9277Z",
  fill: "var(--primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8448 0.852948C12.681 0.800759 14.4733 1.43723 15.8962 2.64525C17.2876 3.82646 18.2353 5.47727 18.578 7.30837C19.9415 7.33109 21.2413 7.91012 22.1985 8.91972C23.1611 9.93499 23.6999 11.3038 23.6999 12.729C23.6999 14.1542 23.1611 15.523 22.1985 16.5383C21.2357 17.5538 19.9264 18.1336 18.5542 18.15L18.5524 18.15H5.54544L5.54337 18.15C4.34952 18.1335 3.19805 17.6908 2.28085 16.8969C1.36379 16.1032 0.736424 15.0066 0.501954 13.7906C0.267492 12.5746 0.439768 11.3114 0.990569 10.2113C1.52848 9.13695 2.39612 8.28073 3.45544 7.77927C3.6945 5.91534 4.55747 4.19711 5.89487 2.9293C7.25236 1.64245 9.00861 0.905137 10.8448 0.852948ZM15.098 4.09867C13.9536 3.04155 12.4723 2.47054 10.946 2.49637C9.4197 2.52219 7.95682 3.14302 6.84581 4.23842C5.73545 5.33318 5.0571 6.82271 4.94583 8.41441C4.94188 8.5745 4.88956 8.72987 4.79541 8.85829C4.70108 8.98696 4.56933 9.08224 4.41834 9.12927C3.6058 9.41601 2.91517 9.99374 2.46985 10.762C2.02398 11.5311 1.85338 12.4409 1.98905 13.3295C2.12472 14.2182 2.5576 15.0268 3.20941 15.6126C3.86088 16.1981 4.68901 16.5234 5.54688 16.5323H18.5524C19.5127 16.5323 20.4349 16.1352 21.1159 15.4252C21.7971 14.7149 22.1808 13.7502 22.1808 12.7431C22.1808 11.7359 21.7971 10.7712 21.1159 10.0609C20.4349 9.3508 19.5126 8.9531 18.5524 8.9531H17.9015C17.7037 8.95219 17.5138 8.87359 17.3708 8.73477C17.2284 8.59662 17.142 8.409 17.1269 8.20947C16.9664 6.62181 16.2421 5.15552 15.098 4.09867Z",
  fill: "var(--primary)"
}));
export const KeyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Key",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Key"
}, " Key"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M14.974 21.254l1.379 1.379a1.557 1.557 0 001.16.48h1.632v1.379a1.872 1.872 0 001.872 1.869h1.379v1.628a1.65 1.65 0 00.472 1.148l1.082 1.082a1.526 1.526 0 001.08.444h4.3a1.345 1.345 0 001.342-1.342v-4.3a1.522 1.522 0 00-.45-1.086l-8.967-8.967a10.251 10.251 0 10-6.279 6.279zM5.661 5.661a8.376 8.376 0 0113.64 9.183.935.935 0 00.2 1.026l9.293 9.3v3.628h-3.627l-.914-.914v-2.208a1.2 1.2 0 00-1.205-1.2h-2.032v-2.03a1.2 1.2 0 00-1.2-1.2h-2.2l-1.74-1.74a.935.935 0 00-1.026-.2A8.376 8.376 0 015.661 5.661zm3.919 7.361A3.432 3.432 0 106.148 9.59a3.434 3.434 0 003.432 3.432zm0-4.967a1.554 1.554 0 11-1.1.455 1.562 1.562 0 011.1-.455z"
}));
export const KnowledgeBaseIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-NetApp-Knowledge-Base",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-NetApp-Knowledge-Base"
}, " NetApp Knowledge Base"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fillRule: "evenodd",
  strokeWidth: 0.4,
  d: "M8.278 16.61c.442-1.266 1.227-3.527 1.51-4.457 1.015-3.344 4.247-5.494 7.687-5.109a6.971 6.971 0 016.174 6.37 6.97 6.97 0 01-2.04 5.503c-.914.906-1.438 2.194-1.438 3.533v1.655a.495.495 0 01-.99 0V22.45c0-1.6.63-3.145 1.73-4.234a5.98 5.98 0 00-3.547-10.188c-2.916-.325-5.765 1.57-6.628 4.412-.287.946-1.078 3.223-1.533 4.48h2.282v3.672c0 .514.42.934.937.934h1.918v2.579a.495.495 0 01-.991 0v-1.59h-.927a1.927 1.927 0 01-1.928-1.923v-2.683h-1.29a.975.975 0 01-.925-1.3zm5.277-2.582c-.528-.165-1.072-.368-1.397-.876-.738-1.152.25-2.54 1.151-3.115 1.34-.856 2.96-1.15 4.445-.806 1.555.362 2.764 1.31 3.406 2.67.658 1.395.613 3.04-.123 4.512a1.913 1.913 0 01-1.42 1.045 1.89 1.89 0 01-1.658-.535c-1.46-1.457-2.532-2.302-4.344-2.877l-.06-.018zm.36-.924c1.995.634 3.207 1.586 4.745 3.12a.91.91 0 00.799.258.934.934 0 00.691-.51c.6-1.2.642-2.53.114-3.65-.51-1.081-1.481-1.836-2.734-2.127a4.414 4.414 0 00-1.002-.112c-.926 0-1.88.273-2.685.787-.501.32-1.215 1.18-.85 1.75.145.227.488.35.856.463l.066.021z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 2,
  d: "M31 16c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15z"
}));
export const LicenseMonochromeIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 19 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.3939 2.37007e-06H0.78694C0.683581 -0.000252417 0.581202 0.0200378 0.485753 0.0596937C0.390304 0.0993497 0.303689 0.157581 0.23094 0.231002C0.0843668 0.380903 0.00249487 0.582351 0.00294001 0.792002V21.208C0.00187355 21.4165 0.083465 21.6169 0.229847 21.7653C0.376229 21.9138 0.57547 21.9982 0.78394 22H17.3899C17.4934 21.9995 17.5958 21.9786 17.6912 21.9385C17.7866 21.8984 17.8732 21.8399 17.946 21.7664C18.0188 21.6928 18.0764 21.6057 18.1155 21.5099C18.1546 21.4141 18.1745 21.3115 18.1739 21.208V0.792002C18.175 0.583699 18.0936 0.383446 17.9474 0.235031C17.8012 0.0866163 17.6022 0.00211442 17.3939 2.37007e-06ZM16.6109 20.413H1.56994V1.583H8.77994V7.783C8.77958 7.93167 8.82102 8.07744 8.89952 8.20369C8.97803 8.32994 9.09044 8.43157 9.22394 8.497C9.35706 8.56126 9.50573 8.58626 9.65255 8.56908C9.79937 8.5519 9.93825 8.49325 10.0529 8.4L12.0119 6.819L13.8379 8.375C13.9512 8.47258 14.0903 8.53535 14.2385 8.55575C14.3866 8.57615 14.5375 8.55332 14.6729 8.49C14.8088 8.42604 14.9236 8.32475 15.004 8.19796C15.0844 8.07118 15.127 7.92413 15.1269 7.774V1.587H16.6269L16.6109 20.413ZM13.5439 6.075L12.5159 5.2C12.3761 5.08396 12.2001 5.02045 12.0184 5.02045C11.8367 5.02045 11.6608 5.08396 11.5209 5.2L10.3449 6.154V1.587H13.5449L13.5439 6.075Z",
  fill: "var(--primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.8349 17.788H3.05694C2.86035 17.811 2.66242 17.7577 2.50404 17.6389C2.34567 17.5202 2.23895 17.3452 2.20594 17.15C2.23918 16.9549 2.34595 16.7801 2.50427 16.6614C2.66259 16.5427 2.86039 16.4892 3.05694 16.512H14.8349C15.0317 16.4887 15.2299 16.5419 15.3885 16.6607C15.5471 16.7795 15.6539 16.9546 15.6869 17.15C15.6569 17.3335 15.5611 17.4998 15.4173 17.6178C15.2736 17.7358 15.0918 17.7973 14.9059 17.791L14.8349 17.788ZM14.8349 14.888H3.05694C2.8602 14.911 2.66214 14.8575 2.50374 14.7386C2.34535 14.6196 2.23873 14.4444 2.20594 14.249C2.23941 14.0541 2.34628 13.8795 2.50457 13.761C2.66286 13.6425 2.86054 13.5892 3.05694 13.612H14.8349C15.0315 13.5887 15.2296 13.6418 15.3882 13.7603C15.5467 13.8789 15.6537 14.0538 15.6869 14.249C15.6569 14.4325 15.5611 14.5988 15.4173 14.7168C15.2736 14.8348 15.0918 14.8963 14.9059 14.89L14.8349 14.888ZM2.20594 11.346C2.23827 11.1503 2.3447 10.9745 2.50314 10.8552C2.66159 10.7358 2.8599 10.6821 3.05694 10.705H14.8319C15.0285 10.682 15.2265 10.7353 15.3848 10.8541C15.5432 10.9728 15.6499 11.1478 15.6829 11.343C15.6499 11.5378 15.5435 11.7125 15.3856 11.8312C15.2276 11.9499 15.0302 12.0035 14.8339 11.981H2.98694C2.80197 11.9875 2.6209 11.9268 2.47729 11.81C2.33368 11.6933 2.23728 11.5284 2.20594 11.346Z",
  fill: "var(--primary)"
}));
export const LightBulbIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 -1.4901161193847656e-8 24 24.200000762939453"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M18.3 11.4c0-1.6-.6-3.2-1.8-4.3-1.1-1.1-2.7-1.8-4.3-1.8-1.6 0-3.2.6-4.3 1.8-1.1 1.1-1.8 2.7-1.8 4.3 0 .5.1 1 .2 1.4.2.7.5 1.3.8 1.9.1.1.1.2.2.3l.1.2c0 .1.1.2.1.2.1.1.1.3.2.4.5.6.8 1.4.8 2.2v2.4c0 .7.4 1.2 1.1 1.4.2 1.3 1.3 2.2 2.5 2.2h.2c1.2-.1 2.1-1 2.3-2.2.6-.2 1-.7 1.1-1.4V18c0-.8.3-1.6.8-2.3.1-.1.2-.3.3-.4l.1-.2c0-.1.1-.1.1-.2.1-.1.1-.2.1-.3.4-.6.7-1.2.9-1.9.2-.3.3-.8.3-1.3zM11.2 22h2.1c-.2.4-.6.7-1.1.7-.3 0-.8 0-1-.7zm3.1-2v.6H10V20h4.3zM10 18.5V18h4.3v.5H10zm6.9-7.1c0 .4-.1.7-.2 1.1v.1c-.1.5-.4 1-.7 1.5-.1.1-.1.2-.2.3l-.1.2c-.1.1-.1.2-.2.3-.1.1-.1.2-.2.3-.3.5-.5.9-.7 1.4H9.8c-.2-.5-.4-1-.7-1.4-.1-.2-.2-.2-.2-.3-.1-.1-.1-.2-.2-.3-.1-.2-.2-.4-.3-.5-.3-.5-.5-1-.7-1.5-.1-.4-.1-.7-.1-1.1 0-2.6 2.1-4.6 4.6-4.6s4.7 1.9 4.7 4.5zm6.5-.5c-.1-.1-.3-.2-.5-.2h-2.2c-.4 0-.7.3-.8.7 0 .2.1.4.2.5.1.1.3.2.5.2h2.2c.2 0 .4-.1.5-.2.1-.1.2-.3.2-.5.1-.2 0-.3-.1-.5zm-.5 0zm-4.7-4.8c.2 0 .4-.1.5-.2l1.5-1.5c.3-.3.3-.7 0-1-.3-.3-.7-.3-1 0l-1.5 1.5c-.3.3-.3.7 0 1 .1.1.3.2.5.2zm-6-2.5c.4 0 .7-.3.7-.7V.7c0-.2-.1-.4-.2-.5-.2-.1-.4-.2-.6-.2-.4 0-.7.3-.7.7v2.2c.1.4.4.7.8.7zM5.7 5.9c.1.1.3.2.4.2.2 0 .4-.1.5-.2.3-.3.3-.7 0-1L5.1 3.4c-.1-.2-.3-.3-.5-.3s-.4.1-.5.2c-.1.2-.2.4-.2.6 0 .1.1.3.2.5l1.6 1.5zm-1.3 5.5c0-.2-.1-.4-.2-.5s-.3-.2-.5-.2H1.4c-.2 0-.4.1-.5.2-.1.1-.2.3-.2.5 0 .4.3.7.7.7h2.1c.6 0 .9-.3.9-.7zm-.7-.5zm2.5 5.8c-.2 0-.4.1-.5.2l-1.5 1.5c-.1.1-.2.3-.2.5s.1.4.2.5c.1.1.3.2.5.2s.4-.1.5-.2l1.5-1.5c.1-.1.2-.3.2-.5s-.1-.4-.2-.5c-.2-.1-.3-.2-.5-.2zm12.5.2c-.3-.3-.7-.3-1 0-.3.3-.3.7 0 1l1.5 1.5c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.7 0-1l-1.5-1.5z"
}));
export const LinkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-External-link",
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-External-link"
}, " External link"), /*#__PURE__*/React.createElement("path", {
  fill: "#7B7B7B",
  className: "primary-fill",
  fillRule: "nonzero",
  d: "M12.906 8.663v5.184H0V.955h5.97v1.697H1.7v9.497h9.507V8.663l1.699-1.647v1.647zM8.766 0h5.112v5.061H12.18V2.935L7.722 7.448 6.5 6.21l4.457-4.514H8.766V0z"
}));
export const LockIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Lock",
  xmlns: "http://www.w3.org/2000/svg",
  width: 82,
  height: 82,
  viewBox: "0 0 82 82",
  overflow: "visible"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Lock"
}, " Lock"), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-919 -395) translate(919 395)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.815 12.871H23.69V8.765c0-4.632-3.714-8.483-8.372-8.553-2.27-.024-4.454.854-6.069 2.439-1.615 1.584-2.527 3.744-2.534 6.001v4.219h-2.12c-1.952.006-3.532 1.577-3.537 3.517v16.88c.005 1.94 1.585 3.51 3.536 3.517h21.221c1.951-.006 3.53-1.578 3.536-3.517v-16.88c-.006-1.94-1.585-3.51-3.536-3.517zm-9.798 10.49v5.951c.004.654-.497 1.2-1.147 1.247-.33.016-.651-.105-.89-.335-.239-.228-.375-.546-.375-.878v-5.988c-1.15-.565-1.762-1.852-1.474-3.106.288-1.254 1.4-2.142 2.68-2.142 1.28 0 2.392.888 2.68 2.142.288 1.254-.323 2.541-1.474 3.106v.003zm4.688-10.7H8.917V8.478c0-3.276 2.638-5.93 5.892-5.93 3.253 0 5.892 2.654 5.892 5.93l.005 4.185h-.001z",
  opacity: 0.34,
  transform: "translate(26.836 22.364)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.125 12.871H23V8.765C23 4.133 19.286.282 14.628.212c-2.27-.024-4.454.854-6.069 2.439-1.615 1.584-2.527 3.744-2.534 6.001v4.219H3.904c-1.952.006-3.532 1.577-3.537 3.517v16.88c.006 1.94 1.586 3.51 3.537 3.517h21.22c1.951-.006 3.53-1.578 3.536-3.517v-16.88c-.005-1.94-1.585-3.51-3.535-3.517zm-9.798 10.49v5.951c.004.654-.497 1.2-1.146 1.247-.33.016-.652-.105-.892-.335-.239-.228-.374-.546-.374-.878v-5.988c-1.15-.565-1.762-1.852-1.474-3.106.288-1.254 1.4-2.142 2.68-2.142 1.28 0 2.392.888 2.68 2.142.288 1.254-.324 2.541-1.474 3.106v.003zm4.688-10.7H8.227V8.478c0-3.276 2.637-5.93 5.892-5.93 3.253 0 5.892 2.654 5.892 5.93l.005 4.185z",
  transform: "translate(26.836 22.364)"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 41,
  r: 41,
  className: "primary-stroke",
  strokeWidth: 3.485
})));
export const MenuArrowIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Expand",
  width: "5px",
  height: "8px",
  viewBox: "0 0 5 8",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Expand"
}, "Expand"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-104.000000, -374.000000)",
  className: "primary-fill"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.000000, 255.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M67.7894191,7.15036593 C67.6617518,7.05409401 67.4885124,7 67.3078629,7 C67.1272135,7 66.9539741,7.05409401 66.8263068,7.15036593 L63.199624,10.6328311 C63.0718146,10.728996 63,10.8594878 63,10.9955612 C63,11.1316346 63.0718146,11.2621264 63.199624,11.3582913 L66.8263068,14.8407564 C66.9968178,14.9757014 67.2510905,15.030357 67.4904697,14.9835173 C67.729849,14.9366776 67.9166589,14.7957148 67.9784193,14.6153209 C68.0401797,14.434927 67.9671701,14.2434942 67.7877175,14.1152963 L64.6425909,10.9955612 L67.7877175,7.8758261 C67.9157528,7.77983142 67.9878736,7.64943513 67.9881928,7.51336168 C67.9885119,7.37728823 67.9170033,7.24670079 67.7894191,7.15036593 Z",
  id: "ic_arrow",
  transform: "translate(65.500000, 11.000000) rotate(180.000000) translate(-65.500000, -11.000000) "
})))))));
export const MenuCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Menu",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  overflow: "visible"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Menu"
}, " Menu"), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  className: "secondary-fill",
  stroke: "none",
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.5,
  className: "primary-stroke",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M12 9a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0112 9zm0 4.5a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zm0 4.5a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0112 18z",
  "data-name": "Union 2"
}));
export const MenuIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Menu",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Menu"
}, " Menu"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#000",
  d: "M12 9a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0112 9zm0 4.5a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.5zm0 4.5a1.5 1.5 0 111.5-1.5A1.5 1.5 0 0112 18z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.5,
  className: "primary-stroke",
  stroke: "#000",
  fill: "none"
}));
export const MoreIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-More",
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 4
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-More"
}, " More"), /*#__PURE__*/React.createElement("path", {
  d: "M10 .25C8.947.25 8.09 1.035 8.09 2S8.948 3.75 10 3.75s1.91-.785 1.91-1.75S11.052.25 10 .25zm-7.818 0C1.129.25.272 1.035.272 2s.857 1.75 1.91 1.75S4.09 2.965 4.09 2 3.235.25 2.18.25zm15.636 0c-1.053 0-1.909.785-1.909 1.75s.856 1.75 1.91 1.75c1.052 0 1.908-.785 1.908-1.75S18.871.25 17.818.25z",
  className: "primary-fill",
  fill: "#434957",
  fillRule: "evenodd"
}));
export const MountVolumeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Mount-volume",
  width: "27px",
  height: "27px",
  viewBox: "0 0 27 27",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Mount-volume"
}, " Mount volume"), /*#__PURE__*/React.createElement("title", null, "Mount"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-4.2%",
  y: "-9.3%",
  width: "109.0%",
  height: "120.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "047---CVS-AWS",
  transform: "translate(-360.000000, -515.000000)",
  className: "primary-stroke"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add-Volume-+-search",
  transform: "translate(320.000000, 373.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "vol-min",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mount",
  transform: "translate(41.000000, 143.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "noun_forward_319479",
  transform: "translate(6.000000, 6.000000)",
  className: "primary-fill",
  fillRule: "nonzero",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.783923077,12.8359771 L0.651230769,12.1773229 C0.643269231,12.1363171 -0.136961538,8.01268 3.53065385,5.06539429 C3.58373077,5.0167 5.15480769,3.63532 8.48538462,3.63532 C8.51192308,3.63532 8.53846154,3.63532 8.565,3.63532 L8.565,0.185714286 L14.5043077,5.95214286 L8.565,11.7185714 L8.565,8.22539714 C8.38984615,8.19976857 8.10853846,8.17157714 7.75026923,8.17157714 C6.22165385,8.17157714 3.32896154,8.70208857 1.13688462,12.2593343 L0.783923077,12.8359771 Z M8.48803846,4.14532857 C5.36180769,4.14532857 3.89688462,5.43444571 3.88361538,5.44726 C1.34919231,7.48473143 1.07584615,10.1065343 1.10769231,11.3546457 C4.38784615,6.72612571 8.83569231,7.74870571 8.89407692,7.76152 L9.09576923,7.80765143 L9.09576923,10.4755857 L13.7585769,5.95214286 L9.09842308,1.4287 L9.09842308,4.15814286 L8.82507692,4.15045429 C8.71096154,4.14789143 8.5995,4.14532857 8.48803846,4.14532857 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeWidth: 1.07,
  cx: 12.5,
  cy: 12.5,
  r: 12.5
}))))))));
export const MountIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Mount",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.5989997634887696 2.4949996223449706 24.8759990234375 17.102000762939454"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Mount"
}, " Mount"), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  className: "primary-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.701,
  d: "M13.44 13.096c-.009 1.593-.025 3.207-.034 4.8l9.17-6.845-9.127-6.855c.002 1.822-.001 2.743 0 4.565a11.052 11.052 0 00-6.764.973 11.37 11.37 0 00-5.583 6.936 11.268 11.268 0 015.705-3.767 11.407 11.407 0 016.633.194zm0 0"
}));
export const NavigationIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "External-link",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "External-link"
}, "External link"), /*#__PURE__*/React.createElement("path", {
  d: "M10.325 2.14167H12.2917L6.46667 7.96667C6.31667 8.11667 6.23333 8.325 6.23333 8.53333C6.23333 8.74167 6.31667 8.95 6.46667 9.1C6.61667 9.25 6.81667 9.33333 7.03333 9.33333C7.25 9.33333 7.45 9.25 7.6 9.1L13.4333 3.275V5.24167C13.4333 5.68333 13.7917 6.05 14.2333 6.05C14.675 6.05 15.0417 5.69167 15.0417 5.24167V1.34167C15.0417 1.34167 15.0417 1.26667 15.0417 1.23333C15.0417 1.18333 15.025 1.13333 15.0083 1.09167C14.9667 0.975 14.9 0.858333 14.8083 0.766667C14.725 0.683333 14.6333 0.625 14.525 0.583333C14.4333 0.55 14.3333 0.533333 14.2333 0.533333H10.325C9.88333 0.533333 9.525 0.891667 9.525 1.34167C9.525 1.79167 9.88333 2.15 10.325 2.15V2.14167Z",
  fill: "#006DC9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2667 8.75C13.825 8.75 13.4667 9.10833 13.4667 9.55833V13.4667H2.10833V2.10833H6.025C6.46667 2.10833 6.825 1.75 6.825 1.3C6.825 0.85 6.46667 0.491667 6.025 0.491667H1.30833C0.858333 0.5 0.5 0.858333 0.5 1.30833V14.275C0.5 14.7167 0.858333 15.075 1.30833 15.075H14.275C14.7167 15.075 15.0833 14.7167 15.0833 14.275V9.55833C15.0833 9.11667 14.725 8.75 14.275 8.75H14.2667Z",
  fill: "#006DC9"
}));
export const NewsSmallIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-News",
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 17,
  viewBox: "0 0 21 17"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-News"
}, " News"), /*#__PURE__*/React.createElement("path", {
  fill: "#3D84FF",
  d: "M12.096 5.702c-.523 0-.673 1.267-.673 2.83 0 1.563.15 2.83.673 2.83.522 0 .672-1.267.672-2.83 0-1.563-.15-2.83-.672-2.83zM11.48 0c-.42 0-.826.125-1.21.354-.906.397-3.422 2.764-3.987 3.26-.508.445-.924.439-.924.439H1.848C.828 4.053 0 6.043 0 8.5c0 2.456.827 4.447 1.848 4.447h3.51s.417-.006.925.44c.404.354 2.045 1.779 3.306 2.718.365.367.76.63 1.177.772.11.051.197.08.258.08.002 0 .002-.005.004-.006.148.032.3.049.452.049 2.34 0 4.237-3.805 4.237-8.5S13.82 0 11.48 0zm1.196 14.12c-1.037 0-1.879-2.516-1.879-5.62 0-3.105.842-5.621 1.88-5.621 1.037 0 1.879 2.516 1.879 5.62 0 3.105-.842 5.622-1.88 5.622zM20.44 3.674c.256-.26-.846-1.06-1.065-1.15-.219-.09-2.957 1.853-2.618 2.388.338.534 3.428-.979 3.683-1.238zm0 9.407c.256.259-.846 1.06-1.065 1.15-.219.09-2.957-1.854-2.618-2.388.338-.534 3.428.978 3.683 1.238zm.381-6.107c.37.043.067 1.33-.04 1.533-.106.204-3.516.39-3.617-.226-.102-.616 3.287-1.349 3.657-1.307z"
}));
export const NssIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-NetApp-Support-site",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.17988017201423645 0.34999987483024597 33.26658630371094 36.0770149230957"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-NetApp-Support-site"
}, " NetApp Support site"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.2,
  d: "M6.046 36.424a1.277 1.277 0 00.78-.264l4.388-3.36a13.43 13.43 0 01-1.382.039l12.128.013a8.013 8.013 0 00.838-.03 3.475 3.475 0 00.979-.717l8.873-8.873a2.734 2.734 0 00-.193-4.034 2.814 2.814 0 00-3.747.257l-3.96 3.959a2.4 2.4 0 00-1.215-.338c-.079 0-1.948-.073-2.4-.078-.314 0-.638.009-.967.015a18.152 18.152 0 01-4.848-.33 34.947 34.947 0 01-1.01-.284 7.788 7.788 0 00-5.162-.241 13.167 13.167 0 00-5.175 3.636l-3.372 3.06A1.282 1.282 0 00.49 30.64l4.59 5.343a1.261 1.261 0 00.967.444zm-4.667-6.7l3.39-3.075a.283.283 0 00.03-.03 12.12 12.12 0 014.727-3.353c1.631-.563 2.879-.2 4.458.257.336.1.68.2 1.04.291a19.326 19.326 0 005.166.369c.324-.006.644-.013.953-.015.333 0 1.679.049 2.366.078a1.316 1.316 0 011.309 1.309 1.312 1.312 0 01-1.309 1.312h-8.638a.7.7 0 00-.648.695c.061.459.707.5 1.064.471h8.221a2.477 2.477 0 002.473-2.477 2.446 2.446 0 00-.391-1.33l3.941-3.941a1.643 1.643 0 012.181-.184 1.545 1.545 0 01.565 1.132 1.567 1.567 0 01-.454 1.18l-8.873 8.873a2.464 2.464 0 01-.992.406h-.181s-10.93-.075-11.068.03L6.116 35.24a.116.116 0 01-.16-.013L1.37 29.878a.111.111 0 01.009-.158z"
}), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill primary-stroke",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.7,
  d: "M19.784 18.955H17.39a1.14 1.14 0 01-1.133-1.148v-1.582a6.97 6.97 0 01-.675-.283l-1.117 1.121a1.158 1.158 0 01-.817.329 1.124 1.124 0 01-.794-.316l-1.692-1.692a1.11 1.11 0 01-.324-.809 1.149 1.149 0 01.34-.8l1.119-1.125a7.165 7.165 0 01-.284-.678h-1.581a1.14 1.14 0 01-1.148-1.122V8.456a1.14 1.14 0 011.148-1.132h1.574a6.973 6.973 0 01.285-.681l-1.116-1.112a1.141 1.141 0 01-.013-1.611l1.693-1.692a1.125 1.125 0 01.793-.316 1.161 1.161 0 01.818.329l1.112 1.114a6.894 6.894 0 01.684-.286V1.498A1.14 1.14 0 0117.39.35h2.394a1.114 1.114 0 01.792.33 1.147 1.147 0 01.337.817v1.572a6.876 6.876 0 01.684.286l1.116-1.114a1.159 1.159 0 01.817-.329 1.125 1.125 0 01.793.316l1.69 1.692a1.113 1.113 0 01.324.809 1.149 1.149 0 01-.34.8L24.884 6.65a7.3 7.3 0 01.285.681h1.574a1.147 1.147 0 01.818.338 1.112 1.112 0 01.329.792v2.389a1.14 1.14 0 01-1.147 1.132h-1.58a6.806 6.806 0 01-.284.678l1.12 1.118a1.152 1.152 0 01.34.8 1.111 1.111 0 01-.324.809l-1.692 1.692a1.125 1.125 0 01-.794.316 1.159 1.159 0 01-.817-.328l-1.121-1.117a6.893 6.893 0 01-.675.283v1.582a1.14 1.14 0 01-1.132 1.14zm-4.263-3.749a.328.328 0 01.154.038 6.38 6.38 0 001.019.425.33.33 0 01.232.317v1.821a.474.474 0 00.465.485h2.393a.475.475 0 00.464-.485v-1.82a.33.33 0 01.232-.317 6.421 6.421 0 001.019-.425.332.332 0 01.389.059l1.296 1.293a.492.492 0 00.347.141.454.454 0 00.324-.128l1.69-1.7a.45.45 0 00.132-.328.485.485 0 00-.145-.341l-1.289-1.289a.331.331 0 01-.06-.389 6.356 6.356 0 00.428-1.021.332.332 0 01.317-.232h1.818a.475.475 0 00.485-.465V8.456a.475.475 0 00-.485-.465h-1.818a.33.33 0 01-.317-.233 6.3 6.3 0 00-.427-1.024.332.332 0 01.058-.384l1.285-1.29a.49.49 0 00.145-.338.452.452 0 00-.129-.328l-1.695-1.7a.454.454 0 00-.324-.129.494.494 0 00-.347.141L21.896 3.99a.332.332 0 01-.39.059 6.366 6.366 0 00-1.022-.429.33.33 0 01-.232-.317v-1.8a.475.475 0 00-.468-.49H17.39a.453.453 0 00-.323.137.485.485 0 00-.142.348v1.809a.33.33 0 01-.233.317 6.385 6.385 0 00-1.026.43.332.332 0 01-.389-.059l-1.281-1.284a.5.5 0 00-.348-.141.452.452 0 00-.32.125l-1.7 1.7a.476.476 0 00.013.671L12.93 6.35a.331.331 0 01.06.389 6.246 6.246 0 00-.428 1.024.331.331 0 01-.318.233h-1.812a.475.475 0 00-.485.465v2.389a.475.475 0 00.485.465h1.817a.335.335 0 01.318.232 6.3 6.3 0 00.428 1.019.331.331 0 01-.059.389l-1.289 1.29a.486.486 0 00-.146.342.454.454 0 00.133.328l1.7 1.695a.451.451 0 00.324.128.494.494 0 00.347-.141l1.289-1.295a.334.334 0 01.227-.096z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.9,
  d: "M18.599 12.79a3.126 3.126 0 113.125-3.125 3.126 3.126 0 01-3.125 3.125zm0-5.73a2.6 2.6 0 102.605 2.6 2.6 2.6 0 00-2.605-2.6z"
})));
export const ObjectStorageIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Object-storage",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Object-storage"
}, " Object storage"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.1056 5.54339C0.912784 5.68208 0.809566 5.91335 0.834391 6.14884L0.801275 17.2395C0.800552 17.4817 0.865743 17.7195 0.989862 17.9275C1.11117 18.1307 1.28434 18.2981 1.49163 18.4124L11.62 23.9962L11.6779 24.0255C11.9269 24.1512 12.2233 24.1376 12.4594 23.9899L22.2967 18.5316C22.5013 18.4181 22.6726 18.2529 22.7933 18.0524C22.918 17.8454 22.9842 17.6084 22.9849 17.3667L23.0181 6.26642V6.21674C23.0181 5.92731 22.8511 5.66415 22.5897 5.54077L12.4726 -0.0241625C12.263 -0.139483 12.0276 -0.199951 11.7883 -0.199951C11.5474 -0.199951 11.3104 -0.138646 11.0997 -0.0218057L1.24591 5.44245L1.1056 5.54339ZM3.36849 6.14004L11.783 1.46618L20.4856 6.26656L12.0708 10.9391L3.36849 6.14004ZM2.50811 7.5379L11.2158 12.349L11.1866 21.8977L2.48387 17.0835L2.50811 7.5379ZM21.3337 7.66498L21.309 17.212L12.8822 21.8832L12.9115 12.3362L21.3337 7.66498Z",
  fill: "var(--icon-primary)"
}));
export const OnOffSwitchIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-On-off-switch",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.30000550150871275 -0.3029999196529388 22.20000762939453 22.20313377380371"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-On-off-switch"
}, " On off switch"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.6,
  d: "M10.8 21.3A10.447 10.447 0 01.3 10.93a10.271 10.271 0 014.026-8.165.731.731 0 011.017.122.709.709 0 01-.123 1 8.853 8.853 0 00-3.472 7.043 9.052 9.052 0 0018.1 0 8.853 8.853 0 00-3.454-7.03.709.709 0 01-.12-1 .73.73 0 011.017-.119A10.268 10.268 0 0121.3 10.93 10.447 10.447 0 0110.8 21.3zm.724-10.94V1.021a.724.724 0 00-1.448 0v9.339a.724.724 0 001.448 0z"
}));
export const OnPremIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-On-premises",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 1 48 30.700002670288086"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-On-premises"
}, " On-premises"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M42.4 7.2c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8M46 1H2C.9 1 0 1.9 0 3v4.8c0 1.1.9 2 2 2h44c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2m-3.6 17.2c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8m3.6-6.3H2c-1.1 0-2 .9-2 2v4.8c0 1.1.9 2 2 2h44c1.1 0 2-.9 2-2v-4.8c0-1.1-.9-2-2-2m-3.6 17.2c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8m3.6-6.3H2c-1.1 0-2 .9-2 2v4.8c0 1.1.9 2 2 2h19.9l4.2.1H46c1.1 0 2-.9 2-2v-4.8c0-1.2-.9-2.1-2-2.1"
}));
export const OptimizedIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Optimized",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Optimized"
}, " Optimized"), /*#__PURE__*/React.createElement("path", {
  d: "M22.8836 10.7881L23.0838 9.80833C23.0727 9.80607 23.0616 9.804 23.0505 9.80211L22.8836 10.7881ZM20.7129 10.4207L20.8798 9.43472C20.8735 9.43365 20.8671 9.43264 20.8608 9.43169L20.7129 10.4207ZM20.1556 9.90636L21.1293 9.6786C21.1272 9.66954 21.125 9.66051 21.1226 9.65151L20.1556 9.90636ZM19.2463 7.73143L20.1069 7.22212C20.1004 7.21117 20.0937 7.20033 20.0868 7.18963L19.2463 7.73143ZM19.2463 6.98197L18.4293 6.40526C18.4212 6.41673 18.4134 6.42837 18.4058 6.44017L19.2463 6.98197ZM20.5223 5.17443L19.7217 4.57518C19.7162 4.58262 19.7107 4.59013 19.7053 4.59772L20.5223 5.17443ZM20.5516 5.08625H19.5516H20.5516ZM20.5223 4.99808L21.3228 4.39883C21.2964 4.36353 21.2677 4.33001 21.2368 4.2985L20.5223 4.99808ZM19.0116 3.45506L19.7262 2.75549C19.6336 2.66089 19.5231 2.58562 19.4011 2.53405L19.0116 3.45506ZM18.9089 3.45506V4.45506C19.0428 4.45506 19.1752 4.4282 19.2985 4.37608L18.9089 3.45506ZM18.8356 3.45506V2.45506C18.6271 2.45506 18.4239 2.52022 18.2543 2.64142L18.8356 3.45506ZM17.0463 4.73357L17.5776 5.58071C17.5946 5.57005 17.6113 5.55888 17.6276 5.54721L17.0463 4.73357ZM16.2836 4.73357L16.815 3.88642C16.8047 3.87999 16.7944 3.87375 16.7839 3.8677L16.2836 4.73357ZM14.0543 3.83714L14.2927 2.86591L14.2829 2.86362L14.0543 3.83714ZM13.541 3.27871L14.5301 3.13147C14.5291 3.12476 14.528 3.11806 14.5269 3.11137L13.541 3.27871ZM13.1743 1.11849L12.1743 1.11065C12.1739 1.16934 12.1786 1.22796 12.1884 1.28583L13.1743 1.11849ZM13.0423 1.00092V2.00092C13.0842 2.00092 13.126 1.99829 13.1676 1.99305L13.0423 1.00092ZM10.8716 1.00092L10.7464 1.99305C10.7879 1.99829 10.8298 2.00092 10.8716 2.00092V1.00092ZM10.7396 1.11849L11.7248 1.29006C11.7351 1.23082 11.7401 1.17078 11.7396 1.11065L10.7396 1.11849ZM10.3583 3.30812L9.37312 3.13654C9.36887 3.16099 9.36552 3.18559 9.36309 3.21028L10.3583 3.30812ZM9.80096 3.94L9.58088 2.96452C9.56645 2.96778 9.55209 2.97135 9.53782 2.97525L9.80096 3.94ZM7.64497 4.85113L7.13656 3.99001C7.12538 3.99662 7.11432 4.00344 7.1034 4.01047L7.64497 4.85113ZM7.2563 4.96552V3.96552V4.96552ZM6.86764 4.85113L6.24381 5.63269C6.27021 5.65377 6.29767 5.67349 6.32607 5.69179L6.86764 4.85113ZM5.13697 3.46975L5.7608 2.68819C5.58363 2.54677 5.36366 2.46975 5.13697 2.46975V3.46975ZM5.04897 3.46975L4.67334 4.39652C4.79267 4.44489 4.92021 4.46975 5.04897 4.46975V3.46975ZM4.96097 3.46975L4.58534 2.54298C4.45949 2.59399 4.34534 2.6701 4.24986 2.76667L4.96097 3.46975ZM3.40631 5.04217L2.6952 4.33909C2.66304 4.37161 2.63315 4.4063 2.60574 4.44292L3.40631 5.04217ZM3.40631 5.21852L4.22326 4.64181C4.2179 4.63422 4.21244 4.62671 4.20687 4.61927L3.40631 5.21852ZM4.6823 7.02606L5.53039 6.49619C5.52045 6.48029 5.51007 6.46467 5.49925 6.44935L4.6823 7.02606ZM4.79182 7.40813H3.79182H4.79182ZM4.6823 7.79021L3.83422 7.26034C3.82638 7.27289 3.81882 7.28562 3.81154 7.2985L4.6823 7.79021ZM3.83164 9.96514L2.85835 9.73554L2.85792 9.73737L3.83164 9.96514ZM3.27431 10.4795L3.12649 9.49046C3.11976 9.49147 3.11304 9.49254 3.10633 9.49368L3.27431 10.4795ZM1.11831 10.8469L1.22962 11.8406C1.24858 11.8385 1.26748 11.8359 1.28629 11.8327L1.11831 10.8469ZM1.00098 10.9791H2.001L2.00096 10.9729L1.00098 10.9791ZM1.00098 13.1687L2.00098 13.1749V13.1687H1.00098ZM1.11831 13.301L1.2841 12.3148C1.26601 12.3118 1.24785 12.3093 1.22962 12.3072L1.11831 13.301ZM3.30364 13.6684L3.13785 14.6546C3.16027 14.6583 3.18281 14.6613 3.20543 14.6636L3.30364 13.6684ZM3.93431 14.2268L2.95864 14.4461C2.96164 14.4594 2.96491 14.4727 2.96846 14.4859L3.93431 14.2268ZM4.84364 16.4017L3.98082 16.9073C3.99014 16.9232 3.9999 16.9388 4.01009 16.9542L4.84364 16.4017ZM4.95872 16.7838H3.95872H4.95872ZM4.84364 17.1659L5.65836 17.7457C5.66479 17.7367 5.67107 17.7276 5.67719 17.7183L4.84364 17.1659ZM3.56764 18.9588L4.36821 19.558C4.373 19.5516 4.37772 19.5451 4.38236 19.5386L3.56764 18.9588ZM3.53831 19.0469H2.53831H3.53831ZM3.56764 19.1351L2.76708 19.7343C2.80125 19.78 2.83927 19.8226 2.88071 19.8618L3.56764 19.1351ZM5.1223 20.6046L4.43537 21.3314C4.55234 21.4419 4.69426 21.5226 4.84908 21.5666L5.1223 20.6046ZM5.2103 20.6046V19.6046C5.11791 19.6046 5.02596 19.6174 4.93708 19.6427L5.2103 20.6046ZM5.29831 20.6046V21.6046C5.50731 21.6046 5.71105 21.5391 5.88092 21.4174L5.29831 20.6046ZM7.1023 19.3114L7.68494 20.1242L7.69158 20.1194L7.1023 19.3114ZM7.51297 19.1792L7.50573 20.1792L7.51724 20.1792L7.51297 19.1792ZM7.86497 19.2821L7.32303 20.1225C7.33674 20.1313 7.35066 20.1398 7.36479 20.148L7.86497 19.2821ZM9.97696 20.1491L9.72448 21.1167C9.73241 21.1188 9.74037 21.1207 9.74835 21.1226L9.97696 20.1491ZM10.4903 20.7075L9.5012 20.8548C9.50214 20.8611 9.50315 20.8674 9.50421 20.8737L10.4903 20.7075ZM10.857 22.8824L11.8508 22.7716C11.8487 22.753 11.8461 22.7346 11.843 22.7162L10.857 22.8824ZM10.989 23V22L10.9828 22L10.989 23ZM13.0863 23L13.0925 22H13.0863V23ZM13.2183 22.8824L12.2322 22.7162C12.2291 22.7346 12.2265 22.753 12.2245 22.7716L13.2183 22.8824ZM13.585 20.7075L14.5711 20.8738L14.5718 20.8689L13.585 20.7075ZM14.0983 20.1491L14.3409 21.1193L14.3505 21.1168L14.0983 20.1491ZM16.269 19.238L16.7829 20.0958C16.7888 20.0923 16.7945 20.0887 16.8003 20.0851L16.269 19.238ZM17.0316 19.238L17.613 18.4243C17.5967 18.4127 17.58 18.4015 17.563 18.3908L17.0316 19.238ZM18.8209 20.5165L18.2396 21.3301C18.32 21.3876 18.4085 21.4328 18.5022 21.4643L18.8209 20.5165ZM18.9236 20.5165L19.2424 21.4643C19.389 21.415 19.5221 21.3324 19.6314 21.2229L18.9236 20.5165ZM20.4636 18.9734L19.8014 18.2241C19.7858 18.2379 19.7706 18.2522 19.7558 18.267L20.4636 18.9734ZM20.4636 18.7971L19.6467 19.3738C19.6914 19.4372 19.7433 19.4951 19.8014 19.5464L20.4636 18.7971ZM19.1876 16.9896L18.3395 17.5194C18.3495 17.5353 18.3599 17.551 18.3707 17.5663L19.1876 16.9896ZM19.1876 16.2254L20.0357 16.7553C20.0393 16.7495 20.0428 16.7437 20.0463 16.7379L19.1876 16.2254ZM20.0969 14.0505L21.0649 14.3017C21.0669 14.2939 21.0688 14.2861 21.0707 14.2782L20.0969 14.0505ZM20.6543 13.5361L20.8021 14.5251C20.8085 14.5242 20.8148 14.5232 20.8212 14.5221L20.6543 13.5361ZM22.8249 13.1687L23.2673 12.2719C23.0787 12.1789 22.8655 12.1477 22.6581 12.1828L22.8249 13.1687ZM23.0009 13.11L23.893 13.562C23.9639 13.4219 24.0009 13.267 24.0009 13.11H23.0009ZM23.0009 10.935L22.0011 10.9149C22.001 10.9216 22.0009 10.9283 22.0009 10.935H23.0009ZM8.7374 10.5515C8.36421 10.1444 7.73164 10.1169 7.32452 10.4901C6.9174 10.8633 6.8899 11.4959 7.26309 11.903L8.7374 10.5515ZM11.0002 14.5L10.2631 15.1757C10.4474 15.3768 10.7058 15.4938 10.9785 15.4998C11.2512 15.5057 11.5145 15.4 11.7074 15.2071L11.0002 14.5ZM17.2074 9.70711C17.5979 9.31658 17.5979 8.68342 17.2074 8.29289C16.8168 7.90237 16.1837 7.90237 15.7931 8.29289L17.2074 9.70711ZM23.0505 9.80211L20.8798 9.43472L20.5461 11.4067L22.7167 11.7741L23.0505 9.80211ZM20.8608 9.43169C20.9256 9.44138 20.9858 9.47032 21.0336 9.51445L19.6772 10.9842C19.9238 11.2117 20.2331 11.3601 20.5651 11.4097L20.8608 9.43169ZM21.0336 9.51445C21.0814 9.55857 21.1146 9.6158 21.1293 9.6786L19.1819 10.1341C19.2582 10.4605 19.4307 10.7567 19.6772 10.9842L21.0336 9.51445ZM21.1226 9.65151C20.8978 8.7986 20.556 7.981 20.1069 7.22212L18.3857 8.24074C18.7407 8.84056 19.0109 9.48688 19.1886 10.1612L21.1226 9.65151ZM20.0868 7.18963C20.119 7.23956 20.136 7.29756 20.136 7.3567H18.136C18.136 7.68173 18.2296 7.99996 18.4058 8.27324L20.0868 7.18963ZM20.136 7.3567C20.136 7.41584 20.119 7.47385 20.0868 7.52377L18.4058 6.44017C18.2296 6.71344 18.136 7.03168 18.136 7.3567H20.136ZM20.0632 7.55868L21.3392 5.75114L19.7053 4.59772L18.4293 6.40526L20.0632 7.55868ZM21.3228 5.77368C21.4715 5.5751 21.5516 5.33387 21.5516 5.08625H19.5516C19.5516 4.90223 19.6112 4.72289 19.7217 4.57518L21.3228 5.77368ZM21.5516 5.08625C21.5516 4.83864 21.4715 4.59741 21.3228 4.39883L19.7217 5.59733C19.6112 5.44962 19.5516 5.27028 19.5516 5.08625H21.5516ZM21.2368 4.2985L19.7262 2.75549L18.2971 4.15464L19.8077 5.69766L21.2368 4.2985ZM19.4011 2.53405C19.2615 2.47501 19.1116 2.44466 18.9603 2.44466V4.44466C18.8442 4.44466 18.7292 4.42138 18.6221 4.37608L19.4011 2.53405ZM18.9603 2.44466C18.809 2.44466 18.659 2.475 18.5194 2.53405L19.2985 4.37608C19.1914 4.42139 19.0763 4.44466 18.9603 4.44466V2.44466ZM18.9089 2.45506H18.8356V4.45506H18.9089V2.45506ZM18.2543 2.64142L16.4649 3.91992L17.6276 5.54721L19.417 4.26871L18.2543 2.64142ZM16.5149 3.88642C16.5597 3.85831 16.6117 3.8433 16.6649 3.8433V5.8433C16.9879 5.8433 17.3042 5.75223 17.5776 5.58071L16.5149 3.88642ZM16.6649 3.8433C16.7182 3.8433 16.7702 3.85831 16.815 3.88642L15.7523 5.58071C16.0257 5.75223 16.342 5.8433 16.6649 5.8433V3.8433ZM16.7839 3.8677C16.0049 3.41762 15.1662 3.08035 14.2926 2.86596L13.8159 4.80832C14.5057 4.9776 15.1681 5.24395 15.7834 5.59944L16.7839 3.8677ZM14.2829 2.86362C14.3467 2.8786 14.4042 2.91235 14.4482 2.9602L12.9758 4.31371C13.2028 4.56068 13.4988 4.73391 13.8257 4.81066L14.2829 2.86362ZM14.4482 2.9602C14.4922 3.00802 14.5206 3.06771 14.5301 3.13147L12.5519 3.42596C12.6012 3.75747 12.7488 4.06677 12.9758 4.31371L14.4482 2.9602ZM14.5269 3.11137L14.1602 0.951143L12.1884 1.28583L12.5551 3.44606L14.5269 3.11137ZM14.1743 1.12632C14.1755 0.967307 14.1428 0.809829 14.0783 0.664415L12.2501 1.47523C12.1991 1.36045 12.1733 1.23615 12.1743 1.11065L14.1743 1.12632ZM14.0783 0.664415C14.0138 0.518904 13.9189 0.388832 13.8 0.282933L12.4698 1.77646C12.3759 1.69282 12.301 1.59012 12.2501 1.47523L14.0783 0.664415ZM13.8 0.282933C13.6811 0.177039 13.5408 0.0976414 13.3884 0.0502906L12.795 1.96025C12.6746 1.92283 12.5637 1.86008 12.4698 1.77646L13.8 0.282933ZM13.3884 0.0502906C13.236 0.00296146 13.0753 -0.0111847 12.917 0.00880027L13.1676 1.99305C13.0425 2.00884 12.9155 1.99766 12.795 1.96025L13.3884 0.0502906ZM13.0423 0.00092268H10.8716V2.00092H13.0423V0.00092268ZM10.9969 0.00880027C10.8386 -0.0111842 10.6779 0.00296044 10.5256 0.0502906L11.1189 1.96025C10.9985 1.99766 10.8714 2.00884 10.7464 1.99305L10.9969 0.00880027ZM10.5256 0.0502906C10.3733 0.0976015 10.2329 0.176949 10.1139 0.282933L11.4441 1.77646C11.3501 1.86017 11.2392 1.92287 11.1189 1.96025L10.5256 0.0502906ZM10.1139 0.282933C9.99501 0.388832 9.90013 0.518904 9.8356 0.664415L11.6639 1.47523C11.6129 1.59012 11.538 1.69282 11.4441 1.77646L10.1139 0.282933ZM9.8356 0.664415C9.77111 0.809829 9.73841 0.967307 9.73966 1.12632L11.7396 1.11065C11.7406 1.23615 11.7148 1.36045 11.6639 1.47523L9.8356 0.664415ZM9.75446 0.946913L9.37312 3.13654L11.3435 3.47969L11.7248 1.29006L9.75446 0.946913ZM9.36309 3.21028C9.3688 3.15216 9.39268 3.09706 9.43163 3.05289L10.9316 4.37583C11.1706 4.10478 11.3182 3.76539 11.3535 3.40595L9.36309 3.21028ZM9.43163 3.05289C9.47065 3.00865 9.52284 2.97762 9.58088 2.96452L10.021 4.91548C10.3739 4.83588 10.6925 4.64695 10.9316 4.37583L9.43163 3.05289ZM9.53782 2.97525C8.69583 3.20491 7.88828 3.5462 7.13656 3.99001L8.15338 5.71225C8.75163 5.35904 9.39422 5.08748 10.0641 4.90476L9.53782 2.97525ZM7.1034 4.01047C7.14886 3.98119 7.20195 3.96552 7.2563 3.96552V5.96552C7.5863 5.96552 7.90922 5.87044 8.18654 5.69179L7.1034 4.01047ZM7.2563 3.96552C7.31066 3.96552 7.36374 3.98119 7.4092 4.01047L6.32607 5.69179C6.60338 5.87044 6.9263 5.96552 7.2563 5.96552V3.96552ZM7.49146 4.06957L5.7608 2.68819L4.51315 4.25131L6.24381 5.63269L7.49146 4.06957ZM5.13697 2.46975H5.04897V4.46975H5.13697V2.46975ZM5.4246 2.54298C5.15548 2.4339 4.85447 2.4339 4.58534 2.54298L5.3366 4.39652C5.12392 4.48272 4.88602 4.48272 4.67334 4.39652L5.4246 2.54298ZM4.24986 2.76667L2.6952 4.33909L4.11742 5.74525L5.67208 4.17283L4.24986 2.76667ZM2.60574 4.44292C2.45715 4.64144 2.37697 4.88265 2.37697 5.13034H4.37697C4.37697 5.31444 4.31739 5.49377 4.20687 5.64141L2.60574 4.44292ZM2.37697 5.13034C2.37697 5.37803 2.45715 5.61924 2.60574 5.81776L4.20687 4.61927C4.31739 4.76692 4.37697 4.94625 4.37697 5.13034H2.37697ZM2.58936 5.79523L3.86535 7.60277L5.49925 6.44935L4.22326 4.64181L2.58936 5.79523ZM3.83422 7.55592C3.80646 7.51149 3.79182 7.46028 3.79182 7.40813H5.79182C5.79182 7.08572 5.70128 6.76971 5.53039 6.49619L3.83422 7.55592ZM3.79182 7.40813C3.79182 7.35599 3.80646 7.30478 3.83422 7.26034L5.53039 8.32007C5.70127 8.04655 5.79182 7.73054 5.79182 7.40813H3.79182ZM3.81154 7.2985C3.38056 8.06173 3.05965 8.88223 2.85835 9.73554L4.80492 10.1947C4.96294 9.52489 5.21483 8.88089 5.55306 8.28192L3.81154 7.2985ZM2.85792 9.73737C2.87262 9.67456 2.90585 9.61733 2.95365 9.57322L4.31004 11.043C4.55656 10.8155 4.72901 10.5193 4.80536 10.1929L2.85792 9.73737ZM2.95365 9.57322C3.00147 9.52909 3.06166 9.50015 3.12649 9.49046L3.42212 11.4685C3.75419 11.4189 4.06348 11.2705 4.31004 11.043L2.95365 9.57322ZM3.10633 9.49368L0.950329 9.86107L1.28629 11.8327L3.44229 11.4653L3.10633 9.49368ZM1.007 9.85308C0.728578 9.88426 0.471886 10.0176 0.286262 10.2268L1.78237 11.5541C1.64008 11.7145 1.44323 11.8167 1.22962 11.8406L1.007 9.85308ZM0.286262 10.2268C0.100668 10.436 -0.000725865 10.7062 0.000998199 10.9853L2.00096 10.9729C2.00228 11.1867 1.92464 11.3937 1.78237 11.5541L0.286262 10.2268ZM0.000979066 10.9791V13.1687H2.00098V10.9791H0.000979066ZM0.000998199 13.1626C-0.000725865 13.4416 0.100673 13.7119 0.286262 13.9211L1.78237 12.5938C1.92463 12.7542 2.00228 12.9612 2.00096 13.1749L0.000998199 13.1626ZM0.286262 13.9211C0.471873 14.1303 0.728559 14.2636 1.007 14.2948L1.22962 12.3072C1.44325 12.3311 1.64009 12.4334 1.78237 12.5938L0.286262 13.9211ZM0.952521 14.2872L3.13785 14.6546L3.46943 12.6822L1.2841 12.3148L0.952521 14.2872ZM3.20543 14.6636C3.14617 14.6577 3.09045 14.6333 3.04617 14.5941L4.37202 13.0967C4.1013 12.857 3.76184 12.7088 3.40185 12.6732L3.20543 14.6636ZM3.04617 14.5941C3.00193 14.5549 2.97145 14.5031 2.95864 14.4461L4.90997 14.0076C4.83078 13.6552 4.64269 13.3364 4.37202 13.0967L3.04617 14.5941ZM2.96846 14.4859C3.19617 15.3348 3.53666 16.1492 3.98082 16.9073L5.70646 15.8962C5.35275 15.2925 5.08155 14.6439 4.90015 13.9677L2.96846 14.4859ZM4.01009 16.9542C3.97651 16.9035 3.95872 16.8443 3.95872 16.7838H5.95872C5.95872 16.4515 5.86086 16.1264 5.67719 15.8493L4.01009 16.9542ZM3.95872 16.7838C3.95872 16.7234 3.97651 16.6641 4.01009 16.6135L5.67719 17.7183C5.86086 17.4412 5.95872 17.1161 5.95872 16.7838H3.95872ZM4.02892 16.5861L2.75292 18.3789L4.38236 19.5386L5.65836 17.7457L4.02892 16.5861ZM2.76708 18.3595C2.61848 18.558 2.53831 18.7992 2.53831 19.0469H4.53831C4.53831 19.231 4.47872 19.4104 4.36821 19.558L2.76708 18.3595ZM2.53831 19.0469C2.53831 19.2947 2.61854 19.5359 2.76708 19.7343L4.36821 18.5358C4.47866 18.6834 4.53831 18.8627 4.53831 19.0469H2.53831ZM2.88071 19.8618L4.43537 21.3314L5.80924 19.8779L4.25457 18.4084L2.88071 19.8618ZM4.84908 21.5666C5.05646 21.6255 5.27614 21.6255 5.48353 21.5666L4.93708 19.6427C5.08693 19.6001 5.24568 19.6001 5.39553 19.6427L4.84908 21.5666ZM5.2103 21.6046H5.29831V19.6046H5.2103V21.6046ZM5.88092 21.4174L7.68492 20.1242L6.51969 18.4987L4.71569 19.7919L5.88092 21.4174ZM7.69158 20.1194C7.63784 20.1586 7.5727 20.1796 7.50573 20.1792L7.52021 18.1792C7.15827 18.1766 6.80526 18.2904 6.51303 18.5035L7.69158 20.1194ZM7.51724 20.1792C7.44818 20.1795 7.38072 20.1597 7.32303 20.1225L8.40691 18.4416C8.13933 18.2691 7.82734 18.1778 7.5087 18.1792L7.51724 20.1792ZM7.36479 20.148C8.10449 20.5752 8.89814 20.9011 9.72448 21.1167L10.2294 19.1815C9.57666 19.0111 8.94962 18.7537 8.36514 18.4161L7.36479 20.148ZM9.74835 21.1226C9.68458 21.1076 9.62704 21.0739 9.58306 21.026L11.0555 19.6725C10.8284 19.4255 10.5324 19.2523 10.2056 19.1756L9.74835 21.1226ZM9.58306 21.026C9.5391 20.9782 9.51069 20.9185 9.5012 20.8548L11.4794 20.5603C11.43 20.2287 11.2825 19.9195 11.0555 19.6725L9.58306 21.026ZM9.50421 20.8737L9.87087 23.0487L11.843 22.7162L11.4764 20.5413L9.50421 20.8737ZM9.86312 22.9933C9.89409 23.2709 10.0265 23.5274 10.2354 23.7134L11.5655 22.2198C11.7256 22.3624 11.8271 22.559 11.8508 22.7716L9.86312 22.9933ZM10.2354 23.7134C10.4443 23.8995 10.715 24.0017 10.9952 24L10.9828 22C11.1977 21.9987 11.4053 22.0771 11.5655 22.2198L10.2354 23.7134ZM10.989 24H13.0863V22H10.989V24ZM13.0801 24C13.3603 24.0017 13.6309 23.8995 13.8399 23.7134L12.5097 22.2198C12.6699 22.0771 12.8775 21.9987 13.0925 22L13.0801 24ZM13.8399 23.7134C14.0488 23.5273 14.1812 23.2707 14.2121 22.9933L12.2245 22.7716C12.2482 22.5591 12.3495 22.3625 12.5097 22.2198L13.8399 23.7134ZM14.2044 23.0487L14.571 20.8737L12.5989 20.5413L12.2322 22.7162L14.2044 23.0487ZM14.5718 20.8689C14.5621 20.9282 14.5353 20.9835 14.4944 21.028L13.022 19.6745C12.7986 19.9175 12.6513 20.2205 12.5981 20.5461L14.5718 20.8689ZM14.4944 21.028C14.4535 21.0726 14.4002 21.1044 14.3409 21.1192L13.8557 19.179C13.5351 19.2591 13.2454 19.4315 13.022 19.6745L14.4944 21.028ZM14.3505 21.1168C15.2056 20.8939 16.0247 20.5501 16.7829 20.0958L15.755 18.3802C15.1598 18.7367 14.5171 19.0065 13.8461 19.1814L14.3505 21.1168ZM16.8003 20.0851C16.7555 20.1132 16.7036 20.1282 16.6503 20.1282V18.1282C16.3273 18.1282 16.011 18.2193 15.7376 18.3908L16.8003 20.0851ZM16.6503 20.1282C16.597 20.1282 16.545 20.1132 16.5003 20.0851L17.563 18.3908C17.2896 18.2193 16.9733 18.1282 16.6503 18.1282V20.1282ZM16.4503 20.0516L18.2396 21.3301L19.4023 19.7028L17.613 18.4243L16.4503 20.0516ZM18.5022 21.4643C18.7423 21.5451 19.0022 21.5451 19.2424 21.4643L18.6049 19.5686C18.7784 19.5103 18.9662 19.5103 19.1397 19.5686L18.5022 21.4643ZM19.6314 21.2229L21.1714 19.6799L19.7558 18.267L18.2158 19.8101L19.6314 21.2229ZM21.1258 19.7228C21.2448 19.6177 21.3397 19.4886 21.4047 19.3444L19.5812 18.5229C19.6325 18.4091 19.7074 18.3072 19.8014 18.2241L21.1258 19.7228ZM21.4047 19.3444C21.4697 19.2001 21.5033 19.0436 21.5033 18.8853H19.5033C19.5033 18.7603 19.5299 18.6367 19.5812 18.5229L21.4047 19.3444ZM21.5033 18.8853C21.5033 18.7269 21.4697 18.5704 21.4047 18.4261L19.5812 19.2477C19.5299 19.1338 19.5033 19.0103 19.5033 18.8853H21.5033ZM21.4047 18.4261C21.3397 18.2819 21.2448 18.1529 21.1258 18.0477L19.8014 19.5464C19.7074 19.4634 19.6325 19.3615 19.5812 19.2477L21.4047 18.4261ZM21.2806 18.2204L20.0046 16.4129L18.3707 17.5663L19.6467 19.3738L21.2806 18.2204ZM20.0357 16.4597C20.0635 16.5042 20.0781 16.5554 20.0781 16.6075H18.0781C18.0781 16.9298 18.1686 17.2459 18.3395 17.5194L20.0357 16.4597ZM20.0781 16.6075C20.0781 16.6596 20.0635 16.7108 20.0357 16.7553L18.3395 15.6955C18.1686 15.9691 18.0781 16.2851 18.0781 16.6075H20.0781ZM20.0463 16.7379C20.4996 15.9784 20.8425 15.1581 21.0649 14.3017L19.129 13.7992C18.9544 14.472 18.6849 15.1164 18.3289 15.7129L20.0463 16.7379ZM21.0707 14.2782C21.056 14.3411 21.0227 14.3983 20.9749 14.4424L19.6186 12.9726C19.372 13.2001 19.1996 13.4963 19.1232 13.8227L21.0707 14.2782ZM20.9749 14.4424C20.9271 14.4865 20.8669 14.5155 20.8021 14.5251L20.5065 12.5471C20.1744 12.5967 19.8651 12.7451 19.6186 12.9726L20.9749 14.4424ZM20.8212 14.5221L22.9918 14.1547L22.6581 12.1828L20.4874 12.5502L20.8212 14.5221ZM22.3826 14.0656C22.65 14.1975 22.9588 14.2186 23.2418 14.1241L22.6082 12.2271C22.8253 12.1546 23.0622 12.1707 23.2673 12.2719L22.3826 14.0656ZM23.2418 14.1241C23.5246 14.0296 23.7584 13.8275 23.893 13.562L22.1089 12.6579C22.212 12.4545 22.3913 12.2995 22.6082 12.2271L23.2418 14.1241ZM24.0009 13.11V10.935H22.0009V13.11H24.0009ZM24.0007 10.9552C24.0061 10.6874 23.9177 10.426 23.7503 10.2163L22.1874 11.4642C22.0629 11.3083 21.9971 11.1139 22.0011 10.9149L24.0007 10.9552ZM23.7503 10.2163C23.5829 10.0066 23.3471 9.86212 23.0838 9.80833L22.6834 11.7678C22.4874 11.7278 22.3119 11.6202 22.1874 11.4642L23.7503 10.2163ZM7.26309 11.903L10.2631 15.1757L11.7374 13.8243L8.7374 10.5515L7.26309 11.903ZM11.7074 15.2071L17.2074 9.70711L15.7931 8.29289L10.2931 13.7929L11.7074 15.2071Z",
  fill: "var(--icon-primary)"
}));
export const OrgIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 23"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-primary)",
  fillRule: "evenodd",
  d: "M14.252.555h-6.2A2.832 2.832 0 0 0 5.22 3.388V5.72H2.89A2.832 2.832 0 0 0 .056 8.553v13.43a.767.767 0 0 0 .767.767h20.661a.767.767 0 0 0 .767-.767V11.652a2.833 2.833 0 0 0-2.833-2.832h-2.333V3.388A2.833 2.833 0 0 0 14.252.555ZM7.137 2.467a1.3 1.3 0 0 1 .92-.38h6.2a1.3 1.3 0 0 1 1.3 1.3v17.829h-1.57v-4.398a1.8 1.8 0 0 0-1.8-1.8H10.12a1.8 1.8 0 0 0-1.8 1.8v4.399H6.756V3.387a1.3 1.3 0 0 1 .38-.92ZM1.97 7.633a1.3 1.3 0 0 1 .92-.38h2.332v13.963H1.59V8.553a1.3 1.3 0 0 1 .38-.92Zm15.115 13.584V10.355h2.333a1.3 1.3 0 0 1 1.3 1.3l.002 9.562h-3.635Zm-7.479-4.4v4.65h3.097v-4.65a.517.517 0 0 0-.517-.516h-2.063a.515.515 0 0 0-.517.517Z",
  clipRule: "evenodd"
}));
export const OvalCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 16,
  viewBox: "0 0 32 16"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  stroke: "primary-fill",
  x: 1,
  y: 1,
  width: 30,
  height: 14,
  rx: 8,
  ry: 8
}), /*#__PURE__*/React.createElement("circle", {
  fill: "primary-fill",
  cx: 16,
  cy: 8,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "primary-fill",
  cx: 10.5,
  cy: 8,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  fill: "primary-fill",
  cx: 21.5,
  cy: 8,
  r: 2
}));
export const PassHintIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Password-hint",
  xmlns: "http://www.w3.org/2000/svg",
  width: 65,
  height: 5,
  viewBox: "0 0 65 5"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Password-hint"
}, " Password hint"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M2.5 5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm10 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm10 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm10 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm10 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm10 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm10 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
}));
export const PencilDarkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "ic-pencil",
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 15,
  viewBox: "0 0 17 15"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "ic-pencil"
}, "Pencil"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.2,
  d: "M15.458 1.955l-.942-1.01A2.073 2.073 0 0 0 11.59.843L2.502 9.317a.457.457 0 0 0-.124.194L.918 14.02a.46.46 0 0 0 .55.589l4.598-1.142a.46.46 0 0 0 .204-.11l9.086-8.474c.405-.377.638-.89.657-1.443a2.055 2.055 0 0 0-.555-1.484zm-9.73 10.647l-3.679.913 1.168-3.606 7.317-6.823 2.511 2.692-7.317 6.824zm9-8.393l-1.01.942-2.51-2.693 1.01-.942a1.153 1.153 0 0 1 1.626.057l.942 1.01a1.149 1.149 0 0 1-.057 1.626z"
}));
export const PencilIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Pencil",
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 15,
  viewBox: "0 0 17 15"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pencil"
}, " Pencil"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.2,
  d: "M15.458 1.955l-.942-1.01A2.073 2.073 0 0 0 11.59.843L2.502 9.317a.457.457 0 0 0-.124.194L.918 14.02a.46.46 0 0 0 .55.589l4.598-1.142a.46.46 0 0 0 .204-.11l9.086-8.474c.405-.377.638-.89.657-1.443a2.055 2.055 0 0 0-.555-1.484zm-9.73 10.647l-3.679.913 1.168-3.606 7.317-6.823 2.511 2.692-7.317 6.824zm9-8.393l-1.01.942-2.51-2.693 1.01-.942a1.153 1.153 0 0 1 1.626.057l.942 1.01a1.149 1.149 0 0 1-.057 1.626z"
}));
export const PiechartIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Pie-chart",
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pie-chart"
}, " Pie chart"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#3D84FF",
  stroke: "#3D84FF",
  strokeWidth: 0.29,
  d: "M17 1C8.189 1 1 8.189 1 17s7.189 16 16 16 16-7.189 16-16S25.811 1 17 1zm14.641 15.342H17.658V2.36c7.583.307 13.676 6.4 13.983 13.983zM17 31.685C8.89 31.685 2.315 25.11 2.315 17c0-7.89 6.225-14.29 14.027-14.641V17c0 .35.307.658.658.658h14.641c-.35 7.802-6.75 14.027-14.641 14.027z"
}));
export const PolicyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Policy",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.1596155047416687 -0.11789338588714598 13.994100189208984 16.599695777893068"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Policy"
}, " Policy"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.3,
  d: "M6.703 16.159a.414.414 0 00.271 0c6.725-2.33 6.626-7.877 6.541-11.932-.008-.442-.017-.857-.017-1.261h0a.412.412 0 00-.412-.412A8.015 8.015 0 017.125.299h0a.412.412 0 00-.575 0A8.023 8.023 0 01.588 2.553a.412.412 0 00-.412.412c0 .4 0 .825-.017 1.261-.082 4.055-.182 9.6 6.543 11.932zM.986 4.247c0-.3.012-.589.015-.872a8.684 8.684 0 005.837-2.211 8.675 8.675 0 005.839 2.213c0 .282.008.572.015.872.076 3.979.165 8.925-5.854 11.087C.816 13.172.901 8.226.986 4.248z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.7,
  d: "M4.914 10.892a.2.2 0 01-.136-.08.207.207 0 01-.038-.155l.3-2.033-1.42-1.459a.209.209 0 01-.051-.209.2.2 0 01.16-.141l1.992-.33.929-1.826a.2.2 0 01.361 0l.929 1.826 1.992.33a.2.2 0 01.163.139.209.209 0 01-.05.211l-1.42 1.459.3 2.033h0a.208.208 0 01-.082.2.2.2 0 01-.21.017l-1.8-.927-1.8.927h0a.2.2 0 01-.117.021zm.288-.573l1.541-.788a.2.2 0 01.183 0l1.546.788-.26-1.736a.208.208 0 01.057-.173l1.217-1.249-1.709-.288h.1c-.1.049-.215-.052-.245-.111l-.8-1.562-.791 1.562a.2.2 0 01-.146.111l-1.708.281 1.217 1.254a.208.208 0 01.057.173l-.26 1.736z"
}));
export const ProjectIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Project",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Project"
}, " Project"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.25 6C2.25 3.92893 3.92893 2.25 6 2.25C7.81422 2.25 9.32753 3.53832 9.67499 5.25H12C12.4142 5.25 12.75 5.58579 12.75 6C12.75 6.41421 12.4142 6.75 12 6.75H9.67499C9.32753 8.46168 7.81422 9.75 6 9.75C3.92893 9.75 2.25 8.07107 2.25 6ZM6 3.75C7.24264 3.75 8.25 4.75736 8.25 6C8.25 7.24264 7.24264 8.25 6 8.25C4.75736 8.25 3.75 7.24264 3.75 6C3.75 4.75736 4.75736 3.75 6 3.75ZM6.75 12C6.75 11.5858 6.41421 11.25 6 11.25C5.58579 11.25 5.25 11.5858 5.25 12L5.25 14.325C3.53832 14.6725 2.25 16.1858 2.25 18C2.25 20.0711 3.92893 21.75 6 21.75C8.07107 21.75 9.75 20.0711 9.75 18C9.75 16.1858 8.46168 14.6725 6.75 14.325V12ZM18.75 9.67499C20.4617 9.32753 21.75 7.81422 21.75 6C21.75 3.92893 20.0711 2.25 18 2.25C15.9289 2.25 14.25 3.92893 14.25 6C14.25 7.81422 15.5383 9.32753 17.25 9.67499V12C17.25 12.4142 17.5858 12.75 18 12.75C18.4142 12.75 18.75 12.4142 18.75 12V9.67499ZM18 8.25C16.7574 8.25 15.75 7.24264 15.75 6C15.75 4.75736 16.7574 3.75 18 3.75C19.2426 3.75 20.25 4.75736 20.25 6C20.25 7.24264 19.2426 8.25 18 8.25ZM12 17.25C11.5858 17.25 11.25 17.5858 11.25 18C11.25 18.4142 11.5858 18.75 12 18.75H14.325C14.6725 20.4617 16.1858 21.75 18 21.75C20.0711 21.75 21.75 20.0711 21.75 18C21.75 15.9289 20.0711 14.25 18 14.25C16.1858 14.25 14.6725 15.5383 14.325 17.25H12ZM15.75 18C15.75 19.2426 16.7574 20.25 18 20.25C19.2426 20.25 20.25 19.2426 20.25 18C20.25 16.7574 19.2426 15.75 18 15.75C16.7574 15.75 15.75 16.7574 15.75 18ZM6 15.75C4.75736 15.75 3.75 16.7574 3.75 18C3.75 19.2426 4.75736 20.25 6 20.25C7.24264 20.25 8.25 19.2426 8.25 18C8.25 16.7574 7.24264 15.75 6 15.75Z",
  fill: "var(--icon-primary)"
}));
export const PyramidIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Pyramid",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "3.9299999999999997 1.93 27.14 27.14"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pyramid"
}, " Pyramid"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(5 3)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "primary-stroke",
  cx: 12.5,
  cy: 12.5,
  r: 12.5
}), /*#__PURE__*/React.createElement("rect", {
  className: "primary-fill",
  width: 1,
  height: 3,
  x: 12,
  y: 6,
  rx: 0.5,
  transform: "rotate(90 12.5 7.5)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "primary-fill",
  width: 1,
  height: 8,
  x: 12,
  y: 8,
  rx: 0.5,
  transform: "rotate(90 12.5 12)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "primary-fill",
  width: 1,
  height: 12,
  x: 12,
  y: 10,
  rx: 0.5,
  transform: "rotate(90 12.5 16)"
})));
export const RedirectToIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "External-link",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 15.999"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "External-link"
}, "External link"), /*#__PURE__*/React.createElement("path", {
  d: "M12.696 9.452v3.617a4.779 4.779 0 01-.017.629l.028-.2a1.807 1.807 0 01-.12.434l.079-.188a1.823 1.823 0 01-.222.38l.123-.162a1.825 1.825 0 01-.307.311l.163-.127a1.81 1.81 0 01-.4.236l.2-.082a1.831 1.831 0 01-.458.123l.212-.028a4.876 4.876 0 01-.567.014H2.883a4.446 4.446 0 01-.583-.017l.2.028a1.807 1.807 0 01-.434-.12l.188.079a1.823 1.823 0 01-.38-.222l.162.123a1.825 1.825 0 01-.311-.307l.127.163a1.81 1.81 0 01-.236-.4l.082.2a1.831 1.831 0 01-.123-.458l.028.212a4.877 4.877 0 01-.014-.567V4.592a4.446 4.446 0 01.017-.583l-.028.2a1.807 1.807 0 01.12-.434l-.079.188a1.823 1.823 0 01.222-.38l-.123.162a1.825 1.825 0 01.307-.311l-.163.127a1.81 1.81 0 01.4-.236l-.2.082a1.831 1.831 0 01.458-.123l-.212.028a7.918 7.918 0 01.935-.014h3.25a.8.8 0 10.011-1.594H2.671a3.7 3.7 0 00-.655.056 2.517 2.517 0 00-1.325.741A2.633 2.633 0 000 4.323v9.067a3.925 3.925 0 00.045.523 2.389 2.389 0 00.252.737 2.449 2.449 0 00.451.611 2.592 2.592 0 001.853.741h9.067a2.714 2.714 0 00.273-.011 3.109 3.109 0 00.471-.077 3.042 3.042 0 00.463-.178 2.422 2.422 0 00.624-.434 2.46 2.46 0 00.734-1.314 3.423 3.423 0 00.057-.646V9.465a.8.8 0 00-1.593-.013zM8.86 1.594h6.337A.8.8 0 0015.208 0H8.87a.8.8 0 10-.011 1.594z",
  className: "primary-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.994 7.14V.803A.8.8 0 1014.4.792v6.337a.8.8 0 101.594.011z",
  className: "primary-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.807 10.314l.818-.818 1.989-1.988 2.465-2.463 2.244-2.242 1.324-1.327.119-.119A.8.8 0 0014.632.236l-.818.818-1.987 1.988-2.465 2.463-2.244 2.242-1.326 1.325-.119.119a.8.8 0 101.134 1.123z",
  className: "primary-fill"
}));
export const RefreshIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Refresh",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.9995644688606262 2.6999671459198 21.9976749420166 19.534000396728516"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Refresh"
}, " Refresh"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M22.864 8.966l-2.307 3.184a.642.642 0 01-.8.2L16.1 10.8a.616.616 0 01-.333-.841.63.63 0 01.846-.331l2.487 1.044a8.5 8.5 0 00-16.795 1.784 8.484 8.484 0 0014.92 5.477.655.655 0 01.923-.077.645.645 0 01.077.917A9.767 9.767 0 1110.792 2.7a9.808 9.808 0 019.535 7.515l1.487-2.038a.671.671 0 01.539-.281.764.764 0 01.385.127.686.686 0 01.127.942z"
}));
export const RemoveCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Remove",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  overflow: "visible"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Remove"
}, " Remove"), /*#__PURE__*/React.createElement("path", {
  d: "M9.739,11.087,6.367,7.716,2.995,11.087A.953.953,0,1,1,1.647,9.739L5.018,6.366,1.647,2.994A.953.953,0,1,1,2.995,1.646L6.367,5.017,9.739,1.646a.953.953,0,1,1,1.348,1.348L7.716,6.366l3.371,3.372a.953.953,0,1,1-1.348,1.348Z",
  transform: "translate(5.633 5.633)",
  className: "primary-fill"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9,
  className: "primary-stroke",
  fill: "none"
})));
export const ResetIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Reset",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "7.387999725341797 6.310410690307617 11.773000335693359 13.825589752197265"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Reset"
}, " Reset"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.274 19.336a5.094 5.094 0 01-5.086-5.087.543.543 0 011.085 0 4.006 4.006 0 004.001 4.002 4.006 4.006 0 004.002-4.002 4.005 4.005 0 00-4.002-4.001.543.543 0 010-1.085 5.093 5.093 0 015.087 5.086 5.094 5.094 0 01-5.087 5.087h0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.336 12.513a.542.542 0 01-.477-.282l-1.263-2.31a.54.54 0 01.063-.612l1.705-2.007a.543.543 0 01.828.703l-1.464 1.722 1.084 1.983a.543.543 0 01-.476.803z"
})));
export const RestoreFileIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Restore-file",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 23"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Restore-file"
}, " Restore file"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.8 20.8l-.2-.1c-.2-.1-.3-.1-.5 0s-.3.2-.3.4c-.1.3.1.7.4.8.1 0 .2.1.3.1h.2c.4 0 .6-.3.6-.6-.1-.3-.2-.5-.5-.6zm1.9.1h-.3c-.3 0-.6.4-.6.7 0 .3.3.6.6.6h.4c.3-.1.6-.4.5-.7.1-.4-.2-.7-.6-.6zm3.9-2.5c-.3-.2-.7 0-.9.3l-.1.2c-.2.3-.1.7.2.9.1.1.2.1.3.1.2 0 .4-.1.5-.3 0 0 0-.1.1-.1 0 0 0-.1.1-.1.2-.4.1-.8-.2-1zm-2.1 1.7l-.2.1c-.3.2-.4.6-.2.9.1.2.3.3.5.3.1 0 .2 0 .3-.1.1 0 .1-.1.2-.1h.1c.3-.2.3-.6.1-.9-.2-.3-.5-.4-.8-.2zm-2.4-8.6h-.2c-2.8 0-5.1 2.2-5.3 5h-.8c-.1 0-.2 0-.3.1-.1.1-.1.2-.1.3 0 .1 0 .1.1.2l1.4 2.3c.1.1.1.1.3.2h.1c.1 0 .2 0 .2-.1l.1-.1L11 17c.1-.2.1-.4-.1-.5-.1 0-.1-.1-.2-.1h-.9c.2-2.1 2-3.8 4.1-3.8h.1c2.2 0 4.1 1.8 4.1 4.1v.3c0 .3.3.6.6.6s.6-.3.6-.6v-.2c.1-3-2.3-5.3-5.2-5.3z",
  className: "primary-fill",
  fill: "var(--icon-primary)",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6 8.1c.9 0 1.6-.8 1.6-1.7V2.2h5.3c.1 0 .2.1.2.2v7.9h.4c.3 0 .6 0 .9.1v-8c0-.8-.7-1.5-1.5-1.5H6.5c-.2 0-.4.1-.5.2l-2 2C1.8 5.2.8 6.1.7 6.4c-.2.1-.2.2-.2.4v10.1c0 .8.7 1.5 1.5 1.5h4.8c-.1-.4-.1-.8-.1-1.3H2c-.1 0-.2-.1-.2-.2V8.1H6zM4.8 4c.7-.6 1.2-1 1.5-1.4v3.8c0 .2-.1.4-.3.4H2c.6-.7 2.2-2.1 2.8-2.8z",
  className: "primary-fill",
  fill: "var(--icon-primary)",
  clipRule: "evenodd"
}));
export const RestoreMonochromeIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.25548959374427793 0.06599279642105105 17.183298301696777 15.39999885559082"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill primary-stroke"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.6,
  d: "M.438 5.221L2.115 7.54a.467.467 0 00.578.148l2.666-1.13a.448.448 0 00.242-.612.458.458 0 00-.615-.241l-1.808.76a6.179 6.179 0 0112.211 1.297 6.17 6.17 0 01-10.851 3.983.476.476 0 00-.671-.056.469.469 0 00-.056.667A7.1 7.1 0 109.217.666a7.133 7.133 0 00-6.935 5.465L1.201 4.649a.488.488 0 00-.392-.2.556.556 0 00-.28.093.5.5 0 00-.091.679z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.4,
  d: "M8.928 4.091a.589.589 0 00-.59.59v3.833a.584.584 0 00.175.415c.765.746 1.2 1.115 1.964 1.88a.586.586 0 10.829-.829L9.517 8.275V4.681a.589.589 0 00-.59-.59z"
})));
export const RestoreVolumeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Restore-volume",
  width: "27px",
  height: "27px",
  viewBox: "0 0 27 27",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Restore-volume"
}, " Restore volume"), /*#__PURE__*/React.createElement("title", null, "Restoree_ic"), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "047---CVS-AWS",
  transform: "translate(-649.000000, -515.000000)",
  stroke: "#006DC9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add-Volume-+-search",
  transform: "translate(320.000000, 373.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clone_ic",
  transform: "translate(330.000000, 143.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Clone"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_copy_232344-(1)",
  transform: "translate(7.000000, 6.000000)",
  fill: "#006DC9",
  fillRule: "nonzero",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(3.259474, 0.095771)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.39157895,10.0444776 L5.72578947,10.0444776 C5.57878316,10.0444776 5.45947368,9.92605851 5.45947368,9.78014925 C5.45947368,9.63424 5.57878316,9.5158209 5.72578947,9.5158209 L6.39157895,9.5158209 C6.83219842,9.5158209 7.19052632,9.16016709 7.19052632,8.72283582 L7.19052632,3.01717604 L4.68329632,0.528656716 L1.33157895,0.528656716 C0.890959474,0.528656716 0.532631579,0.884310522 0.532631579,1.32164179 L0.532631579,1.58597015 C0.532631579,1.7318794 0.413322105,1.85029851 0.266315789,1.85029851 C0.119309474,1.85029851 0,1.7318794 0,1.58597015 L0,1.32164179 C0,0.592888507 0.597346316,0 1.33157895,0 L4.90407211,0 L7.72315789,2.79804784 L7.72315789,8.72283582 C7.72315789,9.4515891 7.12581158,10.0444776 6.39157895,10.0444776 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.45684211,3.1719403 L5.85894737,3.1719403 C5.12471474,3.1719403 4.52736842,2.57905179 4.52736842,1.85029851 L4.52736842,0.264328358 C4.52736842,0.118419104 4.64667789,0 4.79368421,0 C4.94069053,0 5.06,0.118419104 5.06,0.264328358 L5.06,1.85029851 C5.06,2.28762978 5.41832789,2.64328358 5.85894737,2.64328358 L7.45684211,2.64328358 C7.60384842,2.64328358 7.72315789,2.76170269 7.72315789,2.90761194 C7.72315789,3.05352119 7.60384842,3.1719403 7.45684211,3.1719403 Z",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.063684, 2.739055)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.39157895,10.0444776 L1.33157895,10.0444776 C0.597346316,10.0444776 0,9.4515891 0,8.72283582 L0,1.32164179 C0,0.592888507 0.597346316,0 1.33157895,0 L4.90407211,0 L7.72315789,2.79804784 L7.72315789,8.72283582 C7.72315789,9.4515891 7.12581158,10.0444776 6.39157895,10.0444776 Z M1.33157895,0.528656716 C0.890959474,0.528656716 0.532631579,0.884310522 0.532631579,1.32164179 L0.532631579,8.72283582 C0.532631579,9.16016709 0.890959474,9.5158209 1.33157895,9.5158209 L6.39157895,9.5158209 C6.83219842,9.5158209 7.19052632,9.16016709 7.19052632,8.72283582 L7.19052632,3.01717604 L4.68329632,0.528656716 L1.33157895,0.528656716 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.45684211,3.1719403 L5.85894737,3.1719403 C5.12471474,3.1719403 4.52736842,2.57905179 4.52736842,1.85029851 L4.52736842,0.264328358 C4.52736842,0.118419104 4.64667789,0 4.79368421,0 C4.94069053,0 5.06,0.118419104 5.06,0.264328358 L5.06,1.85029851 C5.06,2.28762978 5.41832789,2.64328358 5.85894737,2.64328358 L7.45684211,2.64328358 C7.60384842,2.64328358 7.72315789,2.76170269 7.72315789,2.90761194 C7.72315789,3.05352119 7.60384842,3.1719403 7.45684211,3.1719403 Z",
  id: "Path"
}))), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeWidth: 1.07,
  cx: 12.5,
  cy: 12.5,
  r: 12.5
})))))));
export const RestoreVolumesIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Restore-volumes",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 23"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Restore-volumes"
}, " Restore volumes"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.8 20.7l-.2-.1c-.2-.1-.3-.1-.5 0s-.3.2-.3.4c-.1.3.1.7.4.8.1 0 .2.1.3.1h.2c.4 0 .6-.3.6-.6-.1-.2-.3-.5-.5-.6zm1.9.2h-.3c-.3 0-.6.4-.6.7 0 .3.3.6.6.6h.4c.3-.1.6-.4.5-.7.1-.5-.3-.7-.6-.6zm3.8-2.5c-.3-.2-.7 0-.9.3l-.1.2c-.2.3-.1.7.2.9.1.1.2.1.3.1.2 0 .4-.1.5-.3 0 0 0-.1.1-.1 0 0 0-.1.1-.1.3-.5.2-.9-.2-1zm-2 1.7l-.2.1c-.3.2-.4.6-.2.9.1.2.3.3.5.3.1 0 .2 0 .3-.1.1 0 .1-.1.2-.1h.1c.3-.2.3-.6.1-.9-.2-.4-.6-.4-.8-.2zM14 11.4h-.2c-2.8 0-5.1 2.2-5.3 5h-.7c-.1 0-.2 0-.3.1-.1.1-.1.2-.1.3 0 .1 0 .1.1.2l1.4 2.3c.1.1.1.1.3.2h.1c.1 0 .2 0 .2-.1l.1-.1L11 17c.1-.2.1-.4-.1-.5-.1 0-.1-.1-.2-.1h-.9c.2-2.1 2-3.8 4.1-3.8h.1c2.2 0 4.1 1.8 4.1 4.1v.3c0 .3.3.6.6.6s.6-.3.6-.6v-.2c.1-3-2.4-5.4-5.3-5.4z",
  className: "primary-fill",
  clipRule: "evenodd",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.9 13.6c1.4.4 2.9.6 4.4.6.2-.4.4-.8.7-1.2h-.2c-1.5 0-3.1-.2-4.6-.6-.4-.1-.9-.3-1.2-.6-.3-.2-.3-.3-.3-.3V9.2c.4.2.8.4 1.2.5 1.6.5 3.2.7 4.9.6 1.7 0 3.3-.2 4.9-.6.4-.1.8-.3 1.2-.5v1c.4 0 .8.1 1.2.2V3.5c-.1-.5-.4-.9-.7-1.2-.5-.3-1-.6-1.5-.8C11.4 1 9.8.8 8.3.9h-.9c-1.6 0-3.1.2-4.6.6-.6.2-1.1.5-1.6.8-.4.3-.6.7-.7 1.3v12c0 .5.3 1 .7 1.3.5.3 1 .6 1.5.8 1.3.4 2.7.6 4 .6-.1-.4-.1-.8-.1-1.2-1.2 0-2.4-.2-3.6-.6-.4-.1-.8-.3-1.2-.6-.2-.1-.3-.3-.3-.4V13c.6.3 1 .4 1.4.6zm11-5.9s0 .1-.3.4c-.4.3-.8.5-1.2.6-1.5.4-3 .6-4.6.6h-.2c-1.5 0-3-.2-4.4-.6-.4-.2-.8-.4-1.2-.7-.2-.1-.3-.3-.3-.3V5.2c.4.2.8.4 1.2.5 1.6.5 3.2.7 4.9.6 1.7 0 3.3-.2 4.9-.6.4-.1.8-.3 1.2-.5v2.5zM2 3.2c.3-.2.7-.4 1.1-.5 1.4-.4 2.9-.6 4.3-.6h.8c1.4 0 2.9.2 4.3.6.4.1.8.3 1.2.6.2.1.3.3.3.4 0 0 0 .2-.3.4-.4.3-.8.5-1.2.6-1.4.4-2.8.6-4.3.6h-.3c-1.7-.1-3.2-.3-4.7-.8-.4-.1-.8-.3-1.2-.5-.2-.2-.3-.3-.3-.4 0 0 0-.2.3-.4z",
  fill: "var(--icon-primary)",
  className: "primary-fill",
  clipRule: "evenodd"
}));
export const RoundArrowIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Expand",
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 5,
  viewBox: "0 0 11 5"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Expand"
}, "Expand"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fillRule: "evenodd",
  d: "M.688.21A.703.703 0 0 0 .5.693c0 .18.068.354.188.482L5.041 4.8c.12.128.283.2.453.2.17 0 .334-.072.454-.2L10.3 1.174a.709.709 0 0 0 .178-.664.662.662 0 0 0-.46-.488.617.617 0 0 0-.625.19l-3.9 3.145-3.9-3.145a.623.623 0 0 0-.452-.2.622.622 0 0 0-.454.199z"
}));
export const S3BucketIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-S3-bucket",
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "387 -93 67 65"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-S3-bucket"
}, " S3 bucket"), /*#__PURE__*/React.createElement("ellipse", {
  className: "primary-fill",
  cx: 418.7,
  cy: -85.1,
  rx: 29.9,
  ry: 8.4
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M418.7-74.4c-15.8 0-28.8-3.4-30.4-7.7l8.6 46.3c0 3.5 9.6 6.3 21.5 6.3s21.5-2.8 21.5-6.3L449-82c-1.5 4.2-14.5 7.6-30.3 7.6zm-2.3 24.9c-.9.7-1.8 1-3.3 1-1.6 0-3.5-.2-3.5-.6v-1.5c0 .2.9.4 1.6.6.7.1 1.2.2 1.8.2 1.1 0 1.8-.2 2.3-.6s.8-1 .8-1.7c0-.5-.1-.9-.3-1.2-.2-.3-.5-.6-1-.8-.4-.3-1.1-.5-2-.9-1.3-.5-2.2-1-2.7-1.6s-.8-1.4-.8-2.4.4-1.9 1.2-2.5c.8-.6 1.8-.9 3.1-.9s2.6.2 3.7.7l-.5 1.4c-1.1-.5-2.2-.7-3.3-.7-.8 0-1.5.2-2 .5-.5.4-.7.9-.7 1.5 0 .5.1.9.3 1.2.2.3.5.6.9.8.4.3 1 .5 1.9.8 1.4.5 2.4 1.1 2.9 1.6.5.6.8 1.3.8 2.3.1 1.2-.4 2.1-1.2 2.8zm10.6-.1c-.9.7-2.2 1-3.8 1-.7 0-1.3-.1-1.9-.2-.6-.1-1.7-.3-1.7-.6v-1.5c0 .3 1.1.5 1.8.7.7.2 1.3.2 1.9.2 2.3 0 3.5-.8 3.5-2.6 0-1.6-1.3-2.3-3.9-2.3h-1.3v-2h1.3c1.1 0 1.9 0 2.5-.5s.9-1 .9-1.8c0-.7-.2-1.1-.7-1.5s-1.1-.5-1.9-.5c-.6 0-1.2.1-1.7.3s-1.1.5-1.8.9l-.8-1c.6-.4 1.2-.8 1.9-1 .7-.2 1.5-.4 2.3-.4 1.3 0 2.3.3 3.1.9.7.6 1.1 1.4 1.1 2.5 0 .9 0 1.6-.5 2.1-.5.6-1.8.9-1.8 1.1 1 .1 1.7.5 2.2 1 .5.6.7 1.3.7 2.2.1 1.4-.5 2.4-1.4 3z"
}));
export const SavingsSolidIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Savings",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 45 45"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Savings"
}, " Savings"), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.313 -80.906)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 22.5,
  className: "primary-fill",
  transform: "translate(1.313 80.906)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19.35,
  cy: 19.35,
  r: 19.35,
  className: "primary-fill",
  opacity: 0.1,
  transform: "translate(4.463 84.056)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5,
  d: "M18.322 114.824v-2.816a6.539 6.539 0 0 1-3.755-1.227l.589-1.868a6 6 0 0 0 3.535 1.2 2.707 2.707 0 0 0 2.921-2.733c0-1.534-.957-2.482-2.774-3.318-2.5-1.115-4.05-2.4-4.05-4.824a4.384 4.384 0 0 1 3.706-4.49v-2.816h1.522v2.7a5.972 5.972 0 0 1 3.191.976l-.614 1.84A5.424 5.424 0 0 0 19.5 96.5a2.356 2.356 0 0 0-2.6 2.4c0 1.45.908 2.175 3.044 3.179 2.528 1.171 3.8 2.621 3.8 5.1a4.666 4.666 0 0 1-3.878 4.74v2.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.3,
  d: "M34.357 112.332a1.009 1.009 0 0 1-.618-.243l-3.844-3.493a1.031 1.031 0 0 1-.075-1.313.936.936 0 0 1 1.311.009l2.326 2.072v-8.881a.9.9 0 1 1 1.8 0v8.881l2.282-2.081a.99.99 0 0 1 1.311-.007 1.017 1.017 0 0 1-.075 1.307l-3.8 3.5a.868.868 0 0 1-.618.243z"
})));
export const ScheduleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Schedule",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.49999988079071045 0.5 23 23"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Schedule"
}, " Schedule"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M12 .5A11.5 11.5 0 1023.5 12 11.513 11.513 0 0012 .5zm0 1.769A9.731 9.731 0 112.269 12 9.716 9.716 0 0112 2.269zm0 3.1a.884.884 0 00-.885.885V12a.876.876 0 00.263.622c1.147 1.12 2.3 2.294 3.442 3.442a.88.88 0 101.244-1.244l-3.179-3.179V6.25A.884.884 0 0012 5.365z"
}));
export const SecurityIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Security",
  width: 18,
  height: 23,
  viewBox: "0 0 18 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Security"
}, " Security"), /*#__PURE__*/React.createElement("path", {
  d: "M9.0421 11.351C8.40486 11.3508 7.78845 11.5779 7.30377 11.9917C6.81909 12.4054 6.49795 12.9785 6.39814 13.6079C6.29833 14.2372 6.42639 14.8816 6.75928 15.4249C7.09218 15.9683 7.60805 16.3751 8.2141 16.572V18.972C8.2141 19.174 8.29433 19.3677 8.43713 19.5105C8.57994 19.6533 8.77364 19.7335 8.9756 19.7335C9.17756 19.7335 9.37125 19.6533 9.51406 19.5105C9.65687 19.3677 9.7371 19.174 9.7371 18.972V16.609C10.3634 16.4403 10.9072 16.0499 11.2671 15.5102C11.627 14.9706 11.7785 14.3185 11.6935 13.6755C11.6085 13.0324 11.2928 12.4421 10.805 12.0145C10.3173 11.5869 9.69075 11.3511 9.0421 11.351ZM9.0421 15.182C8.81386 15.182 8.59075 15.1143 8.40097 14.9875C8.2112 14.8607 8.06329 14.6805 7.97594 14.4696C7.8886 14.2588 7.86574 14.0267 7.91027 13.8029C7.9548 13.579 8.06471 13.3734 8.2261 13.212C8.38749 13.0506 8.59311 12.9407 8.81696 12.8962C9.04082 12.8516 9.27285 12.8745 9.48372 12.9618C9.69458 13.0492 9.87481 13.1971 10.0016 13.3869C10.1284 13.5766 10.1961 13.7998 10.1961 14.028C10.1956 14.3338 10.0738 14.6269 9.85745 14.8431C9.64112 15.0592 9.34791 15.1807 9.0421 15.181V15.182Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.9611 7.036V8.48H1.6111C1.40927 8.48 1.21571 8.56018 1.07299 8.70289C0.930275 8.84561 0.850098 9.03917 0.850098 9.241V22.208C0.850098 22.4098 0.930275 22.6034 1.07299 22.7461C1.21571 22.8888 1.40927 22.969 1.6111 22.969H16.3811C16.481 22.969 16.58 22.9493 16.6723 22.9111C16.7646 22.8728 16.8485 22.8168 16.9192 22.7461C16.9899 22.6754 17.0459 22.5916 17.0842 22.4992C17.1224 22.4069 17.1421 22.3079 17.1421 22.208V9.241C17.1421 9.14106 17.1224 9.04211 17.0842 8.94978C17.0459 8.85745 16.9899 8.77356 16.9192 8.70289C16.8485 8.63223 16.7646 8.57617 16.6723 8.53793C16.58 8.49968 16.481 8.48 16.3811 8.48H14.9171V7.036C14.9273 6.24465 14.7803 5.45915 14.4846 4.72507C14.1888 3.99099 13.7502 3.32296 13.1942 2.75973C12.6382 2.19651 11.9759 1.74931 11.2457 1.44409C10.5156 1.13886 9.73201 0.981689 8.9406 0.981689C8.14918 0.981689 7.36564 1.13886 6.63545 1.44409C5.90526 1.74931 5.24296 2.19651 4.68698 2.75973C4.13099 3.32296 3.6924 3.99099 3.39664 4.72507C3.10089 5.45915 2.95386 6.24465 2.9641 7.036H2.9611ZM15.6221 21.444H2.3761V10.003H3.5761C3.62414 10.0128 3.67307 10.0175 3.7221 10.017C3.77109 10.0169 3.81997 10.0122 3.8681 10.003H14.0111C14.0591 10.0128 14.1081 10.0175 14.1571 10.017C14.2061 10.0169 14.255 10.0122 14.3031 10.003H15.6221V21.444ZM13.3951 7.036V8.48H4.4881V7.036C4.47925 6.44554 4.5879 5.85922 4.80774 5.31114C5.02758 4.76306 5.35421 4.26417 5.76864 3.84349C6.18306 3.42281 6.677 3.08874 7.22172 2.86072C7.76645 2.63269 8.35108 2.51526 8.9416 2.51526C9.53212 2.51526 10.1167 2.63269 10.6615 2.86072C11.2062 3.08874 11.7001 3.42281 12.1146 3.84349C12.529 4.26417 12.8556 4.76306 13.0755 5.31114C13.2953 5.85922 13.4039 6.44554 13.3951 7.036Z",
  fill: "var(--icon-primary)"
}));
export const ServerMediatorIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Server-mediator",
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 30,
  viewBox: "0 0 40.5 30.5"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Server-mediator"
}, " Server mediator"), /*#__PURE__*/React.createElement("g", {
  fill: "#006dc9",
  stroke: "#fff",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.758 4.398a1.3 1.3 0 0 1-2.586 0 1.3 1.3 0 0 1 2.586 0Z",
  "data-name": "Path 10802"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.936 15.96a.88.88 0 0 1 0-1.244l2.78-2.78a.88.88 0 1 1 1.245 1.245l-1.278 1.278h5.638a.88.88 0 1 1 0 1.76h-5.637l1.3 1.327a.88.88 0 0 1-1.257 1.231l-2.638-2.694a.883.883 0 0 1-.153-.123Z",
  "data-name": "Path 10803"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.457 20.053a.88.88 0 0 1 0 1.244l-2.78 2.78a.88.88 0 1 1-1.244-1.244l1.278-1.278h-5.639a.88.88 0 0 1 0-1.76h5.636l-1.3-1.327a.88.88 0 1 1 1.258-1.229l2.638 2.694a.891.891 0 0 1 .153.12Z",
  "data-name": "Path 10804"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M29.99 1.679v4.43a12.144 12.144 0 1 1-9.565 21.4H1.679A1.428 1.428 0 0 1 .25 26.083v-5.44a1.429 1.429 0 0 1 1.429-1.429h14.335q-.049-.547-.05-1.108v-.078H1.679A1.428 1.428 0 0 1 .25 16.601v-5.44a1.429 1.429 0 0 1 1.429-1.429h17.635a12.212 12.212 0 0 1 1.3-1.185H1.679A1.429 1.429 0 0 1 .25 7.119v-5.44A1.429 1.429 0 0 1 1.679.25h26.883a1.429 1.429 0 0 1 1.428 1.429ZM2.25 6.55v-4.3h25.74v3.715a12.129 12.129 0 0 0-3.61.585Zm14.116 14.665a12.1 12.1 0 0 0 2.117 4.3H2.25v-4.3Zm1.4-9.482a12.065 12.065 0 0 0-1.629 4.3H2.25v-4.3ZM28.107 28.25a10.143 10.143 0 1 0-10.143-10.143A10.143 10.143 0 0 0 28.107 28.25Z",
  "data-name": "Path 10805"
})));
export const ServerNodeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Server-node",
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 30,
  viewBox: "0 0 40.5 30.5"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Server-node"
}, " Server node"), /*#__PURE__*/React.createElement("g", {
  fill: "#006dc9"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M26.005 4.21a1.263 1.263 0 0 1-2.513 0 1.263 1.263 0 0 1 2.513 0Z",
  "data-name": "Path 10806"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M23.371 22.355a4.366 4.366 0 0 0 2.432.735h5.337a4.594 4.594 0 0 0 2.085-.435 3.208 3.208 0 0 0 1.325-1.24 3.853 3.853 0 0 0 .495-1.979 3.56 3.56 0 0 0-1.307-2.884 3.485 3.485 0 0 0-.682-.423 4.836 4.836 0 0 0-.792-1.506 4.678 4.678 0 0 0-3.812-1.762 4.128 4.128 0 0 0-3.619 2.124 5.693 5.693 0 0 0-.458.979 3.711 3.711 0 0 0-.926.4 3.422 3.422 0 0 0-1.591 3.072 3.45 3.45 0 0 0 1.513 2.919Zm5.082-7.787a2.955 2.955 0 0 1 3.091 2.922 1.782 1.782 0 0 1 1.767 1.948c0 1.948-1.619 1.948-2.208 1.948h-5.3a2.028 2.028 0 0 1-2.209-1.948c0-1.735 1.325-1.948 2.208-1.948.001-.487.531-2.922 2.65-2.922Z",
  "data-name": "Path 10807"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  stroke: "#fff",
  strokeWidth: 0.5,
  d: "M.25 1.614A1.376 1.376 0 0 1 1.638.25h26.12a1.376 1.376 0 0 1 1.392 1.364v5.192a1.348 1.348 0 0 1-.029.28 11.587 11.587 0 0 1-.671 23.164 11.86 11.86 0 0 1-8.9-3.977H1.638A1.376 1.376 0 0 1 .25 24.909v-5.193a1.376 1.376 0 0 1 1.388-1.366h15.02q.015-.573.086-1.132H1.638a1.376 1.376 0 0 1-1.388-1.36v-5.193a1.376 1.376 0 0 1 1.388-1.364h19.851a11.839 11.839 0 0 1 1.936-1.131H1.638A1.376 1.376 0 0 1 .25 6.806Zm2.082 4.511v-3.83h24.732v3.83Zm14.454 14.273a11.374 11.374 0 0 0 1.316 3.829H2.332v-3.829Zm2.512-9.048a11.5 11.5 0 0 0-2.1 3.829H2.332V11.35Zm9.152 16.991a9.683 9.683 0 1 0-9.855-9.682 9.769 9.769 0 0 0 9.855 9.682Z",
  "data-name": "Path 10808"
})));
export const ServiceUnknownIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Service-unknown",
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 29
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Service-unknown"
}, " Service unknown"), /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 14.5,
  r: 14.5,
  fill: "#D8D8D8"
}));
export const SettingsFillIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Settings",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Settings"
}, " Settings"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.7859 10.6779L22.4179 10.2771C22.2721 10.2553 22.1363 10.1902 22.0279 10.0902C21.9195 9.99014 21.8435 9.8598 21.8099 9.71603C21.5904 8.88299 21.2565 8.08449 20.8179 7.34338C20.7394 7.22156 20.6976 7.07961 20.6976 6.93458C20.6976 6.78956 20.7394 6.64761 20.8179 6.52579L22.2099 4.55392C22.2307 4.52617 22.2419 4.49242 22.2419 4.45773C22.2419 4.42304 22.2307 4.38929 22.2099 4.36154L20.5619 2.67825C20.5442 2.67076 20.5251 2.6669 20.5059 2.6669C20.4867 2.6669 20.4676 2.67076 20.4499 2.67825H20.3699L18.4179 4.07298C18.2932 4.1512 18.149 4.19269 18.0019 4.19269C17.8548 4.19269 17.7106 4.1512 17.5859 4.07298C16.8254 3.63358 16.0066 3.30434 15.1539 3.09506C15.0104 3.06137 14.8804 2.98529 14.7805 2.87668C14.6807 2.76806 14.6157 2.63192 14.5939 2.48587L14.1939 0.129256C14.1941 0.110975 14.1903 0.0928762 14.1829 0.0761704C14.1755 0.0594646 14.1646 0.0445381 14.151 0.0323929C14.1373 0.0202478 14.1213 0.0111646 14.1038 0.00575107C14.0864 0.000337504 14.068 -0.00128008 14.0499 0.00100559H11.6819C11.6638 -0.00128008 11.6454 0.000337504 11.628 0.00575107C11.6106 0.0111646 11.5945 0.0202478 11.5809 0.0323929C11.5672 0.0445381 11.5564 0.0594646 11.5489 0.0761704C11.5415 0.0928762 11.5378 0.110975 11.5379 0.129256L11.1219 2.51794C11.1058 2.6823 11.0383 2.83737 10.9292 2.96112C10.82 3.08487 10.6747 3.17099 10.5139 3.20727C9.68927 3.43221 8.89828 3.76649 8.16193 4.20123C8.03547 4.2827 7.88828 4.32602 7.73793 4.32602C7.58758 4.32602 7.4404 4.2827 7.31393 4.20123L5.42594 2.69427H5.32994C5.29915 2.68179 5.26472 2.68179 5.23394 2.69427L3.53794 4.40964C3.51717 4.43739 3.50594 4.47114 3.50594 4.50583C3.50594 4.54051 3.51717 4.57427 3.53794 4.60202L4.92993 6.57388C5.008 6.69884 5.04941 6.84327 5.04941 6.99069C5.04941 7.13811 5.008 7.28255 4.92993 7.4075C4.51036 8.15052 4.19793 8.94934 4.00194 9.78015C3.96831 9.92392 3.89238 10.0543 3.78398 10.1543C3.67558 10.2543 3.5397 10.3195 3.39394 10.3412L1.04194 10.742C1.00659 10.746 0.973947 10.7629 0.950313 10.7896C0.926678 10.8162 0.913723 10.8507 0.913943 10.8863V13.275C0.913723 13.3106 0.926678 13.3451 0.950313 13.3717C0.973947 13.3984 1.00659 13.4153 1.04194 13.4193L3.42594 13.8201C3.58997 13.8363 3.74474 13.9038 3.86825 14.0132C3.99176 14.1225 4.07773 14.2681 4.11394 14.4293C4.33709 15.2611 4.67074 16.0591 5.10594 16.8019C5.18781 16.9254 5.23148 17.0704 5.23148 17.2187C5.23148 17.367 5.18781 17.512 5.10594 17.6355L3.71394 19.5914C3.69317 19.6191 3.68194 19.6529 3.68194 19.6876C3.68194 19.7222 3.69317 19.756 3.71394 19.7837L5.40993 21.3869C5.44132 21.3958 5.47455 21.3958 5.50593 21.3869H5.60194L7.56993 19.9761C7.70002 19.8812 7.85704 19.8307 8.01793 19.8318C8.15407 19.8313 8.28745 19.8702 8.40193 19.9441C9.12421 20.3613 9.89913 20.6794 10.7059 20.8899C10.8494 20.9236 10.9795 20.9997 11.0793 21.1083C11.1792 21.2169 11.2442 21.3531 11.2659 21.4991L11.6659 23.8717C11.6699 23.9072 11.6868 23.9399 11.7134 23.9636C11.74 23.9872 11.7744 24.0002 11.8099 24H14.0979C14.1335 24.0002 14.1679 23.9872 14.1945 23.9636C14.2211 23.9399 14.238 23.9072 14.2419 23.8717L14.6419 21.4991C14.6657 21.3539 14.7314 21.2188 14.8309 21.1105C14.9304 21.0022 15.0594 20.9255 15.2019 20.8899C16.0344 20.6729 16.8317 20.3383 17.5699 19.896C17.6946 19.8177 17.8388 19.7762 17.9859 19.7762C18.133 19.7762 18.2772 19.8177 18.4019 19.896L20.3539 21.2907C20.3902 21.3029 20.4296 21.3029 20.4659 21.2907L22.1459 19.6074C22.1595 19.5954 22.1704 19.5805 22.1779 19.564C22.1854 19.5474 22.1892 19.5294 22.1892 19.5112C22.1892 19.493 22.1854 19.475 22.1779 19.4584C22.1704 19.4418 22.1595 19.427 22.1459 19.415L20.7539 17.4432C20.6758 17.3182 20.6344 17.1738 20.6344 17.0263C20.6344 16.8789 20.6758 16.7345 20.7539 16.6095C21.1954 15.8699 21.5294 15.0709 21.7459 14.2369C21.7795 14.0931 21.8555 13.9628 21.9639 13.8627C22.0723 13.7627 22.2081 13.6976 22.3539 13.6758L24.7219 13.275C24.7559 13.2918 24.7951 13.2944 24.831 13.2824C24.867 13.2704 24.8968 13.2447 24.9139 13.2109V10.8382C24.9147 10.8007 24.9023 10.7641 24.8789 10.7348C24.8555 10.7056 24.8226 10.6854 24.7859 10.6779ZM12.9139 16.337C12.0582 16.3402 11.2207 16.0886 10.5079 15.6142C9.795 15.1398 9.23882 14.4639 8.90987 13.6724C8.58091 12.8808 8.49401 12.0092 8.66019 11.168C8.82637 10.3269 9.23813 9.55416 9.84326 8.94784C10.4484 8.34153 11.2196 7.92897 12.0591 7.76247C12.8986 7.59596 13.7685 7.68303 14.5585 8.01263C15.3485 8.34223 16.0231 8.8995 16.4965 9.61377C16.97 10.328 17.2211 11.1671 17.2179 12.0245C17.2137 13.167 16.7589 14.2614 15.9527 15.0692C15.1464 15.8771 14.0541 16.3328 12.9139 16.337Z",
  fill: "var(--icon-primary)"
}));
export const SettingsThickIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Settings",
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 27,
  viewBox: "0 0 27 27"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Settings"
}, " Settings"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill primary-stroke",
  fillRule: "evenodd",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.107 14.108c0 .344-.29.624-.649.624h-2.442c-.195 0-.367.127-.426.313-.145.459-.338.92-.574 1.371-.091.173-.059.384.08.523l1.731 1.732c.124.123.194.286.195.458.003.168-.061.325-.177.442l-2.274 2.273c-.237.235-.655.228-.9-.017l-1.735-1.735c-.138-.137-.349-.17-.522-.08-.454.237-.915.43-1.369.573-.186.058-.312.23-.312.426v2.446c0 .358-.28.65-.625.65h-3.215c-.344 0-.624-.292-.624-.65v-2.446c0-.196-.127-.368-.313-.426-.454-.143-.915-.336-1.368-.573-.066-.034-.137-.05-.207-.05-.116 0-.23.045-.316.13l-1.734 1.734c-.245.246-.665.253-.901.018L3.157 19.57c-.117-.117-.18-.274-.178-.442.002-.172.071-.335.196-.459l1.73-1.731c.14-.139.171-.35.08-.523-.235-.451-.429-.912-.573-1.371-.06-.186-.233-.313-.428-.313H1.542c-.358 0-.65-.28-.65-.624v-3.215c0-.345.292-.625.65-.625H3.98c.195 0 .367-.127.425-.313.143-.456.337-.918.575-1.376.09-.173.058-.385-.08-.523L3.174 6.331c-.253-.254-.261-.658-.018-.902L5.43 3.156c.236-.235.656-.228.902.017l1.723 1.723c.138.139.35.171.523.08.455-.238.919-.432 1.379-.577.186-.058.312-.231.312-.426v-2.43c0-.36.28-.65.625-.65h3.215c.344 0 .624.29.624.65v2.43c0 .195.126.368.313.426.46.145.924.34 1.379.577.172.091.383.059.522-.08l1.724-1.723c.245-.245.663-.253.901-.017l2.273 2.273c.244.244.236.648-.017.901L20.1 8.056c-.137.138-.17.35-.08.523.24.458.433.92.576 1.376.058.186.23.313.425.313h2.437c.358 0 .65.28.65.624v3.216zm-.649-4.733h-2.115c-.11-.305-.237-.61-.383-.915l1.498-1.499c.29-.29.452-.674.457-1.08.005-.41-.152-.795-.44-1.083l-2.273-2.273c-.573-.573-1.581-.566-2.163.017l-1.496 1.495c-.304-.146-.61-.274-.918-.384v-2.11c0-.851-.68-1.543-1.517-1.543h-3.215c-.837 0-1.518.692-1.518 1.542v2.111c-.307.11-.614.238-.918.384L6.962 2.542c-.583-.583-1.59-.59-2.164-.017L2.525 4.798c-.592.591-.584 1.562.017 2.164L4.04 8.46c-.146.304-.274.61-.383.915H1.542c-.85 0-1.542.68-1.542 1.517v3.215c0 .837.692 1.518 1.542 1.518h2.121c.11.305.237.61.382.91l-1.503 1.503c-.29.29-.453.674-.457 1.08-.005.412.152.796.44 1.084l2.273 2.273c.573.573 1.581.567 2.164-.017l1.506-1.507c.301.145.604.272.907.381v2.126c0 .85.68 1.542 1.517 1.542h3.215c.837 0 1.518-.692 1.518-1.542v-2.126c.302-.108.605-.236.907-.38l1.506 1.506c.583.583 1.59.59 2.164.017l2.273-2.273c.288-.288.444-.672.44-1.083-.006-.407-.167-.79-.457-1.08l-1.504-1.504c.146-.3.273-.605.382-.91h2.122c.85 0 1.542-.681 1.542-1.518v-3.215c0-.836-.692-1.517-1.542-1.517h0z",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 16.957c-2.462 0-4.464-2.003-4.464-4.465 0-2.462 2.002-4.464 4.464-4.464 2.462 0 4.464 2.002 4.464 4.464 0 2.462-2.002 4.465-4.464 4.465m0-9.822c-2.954 0-5.357 2.403-5.357 5.357S9.546 17.85 12.5 17.85s5.357-2.403 5.357-5.357-2.403-5.357-5.357-5.357",
  transform: "translate(1 1)"
})));
export const SettingsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Settings",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Settings"
}, " Settings"), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  d: "M22.8834 10.7881L20.7127 10.4207C20.5791 10.4007 20.4545 10.341 20.3552 10.2493C20.2558 10.1576 20.1862 10.0381 20.1554 9.90636C19.9541 9.14274 19.6481 8.41078 19.246 7.73143C19.1741 7.61976 19.1358 7.48964 19.1358 7.3567C19.1358 7.22376 19.1741 7.09364 19.246 6.98197L20.522 5.17443C20.5411 5.14899 20.5514 5.11805 20.5514 5.08625C20.5514 5.05446 20.5411 5.02352 20.522 4.99808L19.0114 3.45506C18.9951 3.44819 18.9777 3.44466 18.96 3.44466C18.9424 3.44466 18.9249 3.44819 18.9087 3.45506H18.8354L17.046 4.73357C16.9317 4.80527 16.7996 4.8433 16.6647 4.8433C16.5298 4.8433 16.3977 4.80527 16.2834 4.73357C15.5862 4.33079 14.8357 4.02897 14.054 3.83714C13.9225 3.80625 13.8033 3.73652 13.7118 3.63695C13.6202 3.53739 13.5606 3.41259 13.5407 3.27871L13.174 1.11849C13.1742 1.10173 13.1707 1.08514 13.1639 1.06982C13.1572 1.05451 13.1472 1.04083 13.1347 1.02969C13.1222 1.01856 13.1074 1.01024 13.0915 1.00527C13.0755 1.00031 13.0586 0.998827 13.0421 1.00092H10.8714C10.8548 0.998827 10.8379 1.00031 10.822 1.00527C10.806 1.01024 10.7913 1.01856 10.7788 1.02969C10.7663 1.04083 10.7563 1.05451 10.7495 1.06982C10.7427 1.08514 10.7393 1.10173 10.7394 1.11849L10.3581 3.30812C10.3432 3.45877 10.2814 3.60092 10.1814 3.71436C10.0813 3.8278 9.94812 3.90675 9.80072 3.94C9.04478 4.14619 8.31971 4.45262 7.64472 4.85113C7.5288 4.92581 7.39388 4.96552 7.25606 4.96552C7.11824 4.96552 6.98332 4.92581 6.86739 4.85113L5.13673 3.46975H5.04873C5.02051 3.45831 4.98895 3.45831 4.96073 3.46975L3.40607 5.04217C3.38702 5.0676 3.37673 5.09855 3.37673 5.13034C3.37673 5.16214 3.38702 5.19308 3.40607 5.21852L4.68206 7.02606C4.75362 7.1406 4.79158 7.273 4.79158 7.40813C4.79158 7.54327 4.75362 7.67567 4.68206 7.79021C4.29745 8.47131 4.01105 9.20356 3.8314 9.96514C3.80057 10.0969 3.73097 10.2164 3.6316 10.3081C3.53223 10.3998 3.40768 10.4595 3.27406 10.4795L1.11807 10.8469C1.08566 10.8505 1.05574 10.866 1.03407 10.8904C1.01241 10.9149 1.00053 10.9465 1.00073 10.9791V13.1687C1.00053 13.2014 1.01241 13.233 1.03407 13.2574C1.05574 13.2819 1.08566 13.2974 1.11807 13.301L3.3034 13.6684C3.45376 13.6832 3.59563 13.7452 3.70885 13.8454C3.82207 13.9457 3.90087 14.0791 3.93406 14.2268C4.13862 14.9893 4.44446 15.7208 4.8434 16.4017C4.91844 16.515 4.95848 16.6479 4.95848 16.7838C4.95848 16.9198 4.91844 17.0527 4.8434 17.1659L3.5674 18.9588C3.54836 18.9842 3.53806 19.0151 3.53806 19.0469C3.53806 19.0787 3.54836 19.1097 3.5674 19.1351L5.12206 20.6046C5.15083 20.6128 5.18129 20.6128 5.21006 20.6046H5.29806L7.10206 19.3114C7.2213 19.2245 7.36524 19.1781 7.51272 19.1792C7.63752 19.1786 7.75978 19.2144 7.86472 19.2821C8.52681 19.6645 9.23716 19.9561 9.97672 20.1491C10.1082 20.18 10.2275 20.2497 10.319 20.3493C10.4105 20.4488 10.4701 20.5736 10.4901 20.7075L10.8567 22.8824C10.8603 22.9149 10.8758 22.9449 10.9002 22.9666C10.9246 22.9883 10.9561 23.0002 10.9887 23H13.086C13.1187 23.0002 13.1502 22.9883 13.1746 22.9666C13.1989 22.9449 13.2144 22.9149 13.218 22.8824L13.5847 20.7075C13.6065 20.5744 13.6667 20.4505 13.7579 20.3513C13.8492 20.2521 13.9674 20.1818 14.098 20.1491C14.8611 19.9502 15.592 19.6434 16.2687 19.238C16.383 19.1663 16.5152 19.1282 16.65 19.1282C16.7849 19.1282 16.9171 19.1663 17.0314 19.238L18.8207 20.5165C18.854 20.5277 18.8901 20.5277 18.9234 20.5165L20.4634 18.9734C20.4759 18.9624 20.4859 18.9488 20.4927 18.9336C20.4995 18.9184 20.5031 18.9019 20.5031 18.8853C20.5031 18.8686 20.4995 18.8521 20.4927 18.8369C20.4859 18.8217 20.4759 18.8081 20.4634 18.7971L19.1874 16.9896C19.1158 16.875 19.0779 16.7426 19.0779 16.6075C19.0779 16.4723 19.1158 16.3399 19.1874 16.2254C19.592 15.5474 19.8982 14.815 20.0967 14.0505C20.1275 13.9187 20.1971 13.7992 20.2965 13.7075C20.3959 13.6158 20.5204 13.5561 20.654 13.5361L22.8247 13.1687C22.8559 13.1841 22.8918 13.1866 22.9247 13.1756C22.9577 13.1646 22.985 13.141 23.0007 13.11V10.935C23.0014 10.9007 22.99 10.8671 22.9686 10.8403C22.9472 10.8134 22.917 10.795 22.8834 10.7881ZM12.0007 15.9756C11.2163 15.9785 10.4486 15.7479 9.79516 15.313C9.1417 14.8781 8.63187 14.2586 8.33033 13.533C8.02879 12.8074 7.94913 12.0084 8.10146 11.2374C8.25379 10.4663 8.63124 9.75798 9.18594 9.20219C9.74063 8.6464 10.4476 8.26822 11.2171 8.11559C11.9866 7.96296 12.7841 8.04278 13.5083 8.34491C14.2324 8.64704 14.8508 9.15788 15.2848 9.81262C15.7188 10.4674 15.9489 11.2365 15.946 12.0225C15.9422 13.0697 15.5253 14.073 14.7862 14.8135C14.0472 15.554 13.0459 15.9717 12.0007 15.9756Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 1.8
}));
export const SizeCapacityIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Size-capacity",
  id: "ic_size_capacity",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Size-capacity"
}, " Size capacity"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  id: "Path_10693",
  "data-name": "Path 10693",
  d: "M23.2,0H.8A.8.8,0,0,0,0,.8V23.2a.8.8,0,0,0,.8.8H23.2a.8.8,0,0,0,.8-.8V.8a.8.8,0,0,0-.8-.8Zm-.8,22.4H1.6V1.6H22.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  id: "Path_10694",
  "data-name": "Path 10694",
  d: "M14.624,10.36a.8.8,0,0,0,.576-.24L19.3,5.9V8.632a.8.8,0,1,0,1.6,0v-4.7a.8.8,0,0,0-.1-.288.791.791,0,0,0-.176-.256l-.08-.048a.568.568,0,0,0-.384-.152H15.488a.8.8,0,1,0,0,1.6H18.2l-4.152,4.28a.8.8,0,0,0,.576,1.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  id: "Path_10695",
  "data-name": "Path 10695",
  d: "M3.2,20.36a.8.8,0,0,0,.112.176.762.762,0,0,0,.056.08.8.8,0,0,0,.568.24h4.7a.8.8,0,0,0,0-1.6H5.92L10.136,15.2a.8.8,0,1,0-1.112-1.152l-4.28,4.12V15.456a.8.8,0,1,0-1.6,0v4.6a.9.9,0,0,0,0,.1A.815.815,0,0,0,3.2,20.36Z"
}));
export const SnapshotIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Snapshot-copy",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.20001251399517062 -0.19999999701976778 26.80002670288086 21.25199966430664"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Snapshot-copy"
}, " Snapshot copy"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  stroke: "#fff",
  strokeWidth: 0.4,
  d: "M9.669.2h7.061a.955.955 0 0 1 .839.526Zm0 0a.989.989 0 0 0-.837.525L7.613 3.192H2.902A2.739 2.739 0 0 0 .2 5.938v11.967a2.739 2.739 0 0 0 2.7 2.747h20.6a2.739 2.739 0 0 0 2.7-2.747V5.938a2.739 2.739 0 0 0-2.7-2.747h-4.713L17.57.726Zm-.632 4.369 1.213-2.466h5.9l1.217 2.466a.955.955 0 0 0 .839.526h5.3a.815.815 0 0 1 .829.844v11.966a.815.815 0 0 1-.829.844H2.902a.815.815 0 0 1-.829-.844V5.938a.815.815 0 0 1 .829-.844h5.3a.955.955 0 0 0 .835-.525ZM13.2 5.884a5.739 5.739 0 1 0 5.644 5.738A5.706 5.706 0 0 0 13.2 5.884Zm0 1.9a3.836 3.836 0 1 1-3.771 3.835A3.79 3.79 0 0 1 13.2 7.787Z"
}));
export const SourceCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Source",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.17426021099090572 0.1999926090240478 23.62599906921387 23.6260009765625"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Source"
}, " Source"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 1a11.013 11.013 0 107.775 3.226A11 11 0 0012.001 1zm0 21.267a10.278 10.278 0 117.256-3.01A10.271 10.271 0 0112 22.267z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.931 8.074a.367.367 0 00-.519.519L16.819 12l-3.407 3.407a.367.367 0 10.519.519l3.667-3.667a.367.367 0 000-.519zm-3.861 0a.367.367 0 01.519.519L7.182 12l3.407 3.407a.367.367 0 11-.519.519l-3.667-3.667a.367.367 0 010-.519z"
})));
export const SourceVolumeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Source-volume",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.24999983608722687 0.24682775139808655 36.94900131225586 22.006519317626953"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Source-volume"
}, " Source volume"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M8.941.25a19.38 19.38 0 00-5.959.828 6.285 6.285 0 00-1.909.961 1.952 1.952 0 00-.815 1.383v.028c0 .018-.006.036-.008.055v15.5a1.916 1.916 0 00.823 1.461 6.285 6.285 0 001.909.961 19.381 19.381 0 005.959.823h1.022a19.326 19.326 0 005.951-.828 6.285 6.285 0 001.909-.961A1.926 1.926 0 0018.65 19V3.45c0-.016 0-.031-.008-.047a1.97 1.97 0 00-.823-1.367 6.285 6.285 0 00-1.909-.961A19.326 19.326 0 009.963.25zm0 1h1.022a18.5 18.5 0 015.623.773 5.385 5.385 0 011.59.789c.341.272.455.5.455.687s-.12.4-.487.68a5.944 5.944 0 01-1.7.789 20.825 20.825 0 01-5.994.782 20.885 20.885 0 01-6-.781 5.945 5.945 0 01-1.7-.789c-.367-.275-.479-.506-.479-.68s.106-.415.447-.687a5.445 5.445 0 011.6-.789 18.5 18.5 0 015.623-.774zm8.69 3.812V8.75c0 .174-.12.4-.487.68a5.944 5.944 0 01-1.7.789A20.825 20.825 0 019.453 11a20.885 20.885 0 01-6-.781 5.945 5.945 0 01-1.7-.789c-.367-.275-.479-.506-.479-.68a.367.367 0 000-.047V5.07a7.122 7.122 0 001.869.852 21.691 21.691 0 006.31.828 21.631 21.631 0 006.3-.828 7.092 7.092 0 001.877-.859zm0 5.25v3.438c0 .174-.12.4-.487.68a5.944 5.944 0 01-1.7.789A20.825 20.825 0 019.453 16a20.885 20.885 0 01-6-.781 5.945 5.945 0 01-1.7-.789c-.367-.275-.479-.506-.479-.68a.367.367 0 000-.047V10.32a7.122 7.122 0 001.869.852 21.692 21.692 0 006.31.828 21.631 21.631 0 006.3-.828 7.092 7.092 0 001.877-.859zm0 5V19c0 .186-.114.415-.455.688a5.384 5.384 0 01-1.59.789 18.5 18.5 0 01-5.623.773H8.941a18.5 18.5 0 01-5.623-.773 5.445 5.445 0 01-1.6-.789c-.341-.272-.447-.5-.447-.688v-3.68a7.122 7.122 0 001.869.852A21.691 21.691 0 009.45 17a21.631 21.631 0 006.3-.828 7.092 7.092 0 001.877-.859z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.1,
  d: "M37.199 11.989a1.009 1.009 0 00-.243-.618l-4.794-5.094a1.031 1.031 0 00-1.312-.079.936.936 0 00.01 1.315l3.371 3.577H22.35a.9.9 0 100 1.8h11.881l-3.371 3.575a.99.99 0 00-.01 1.311 1.017 1.017 0 001.311-.075l4.794-5.094a.868.868 0 00.243-.618z"
}));
export const SpyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Spy",
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 32 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Spy"
}, " Spy"), /*#__PURE__*/React.createElement("style", null, ".st0{fill-rule:evenodd;clip-rule:evenodd}"), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke primary-fill",
  d: "M23.1 12.8c-.3 0-.5-.2-.5-.5l-.4-1.6c-.3-1.4-1.7-2.2-3-1.9l-1.7.4c-.8.2-1.6.2-2.3 0l-1.7-.4c-1.4-.3-2.7.5-3 1.9l-.4 1.6c-.1.3-.3.5-.5.5-2.3.4-4.2 1.2-4.2 2.4 0 1 1.2 1.7 3 2.1.4.1.6.4.6.7l-.4 3.4c-.1.9.5 1.6 1.4 1.7 1.2.2 2.9.2 3.8.3h.5c.5 0 1-.2 1.3-.6l.5-.5c.3-.3.7-.3 1 0l.4.5c.4.4.9.6 1.4.6 1 0 2.8-.2 4.1-.3.4-.1.8-.3 1-.6.3-.3.4-.7.3-1.1l-.6-3.4c0-.3.2-.7.5-.7 1.8-.5 3-1.1 3-2.1.1-1.2-1.8-2-4.1-2.4zm0 9.1c-.1.1-.2.2-.3.2-1.2.2-3 .3-4 .3-.2 0-.4-.1-.6-.2l-.4-.5-.1-.1c-.7-.6-1.8-.6-2.5.1l-.5.5c-.1.2-.3.2-.5.2-1.7-.1-3.2-.2-4.2-.3-.3 0-.5-.3-.4-.6l.4-3.3c.1-.4.4-.6.8-.6 1.9.3 3.7.4 5.6.4 1.9 0 3.7-.1 5.6-.4.4-.1.7.2.8.6l.4 3.3c0 .2 0 .3-.1.4zm-6.7-4.8c-6.5 0-9.8-1.3-9.8-1.9 0-.3.9-.8 2.5-1.2h.2c.2.1.4.3.3.5 0 .3.1.5.4.6h.1c.3.1.6-.1.6-.4l.9-3.8c.2-.8 1-1.3 1.8-1.1l1.7.4c.9.2 1.9.2 2.8 0l1.7-.4c.8-.2 1.6.3 1.8 1.1l.9 3.8c.1.3.3.5.6.4h.1c.2-.1.4-.3.3-.6v-.2c.1-.2.3-.4.5-.3 1.7.4 2.5.9 2.5 1.2-.1.5-3.4 1.9-9.9 1.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke primary-fill",
  d: "M14.9 19.6c-.5-.4-1-.6-1.6-.6-.6 0-1.1.2-1.6.6-.2.1-.2.4-.1.5l.1.1c.5.4 1 .6 1.6.6.6 0 1.1-.2 1.6-.6.1-.2.2-.4 0-.6zm6.4 0c-.5-.4-1-.6-1.6-.6-.6 0-1.1.2-1.6.6-.2.1-.2.4-.1.5l.1.1c.5.4 1 .6 1.6.6.6 0 1.1-.2 1.6-.6.2-.2.2-.4 0-.6.1 0 .1 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke primary-fill",
  d: "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16c0-8.9-7.2-16-16-16zm0 30.6C7.9 30.7 1.4 24.1 1.4 16S7.9 1.3 16 1.3 30.7 7.9 30.7 16 24.1 30.6 16 30.6z"
}));
export const SsdIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Solid-state-disk",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 38.583 40.25"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Solid-state-disk"
}, " Solid state disk"), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12548"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 0.5,
  d: "M14.416.25a30.951 30.951 0 00-9.713 1.38 10.163 10.163 0 00-3.112 1.6 3.268 3.268 0 00-1.328 2.3v.039c0 .029-.01.06-.013.091v25.839a3.211 3.211 0 001.341 2.435 10.163 10.163 0 003.112 1.6 30.953 30.953 0 009.713 1.38h4.094c.618 0-.659-9.115 0-9.652.788-.643 11.739-1.74 11.739-2.7V5.588c0-.026-.008-.052-.013-.078a3.3 3.3 0 00-1.341-2.279 10.163 10.163 0 00-3.112-1.6 30.864 30.864 0 00-9.7-1.381zm0 1.667h1.667a29.54 29.54 0 019.167 1.289 8.706 8.706 0 012.591 1.315c.557.454.742.837.742 1.146 0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.302 33.347 33.347 0 01-9.779-1.3 9.6 9.6 0 01-2.774-1.318c-.6-.459-.781-.843-.781-1.133a1.566 1.566 0 01.734-1.145 8.8 8.8 0 012.6-1.315 29.541 29.541 0 019.167-1.289zm14.167 6.354v6.146c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.301 33.348 33.348 0 01-9.779-1.3 9.6 9.6 0 01-2.774-1.316c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078V8.284a11.492 11.492 0 003.047 1.419 34.636 34.636 0 0010.287 1.38 34.54 34.54 0 0010.273-1.38 11.444 11.444 0 003.06-1.432zm0 8.75v5.729c0 .29-.2.674-.794 1.133S19.102 26.5 15.25 26.5a33.347 33.347 0 01-9.779-1.3 9.6 9.6 0 01-2.773-1.315c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078v-5.64a11.492 11.492 0 003.046 1.416 34.636 34.636 0 0010.287 1.383 34.54 34.54 0 0010.273-1.383 11.444 11.444 0 003.06-1.432zm.312 8.177c0 .309-11.127.848-11.683 1.3s.217 5.085 0 9.036l-2.796-.284a29.54 29.54 0 01-9.166-1.29 8.8 8.8 0 01-2.6-1.31 1.566 1.566 0 01-.729-1.146v-6.137a11.492 11.492 0 003.047 1.419 34.636 34.636 0 0010.282 1.38z",
  className: "primary-fill primary-stroke",
  "data-name": "Subtraction 12"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12549"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.916 40.25h-20a1.669 1.669 0 01-1.667-1.667v-15a1.669 1.669 0 011.667-1.666h20a1.669 1.669 0 011.667 1.667v15a1.669 1.669 0 01-1.667 1.666zM23.97 34.007V35a4.1 4.1 0 001.785.338 2.705 2.705 0 001.709-.488 1.623 1.623 0 00.62-1.345 1.741 1.741 0 00-.154-.756 1.619 1.619 0 00-.483-.575 4.771 4.771 0 00-1.038-.55 5.752 5.752 0 01-.869-.418 1.079 1.079 0 01-.347-.336.831.831 0 01-.105-.428.73.73 0 01.264-.587 1.178 1.178 0 01.773-.222 4.034 4.034 0 011.529.361l.334-.857a4.521 4.521 0 00-1.839-.404 2.379 2.379 0 00-1.534.462 1.546 1.546 0 00-.566 1.265 1.73 1.73 0 00.361 1.1 2.981 2.981 0 001.239.813 4.119 4.119 0 011.125.594.8.8 0 01.273.61.777.777 0 01-.3.637 1.471 1.471 0 01-.921.238 3.971 3.971 0 01-.921-.119 4.9 4.9 0 01-.935-.326zm-4.948 0V35a4.1 4.1 0 001.785.338 2.705 2.705 0 001.709-.488 1.623 1.623 0 00.62-1.345 1.741 1.741 0 00-.154-.756 1.619 1.619 0 00-.483-.575 4.771 4.771 0 00-1.038-.55 5.752 5.752 0 01-.869-.418 1.079 1.079 0 01-.343-.335.831.831 0 01-.105-.428.73.73 0 01.264-.587 1.178 1.178 0 01.773-.222 4.034 4.034 0 011.529.361l.334-.857a4.521 4.521 0 00-1.837-.405 2.379 2.379 0 00-1.534.462 1.546 1.546 0 00-.571 1.265 1.73 1.73 0 00.361 1.1 2.981 2.981 0 001.239.813 4.119 4.119 0 011.125.594.8.8 0 01.272.61.777.777 0 01-.3.637 1.471 1.471 0 01-.921.238 3.971 3.971 0 01-.921-.119 4.9 4.9 0 01-.935-.326zm10.306-5.182v6.425h1.8a3.566 3.566 0 002.544-.842 3.219 3.219 0 00.883-2.433 3.1 3.1 0 00-.852-2.325 3.3 3.3 0 00-2.386-.826zm1.8 5.541h-.747v-4.662h.909c1.432 0 2.158.776 2.158 2.308a2.072 2.072 0 01-2.323 2.355z",
  className: "primary-fill",
  "data-name": "Subtraction 14"
})));
export const StarIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Star",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.004025966394692659 -0.003517684992402792 17.007965087890625 17.00341796875"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Star"
}, " Star"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  d: "M16.554 6.132l-5.229-.792L8.912.259a.436.436 0 00-.8 0L5.683 5.341l-5.229.782a.532.532 0 00-.424.371.561.561 0 00.133.56l3.8 3.848-.9 5.516a.51.51 0 00.192.487.466.466 0 00.505.038l4.753-2.6 4.763 2.6a.466.466 0 00.5-.046.508.508 0 00.19-.479l-.9-5.516 3.789-3.84a.561.561 0 00.131-.558.53.53 0 00-.422-.37z"
}));
export const StopWatchIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Stop-watch",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25.143,
  viewBox: "0 0 24 25.143"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Stop-watch"
}, " Stop watch"), /*#__PURE__*/React.createElement("g", {
  id: "ic_stop_watch",
  transform: "translate(-2 -1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10696",
  fill: "var(--icon-primary)",
  "data-name": "Path 10696",
  d: "M11.423,13.525,15.276,9.9a.924.924,0,0,1,1.251,0,.828.828,0,0,1,.191.269.789.789,0,0,1,0,.636.827.827,0,0,1-.191.269L12.674,14.7a.918.918,0,0,1-1.219-.021.8.8,0,0,1-.032-1.153Z",
  transform: "translate(1.314 1.236)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10697",
  fill: "var(--icon-primary)",
  "data-name": "Path 10697",
  d: "M14.536,4.7a11.573,11.573,0,0,1,7.455,3.7A10.393,10.393,0,0,1,24.7,15.947a10.514,10.514,0,0,1-3.523,7.24,11.831,11.831,0,0,1-15.644,0,10.514,10.514,0,0,1-3.523-7.24A10.393,10.393,0,0,1,4.729,8.4a11.573,11.573,0,0,1,7.458-3.7V3.219H10.858a1.207,1.207,0,0,1-.829-.325,1.068,1.068,0,0,1,0-1.569A1.207,1.207,0,0,1,10.858,1h5.007a1.207,1.207,0,0,1,.829.325,1.068,1.068,0,0,1,0,1.569,1.207,1.207,0,0,1-.829.325H14.536Zm-1.175,19.14a9.329,9.329,0,0,1-4.972-1.447A8.6,8.6,0,0,1,5.1,18.575a8.065,8.065,0,0,1-.5-4.9A8.359,8.359,0,0,1,7.07,9.338a9.137,9.137,0,0,1,4.592-2.313,9.439,9.439,0,0,1,5.176.489,8.879,8.879,0,0,1,4.019,3.126,8.167,8.167,0,0,1,1.509,4.711,8.291,8.291,0,0,1-2.648,6.006A9.263,9.263,0,0,1,13.361,23.838Z",
  transform: "translate(0 0)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10698",
  fill: "var(--icon-primary)",
  "data-name": "Path 10698",
  d: "M23.614,7.6a9.675,9.675,0,0,0-4.17-3.915,1.233,1.233,0,0,0-.894-.078,1.16,1.16,0,0,0-.69.543A1.057,1.057,0,0,0,17.778,5a1.128,1.128,0,0,0,.574.653,7.382,7.382,0,0,1,3.186,2.988,1.141,1.141,0,0,0,.434.433,1.226,1.226,0,0,0,.608.158,1.21,1.21,0,0,0,.549-.13,1.16,1.16,0,0,0,.356-.273,1.089,1.089,0,0,0,.217-.381,1.05,1.05,0,0,0,.046-.431,1.062,1.062,0,0,0-.132-.415Z",
  transform: "translate(2.246 0.366)"
})));
export const SubscriptionIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Subscription",
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 28,
  viewBox: "0 0 25 28"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Subscription"
}, " Subscription"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fill: "#434957"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.264 0H7.027C4.994 0 3.333 1.698 3.333 3.778v3.496H5.41V3.778c0-.892.705-1.656 1.618-1.656h14.279c.872 0 1.619.722 1.619 1.656v14.6c0 .892-.706 1.656-1.62 1.656h-9.638v2.123h9.639c2.034 0 3.694-1.698 3.694-3.778V3.778C24.958 1.698 23.298 0 21.264 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.519 27.053v-.784C2.107 25.936.981 24.934.545 23.625a.851.851 0 0 1 .135-.798.967.967 0 0 1 .763-.369c.468-.003.888.271 1.05.685.307.808 1.12 1.347 2.03 1.348.996 0 2.158-.44 2.158-1.682 0-.962-1.304-1.721-2.685-2.525C2.29 19.291.357 18.166.357 16.148c0-1.771 1.283-3.124 3.162-3.48v-.765c0-.523.45-.946 1.005-.946.555 0 1.004.423 1.004.946v.784c1.412.334 2.539 1.335 2.975 2.644a.851.851 0 0 1-.136.799.967.967 0 0 1-.763.368c-.467.003-.887-.27-1.049-.684-.308-.808-1.12-1.348-2.031-1.349-.995 0-2.157.441-2.157 1.683 0 .962 1.304 1.721 2.685 2.525 1.705.993 3.638 2.118 3.638 4.136 0 1.77-1.282 3.124-3.162 3.48v.764c0 .523-.45.947-1.004.947-.555 0-1.005-.424-1.005-.947z"
})));
export const SuccessCircleThinIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Success",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.25 25.25"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Success"
}, " Success"), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  className: "primary-stroke",
  strokeMiterlimit: 10,
  strokeWidth: 1.25,
  d: "M12.625.625a12 12 0 11-12 12 12 12 0 0112-12z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M17.755 8.625a.862.862 0 00-.594.263c-2.137 2.141-4.084 4.254-6.161 6.364l-2.628-2.1a.865.865 0 00-1.081 1.351l3.243 2.594a.865.865 0 001.155-.068c2.324-2.329 4.413-4.625 6.7-6.918a.865.865 0 00-.635-1.486z"
}));
export const SuccessCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Success",
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  viewBox: "-1 -1 26 26"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Success"
}, " Success"), /*#__PURE__*/React.createElement("circle", {
  className: "primary-stroke",
  cx: 12,
  cy: 12,
  r: 11,
  fill: "none",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M16.789 8.745a1.187 1.187 0 00-1.672 0l-4.256 4.256-1.842-1.841a1.182 1.182 0 10-1.673 1.667l2.678 2.678a1.183 1.183 0 001.672 0l5.091-5.093a1.183 1.183 0 000-1.672z"
}));
export const SuitcaseIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Suitcase",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Suitcase"
}, " Suitcase"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0002 0C24.3174 0 27.8378 3.42032 27.9938 7.7L28 8H32C36.4188 8 40 11.5812 40 16V32C40 36.4188 36.4188 40 32 40H8C3.5812 40 0 36.4188 0 32V16C0 11.5812 3.58124 8 8 8H12C12 3.5812 15.5812 0 20 0H20.0002ZM32.0002 10.6672H8.00015C5.05483 10.6672 2.66735 13.0547 2.66735 16V32C2.66735 34.9453 5.05487 37.3328 8.00015 37.3328H32.0002C34.9455 37.3328 37.333 34.9453 37.333 32V16C37.333 13.0547 34.9454 10.6672 32.0002 10.6672ZM12.0002 26.6672C12.7361 26.6672 13.333 27.2641 13.333 28V30.6672C13.333 31.4031 12.7361 32 12.0002 32H9.33295C8.59703 32 8.00015 31.4031 8.00015 30.6672V28C8.00015 27.2641 8.59703 26.6672 9.33295 26.6672H12.0002ZM25.333 28C26.0705 28 26.6673 28.5969 26.6673 29.3328C26.6673 30.0703 26.0704 30.6672 25.333 30.6672H18.6674C17.9298 30.6672 17.333 30.0703 17.333 29.3328C17.333 28.5969 17.9299 28 18.6674 28H25.333ZM12.0002 16C12.7361 16 13.333 16.5969 13.333 17.3328V20C13.333 20.7359 12.7361 21.3328 12.0002 21.3328H9.33295C8.59703 21.3328 8.00015 20.7359 8.00015 20V17.3328C8.00015 16.5969 8.59703 16 9.33295 16H12.0002ZM30.6674 17.3328C31.4033 17.3328 32.0002 17.9297 32.0002 18.6672C32.0002 19.4031 31.4033 20 30.6674 20H18.6674C17.9298 20 17.333 19.4031 17.333 18.6672C17.333 17.9296 17.9299 17.3328 18.6674 17.3328H30.6674ZM20.0002 2.6672C17.0548 2.6672 14.6674 5.05472 14.6674 8H25.333L25.3267 7.73438C25.1876 4.9125 22.8564 2.66718 20.0003 2.66718L20.0002 2.6672Z",
  fill: "var(--icon-primary)"
}));
export const SupportMonochromeIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 31,
  height: 28,
  viewBox: "0 0 31 28"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fillRule: "nonzero",
  d: "M27.854 19.056c-.572 2.461-1.79 4.655-3.448 6.362.022.106.035.217.035.33 0 .787-.59 1.425-1.317 1.425s-1.316-.638-1.316-1.425c0-.786.59-1.424 1.316-1.424.291 0 .56.102.778.274 1.462-1.56 2.5-3.467 3.017-5.542h-1.898v-7.664h1.42C25.588 5.492 20.802.959 15.037.959c-5.765 0-10.55 4.534-11.403 10.435H4.98v7.663H1.897c-1.23 0-1.862-.578-1.896-1.732V13.31c0-1.277.476-1.916 1.428-1.916h1.29C3.58 4.961 8.774 0 15.039 0c6.264 0 11.458 4.961 12.318 11.393h1.216c.953 0 1.428.638 1.428 1.916v4.016c-.035 1.155-.668 1.732-1.898 1.732h-.248v-.001zm-24.048-.983v-5.697H1.928c-.504 0-.755.475-.755 1.424v2.985c.018.859.353 1.288 1.003 1.288h1.63zm22.388 0h1.63c.65 0 .985-.43 1.003-1.287V13.8c0-.95-.251-1.425-.755-1.425h-1.878v5.697z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  d: "M19.045 19.205l.843-.89c.34-.357.37-.845.074-1.246l-.427-.582c.087-.188.163-.381.227-.579l.72-.108c.46-.07.768-.439.768-.918v-1.298c0-.48-.31-.848-.77-.917l-.718-.109c-.075-.23-.166-.454-.273-.671l.419-.594c.289-.405.248-.894-.104-1.244-.284-.291-.574-.585-.865-.88-.317-.336-.841-.368-1.197-.073l-.565.444c-.18-.09-.367-.17-.558-.236l-.105-.741c-.067-.479-.424-.8-.89-.8h-1.248c-.463 0-.82.318-.89.79l-.104.75c-.224.078-.44.172-.65.282-.181-.138-.373-.282-.577-.435-.358-.28-.872-.24-1.181.093-.201.21-.863.91-.863.91-.338.357-.367.845-.073 1.244l.428.583c-.088.188-.165.382-.228.577l-.72.11c-.459.069-.768.44-.768.925v1.283c0 .486.31.857.773.925l.715.108c.074.228.165.454.273.671-.095.133-.419.595-.419.595-.291.407-.253.883.099 1.24l.87.883c.233.233.474.282.635.282.2 0 .39-.07.564-.21l.563-.443c.181.092.369.171.56.237.022.172.103.739.103.739.069.48.427.801.89.801h1.248c.463 0 .82-.317.889-.79l.105-.75c.218-.076.436-.17.65-.282l.569.43c.386.293.875.25 1.207-.106h0zM15 16.821c-1.379 0-2.5-1.161-2.5-2.588s1.121-2.587 2.5-2.587c1.378 0 2.5 1.16 2.5 2.587 0 1.427-1.122 2.588-2.5 2.588z"
})));
export const SvmIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Storage-virtual-machine",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Storage-virtual-machine"
}, " Storage virtual machine"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_844_23466)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 5.5C1.6 5.5 0.5 6.8 0.5 8.3V10.7C0.5 12.3 1.6 13.5 3 13.5H16.6C18 13.5 19.1 12.2 19.1 10.7V8.3C19.1 6.7 18 5.5 16.6 5.5H3ZM1.9 8.3C1.9 7.6 2.4 7 3.1 7H16.7C17.3 7 17.9 7.6 17.9 8.3V10.7C17.9 11.4 17.4 12 16.7 12H3C2.4 12 1.8 11.4 1.8 10.7V8.3H1.9Z",
  className: "primary-fill",
  fill: "#0067C5"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 15.3999C1.6 15.3999 0.5 16.6999 0.5 18.1999V20.5999C0.5 22.1999 1.6 23.4999 3 23.4999H16.6C18 23.4999 19.1 22.1999 19.1 20.6999V18.2999C19.1 16.6999 18 15.4999 16.6 15.4999H3V15.3999ZM1.9 18.1999C1.9 17.4999 2.4 16.8999 3.1 16.8999H16.7C17.3 16.8999 17.9 17.4999 17.9 18.1999V20.5999C17.9 21.2999 17.4 21.8999 16.7 21.8999H3C2.4 21.8999 1.8 21.2999 1.8 20.5999V18.1999H1.9Z",
  className: "primary-fill",
  fill: "#0067C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.9998 4.6999V2.9999C6.9998 2.4999 7.3998 2.0999 7.8998 2.0999H8.8998V0.399902H7.8998C6.4998 0.399902 5.2998 1.5999 5.2998 2.9999V4.5999H6.9998V4.6999Z",
  className: "primary-fill",
  fill: "#0067C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.7999 15.3999V16.9999C22.7999 17.4999 22.3999 17.8999 21.8999 17.8999H20.8999V19.5999H21.8999C23.2999 19.5999 24.4999 18.3999 24.4999 16.9999V15.3999H22.7999Z",
  className: "primary-fill",
  fill: "#0067C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2998 2.2H21.8998C22.3998 2.2 22.7998 2.6 22.7998 3.1V4.1H24.4998V3.1C24.4998 1.7 23.2998 0.5 21.8998 0.5H20.2998V2.2Z",
  className: "primary-fill",
  fill: "#0067C5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.7997 0.399902H10.6997V2.0999H13.7997V0.399902Z",
  className: "primary-fill",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4999 0.399902H15.3999V2.0999H18.4999V0.399902Z",
  className: "primary-fill",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.4998 5.7998H22.7998V8.8998H24.4998V5.7998Z",
  className: "primary-fill",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.4998 10.5H22.7998V13.6H24.4998V10.5Z",
  className: "primary-fill",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_844_23466"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 23,
  fill: "white",
  transform: "translate(0.5 0.5)"
}))));
export const SyncAsSourceIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Sync-as-source",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.325000762939453 16.600000381469727"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Sync-as-source"
}, " Sync as source"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  d: "M0 8.3C0 3.7 3.7 0 8.3 0c2.4 0 4.6 1 6.2 2.8l-.1.1-.9.9c-1.3-1.5-3.2-2.4-5.2-2.4-3.8 0-6.9 3.1-6.9 6.9 0 3.8 3.1 6.9 6.9 6.9 2 0 3.9-.9 5.2-2.4l1 1c-1.6 1.8-3.8 2.8-6.2 2.8-4.6 0-8.3-3.7-8.3-8.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  d: "M19.1 8.8c.3-.3.3-.7 0-1l-3-3c-.3-.2-.7-.2-1 .1-.2.3-.2.6 0 .9l1.8 1.8h-6c-.4 0-.7.3-.7.7s.4.7.7.7h6l-1.8 1.8c-.3.3-.3.7 0 1 .3.3.7.3 1 0l3-3z"
}));
export const SyncAsTargetIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Sync-as-target",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.025000005960464478 0 19.32499885559082 16.60491371154785"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Sync-as-target"
}, " Sync as target"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  d: "M19.3 8.3C19.3 3.7 15.6 0 11 0 8.7 0 6.4 1 4.8 2.8l.1.1.9.9C8.3.9 12.7.6 15.5 3.1s3.2 6.9.7 9.7-6.8 3.2-9.7.7c-.2-.2-.5-.4-.7-.7l-1 1c3 3.4 8.3 3.8 11.7.7 1.8-1.5 2.8-3.8 2.8-6.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "var(--icon-primary)",
  d: "M.2 8.8c-.3-.3-.3-.7 0-1l3-3c.3-.3.7-.3 1 0 .3.3.3.7 0 1L2.4 7.6h6c.4 0 .7.3.7.7s-.3.7-.7.7h-6l1.8 1.8c.3.3.3.7 0 1-.3.3-.7.3-1 0l-3-3z"
}));
export const SystemIdIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-System-ID",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-System-ID"
}, " System ID"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3306 6.73037C11.3517 6.72474 11.3728 6.71912 11.3943 6.71912C11.4464 6.71959 11.4993 6.73973 11.5406 6.7716C11.5818 6.80348 11.6095 6.84895 11.6231 6.8991L11.9381 8.0766C12.3164 8.07051 12.7012 8.1202 13.0743 8.2266L13.6818 7.1691C13.6973 7.14192 13.7207 7.11707 13.7456 7.09785C13.7704 7.07863 13.7976 7.06457 13.8281 7.0566C13.8585 7.04864 13.8909 7.04864 13.9218 7.05285C13.9528 7.05707 13.9846 7.06692 14.0118 7.08285L15.2531 7.79911C15.2803 7.81505 15.3051 7.83427 15.3244 7.85911C15.3436 7.88395 15.3576 7.91489 15.3656 7.94536C15.3736 7.97583 15.3736 8.00817 15.3694 8.03911C15.3651 8.07005 15.3548 8.09817 15.3394 8.12536L14.7319 9.18286C15.0108 9.45286 15.2419 9.76036 15.4256 10.0904L16.6031 9.77536C16.6336 9.76645 16.6659 9.76364 16.6969 9.76786C16.7278 9.77208 16.7597 9.78239 16.7869 9.79786C16.814 9.81333 16.8389 9.83677 16.8581 9.86161C16.8773 9.88645 16.8914 9.91364 16.8994 9.94411L17.2706 11.3315C17.2795 11.362 17.2823 11.3944 17.2781 11.4253C17.2739 11.4562 17.2636 11.4844 17.2481 11.5115C17.2326 11.5387 17.2092 11.5636 17.1844 11.5828C17.1595 11.602 17.1319 11.6156 17.1019 11.6241L15.9206 11.9466C15.9267 12.3225 15.8803 12.7008 15.7743 13.0715L16.8318 13.6828C16.859 13.6987 16.8801 13.7217 16.8993 13.7466C16.9186 13.7714 16.9326 13.7986 16.9406 13.8291C16.9495 13.8595 16.9523 13.8919 16.9481 13.9228C16.9439 13.9537 16.9336 13.9856 16.9181 14.0128L16.2018 15.2541C16.1859 15.2813 16.1629 15.3061 16.1381 15.3253C16.1132 15.3446 16.0861 15.3586 16.0556 15.3666C16.0251 15.3741 15.9928 15.3783 15.9618 15.3741C15.9309 15.3699 15.899 15.36 15.8718 15.3441L14.8143 14.7328C14.5434 15.0122 14.2387 15.2466 13.9068 15.4303L14.2256 16.6078C14.2336 16.6383 14.2336 16.6702 14.2293 16.7016C14.2251 16.733 14.2153 16.7606 14.1993 16.7878C14.1839 16.815 14.1642 16.8399 14.1393 16.8591C14.1145 16.8783 14.0873 16.8924 14.0568 16.9003L12.6694 17.2716C12.6389 17.2791 12.6066 17.2833 12.5756 17.2791C12.5447 17.2749 12.5128 17.2646 12.4856 17.2491C12.4585 17.2336 12.4336 17.2102 12.4144 17.1853C12.3952 17.1605 12.3811 17.1333 12.3731 17.1028L12.0581 15.9253C11.6799 15.9314 11.2983 15.8817 10.9256 15.7753L10.3181 16.8291C10.3027 16.8563 10.2792 16.8811 10.2544 16.9003C10.2296 16.9195 10.2024 16.9336 10.1719 16.9416C10.1414 16.9491 10.1091 16.9533 10.0781 16.9491C10.0472 16.9449 10.0153 16.9345 9.98814 16.9191L8.74314 16.1991C8.71596 16.1831 8.69486 16.1639 8.67564 16.1391C8.65643 16.1142 8.64236 16.087 8.63439 16.0566C8.62549 16.0261 8.62268 15.9938 8.62689 15.9628C8.63111 15.9319 8.64096 15.9 8.65689 15.8728L9.26815 14.8153C8.98925 14.5458 8.7544 14.2421 8.57065 13.9116L7.39315 14.2266C7.36268 14.2341 7.33034 14.2383 7.2994 14.2341C7.26846 14.2299 7.24034 14.22 7.21315 14.2041C7.18596 14.1886 7.16112 14.1652 7.1419 14.1403C7.12268 14.1155 7.10862 14.0883 7.10065 14.0578L6.7294 12.6704C6.72049 12.6399 6.71768 12.6076 6.7219 12.5766C6.72611 12.5457 6.73643 12.5138 6.7519 12.4866C6.76736 12.4595 6.78705 12.4384 6.8119 12.4191C6.83674 12.3999 6.86768 12.3859 6.89815 12.3779L8.07565 12.0592C8.07002 11.6813 8.11924 11.2998 8.22565 10.9267L7.16815 10.3154C7.14096 10.2995 7.11611 10.2802 7.0969 10.2554C7.07768 10.2306 7.06361 10.2034 7.05564 10.1729C7.04768 10.1424 7.04768 10.1101 7.0519 10.0791C7.05611 10.0482 7.06596 10.0163 7.0819 9.98915L7.79815 8.74787C7.81362 8.72068 7.83706 8.69584 7.8619 8.67662C7.88674 8.6574 7.91393 8.64334 7.9444 8.63537C7.97487 8.62646 8.00721 8.62365 8.03815 8.62787C8.06909 8.63209 8.09721 8.6424 8.1244 8.65787L9.1819 9.26912C9.4519 8.99022 9.75893 8.75537 10.0894 8.57162L9.7744 7.39412C9.76549 7.36365 9.76268 7.33131 9.7669 7.30037C9.77112 7.26943 9.78096 7.23756 9.7969 7.21037C9.81284 7.18319 9.83581 7.16209 9.86065 7.14287C9.88549 7.12365 9.91268 7.10959 9.94315 7.10162L11.3306 6.73037ZM13.213 9.89906C12.8334 9.68015 12.4158 9.57656 12.0056 9.57656C11.1656 9.5756 10.3466 10.0111 9.89801 10.7878C9.22916 11.9452 9.62942 13.4302 10.7868 14.0991C11.9442 14.7666 13.4305 14.3714 14.098 13.2141C14.7656 12.0567 14.3704 10.568 13.213 9.89906Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4C0 2.89543 0.895431 2 2 2H22C23.1046 2 24 2.89543 24 4V20C24 21.1046 23.1046 22 22 22H2C0.89543 22 0 21.1046 0 20V4ZM2.2 19.8V4.2H21.8V19.8H2.2Z",
  fill: "var(--icon-primary)"
}));
export const TableSortAscIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Sort-ascending",
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 4
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Sort-ascending"
}, "Sort ascending"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fillRule: "evenodd",
  d: "M3 0L0 4h6L3 0z"
}));
export const TableSortDescIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Sort-descending",
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 4
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Sort-descending"
}, "Sort descending"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fillRule: "evenodd",
  d: "M3 4L0 0h6L3 4z"
}));
export const TableViewIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Table-view",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Table-view"
}, " Table view"), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23 21.25H7.98a.25.25 0 01-.25-.25v-4a.25.25 0 01.25-.25H23a.25.25 0 01.25.25v4a.25.25 0 01-.25.25zm-18 0H1A.25.25 0 01.75 21v-4a.25.25 0 01.25-.25h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25zm18-7H7.98a.25.25 0 01-.25-.25v-4a.25.25 0 01.25-.25H23a.25.25 0 01.25.25v4a.25.25 0 01-.25.25zm-18 0H1A.25.25 0 01.75 14v-4A.25.25 0 011 9.75h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25zm18-7H7.98A.25.25 0 017.73 7V3a.25.25 0 01.25-.25H23a.25.25 0 01.25.25v4a.25.25 0 01-.25.25zm-18 0H1A.25.25 0 01.75 7V3A.25.25 0 011 2.75h4a.25.25 0 01.25.25v4a.25.25 0 01-.25.25z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M22.5 20.5v-3H8.48v3H22.5m-18 0v-3h-3v3h3m18-7v-3H8.48v3H22.5m-18 0v-3h-3v3h3m18-7v-3H8.48v3H22.5m-18 0v-3h-3v3h3M23 22H7.98a1 1 0 01-1-1v-4a1 1 0 011-1H23a1 1 0 011 1v4a1 1 0 01-1 1zM5 22H1a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zm18-7H7.98a1 1 0 01-1-1v-4a1 1 0 011-1H23a1 1 0 011 1v4a1 1 0 01-1 1zM5 15H1a1 1 0 01-1-1v-4a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1zm18-7H7.98a1 1 0 01-1-1V3a1 1 0 011-1H23a1 1 0 011 1v4a1 1 0 01-1 1zM5 8H1a1 1 0 01-1-1V3a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}));
export const TagIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Tag",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.10031541883945466 -0.09957875013351442 33.56841506958008 33.65067138671875"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Tag"
}, " Tag"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.589 5.155a4.689 4.689 0 104.69 4.689 4.692 4.692 0 00-4.69-4.689zm0 7a2.253 2.253 0 110-4.506 2.253 2.253 0 010 4.506z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.824.101l-9.379.3a6.758 6.758 0 00-4.262 1.948L1.607 15.934a5.109 5.109 0 000 7.247l8.647 8.647a5.183 5.183 0 003.592 1.523 4.925 4.925 0 003.592-1.523l13.58-13.58a6.61 6.61 0 001.948-4.262l.3-9.377A4.373 4.373 0 0028.824.101zm1.766 13.7a4.065 4.065 0 01-1.218 2.68L15.733 30.122a2.685 2.685 0 01-3.776 0l-8.645-8.648a2.685 2.685 0 010-3.776l13.58-13.58A4.05 4.05 0 0119.511 2.9l9.377-.3a1.876 1.876 0 011.948 1.948z"
})));
export const TargetVolumeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Target-volume",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.05000002682209015 0.24682752788066864 38.20000076293945 22.006519317626953"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Target-volume"
}, " Target volume"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M28.541.25a19.38 19.38 0 00-5.959.828 6.285 6.285 0 00-1.909.961 1.952 1.952 0 00-.815 1.383v.028c0 .018-.006.036-.008.055v15.5a1.916 1.916 0 00.823 1.461 6.285 6.285 0 001.909.961 19.381 19.381 0 005.959.823h1.022a19.326 19.326 0 005.951-.828 6.285 6.285 0 001.909-.961A1.926 1.926 0 0038.25 19V3.45c0-.016 0-.031-.008-.047a1.97 1.97 0 00-.823-1.367 6.285 6.285 0 00-1.909-.961A19.326 19.326 0 0029.563.25zm0 1h1.022a18.5 18.5 0 015.623.773 5.385 5.385 0 011.59.789c.341.272.455.5.455.687s-.12.4-.487.68a5.944 5.944 0 01-1.7.789 20.825 20.825 0 01-5.994.782 20.885 20.885 0 01-6-.781 5.945 5.945 0 01-1.7-.789c-.367-.275-.479-.506-.479-.68s.106-.415.447-.687a5.445 5.445 0 011.6-.789 18.5 18.5 0 015.623-.774zm8.69 3.812V8.75c0 .174-.12.4-.487.68a5.944 5.944 0 01-1.7.789 20.825 20.825 0 01-5.991.781 20.885 20.885 0 01-6-.781 5.945 5.945 0 01-1.7-.789c-.367-.275-.479-.506-.479-.68a.367.367 0 000-.047V5.07a7.122 7.122 0 001.869.852 21.691 21.691 0 006.31.828 21.631 21.631 0 006.3-.828 7.092 7.092 0 001.877-.859zm0 5.25v3.438c0 .174-.12.4-.487.68a5.944 5.944 0 01-1.7.789 20.825 20.825 0 01-5.991.781 20.885 20.885 0 01-6-.781 5.945 5.945 0 01-1.7-.789c-.367-.275-.479-.506-.479-.68a.367.367 0 000-.047V10.32a7.122 7.122 0 001.869.852 21.692 21.692 0 006.31.828 21.631 21.631 0 006.3-.828 7.092 7.092 0 001.877-.859zm0 5V19c0 .186-.114.415-.455.688a5.384 5.384 0 01-1.59.789 18.5 18.5 0 01-5.623.773h-1.022a18.5 18.5 0 01-5.623-.773 5.445 5.445 0 01-1.6-.789c-.341-.272-.447-.5-.447-.688v-3.68a7.122 7.122 0 001.869.852 21.691 21.691 0 006.31.828 21.631 21.631 0 006.3-.828 7.092 7.092 0 001.877-.859z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.1,
  d: "M15.799 11.989a1.009 1.009 0 00-.243-.618l-4.794-5.094a1.031 1.031 0 00-1.312-.079.936.936 0 00.01 1.315l3.371 3.577H.95a.9.9 0 100 1.8h11.881L9.46 16.465a.99.99 0 00-.01 1.311 1.017 1.017 0 001.311-.075l4.794-5.094a.868.868 0 00.243-.618z"
}));
export const TechnicalSupportIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Technical-support",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Technical-support"
}, " Technical support"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fillRule: "evenodd",
  strokeWidth: 0.4,
  d: "M9.363 15.435c0-.361.295-.642.657-.642h1.604v4.777H10.02a.655.655 0 01-.657-.653v-3.482zm13.274 0v3.482a.655.655 0 01-.656.653h-1.605v-4.777h1.605c.36 0 .656.28.656.642zm-7.075 8.161a.528.528 0 01-1.058 0v-.051a.53.53 0 01.53-.525.53.53 0 01.528.525v.051zm-5.543-3.15h2.028a.45.45 0 00.452-.435v-5.67c0-.24-.208-.423-.452-.423H10.42V13.6c0-3.158 2.51-5.726 5.58-5.726 3.07 0 5.58 2.568 5.58 5.726v.317h-1.627c-.24 0-.452.182-.452.423v5.67c0 .241.208.434.452.434h.423v1.448c0 .682-.558 1.25-1.24 1.25h-2.779a1.384 1.384 0 00-1.334-.991c-.77 0-1.397.62-1.397 1.393v.051c0 .77.623 1.404 1.397 1.404.627 0 1.156-.434 1.334-.98h2.78a2.128 2.128 0 002.114-2.127v-1.448h.73a1.53 1.53 0 001.531-1.528v-3.482c0-.682-.438-1.262-1.058-1.459V13.6C22.454 9.962 19.552 7 16 7c-3.552 0-6.455 2.961-6.455 6.6v.376a1.523 1.523 0 00-1.057 1.459v3.482a1.53 1.53 0 001.531 1.528z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-stroke",
  strokeWidth: 2,
  d: "M31 16c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1c8.284 0 15 6.716 15 15z"
}));
export const TemplateIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Template",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17.4 19.4"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Template"
}, " Template"), /*#__PURE__*/React.createElement("g", {
  className: "primary-stroke",
  "data-name": "template icom"
}, /*#__PURE__*/React.createElement("g", {
  className: "secondary-fill",
  strokeWidth: 1.7,
  "data-name": "Rectangle 591",
  transform: "translate(1.7 1.7)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 16,
  stroke: "none",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 15.7,
  height: 17.7,
  x: -0.85,
  y: -0.85,
  fill: "none",
  rx: 1.85
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  d: "M5.2 6.2h7",
  "data-name": "Line 170"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  d: "M5.2 12.2h7",
  "data-name": "Line 174"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  d: "M5.2 9.2h7",
  "data-name": "Line 173"
})));
export const TooltipIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Tooltip",
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  viewBox: "0 0 13 13"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Tooltip"
}, " Tooltip"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.5 0A6.499 6.499 0 0 0 0 6.497a6.5 6.5 0 0 0 13 0A6.497 6.497 0 0 0 6.5 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#688BB7",
  d: "M7.113 7.627H5.824L5.439 2H7.49l-.378 5.627zM5.35 9.902c0-.352.096-.62.289-.802.192-.183.467-.275.822-.275.35 0 .62.095.807.285.188.19.282.454.282.792 0 .337-.095.605-.285.802-.19.197-.458.296-.804.296-.35 0-.623-.095-.818-.285-.195-.19-.293-.461-.293-.813z"
})));
export const UpgradeNowIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Upgrade-now",
  xmlns: "http://www.w3.org/2000/svg",
  id: "ic_spaceship",
  viewBox: "0 0 20 20"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Upgrade-now"
}, " Upgrade now"), /*#__PURE__*/React.createElement("path", {
  id: "_24px_shape",
  fill: "none",
  d: "M0 0h20v20H0z",
  "data-name": "24px_shape"
}), /*#__PURE__*/React.createElement("g", {
  id: "np_spaceship_2493748_000000",
  transform: "translate(.54 .54)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  id: "Path_10415",
  d: "M23.012 5.01a.332.332 0 0 0-.212-.21 9.021 9.021 0 0 0-2.632-.371 7.771 7.771 0 0 0-5.765 2.39 36.194 36.194 0 0 0-3.15 3.881c-.788-.417-3.084-1.447-4.205.027a40.056 40.056 0 0 0-2.553 4.045.332.332 0 0 0 .345.487 9.786 9.786 0 0 1 3.889.017l.174.174-.921.418a.331.331 0 0 0-.1.536l.528.528a5.509 5.509 0 0 0-2.5 4.647.331.331 0 0 0 .316.315c.077 0 .154.006.23.006a5.575 5.575 0 0 0 4.419-2.5l.528.528a.328.328 0 0 0 .234.1.3.3 0 0 0 .06-.006.331.331 0 0 0 .242-.189l.418-.92.174.174a9.764 9.764 0 0 1 .016 3.886.331.331 0 0 0 .327.386.328.328 0 0 0 .16-.041 40.063 40.063 0 0 0 4.046-2.552c1.475-1.12.444-3.415.028-4.2a36.28 36.28 0 0 0 3.885-3.166c3.625-3.43 2.035-8.34 2.019-8.39zM5.4 14.513a35.673 35.673 0 0 1 2.172-3.384c.776-1.021 2.574-.248 3.293.121a44.468 44.468 0 0 0-2.1 3.335 9.7 9.7 0 0 0-3.36-.072zm4.995 4.4a5.079 5.079 0 0 1-3.828 2.318 5.081 5.081 0 0 1 2.323-3.824l.755.754zm1.137.2-2.841-2.841.711-.324 2.456 2.452zm5.145 1.113A35.608 35.608 0 0 1 13.3 22.4a9.712 9.712 0 0 0-.072-3.359c.52-.3 1.8-1.043 3.336-2.1.365.722 1.13 2.524.123 3.29zm3.855-7.306a42.893 42.893 0 0 1-7.665 5.558l-3.539-3.541a42.788 42.788 0 0 1 5.561-7.661 7.126 7.126 0 0 1 5.284-2.182 8.939 8.939 0 0 1 2.259.289c.225.838 1.064 4.739-1.894 7.539z",
  "data-name": "Path 10415",
  transform: "translate(-4.454 -4.43)"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  id: "Path_10416",
  d: "M60.424 20.73a2.188 2.188 0 1 0 1.546.641 2.173 2.173 0 0 0-1.546-.641zm1.076 3.264a1.521 1.521 0 1 1 .447-1.078 1.515 1.515 0 0 1-.447 1.078z",
  "data-name": "Path 10416",
  transform: "translate(-47.066 -17.346)"
})));
export const UserFillIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-User",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-User"
}, " User"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9139 24C19.5414 24 24.9139 18.6274 24.9139 12C24.9139 5.37258 19.5414 0 12.9139 0C6.28652 0 0.91394 5.37258 0.91394 12C0.91394 18.6274 6.28652 24 12.9139 24ZM16.1358 12.5411C15.8169 12.3604 15.4285 12.4336 15.1059 12.6076C14.4608 12.9553 13.6815 13.1161 12.9138 13.1161C12.0572 13.1161 11.3481 12.8306 10.9066 12.5934C10.5884 12.4224 10.2023 12.3559 9.88241 12.5238C8.41855 13.2922 7.58999 14.6157 7.33395 16.5257C7.29138 16.8432 7.42304 17.159 7.67624 17.3553C9.29688 18.6121 11.0676 19.2405 12.9883 19.2405C14.9099 19.2405 16.6389 18.6686 18.1752 17.5247C18.4151 17.346 18.5557 17.0613 18.538 16.7627C18.4817 15.8102 18.1361 13.6749 16.1358 12.5411ZM16.7489 7.76047C16.7489 9.83733 15.0652 11.5209 12.9884 11.5209C10.9115 11.5209 9.22791 9.83733 9.22791 7.76047C9.22791 5.68362 10.9115 4 12.9884 4C15.0652 4 16.7489 5.68362 16.7489 7.76047Z",
  fill: "var(--icon-primary)"
}));
export const UserIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-User",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-User"
}, " User"), /*#__PURE__*/React.createElement("path", {
  d: "M12.002 0.500003C9.64753 0.498394 7.34938 1.21987 5.41831 2.56687C3.48725 3.91387 2.01642 5.82141 1.20474 8.03152C0.39306 10.2416 0.279682 12.6477 0.879939 14.9243C1.4802 17.201 2.76513 19.2384 4.56098 20.761C4.81297 20.978 5.07498 21.181 5.34298 21.372C5.41097 21.421 5.47498 21.472 5.54297 21.513C7.44651 22.8072 9.69516 23.4992 11.997 23.4992C14.2988 23.4992 16.5474 22.8072 18.451 21.513C18.521 21.467 18.586 21.413 18.651 21.372C18.921 21.18 19.184 20.977 19.436 20.758C21.2302 19.2355 22.5139 17.199 23.1137 14.9235C23.7134 12.6481 23.6004 10.2434 22.7897 8.03429C21.979 5.82519 20.5098 3.91813 18.5806 2.57073C16.6514 1.22334 14.3551 0.500553 12.002 0.500003ZM12.002 22.149C10.7973 22.1494 9.60221 21.9347 8.47298 21.515C8.35398 21.469 8.23497 21.415 8.11597 21.374C7.35723 21.0592 6.64016 20.6522 5.98098 20.162C5.97234 20.1565 5.9643 20.1501 5.95697 20.143C6.16193 18.6919 6.88885 17.3652 8.00159 16.4115C9.11434 15.4578 10.5366 14.9425 12.002 14.962C13.4686 14.9423 14.8921 15.4582 16.0057 16.4128C17.1192 17.3675 17.8464 18.6956 18.051 20.148L18.024 20.167C17.3648 20.6572 16.6477 21.0642 15.889 21.379C15.77 21.428 15.651 21.479 15.532 21.52C14.4026 21.9384 13.2074 22.1514 12.003 22.149H12.002ZM8.73398 10.339C8.73378 9.69221 8.92539 9.0599 9.28458 8.52202C9.64377 7.98414 10.1544 7.56486 10.7519 7.3172C11.3494 7.06955 12.0069 7.00465 12.6413 7.13071C13.2757 7.25677 13.8584 7.56813 14.3159 8.02541C14.7733 8.48269 15.0848 9.06534 15.2111 9.69969C15.3373 10.334 15.2726 10.9916 15.0252 11.5891C14.7777 12.1867 14.3586 12.6975 13.8208 13.0568C13.283 13.4162 12.6508 13.608 12.004 13.608C11.1369 13.608 10.3053 13.2636 9.69209 12.6506C9.07887 12.0376 8.73424 11.2061 8.73398 10.339ZM19.259 19.089L19.232 19.116C18.9334 17.9761 18.3644 16.9251 17.5732 16.0519C16.782 15.1787 15.792 14.5091 14.687 14.1C15.4848 13.5312 16.0814 12.7237 16.3904 11.7939C16.6995 10.864 16.7052 9.86006 16.4066 8.92682C16.108 7.99358 15.5206 7.17934 14.7292 6.60162C13.9378 6.0239 12.9833 5.71257 12.0035 5.71257C11.0236 5.71257 10.0691 6.0239 9.27772 6.60162C8.48631 7.17934 7.89893 7.99358 7.60035 8.92682C7.30176 9.86006 7.30742 10.864 7.6165 11.7939C7.92558 12.7237 8.52211 13.5312 9.31997 14.1C8.21492 14.5097 7.22478 15.1795 6.43332 16.0528C5.64186 16.9261 5.07236 17.9771 4.77297 19.117L4.74598 19.09C3.34946 17.6619 2.40545 15.8534 2.03221 13.8912C1.65898 11.929 1.87312 9.90021 2.6478 8.05914C3.42249 6.21806 4.72326 4.64654 6.38716 3.54148C8.05105 2.43642 10.0041 1.84696 12.0015 1.84696C13.9989 1.84696 15.9519 2.43642 17.6158 3.54148C19.2797 4.64654 20.5805 6.21806 21.3551 8.05914C22.1298 9.90021 22.344 11.929 21.9707 13.8912C21.5975 15.8534 20.6535 17.6619 19.257 19.09L19.259 19.089Z",
  className: "primary-fill primary-stroke",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.5
}));
export const VolumeGP2Icon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume-Group",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.4919999837875366 -0.2520243972539902 24.007999420166016 25.002023696899414"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume-Group"
}, " Volume Group"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M9.5.251a18.571 18.571 0 00-5.828.828A6.1 6.1 0 001.8 2.04 1.961 1.961 0 001 3.423v.028c0 .018-.006.036-.008.055v15.5a1.927 1.927 0 00.8 1.461 6.1 6.1 0 001.867.961 18.572 18.572 0 005.841.823h1a18.519 18.519 0 005.82-.828 6.1 6.1 0 001.867-.961A1.936 1.936 0 0019 19.001V3.451c0-.016 0-.031-.008-.047a1.978 1.978 0 00-.8-1.367 6.1 6.1 0 00-1.872-.958A18.519 18.519 0 0010.5.251zm0 1h1a17.724 17.724 0 015.5.773 5.224 5.224 0 011.555.789c.334.272.445.5.445.687s-.117.4-.477.68a5.758 5.758 0 01-1.664.789A19.951 19.951 0 0110 5.751a20.009 20.009 0 01-5.867-.781 5.759 5.759 0 01-1.664-.789C2.109 3.905 2 3.675 2 3.501a.939.939 0 01.438-.687A5.281 5.281 0 014 2.024a17.725 17.725 0 015.5-.773zM18 5.063v3.688c0 .174-.117.4-.477.68a5.758 5.758 0 01-1.664.789 19.952 19.952 0 01-5.859.781 20.009 20.009 0 01-5.867-.781 5.759 5.759 0 01-1.664-.789c-.36-.28-.469-.506-.469-.68a.375.375 0 000-.047V5.071a6.9 6.9 0 001.828.852A20.782 20.782 0 0010 6.751a20.724 20.724 0 006.164-.828A6.867 6.867 0 0018 5.063zm0 5.25v3.438c0 .174-.117.4-.477.68a5.758 5.758 0 01-1.664.789 19.951 19.951 0 01-5.859.781 20.009 20.009 0 01-5.867-.781 5.759 5.759 0 01-1.664-.789c-.36-.28-.469-.506-.469-.68a.375.375 0 000-.047v-3.383a6.9 6.9 0 001.828.852 20.782 20.782 0 006.172.828 20.724 20.724 0 006.164-.828 6.867 6.867 0 001.836-.86zm0 5v3.688c0 .186-.111.415-.445.688a5.223 5.223 0 01-1.555.788 17.725 17.725 0 01-5.5.774h-1a17.724 17.724 0 01-5.5-.774 5.282 5.282 0 01-1.563-.789.939.939 0 01-.437-.687v-3.68a6.9 6.9 0 001.828.852 20.782 20.782 0 006.172.828 20.724 20.724 0 006.164-.828 6.867 6.867 0 001.836-.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M11 13.25h12a1 1 0 011 1v9a1 1 0 01-1 1H11a1 1 0 01-1-1v-9a1 1 0 011-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.5 18.793a2.134 2.134 0 002.157 2.248 2.188 2.188 0 001.725-.818v-1.658H13.45v.792h1.081v.527a1.317 1.317 0 01-.875.331 1.312 1.312 0 01-1.269-1.422 1.312 1.312 0 011.27-1.424 1.133 1.133 0 01.96.546l.717-.416a1.872 1.872 0 00-1.677-.949 2.124 2.124 0 00-2.157 2.243zm4.447 2.164h.863v-1.553h1.032a1.305 1.305 0 001.361-1.385 1.309 1.309 0 00-1.361-1.4h-1.9zm2.375-2.944a.57.57 0 01-.6.6h-.913v-1.2h.918a.574.574 0 01.595.6zm1.178 2.944h3.05v-.812h-1.689c1.087-.819 1.658-1.462 1.658-2.2a1.408 1.408 0 00-1.552-1.388 2 2 0 00-1.561.708l.492.611a1.4 1.4 0 011.081-.5.593.593 0 01.662.566c0 .533-.486.981-2.144 2.288z"
}));
export const VolumeGP3Icon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume-Group",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.4919999837875366 -0.2520243972539902 24.007999420166016 25.002023696899414"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume-Group"
}, " Volume Group"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M9.5.251a18.571 18.571 0 00-5.828.828A6.1 6.1 0 001.8 2.04 1.961 1.961 0 001 3.423v.028c0 .018-.006.036-.008.055v15.5a1.927 1.927 0 00.8 1.461 6.1 6.1 0 001.867.961 18.572 18.572 0 005.841.823h1a18.519 18.519 0 005.82-.828 6.1 6.1 0 001.867-.961A1.936 1.936 0 0019 19.001V3.451c0-.016 0-.031-.008-.047a1.978 1.978 0 00-.8-1.367 6.1 6.1 0 00-1.872-.958A18.519 18.519 0 0010.5.251zm0 1h1a17.724 17.724 0 015.5.773 5.224 5.224 0 011.555.789c.334.272.445.5.445.687s-.117.4-.477.68a5.758 5.758 0 01-1.664.789A19.951 19.951 0 0110 5.751a20.009 20.009 0 01-5.867-.781 5.759 5.759 0 01-1.664-.789C2.109 3.905 2 3.675 2 3.501a.939.939 0 01.438-.687A5.281 5.281 0 014 2.024a17.725 17.725 0 015.5-.773zM18 5.063v3.688c0 .174-.117.4-.477.68a5.758 5.758 0 01-1.664.789 19.952 19.952 0 01-5.859.781 20.009 20.009 0 01-5.867-.781 5.759 5.759 0 01-1.664-.789c-.36-.28-.469-.506-.469-.68a.375.375 0 000-.047V5.071a6.9 6.9 0 001.828.852A20.782 20.782 0 0010 6.751a20.724 20.724 0 006.164-.828A6.867 6.867 0 0018 5.063zm0 5.25v3.438c0 .174-.117.4-.477.68a5.758 5.758 0 01-1.664.789 19.951 19.951 0 01-5.859.781 20.009 20.009 0 01-5.867-.781 5.759 5.759 0 01-1.664-.789c-.36-.28-.469-.506-.469-.68a.375.375 0 000-.047v-3.383a6.9 6.9 0 001.828.852 20.782 20.782 0 006.172.828 20.724 20.724 0 006.164-.828 6.867 6.867 0 001.836-.86zm0 5v3.688c0 .186-.111.415-.445.688a5.223 5.223 0 01-1.555.788 17.725 17.725 0 01-5.5.774h-1a17.724 17.724 0 01-5.5-.774 5.282 5.282 0 01-1.563-.789.939.939 0 01-.437-.687v-3.68a6.9 6.9 0 001.828.852 20.782 20.782 0 006.172.828 20.724 20.724 0 006.164-.828 6.867 6.867 0 001.836-.86z",
  "data-name": "Group 11529"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M11 13.25h12a1 1 0 011 1v9a1 1 0 01-1 1H11a1 1 0 01-1-1v-9a1 1 0 011-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.476 18.65a2.066 2.066 0 002.16 2.108 2.252 2.252 0 001.728-.77v-1.551h-1.935v.742h1.083v.493a1.371 1.371 0 01-.876.31 1.264 1.264 0 01-1.272-1.332 1.264 1.264 0 011.272-1.332 1.151 1.151 0 01.961.511l.718-.389a1.9 1.9 0 00-1.679-.888 2.058 2.058 0 00-2.16 2.098zm4.454 2.026h.864v-1.454h1.034a1.264 1.264 0 001.363-1.3 1.266 1.266 0 00-1.363-1.304h-1.9zm2.378-2.756a.553.553 0 01-.6.56h-.915v-1.122h.919a.557.557 0 01.596.562zm1.016 2.178a2.028 2.028 0 001.6.651c.973 0 1.6-.493 1.6-1.192a1.018 1.018 0 00-.949-.973 1 1 0 00.888-.926c0-.675-.584-1.1-1.533-1.1a2 2 0 00-1.551.645l.426.535a1.47 1.47 0 011.034-.426c.426 0 .754.164.754.487 0 .3-.3.45-.748.45-.158 0-.432 0-.5-.006v.754c.061-.006.335-.006.5-.006.566 0 .815.152.815.481 0 .31-.274.523-.767.523a1.616 1.616 0 01-1.119-.462z"
}));
export const VolumeST1Icon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume-ST1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "1.1669998168945312 -0.25504395365715027 39.33300018310547 41.00604248046875"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume-ST1"
}, " Volume ST1"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M15.834.25A30.951 30.951 0 006.12 1.63a10.164 10.164 0 00-3.112 1.6 3.268 3.268 0 00-1.328 2.3v.039c0 .029-.01.06-.013.091V31.5a3.211 3.211 0 001.341 2.435 10.163 10.163 0 003.112 1.6 30.953 30.953 0 009.713 1.38H17.5a30.865 30.865 0 009.7-1.38 10.164 10.164 0 003.112-1.6 3.226 3.226 0 001.355-2.435V5.589c0-.026-.008-.052-.013-.078a3.3 3.3 0 00-1.341-2.279 10.163 10.163 0 00-3.112-1.6A30.865 30.865 0 0017.5.25zm0 1.667h1.667a29.54 29.54 0 019.166 1.289 8.706 8.706 0 012.591 1.315c.557.454.742.837.742 1.146 0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.302 33.348 33.348 0 01-9.779-1.3A9.6 9.6 0 014.115 6.8c-.6-.459-.781-.843-.781-1.133a1.566 1.566 0 01.733-1.146 8.8 8.8 0 012.6-1.315 29.541 29.541 0 019.167-1.289zM30 8.271v6.146c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.302 33.348 33.348 0 01-9.779-1.3 9.6 9.6 0 01-2.773-1.317c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078V8.284A11.492 11.492 0 006.38 9.703a34.637 34.637 0 0010.287 1.38 34.541 34.541 0 0010.273-1.38A11.444 11.444 0 0030 8.271zm0 8.75v5.729c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.302 33.348 33.348 0 01-9.779-1.3 9.6 9.6 0 01-2.773-1.315c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078v-5.64A11.492 11.492 0 006.38 18.45a34.637 34.637 0 0010.287 1.383A34.541 34.541 0 0026.94 18.45 11.444 11.444 0 0030 17.018zm0 8.333V31.5c0 .309-.186.692-.742 1.146a8.706 8.706 0 01-2.591 1.315A29.542 29.542 0 0117.5 35.25h-1.666a29.54 29.54 0 01-9.167-1.289 8.8 8.8 0 01-2.6-1.311 1.566 1.566 0 01-.729-1.146v-6.137a11.492 11.492 0 003.047 1.419 34.637 34.637 0 0010.282 1.381 34.54 34.54 0 0010.273-1.38A11.444 11.444 0 0030 25.355z",
  "data-name": "Subtraction 12"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M18.334 21.917h20A1.667 1.667 0 0140 23.584v15a1.667 1.667 0 01-1.667 1.667h-20a1.667 1.667 0 01-1.666-1.667v-15a1.667 1.667 0 011.667-1.667z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.001 33.516a4.164 4.164 0 003.065 1.149c1.95 0 2.892-1 2.892-2.318 0-1.6-1.517-1.961-2.708-2.232-.834-.2-1.441-.347-1.441-.834 0-.433.368-.737 1.062-.737a3.083 3.083 0 012.069.791l.855-1.127a4.019 4.019 0 00-2.815-1.007c-1.7 0-2.741.975-2.741 2.177 0 1.614 1.517 1.939 2.7 2.21.831.195 1.456.379 1.456.921 0 .412-.412.812-1.257.812a3.168 3.168 0 01-2.3-.975zm8.374 1.019h1.549v-5.872h2.1v-1.354h-5.762v1.354h2.113zm5.893 0h1.549v-7.226h-1.343l-2.279 2.286.878.921 1.195-1.225z"
}));
export const VolumeIO1MonochromeIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.4919999837875366 -0.2520243972539902 24.007999420166016 25.002023696899414"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M9.5.251a18.571 18.571 0 00-5.828.828A6.1 6.1 0 001.8 2.04 1.961 1.961 0 001 3.423v.028c0 .018-.006.036-.008.055v15.5a1.927 1.927 0 00.8 1.461 6.1 6.1 0 001.867.961 18.572 18.572 0 005.841.823h1a18.519 18.519 0 005.82-.828 6.1 6.1 0 001.867-.961A1.936 1.936 0 0019 19.001V3.451c0-.016 0-.031-.008-.047a1.978 1.978 0 00-.8-1.367 6.1 6.1 0 00-1.872-.958A18.519 18.519 0 0010.5.251zm0 1h1a17.724 17.724 0 015.5.773 5.224 5.224 0 011.555.789c.334.272.445.5.445.687s-.117.4-.477.68a5.758 5.758 0 01-1.664.789A19.951 19.951 0 0110 5.751a20.009 20.009 0 01-5.867-.781 5.759 5.759 0 01-1.664-.789C2.109 3.905 2 3.675 2 3.501a.939.939 0 01.438-.687A5.281 5.281 0 014 2.024a17.725 17.725 0 015.5-.773zM18 5.063v3.688c0 .174-.117.4-.477.68a5.758 5.758 0 01-1.664.789 19.952 19.952 0 01-5.859.781 20.009 20.009 0 01-5.867-.781 5.759 5.759 0 01-1.664-.789c-.36-.28-.469-.506-.469-.68a.375.375 0 000-.047V5.071a6.9 6.9 0 001.828.852A20.782 20.782 0 0010 6.751a20.724 20.724 0 006.164-.828A6.867 6.867 0 0018 5.063zm0 5.25v3.438c0 .174-.117.4-.477.68a5.758 5.758 0 01-1.664.789 19.951 19.951 0 01-5.859.781 20.009 20.009 0 01-5.867-.781 5.759 5.759 0 01-1.664-.789c-.36-.28-.469-.506-.469-.68a.375.375 0 000-.047v-3.383a6.9 6.9 0 001.828.852 20.782 20.782 0 006.172.828 20.724 20.724 0 006.164-.828 6.867 6.867 0 001.836-.86zm0 5v3.688c0 .186-.111.415-.445.688a5.223 5.223 0 01-1.555.788 17.725 17.725 0 01-5.5.774h-1a17.724 17.724 0 01-5.5-.774 5.282 5.282 0 01-1.563-.789.939.939 0 01-.437-.687v-3.68a6.9 6.9 0 001.828.852 20.782 20.782 0 006.172.828 20.724 20.724 0 006.164-.828 6.867 6.867 0 001.836-.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M11 13.25h12a1 1 0 011 1v9a1 1 0 01-1 1H11a1 1 0 01-1-1v-9a1 1 0 011-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.489 17.405a.494.494 0 00.5-.495.494.494 0 00-.5-.494.5.5 0 00-.494.494.5.5 0 00.494.495zm-.4 3.6h.826v-3.14h-.826zm1.326-2.164a2.177 2.177 0 002.257 2.242 2.178 2.178 0 002.269-2.242 2.178 2.178 0 00-2.269-2.243 2.177 2.177 0 00-2.262 2.243zm3.581 0a1.32 1.32 0 01-1.324 1.423 1.315 1.315 0 01-1.313-1.423 1.311 1.311 0 011.313-1.424 1.316 1.316 0 011.317 1.424zm2.349 2.164h.929V16.67h-.806l-1.365 1.371.526.553.715-.734z"
}));
export const VolumeInfoIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume-info",
  width: "27px",
  height: "27px",
  viewBox: "0 0 27 27",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume-info"
}, " Volume info"), /*#__PURE__*/React.createElement("title", null, "Info_icon"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-4.2%",
  y: "-9.3%",
  width: "109.0%",
  height: "120.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "047---CVS-AWS",
  transform: "translate(-665.000000, -405.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add-Volume-+-search",
  transform: "translate(320.000000, 373.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "vol-min",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Info_icon",
  transform: "translate(345.500000, 33.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Info"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
  id: "i",
  fontFamily: "OpenSans-Semibold, Open Sans",
  fontSize: 14,
  fontWeight: 500,
  className: "primary-fill"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 11.5483398,
  y: 18
}, "i")), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  className: "primary-stroke",
  strokeWidth: 1.07,
  cx: 13,
  cy: 12.5,
  r: 12.5
})))))))));
export const VolumeSsdIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume-SSD",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.25 -0.2550266981124878 39.33300018310547 41.005027770996094"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume-SSD"
}, " Volume SSD"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M14.416.25a30.951 30.951 0 00-9.713 1.38 10.163 10.163 0 00-3.112 1.6 3.268 3.268 0 00-1.328 2.3v.039c0 .029-.01.06-.013.091v25.839a3.211 3.211 0 001.341 2.435 10.163 10.163 0 003.112 1.6 30.953 30.953 0 009.713 1.38h4.094c.618 0-.659-9.115 0-9.652.788-.643 11.739-1.74 11.739-2.7V5.588c0-.026-.008-.052-.013-.078a3.3 3.3 0 00-1.341-2.279 10.163 10.163 0 00-3.112-1.6 30.864 30.864 0 00-9.7-1.381zm0 1.667h1.667a29.54 29.54 0 019.167 1.289 8.706 8.706 0 012.591 1.315c.557.454.742.837.742 1.146 0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.302 33.347 33.347 0 01-9.779-1.3 9.6 9.6 0 01-2.774-1.318c-.6-.459-.781-.843-.781-1.133a1.566 1.566 0 01.734-1.145 8.8 8.8 0 012.6-1.315 29.541 29.541 0 019.167-1.289zm14.167 6.354v6.146c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.301 33.348 33.348 0 01-9.779-1.3 9.6 9.6 0 01-2.774-1.316c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078V8.284a11.492 11.492 0 003.047 1.419 34.636 34.636 0 0010.287 1.38 34.54 34.54 0 0010.273-1.38 11.444 11.444 0 003.06-1.432zm0 8.75v5.729c0 .29-.2.674-.794 1.133S19.102 26.5 15.25 26.5a33.347 33.347 0 01-9.779-1.3 9.6 9.6 0 01-2.773-1.315c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078v-5.64a11.492 11.492 0 003.046 1.416 34.636 34.636 0 0010.287 1.383 34.54 34.54 0 0010.273-1.383 11.444 11.444 0 003.06-1.432zm.312 8.177c0 .309-11.127.848-11.683 1.3s.217 5.085 0 9.036l-2.796-.284a29.54 29.54 0 01-9.166-1.29 8.8 8.8 0 01-2.6-1.31 1.566 1.566 0 01-.729-1.146v-6.137a11.492 11.492 0 003.047 1.419 34.636 34.636 0 0010.282 1.38z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M36.916 40.25h-20a1.669 1.669 0 01-1.667-1.667v-15a1.669 1.669 0 011.667-1.666h20a1.669 1.669 0 011.667 1.667v15a1.669 1.669 0 01-1.667 1.666zM23.97 34.007V35a4.1 4.1 0 001.785.338 2.705 2.705 0 001.709-.488 1.623 1.623 0 00.62-1.345 1.741 1.741 0 00-.154-.756 1.619 1.619 0 00-.483-.575 4.771 4.771 0 00-1.038-.55 5.752 5.752 0 01-.869-.418 1.079 1.079 0 01-.347-.336.831.831 0 01-.105-.428.73.73 0 01.264-.587 1.178 1.178 0 01.773-.222 4.034 4.034 0 011.529.361l.334-.857a4.521 4.521 0 00-1.839-.404 2.379 2.379 0 00-1.534.462 1.546 1.546 0 00-.566 1.265 1.73 1.73 0 00.361 1.1 2.981 2.981 0 001.239.813 4.119 4.119 0 011.125.594.8.8 0 01.273.61.777.777 0 01-.3.637 1.471 1.471 0 01-.921.238 3.971 3.971 0 01-.921-.119 4.9 4.9 0 01-.935-.326zm-4.948 0V35a4.1 4.1 0 001.785.338 2.705 2.705 0 001.709-.488 1.623 1.623 0 00.62-1.345 1.741 1.741 0 00-.154-.756 1.619 1.619 0 00-.483-.575 4.771 4.771 0 00-1.038-.55 5.752 5.752 0 01-.869-.418 1.079 1.079 0 01-.343-.335.831.831 0 01-.105-.428.73.73 0 01.264-.587 1.178 1.178 0 01.773-.222 4.034 4.034 0 011.529.361l.334-.857a4.521 4.521 0 00-1.837-.405 2.379 2.379 0 00-1.534.462 1.546 1.546 0 00-.571 1.265 1.73 1.73 0 00.361 1.1 2.981 2.981 0 001.239.813 4.119 4.119 0 011.125.594.8.8 0 01.272.61.777.777 0 01-.3.637 1.471 1.471 0 01-.921.238 3.971 3.971 0 01-.921-.119 4.9 4.9 0 01-.935-.326zm10.306-5.182v6.425h1.8a3.566 3.566 0 002.544-.842 3.219 3.219 0 00.883-2.433 3.1 3.1 0 00-.852-2.325 3.3 3.3 0 00-2.386-.826zm1.8 5.541h-.747v-4.662h.909c1.432 0 2.158.776 2.158 2.308a2.072 2.072 0 01-2.323 2.355z"
}));
export const VolumeStrokeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume-",
  xmlns: "http://www.w3.org/2000/svg",
  id: "ic_volume",
  viewBox: "-0.5 -0.5 36 40"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume-"
}, " Volume "), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  d: "M14.166 0a30.951 30.951 0 0 0-9.713 1.38 10.163 10.163 0 0 0-3.112 1.6 3.268 3.268 0 0 0-1.328 2.3v.039c0 .029-.01.06-.013.091v25.84a3.211 3.211 0 0 0 1.341 2.435 10.163 10.163 0 0 0 3.112 1.6 30.953 30.953 0 0 0 9.713 1.38h1.667a30.864 30.864 0 0 0 9.7-1.38 10.163 10.163 0 0 0 3.112-1.6A3.226 3.226 0 0 0 30 31.25V5.339c0-.026-.008-.052-.013-.078a3.3 3.3 0 0 0-1.341-2.279 10.163 10.163 0 0 0-3.112-1.6A30.864 30.864 0 0 0 15.833 0zm0 1.667h1.667A29.54 29.54 0 0 1 25 2.956a8.706 8.706 0 0 1 2.591 1.315c.557.454.742.837.742 1.146 0 .29-.2.674-.794 1.133a9.6 9.6 0 0 1-2.773 1.315A33.252 33.252 0 0 1 15 9.167a33.347 33.347 0 0 1-9.779-1.3 9.6 9.6 0 0 1-2.774-1.318c-.6-.459-.781-.843-.781-1.133A1.566 1.566 0 0 1 2.4 4.271 8.8 8.8 0 0 1 5 2.956a29.541 29.541 0 0 1 9.167-1.289zm14.167 6.354v6.146c0 .29-.2.674-.794 1.133a9.6 9.6 0 0 1-2.773 1.315A33.252 33.252 0 0 1 15 17.916a33.348 33.348 0 0 1-9.779-1.3A9.6 9.6 0 0 1 2.447 15.3c-.6-.459-.781-.843-.781-1.133a.626.626 0 0 0 0-.078V8.034a11.492 11.492 0 0 0 3.047 1.419A34.636 34.636 0 0 0 15 10.833a34.54 34.54 0 0 0 10.273-1.38 11.444 11.444 0 0 0 3.06-1.432zm0 8.75V22.5c0 .29-.2.674-.794 1.133a9.6 9.6 0 0 1-2.773 1.315A33.252 33.252 0 0 1 15 26.25a33.348 33.348 0 0 1-9.779-1.3 9.6 9.6 0 0 1-2.773-1.315c-.6-.459-.781-.843-.781-1.133a.626.626 0 0 0 0-.078v-5.64A11.492 11.492 0 0 0 4.713 18.2 34.637 34.637 0 0 0 15 19.583 34.54 34.54 0 0 0 25.273 18.2a11.444 11.444 0 0 0 3.06-1.432zm0 8.333v6.146c0 .309-.186.692-.742 1.146A8.706 8.706 0 0 1 25 33.711 29.541 29.541 0 0 1 15.833 35h-1.667A29.54 29.54 0 0 1 5 33.711 8.8 8.8 0 0 1 2.4 32.4a1.566 1.566 0 0 1-.729-1.146v-6.137a11.492 11.492 0 0 0 3.047 1.419A34.636 34.636 0 0 0 15 27.916a34.54 34.54 0 0 0 10.273-1.38 11.444 11.444 0 0 0 3.06-1.432z",
  transform: "translate(.25 .25)",
  style: {
    strokeWidth: ".5px"
  }
}));
export const VolumeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume"
}, " Volume"), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1)",
  className: "primary-fill"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 14,
  cy: 2.597,
  rx: 14,
  ry: 3.597
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 7.884c-7.933 0-14-1.742-14-3.773v8.706c0 2.031 6.222 3.627 14 3.627s14-1.596 14-3.627v-8.56c0 2.03-6.067 3.627-14 3.627z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 18.016c-7.933 0-14-1.596-14-3.627v8.706c0 2.031 6.222 3.627 14 3.627s14-1.596 14-3.627v-8.706c0 2.031-6.067 3.627-14 3.627z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 28.294c-7.933 0-14-1.596-14-3.627v8.706C0 35.403 6.222 37 14 37s14-1.596 14-3.627v-8.706c0 2.031-6.067 3.627-14 3.627z"
})));
export const WarningTriangleHollowIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Warning-",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Warning-"
}, " Warning "), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M13.1179 9.45193V14.1229C13.1179 14.4284 12.9983 14.7214 12.7852 14.9374C12.5722 15.1534 12.2833 15.2748 11.982 15.2748C11.6807 15.2748 11.3918 15.1534 11.1787 14.9374C10.9657 14.7214 10.846 14.4284 10.846 14.1229V9.45193C10.846 9.14643 10.9657 8.85345 11.1787 8.63743C11.3918 8.42141 11.6807 8.30005 11.982 8.30005C12.2833 8.30005 12.5722 8.42141 12.7852 8.63743C12.9983 8.85345 13.1179 9.14643 13.1179 9.45193Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M11.9824 16.5314C12.2983 16.5316 12.6043 16.6429 12.8483 16.8462C13.0923 17.0495 13.2592 17.3324 13.3207 17.6465C13.3821 17.9606 13.3342 18.2867 13.1852 18.569C13.0361 18.8514 12.7951 19.0726 12.5033 19.195C12.2114 19.3174 11.8867 19.3334 11.5846 19.2402C11.2824 19.1471 11.0214 18.9506 10.8461 18.6842C10.6707 18.4179 10.5919 18.0981 10.623 17.7794C10.6541 17.4607 10.7932 17.1628 11.0167 16.9364C11.1435 16.8079 11.2941 16.706 11.4598 16.6365C11.6255 16.567 11.8031 16.5313 11.9824 16.5314Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7798 2.06778C12.9794 0.644073 11.0206 0.644075 10.2202 2.06778L0.298526 19.7148C-0.56326 21.2476 0.567041 23 2.07833 23H21.9217C23.433 23 24.5633 21.2476 23.7015 19.7148L13.7798 2.06778ZM11.7955 3.10869C11.8283 3.05031 11.895 3 12 3C12.105 3 12.1717 3.05031 12.2045 3.10869L22.1262 20.7558C22.145 20.7892 22.1468 20.8106 22.1466 20.8234C22.1463 20.8399 22.1417 20.8638 22.1262 20.8913C22.0965 20.9442 22.0328 21 21.9217 21H2.07833C1.96718 21 1.90354 20.9442 1.87381 20.8913C1.85834 20.8638 1.85368 20.8399 1.8534 20.8234C1.85319 20.8106 1.85499 20.7892 1.87381 20.7558L11.7955 3.10869Z",
  fill: "var(--icon-primary)"
}));
export const WarningTriangleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Warning",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.759579062461853 0.9582936763763428 17.480844497680664 15.041706085205078"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Warning"
}, " Warning"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M8.64 1.448a1 1 0 011.72 0l7.74 13.041A1 1 0 0117.243 16H1.757A1 1 0 01.9 14.489z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.4 5.834v4.333a.865.865 0 01-.893.833.928.928 0 01-.893-.833V5.834a.867.867 0 01.893-.833.928.928 0 01.893.833zm.1 7.167a1 1 0 01-2 0 .96.96 0 011-1 .96.96 0 011 .999z"
}));
export const WarningIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Warning",
  id: "ic_warning",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  overflow: "visible"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Warning"
}, " Warning"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  className: "primary-stroke",
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.01,15.452V9.389a1.231,1.231,0,0,1,2.463,0v6.063a1.231,1.231,0,0,1-2.463,0ZM9.241,6.814a1.48,1.48,0,1,1,1.047-.433,1.48,1.48,0,0,1-1.047.433Z",
  transform: "translate(21.221 22.084) rotate(180)",
  className: "primary-fill"
}));
export const AddIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Add",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Add"
}, " Add"), /*#__PURE__*/React.createElement("path", {
  d: "M12.7982 12.7984L17.9099 12.8189C18.02 12.8185 18.1289 12.7963 18.2304 12.7536C18.3318 12.7109 18.4238 12.6485 18.501 12.57C18.6405 12.4211 18.7155 12.2231 18.7096 12.0192C18.7023 11.8098 18.6158 11.611 18.4676 11.4629C18.3195 11.3147 18.1207 11.2282 17.9113 11.2209L12.7982 11.2018L12.8187 6.0901C12.8183 5.98002 12.7961 5.8711 12.7534 5.76964C12.7107 5.66819 12.6483 5.57619 12.5698 5.49896C12.4209 5.35945 12.2229 5.28447 12.019 5.29036C11.8115 5.30419 11.6158 5.392 11.4675 5.53785C11.3881 5.60904 11.3262 5.69754 11.2866 5.7965C11.247 5.89546 11.2307 6.00222 11.2391 6.10848L11.2016 11.2018L6.08991 11.1813C5.98016 11.1817 5.87157 11.2038 5.77038 11.2462C5.66918 11.2887 5.57736 11.3507 5.50018 11.4288C5.36068 11.5776 5.28569 11.7756 5.29158 11.9796C5.30541 12.1871 5.39322 12.3828 5.53907 12.5311C5.61194 12.6083 5.70072 12.6687 5.79925 12.7081C5.89779 12.7476 6.00372 12.7651 6.1097 12.7595L11.2016 12.7984L11.1811 17.9101C11.1782 18.0158 11.1969 18.1209 11.2362 18.2191C11.2755 18.3172 11.3345 18.4063 11.4095 18.4807L11.4286 18.4998C11.5774 18.6393 11.7755 18.7143 11.9794 18.7084C12.1867 18.699 12.3837 18.615 12.5339 18.4718C12.6842 18.3286 12.7775 18.1358 12.7968 17.9292L12.7982 12.7984Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.2
}));
export const AddRemoveColumnIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Add-or-remove-column",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Add-or-remove-column"
}, " Add or remove column"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 3.7H4C3.83432 3.7 3.7 3.83431 3.7 4V20C3.7 20.1657 3.83431 20.3 4 20.3H20C20.1657 20.3 20.3 20.1657 20.3 20V4C20.3 3.83432 20.1657 3.7 20 3.7ZM4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.99995 20.3L7.99995 3.7H9.69995L9.69995 20.3H7.99995Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 20.3L14 3.7H15.7L15.7 20.3H14Z",
  fill: "var(--icon-primary)"
}));
export const AggregateIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Aggregate",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Aggregate"
}, " Aggregate"), /*#__PURE__*/React.createElement("path", {
  d: "M20.1504 4.68596V11.686M12.1504 4.68596V11.686M4.15038 4.68596V11.686M16.8 2.23296V21.138C16.8063 21.4623 16.9121 21.7713 17.0956 22.0008C17.279 22.2303 17.5261 22.3628 17.7856 22.371C21.036 22.349 20.6272 22.365 22.5152 22.371C22.7747 22.3628 23.0217 22.2303 23.2052 22.0008C23.3887 21.7713 23.4945 21.4623 23.5008 21.138V2.23296C23.4945 1.90859 23.3887 1.59966 23.2052 1.37014C23.0217 1.14062 22.7747 1.00808 22.5152 0.99996H17.7856C17.6554 0.996971 17.5261 1.02683 17.4054 1.08775C17.2847 1.14867 17.1751 1.23939 17.083 1.3545C16.991 1.46961 16.9185 1.60674 16.8699 1.75768C16.8213 1.90862 16.7975 2.07026 16.8 2.23296ZM22.5808 1.82196C22.6247 1.8186 22.6686 1.82693 22.7097 1.84639C22.7508 1.86586 22.7882 1.89602 22.8192 1.93487C22.8503 1.97373 22.8745 2.0204 22.89 2.07179C22.9056 2.12317 22.9123 2.17811 22.9096 2.23296V21.138C22.9123 21.1928 22.9056 21.2477 22.89 21.2991C22.8745 21.3505 22.8503 21.3972 22.8192 21.436C22.7882 21.4749 22.7508 21.5051 22.7097 21.5245C22.6686 21.544 22.6247 21.5523 22.5808 21.549H17.7856C17.7417 21.5523 17.6978 21.544 17.6566 21.5245C17.6155 21.5051 17.5782 21.4749 17.5471 21.436C17.516 21.3972 17.4919 21.3505 17.4763 21.2991C17.4608 21.2477 17.4541 21.1928 17.4568 21.138V2.23296C17.4541 2.17811 17.4608 2.12317 17.4763 2.07179C17.4919 2.0204 17.516 1.97373 17.5471 1.93487C17.5782 1.89602 17.6155 1.86586 17.6566 1.84639C17.6978 1.82693 17.7417 1.8186 17.7856 1.82196H22.5808ZM8.79998 2.23296V21.138C8.80627 21.4623 8.9121 21.7713 9.09557 22.0008C9.27904 22.2303 9.52609 22.3628 9.78558 22.371C13.036 22.349 12.6272 22.365 14.5152 22.371C14.7747 22.3628 15.0217 22.2303 15.2052 22.0008C15.3887 21.7713 15.4945 21.4623 15.5008 21.138V2.23296C15.4945 1.90859 15.3887 1.59966 15.2052 1.37014C15.0217 1.14062 14.7747 1.00808 14.5152 0.99996H9.78558C9.65543 0.996971 9.52613 1.02683 9.40541 1.08775C9.2847 1.14867 9.17506 1.23939 9.08305 1.3545C8.99104 1.46961 8.91854 1.60674 8.86991 1.75768C8.82127 1.90862 8.79749 2.07026 8.79998 2.23296ZM14.5808 1.82196C14.6247 1.8186 14.6686 1.82693 14.7097 1.84639C14.7508 1.86586 14.7882 1.89602 14.8192 1.93487C14.8503 1.97373 14.8745 2.0204 14.89 2.07179C14.9056 2.12317 14.9123 2.17811 14.9096 2.23296V21.138C14.9123 21.1928 14.9056 21.2477 14.89 21.2991C14.8745 21.3505 14.8503 21.3972 14.8192 21.436C14.7882 21.4749 14.7508 21.5051 14.7097 21.5245C14.6686 21.544 14.6247 21.5523 14.5808 21.549H9.78558C9.7417 21.5523 9.69776 21.544 9.65664 21.5245C9.61553 21.5051 9.5782 21.4749 9.54712 21.436C9.51603 21.3972 9.4919 21.3505 9.47633 21.2991C9.46076 21.2477 9.45409 21.1928 9.45678 21.138V2.23296C9.45409 2.17811 9.46076 2.12317 9.47633 2.07179C9.4919 2.0204 9.51603 1.97373 9.54712 1.93487C9.5782 1.89602 9.61553 1.86586 9.65664 1.84639C9.69776 1.82693 9.7417 1.8186 9.78558 1.82196H14.5808ZM0.799983 2.23296V21.138C0.806267 21.4623 0.9121 21.7713 1.09557 22.0008C1.27904 22.2303 1.52609 22.3628 1.78558 22.371C5.03598 22.349 4.62718 22.365 6.51518 22.371C6.77467 22.3628 7.02173 22.2303 7.20519 22.0008C7.38866 21.7713 7.4945 21.4623 7.50078 21.138V2.23296C7.4945 1.90859 7.38866 1.59966 7.20519 1.37014C7.02173 1.14062 6.77467 1.00808 6.51518 0.99996H1.78558C1.65543 0.996971 1.52612 1.02683 1.40541 1.08775C1.2847 1.14867 1.17506 1.23939 1.08305 1.3545C0.991035 1.46961 0.918542 1.60674 0.869905 1.75768C0.821268 1.90862 0.797486 2.07026 0.799983 2.23296ZM6.58078 1.82196C6.62466 1.8186 6.66861 1.82693 6.70972 1.84639C6.75083 1.86586 6.78816 1.89602 6.81925 1.93487C6.85033 1.97373 6.87446 2.0204 6.89003 2.07179C6.90561 2.12317 6.91227 2.17811 6.90958 2.23296V21.138C6.91227 21.1928 6.90561 21.2477 6.89003 21.2991C6.87446 21.3505 6.85033 21.3972 6.81925 21.436C6.78816 21.4749 6.75083 21.5051 6.70972 21.5245C6.66861 21.544 6.62466 21.5523 6.58078 21.549H1.78558C1.7417 21.5523 1.69775 21.544 1.65664 21.5245C1.61553 21.5051 1.5782 21.4749 1.54712 21.436C1.51603 21.3972 1.4919 21.3505 1.47633 21.2991C1.46076 21.2477 1.45409 21.1928 1.45678 21.138V2.23296C1.45409 2.17811 1.46076 2.12317 1.47633 2.07179C1.4919 2.0204 1.51603 1.97373 1.54712 1.93487C1.5782 1.89602 1.61553 1.86586 1.65664 1.84639C1.69775 1.82693 1.7417 1.8186 1.78558 1.82196H6.58078Z",
  stroke: "var(--icon-primary)",
  strokeLinecap: "round"
}));
export const ApiIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "API",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "API"
}, "API"), /*#__PURE__*/React.createElement("path", {
  d: "M3.59149 19.0499C3.07368 18.1273 2.85042 17.0572 2.95399 15.9939V14.8719C2.99661 14.3194 2.89104 13.7655 2.64883 13.2719C2.24922 12.8592 1.71619 12.6164 1.15399 12.5909C0.960875 12.5746 0.778812 12.4911 0.636721 12.3539C0.520223 12.1948 0.46439 11.9964 0.480158 11.7969C0.470261 11.625 0.515895 11.4547 0.609768 11.3129C0.716754 11.1828 0.862851 11.0943 1.02438 11.0619C1.12038 11.0419 1.24908 11.0099 1.42188 10.9619C1.90348 10.8715 2.3326 10.59 2.61906 10.1768C2.90553 9.76347 3.02712 9.25057 2.95797 8.74593V7.59993C2.85611 6.53575 3.08194 5.46543 3.60297 4.54393C3.88853 4.24362 4.23519 4.01394 4.61735 3.87184C4.99951 3.72974 5.40745 3.67886 5.81102 3.72293C6.02171 3.70897 6.23013 3.77583 6.39672 3.91092C6.46606 3.97558 6.52046 4.05554 6.55633 4.14499C6.59221 4.23443 6.60848 4.3311 6.60391 4.42792C6.60391 4.87392 6.33354 5.13192 5.79274 5.20192C5.6881 5.22092 5.60075 5.23393 5.54219 5.23993C5.38334 5.25806 5.22988 5.30992 5.09102 5.3923C4.95216 5.47469 4.83078 5.58584 4.73477 5.71892C4.54673 6.16055 4.46925 6.64461 4.5093 7.12593V8.54892C4.56236 9.33264 4.43566 10.1183 4.13969 10.8409C3.99547 11.0814 3.80714 11.2898 3.58539 11.4542C3.36365 11.6186 3.11291 11.7357 2.84758 11.7989C3.38466 11.9384 3.84823 12.2907 4.13969 12.7809C4.43487 13.5021 4.56155 14.2859 4.5093 15.0679V16.4999C4.47132 16.9587 4.54077 17.4203 4.7118 17.8449C4.88844 18.0984 5.1542 18.2688 5.45102 18.3189C5.52974 18.3379 5.643 18.3579 5.7918 18.3779C6.3326 18.4559 6.60297 18.7203 6.60297 19.1709C6.60792 19.2675 6.5915 19.364 6.55469 19.4529C6.51788 19.5417 6.46175 19.6204 6.39086 19.6829C6.21825 19.816 6.00614 19.8815 5.7918 19.8679C5.38959 19.9128 4.98285 19.8626 4.60188 19.7209C4.2209 19.5793 3.87552 19.3499 3.59149 19.0499ZM17.6141 19.4599C17.5429 19.3977 17.4866 19.319 17.4496 19.2301C17.4126 19.1413 17.396 19.0446 17.4011 18.9479C17.4011 18.4959 17.6715 18.2316 18.2123 18.1549C18.3611 18.1359 18.4733 18.1149 18.554 18.0959C18.8504 18.0454 19.1158 17.8751 19.2923 17.6219C19.4632 17.1972 19.5332 16.7358 19.4959 16.2769V14.8459C19.4431 14.0638 19.5698 13.2799 19.8655 12.5589C20.1563 12.0685 20.6197 11.7161 21.1567 11.5769C20.8914 11.514 20.6408 11.3969 20.4191 11.2325C20.1975 11.068 20.0094 10.8595 19.8655 10.6189C19.5691 9.89643 19.4424 9.11067 19.4959 8.32692V6.89992C19.536 6.4185 19.4579 5.93438 19.2693 5.49292C19.1732 5.35969 19.0519 5.24843 18.9128 5.16603C18.7738 5.08364 18.62 5.03188 18.4609 5.01393C18.4005 5.00793 18.316 4.99492 18.2113 4.97592C17.6712 4.90459 17.4008 4.64659 17.4002 4.20192C17.3955 4.10509 17.4116 4.00842 17.4475 3.91896C17.4834 3.8295 17.5382 3.74953 17.6076 3.68492C17.774 3.54947 17.9822 3.48224 18.193 3.49593C18.5966 3.45135 19.0047 3.50199 19.387 3.64412C19.7692 3.78625 20.1158 4.0162 20.4011 4.31692C20.9237 5.23783 21.1504 6.30848 21.0482 7.37292V8.52393C20.9791 9.02857 21.1004 9.54147 21.3869 9.95476C21.6733 10.368 22.1025 10.6495 22.5841 10.7399C22.7569 10.7849 22.8894 10.8159 22.9816 10.8399C23.143 10.8727 23.2892 10.9611 23.3964 11.0909C23.4901 11.2328 23.5357 11.4031 23.526 11.5749C23.5419 11.7744 23.486 11.9729 23.3695 12.1319C23.2269 12.269 23.0444 12.3524 22.851 12.3689C22.2889 12.3947 21.7562 12.6375 21.3564 13.0499C21.1147 13.5436 21.0092 14.0975 21.052 14.6499V15.7719C21.1548 16.8357 20.9322 17.9061 20.4156 18.8299C20.1312 19.1283 19.7861 19.3562 19.4057 19.4969C19.0254 19.6377 18.6195 19.6876 18.2181 19.6429C18.0024 19.6585 17.7882 19.5937 17.6141 19.4599ZM14.7006 11.7909C14.7 11.6056 14.7345 11.422 14.8021 11.2505C14.8697 11.0791 14.9689 10.9232 15.0944 10.7917C15.2198 10.6603 15.3689 10.5559 15.5331 10.4846C15.6973 10.4132 15.8734 10.3763 16.0513 10.3759C16.4104 10.3773 16.7542 10.527 17.0073 10.7924C17.2604 11.0577 17.4021 11.4169 17.4011 11.7909C17.4021 12.165 17.2604 12.5241 17.0073 12.7895C16.7542 13.0548 16.4104 13.2046 16.0513 13.2059C15.8734 13.2055 15.6973 13.1686 15.5331 13.0973C15.3689 13.0259 15.2198 12.9215 15.0944 12.7901C14.9689 12.6587 14.8697 12.5028 14.8021 12.3313C14.7345 12.1599 14.7 11.9763 14.7006 11.7909ZM10.6504 11.7909C10.6498 11.6057 10.6841 11.4221 10.7516 11.2507C10.8191 11.0793 10.9186 10.9235 11.0439 10.7921C11.1693 10.6607 11.3181 10.5563 11.4822 10.4849C11.6463 10.4135 11.8223 10.3765 12.0002 10.3759C12.3595 10.377 12.7036 10.5266 12.9571 10.792C13.2106 11.0573 13.3526 11.4166 13.3518 11.7909C13.3526 12.1652 13.2106 12.5246 12.9571 12.7899C12.7036 13.0552 12.3595 13.2049 12.0002 13.2059C11.8223 13.2054 11.6463 13.1684 11.4822 13.097C11.3181 13.0256 11.1693 12.9212 11.0439 12.7898C10.9186 12.6584 10.8191 12.5025 10.7516 12.3311C10.6841 12.1597 10.6498 11.9762 10.6504 11.7909ZM6.60016 11.7909C6.59953 11.6056 6.63408 11.422 6.70164 11.2505C6.7692 11.0791 6.86846 10.9232 6.99391 10.7917C7.11936 10.6603 7.26845 10.5559 7.43266 10.4846C7.59687 10.4132 7.77294 10.3763 7.95086 10.3759C8.1287 10.3765 8.30473 10.4135 8.46883 10.4849C8.63293 10.5563 8.782 10.6607 8.90735 10.7921C9.03269 10.9235 9.13188 11.0793 9.19938 11.2507C9.26688 11.4221 9.30126 11.6057 9.30063 11.7909C9.30126 11.9762 9.26688 12.1597 9.19938 12.3311C9.13188 12.5025 9.03269 12.6584 8.90735 12.7898C8.782 12.9212 8.63293 13.0256 8.46883 13.097C8.30473 13.1684 8.1287 13.2054 7.95086 13.2059C7.77286 13.2057 7.59674 13.1688 7.43242 13.0975C7.26811 13.0263 7.11876 12.9219 6.99321 12.7905C6.86765 12.659 6.76833 12.5031 6.70071 12.3316C6.63308 12.1601 6.59953 11.9763 6.60016 11.7909Z",
  fill: "var(--icon-primary)"
}));
export const ArrowLeftIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Arrow-left",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Arrow-left"
}, " Arrow left"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3791 6.16605C10.1775 6.01449 9.92873 5.93924 9.67694 5.95365C9.42515 5.96805 9.18655 6.07112 9.00356 6.24468L4.20782 11.3405C4.03915 11.5156 3.94568 11.7505 3.95004 11.9939L3.95007 11.995C3.95946 12.2338 4.04931 12.4624 4.20507 12.6436L9.00054 17.7393L9.0029 17.7416C9.18674 17.9133 9.4247 18.0155 9.6758 18.0306C9.9269 18.0457 10.1758 17.9734 10.379 17.825L10.3849 17.8189C10.5656 17.633 10.6658 17.3833 10.6639 17.1241C10.6619 16.8651 10.5581 16.6173 10.3749 16.4342L7.08385 12.942H18.849C19.101 12.942 19.3426 12.8419 19.5208 12.6638C19.6989 12.4856 19.799 12.244 19.799 11.992C19.799 11.7401 19.6989 11.4984 19.5208 11.3203C19.3426 11.1421 19.101 11.042 18.849 11.042H7.0839L10.3754 7.55132L10.3762 7.5504C10.5456 7.36161 10.6402 7.11742 10.6421 6.86379C10.6441 6.61015 10.5532 6.36454 10.3867 6.17319L10.3876 6.17245L10.3791 6.16605Z",
  fill: "var(--icon-primary)"
}));
export const ArrowUpIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Arrow-up",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Arrow-up"
}, " Arrow up"), /*#__PURE__*/React.createElement("path", {
  d: "M17.6213 9.12154L12.5257 4.32601C12.3506 4.15734 12.1155 4.06366 11.8721 4.06802L11.871 4.06805C11.6322 4.07744 11.4036 4.16729 11.2224 4.32305L6.12665 9.11852L6.12445 9.12088C5.95274 9.30472 5.85052 9.54268 5.8354 9.79378C5.82028 10.0449 5.89263 10.2938 6.04104 10.4969L6.04714 10.5029C6.23304 10.6836 6.48265 10.7838 6.74192 10.7818C7.00093 10.7799 7.24875 10.6761 7.43183 10.4929L10.924 7.20183V18.967C10.924 19.219 11.0241 19.4606 11.2022 19.6388C11.3804 19.8169 11.622 19.917 11.874 19.917C12.1259 19.917 12.3676 19.8169 12.5457 19.6388C12.7239 19.4606 12.824 19.219 12.824 18.967V7.20188L16.3147 10.4934L16.3156 10.4942C16.5044 10.6636 16.7486 10.7582 17.0022 10.7601C17.2559 10.762 17.5015 10.6712 17.6928 10.5047L17.6935 10.5056L17.7 10.4971C17.8515 10.2955 17.9268 10.0467 17.9124 9.79493C17.8979 9.54314 17.7949 9.30453 17.6213 9.12154Z",
  fill: "var(--icon-primary)"
}));
export const BreadcrumbsArrowIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.9905 11.9429C13.9791 11.8551 13.9415 11.7728 13.8827 11.7069L10.7027 8.15186C10.6696 8.10771 10.6274 8.07131 10.5788 8.0452C10.5303 8.01909 10.4766 8.00389 10.4216 8.00065C10.3666 7.99742 10.3116 8.00622 10.2603 8.02646C10.2091 8.04671 10.1628 8.07789 10.1248 8.11786C10.0447 8.20131 10 8.31259 10 8.42836C10 8.54413 10.0447 8.6554 10.1248 8.73886L13.0443 12.0009L10.1278 15.2629C10.048 15.3463 10.0035 15.4573 10.0035 15.5729C10.0035 15.6884 10.048 15.7995 10.1278 15.8829C10.1663 15.923 10.2129 15.9542 10.2647 15.9744C10.3164 15.9946 10.3718 16.0033 10.4272 15.9999C10.4822 15.9962 10.5357 15.9808 10.5842 15.9548C10.6328 15.9287 10.6752 15.8926 10.7087 15.8489L13.8887 12.2939C13.9305 12.2464 13.9617 12.1905 13.9803 12.13C13.9989 12.0695 14.0044 12.0057 13.9965 11.9429H13.9905Z",
  fill: "var(--icon-primary)"
}));
export const CardsViewIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Cards-view",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Cards-view"
}, " Cards view"), /*#__PURE__*/React.createElement("path", {
  d: "M21.9999 19.9996V13.9996H14.0002V19.9996H21.9999ZM10.0003 19.9996V13.9996H2.00049V19.9996H10.0003ZM21.9999 9.99976V3.99976H14.0002V9.99976H21.9999ZM10.0003 9.99976V3.99976H2.00049V9.99976H10.0003ZM22.5001 21.4996H13.5001C12.9475 21.4996 12.5002 21.0524 12.5002 20.4998V13.5004C12.5002 12.9478 12.9475 12.4996 13.5001 12.4996H22.5001C23.0527 12.4996 23.4999 12.9478 23.4999 13.5004V20.4998C23.4999 21.0524 23.0527 21.4996 22.5001 21.4996ZM10.5004 21.4996H1.50037C0.947815 21.4996 0.500488 21.0524 0.500488 20.4998V13.5004C0.500488 12.9478 0.947815 12.4996 1.50037 12.4996H10.5004C11.0521 12.4996 11.5003 12.9478 11.5003 13.5004V20.4998C11.5003 21.0524 11.0521 21.4996 10.5004 21.4996ZM22.5001 11.4998H13.5001C12.9475 11.4998 12.5002 11.0524 12.5002 10.4998V3.49963C12.5002 2.94794 12.9475 2.49976 13.5001 2.49976H22.5001C23.0527 2.49976 23.4999 2.94794 23.4999 3.49963V10.4998C23.4999 11.0524 23.0527 11.4998 22.5001 11.4998ZM10.5004 11.4998H1.50037C0.947815 11.4998 0.500488 11.0524 0.500488 10.4998V3.49963C0.500488 2.94794 0.947815 2.49976 1.50037 2.49976H10.5004C11.0521 2.49976 11.5003 2.94794 11.5003 3.49963V10.4998C11.5003 11.0524 11.0521 11.4998 10.5004 11.4998Z",
  fill: "var(--icon-primary)"
}));
export const CircleOkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-OK",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-OK"
}, " OK"), /*#__PURE__*/React.createElement("path", {
  d: "M15.9531 8.40063C16.2663 8.40063 16.5667 8.5244 16.7891 8.74498L16.7871 8.73998C17.0086 8.96179 17.1331 9.26247 17.1331 9.57598C17.1331 9.88948 17.0086 10.1902 16.7871 10.412L11.6961 15.505C11.4743 15.7265 11.1736 15.851 10.8601 15.851C10.5466 15.851 10.2459 15.7265 10.0241 15.505L7.34608 12.827C7.22861 12.719 7.13423 12.5883 7.06863 12.4428C7.00302 12.2974 6.96755 12.1401 6.96435 11.9806C6.96115 11.8211 6.99028 11.6625 7.05 11.5145C7.10972 11.3666 7.19878 11.2322 7.31181 11.1196C7.42485 11.0069 7.55952 10.9184 7.70771 10.8592C7.85591 10.8 8.01455 10.7714 8.17407 10.7752C8.3336 10.779 8.49071 10.815 8.63594 10.8811C8.78116 10.9473 8.9115 11.0421 9.01908 11.16L10.8611 13.001L15.1171 8.74498C15.3394 8.5244 15.6399 8.40063 15.9531 8.40063Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
  fill: "var(--icon-primary)"
}));
export const CloseIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Close",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Close"
}, " Close"), /*#__PURE__*/React.createElement("path", {
  d: "M13.129 12L16.758 8.40003C16.8356 8.32189 16.8969 8.22917 16.9384 8.12722C16.9799 8.02527 17.0009 7.91611 17 7.80603C16.9934 7.6021 16.9064 7.40907 16.758 7.26902C16.6047 7.12619 16.403 7.04677 16.1935 7.04677C15.984 7.04677 15.7823 7.12619 15.629 7.26902L12 10.871L8.40001 7.24203C8.32187 7.16448 8.22916 7.10317 8.12721 7.06164C8.02526 7.0201 7.91609 6.99916 7.80601 7.00003C7.60209 7.00666 7.40906 7.09365 7.26901 7.24203C7.13204 7.39856 7.05575 7.59903 7.05401 7.80702C7.04825 7.91346 7.06709 8.0198 7.10905 8.11778C7.15102 8.21576 7.21499 8.30276 7.29601 8.37203L10.871 12L7.24201 15.6C7.16471 15.6779 7.10354 15.7703 7.06201 15.8719C7.02048 15.9735 6.99941 16.0823 7.00001 16.192C7.00665 16.3959 7.09364 16.589 7.24201 16.729C7.39855 16.866 7.59902 16.9423 7.80701 16.944C7.9131 16.9471 8.01858 16.927 8.11614 16.8852C8.2137 16.8434 8.30101 16.7809 8.37201 16.702L12 13.129L15.6 16.758C15.6727 16.8348 15.7603 16.8959 15.8575 16.9375C15.9546 16.9791 16.0593 17.0004 16.165 17H16.192C16.3959 16.9934 16.589 16.9064 16.729 16.758C16.869 16.6048 16.9488 16.4061 16.9538 16.1986C16.9588 15.9911 16.8885 15.7888 16.756 15.629L13.129 12Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.2
}));
export const CompanyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Company",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Company"
}, "Company"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2522 1.05493H9.05225C8.68019 1.0548 8.31166 1.12798 7.9679 1.27029C7.62411 1.41262 7.31173 1.6213 7.04863 1.88441C6.78552 2.14751 6.57684 2.45989 6.43451 2.80368C6.2922 3.14744 6.21902 3.51597 6.21915 3.88803V6.22093H3.88915C3.51719 6.2208 3.14884 6.29395 2.80515 6.43619C2.46143 6.57845 2.14911 6.78703 1.88601 7.05002C1.62292 7.31301 1.41422 7.62525 1.27183 7.96892C1.12944 8.31258 1.05615 8.68094 1.05615 9.05293V22.4829C1.05615 22.6864 1.13696 22.8814 1.2808 23.0253C1.42464 23.1691 1.61973 23.2499 1.82315 23.2499H22.4842C22.6876 23.2499 22.8827 23.1691 23.0265 23.0253C23.1703 22.8814 23.2512 22.6864 23.2512 22.4829V12.1519C23.2512 11.4006 22.9527 10.68 22.4214 10.1487C21.8899 9.61723 21.1693 9.31993 20.4182 9.31993H18.0852V3.88793C18.0852 3.13657 17.7867 2.41599 17.2554 1.8847C16.7241 1.35341 16.0035 1.05493 15.2522 1.05493ZM8.13691 2.96769C8.38071 2.7239 8.71137 2.58693 9.05615 2.58693H15.2562C15.6009 2.58693 15.9316 2.7239 16.1754 2.96769C16.4192 3.21149 16.5562 3.54215 16.5562 3.88693V21.7159H14.9862V17.3179C14.9862 16.8405 14.7965 16.3827 14.4589 16.0451C14.1214 15.7076 13.6635 15.5179 13.1862 15.5179H11.1202C10.6428 15.5179 10.1849 15.7076 9.84736 16.0451C9.5098 16.3827 9.32015 16.8405 9.32015 17.3179V21.7169H7.75615V3.88693C7.75615 3.54215 7.89312 3.21149 8.13691 2.96769ZM2.96991 8.13369C3.21371 7.8899 3.54437 7.75293 3.88915 7.75293H6.22215V21.7159H2.58915V9.05293C2.58915 8.70815 2.72612 8.37749 2.96991 8.13369ZM18.0852 21.7169V10.8549H20.4182C20.7629 10.8549 21.0936 10.9919 21.3374 11.2357C21.5812 11.4795 21.7182 11.8102 21.7182 12.155L21.7201 21.7169H18.0852ZM10.6062 17.3179V21.9669H13.7032V17.3179C13.7032 17.1808 13.6487 17.0493 13.5517 16.9524C13.4548 16.8554 13.3233 16.8009 13.1862 16.8009H11.1232C11.0552 16.8008 10.9879 16.8141 10.9251 16.84C10.8624 16.866 10.8053 16.904 10.7573 16.9521C10.7093 17.0001 10.6712 17.0571 10.6452 17.1199C10.6193 17.1827 10.606 17.25 10.6062 17.3179Z",
  fill: "var(--icon-primary)"
}));
export const ConnectorDarkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "ic_connector",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "ic_connector"
}, "Connector"), /*#__PURE__*/React.createElement("path", {
  d: "M12.287 7.27322H12.8034C12.9213 7.27322 13.0357 7.38843 13.0902 7.56018V8.07615C13.0925 8.11445 13.0867 8.15281 13.0731 8.18869C13.0595 8.22456 13.0385 8.25715 13.0114 8.28428C12.9843 8.31141 12.9517 8.33246 12.9158 8.34605C12.88 8.35965 12.8417 8.36546 12.8034 8.36311H12.287C12.2488 8.36546 12.2104 8.35965 12.1746 8.34605C12.1387 8.33246 12.1062 8.31141 12.0791 8.28428C12.0519 8.25715 12.0309 8.22456 12.0173 8.18869C12.0037 8.15281 11.9979 8.11445 12.0003 8.07615V7.56018C11.9979 7.52189 12.0037 7.48353 12.0173 7.44765C12.0309 7.41177 12.0519 7.37919 12.0791 7.35206C12.1062 7.32493 12.1387 7.30387 12.1746 7.29028C12.2104 7.27669 12.2488 7.27088 12.287 7.27322Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9994 7.27322H14.4545C14.4181 7.27088 14.3817 7.27669 14.3476 7.29028C14.3135 7.30387 14.2826 7.32493 14.2568 7.35206C14.2311 7.37919 14.2111 7.41177 14.1982 7.44765C14.1853 7.48353 14.1797 7.52189 14.182 7.56018V8.07615C14.1797 8.11445 14.1853 8.15281 14.1982 8.18869C14.2111 8.22456 14.2311 8.25715 14.2568 8.28428C14.2826 8.31141 14.3135 8.33246 14.3476 8.34605C14.3817 8.35965 14.4181 8.36546 14.4545 8.36311H14.9994C15.0358 8.36546 15.0722 8.35965 15.1063 8.34605C15.1404 8.33246 15.1713 8.31141 15.1971 8.28428C15.2228 8.25715 15.2428 8.22456 15.2557 8.18869C15.2686 8.15281 15.2741 8.11445 15.2719 8.07615V7.56018C15.2169 7.38843 15.1082 7.27322 14.9994 7.27322Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6508 7.27322H17.1671C17.2815 7.27322 17.396 7.38843 17.4539 7.56018V8.07615C17.4562 8.11445 17.4504 8.15281 17.4368 8.18869C17.4232 8.22456 17.4022 8.25715 17.3751 8.28428C17.348 8.31141 17.3154 8.33246 17.2796 8.34605C17.2437 8.35965 17.2054 8.36546 17.1671 8.36311H16.6508C16.6125 8.36546 16.5742 8.35965 16.5383 8.34605C16.5024 8.33246 16.4699 8.31141 16.4428 8.28428C16.4157 8.25715 16.3946 8.22456 16.381 8.18869C16.3674 8.15281 16.3616 8.11445 16.364 8.07615V7.56018C16.3616 7.52189 16.3674 7.48353 16.381 7.44765C16.3946 7.41177 16.4157 7.37919 16.4428 7.35206C16.4699 7.32493 16.5024 7.30387 16.5383 7.29028C16.5742 7.27669 16.6125 7.27088 16.6508 7.27322Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.36353 5C4.36353 4.44772 4.81125 4 5.36353 4H18.6362C19.1885 4 19.6362 4.44772 19.6362 5V10.6363C19.6362 11.1886 19.1885 11.6363 18.6362 11.6363H5.36353C4.81125 11.6363 4.36353 11.1886 4.36353 10.6363V5ZM5.36353 5H18.6362L18.6362 10.6363L5.36353 10.6363V5Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6986 7.9178C23.694 8.04933 23.65 8.17525 23.5738 8.27509L22.1157 10.0815C22.0255 10.1757 21.9089 10.2315 21.7861 10.2394C21.6633 10.2473 21.5418 10.2068 21.4426 10.1248C21.3551 10.023 21.3066 9.88652 21.3074 9.74479C21.3083 9.60306 21.3585 9.46737 21.4473 9.36688L22.1742 8.43755H19.7061C19.5835 8.43755 19.5864 8.37267 19.4998 8.27509C19.4998 8.10985 19.4998 8.0558 19.4998 7.9178C19.4998 7.7798 19.4998 7.75189 19.4998 7.56224C19.5864 7.46466 19.5835 7.39689 19.7061 7.39689L22.1753 7.39689L21.4508 6.47625C21.3677 6.37199 21.3214 6.23701 21.3208 6.09689C21.3201 5.95677 21.3651 5.82124 21.4473 5.71599C21.546 5.6334 21.6674 5.59269 21.7902 5.60105C21.9129 5.6094 22.0291 5.66628 22.1183 5.76167L23.5707 7.56224C23.6527 7.65801 23.7007 7.78479 23.6986 7.9178Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1963 17.0903H11.7126C11.7509 17.0927 11.7892 17.0869 11.8251 17.0733C11.8609 17.0597 11.8935 17.0386 11.9206 17.0115C11.9477 16.9844 11.9688 16.9518 11.9823 16.9159C11.9959 16.88 12.0017 16.8417 11.9994 16.8034V16.2874C12.0017 16.2491 11.9959 16.2108 11.9823 16.1749C11.9688 16.139 11.9477 16.1064 11.9206 16.0793C11.8935 16.0522 11.8609 16.0311 11.8251 16.0175C11.7892 16.0039 11.7509 15.9981 11.7126 16.0005H11.1963C11.158 15.9981 11.1197 16.0039 11.0838 16.0175C11.048 16.0311 11.0154 16.0522 10.9883 16.0793C10.9612 16.1064 10.9401 16.139 10.9265 16.1749C10.913 16.2108 10.9071 16.2491 10.9095 16.2874V16.8034C10.9639 16.9751 11.0783 17.0903 11.1963 17.0903Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5452 17.0903H9.00023C8.8915 17.0903 8.78277 16.9751 8.72774 16.8034V16.2874C8.72551 16.2491 8.73103 16.2108 8.74394 16.1749C8.75684 16.139 8.77684 16.1064 8.8026 16.0793C8.82836 16.0522 8.8593 16.0311 8.89337 16.0175C8.92744 16.0039 8.96386 15.9981 9.00023 16.0005H9.5452C9.58156 15.9981 9.61798 16.0039 9.65205 16.0175C9.68612 16.0311 9.71706 16.0522 9.74282 16.0793C9.76858 16.1064 9.78858 16.139 9.80148 16.1749C9.81439 16.2108 9.81991 16.2491 9.81768 16.2874V16.8034C9.81991 16.8417 9.81439 16.88 9.80148 16.9159C9.78858 16.9518 9.76858 16.9844 9.74282 17.0115C9.71706 17.0386 9.68612 17.0597 9.65205 17.0733C9.61798 17.0869 9.58156 17.0927 9.5452 17.0903Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.83256 17.0903H7.3489C7.38717 17.0927 7.4255 17.0869 7.46136 17.0733C7.49721 17.0597 7.52978 17.0386 7.55689 17.0115C7.584 16.9844 7.60504 16.9518 7.61863 16.9159C7.63221 16.88 7.63802 16.8417 7.63568 16.8034V16.2874C7.63802 16.2491 7.63221 16.2108 7.61863 16.1749C7.60504 16.139 7.584 16.1064 7.55689 16.0793C7.52978 16.0522 7.49721 16.0311 7.46136 16.0175C7.4255 16.0039 7.38717 15.9981 7.3489 16.0005H6.83256C6.79429 15.9981 6.75596 16.0039 6.7201 16.0175C6.68425 16.0311 6.65168 16.0522 6.62457 16.0793C6.59746 16.1064 6.57641 16.139 6.56283 16.1749C6.54925 16.2108 6.54344 16.2491 6.54578 16.2874V16.8034C6.6037 16.9751 6.71813 17.0903 6.83256 17.0903Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6361 20.3636C19.1884 20.3636 19.6361 19.9159 19.6361 19.3636V13.7272C19.6361 13.175 19.1884 12.7272 18.6361 12.7272L5.36344 12.7272C4.81115 12.7272 4.36344 13.175 4.36344 13.7272V16.0497C4.3454 16.0425 4.32305 16.0387 4.29331 16.0387L1.82516 16.0387L2.55215 15.1094C2.64091 15.0089 2.69112 14.8732 2.69198 14.7315C2.69285 14.5897 2.6443 14.4533 2.55677 14.3514C2.45759 14.2694 2.33614 14.2289 2.21331 14.2368C2.09047 14.2447 1.97392 14.3006 1.88369 14.3948L0.425606 16.2012C0.349411 16.301 0.305443 16.4269 0.300848 16.5585C0.298735 16.6915 0.346689 16.8182 0.428686 16.914L1.88112 18.7146C1.97029 18.81 2.08649 18.8668 2.20924 18.8752C2.332 18.8836 2.45343 18.8429 2.55215 18.7603C2.63429 18.655 2.6793 18.5195 2.67864 18.3794C2.67798 18.2392 2.63169 18.1043 2.54856 18L1.82413 17.0794L4.29331 17.0794C4.32305 17.0794 4.3454 17.0754 4.36344 17.0679L4.36344 19.3636C4.36344 19.9159 4.81115 20.3636 5.36344 20.3636L18.6361 20.3636ZM5.36344 19.3636L18.6361 19.3636V13.7272L5.36344 13.7272L5.36344 19.3636Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.287 7.27322H12.8034C12.9213 7.27322 13.0357 7.38843 13.0902 7.56018V8.07615C13.0925 8.11445 13.0867 8.15281 13.0731 8.18869C13.0595 8.22456 13.0385 8.25715 13.0114 8.28428C12.9843 8.31141 12.9517 8.33246 12.9158 8.34605C12.88 8.35965 12.8417 8.36546 12.8034 8.36311H12.287C12.2488 8.36546 12.2104 8.35965 12.1746 8.34605C12.1387 8.33246 12.1062 8.31141 12.0791 8.28428C12.0519 8.25715 12.0309 8.22456 12.0173 8.18869C12.0037 8.15281 11.9979 8.11445 12.0003 8.07615V7.56018C11.9979 7.52189 12.0037 7.48353 12.0173 7.44765C12.0309 7.41177 12.0519 7.37919 12.0791 7.35206C12.1062 7.32493 12.1387 7.30387 12.1746 7.29028C12.2104 7.27669 12.2488 7.27088 12.287 7.27322Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9994 7.27322H14.4545C14.4181 7.27088 14.3817 7.27669 14.3476 7.29028C14.3135 7.30387 14.2826 7.32493 14.2568 7.35206C14.2311 7.37919 14.2111 7.41177 14.1982 7.44765C14.1853 7.48353 14.1797 7.52189 14.182 7.56018V8.07615C14.1797 8.11445 14.1853 8.15281 14.1982 8.18869C14.2111 8.22456 14.2311 8.25715 14.2568 8.28428C14.2826 8.31141 14.3135 8.33246 14.3476 8.34605C14.3817 8.35965 14.4181 8.36546 14.4545 8.36311H14.9994C15.0358 8.36546 15.0722 8.35965 15.1063 8.34605C15.1404 8.33246 15.1713 8.31141 15.1971 8.28428C15.2228 8.25715 15.2428 8.22456 15.2557 8.18869C15.2686 8.15281 15.2741 8.11445 15.2719 8.07615V7.56018C15.2169 7.38843 15.1082 7.27322 14.9994 7.27322Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6508 7.27322H17.1671C17.2815 7.27322 17.396 7.38843 17.4539 7.56018V8.07615C17.4562 8.11445 17.4504 8.15281 17.4368 8.18869C17.4232 8.22456 17.4022 8.25715 17.3751 8.28428C17.348 8.31141 17.3154 8.33246 17.2796 8.34605C17.2437 8.35965 17.2054 8.36546 17.1671 8.36311H16.6508C16.6125 8.36546 16.5742 8.35965 16.5383 8.34605C16.5024 8.33246 16.4699 8.31141 16.4428 8.28428C16.4157 8.25715 16.3946 8.22456 16.381 8.18869C16.3674 8.15281 16.3616 8.11445 16.364 8.07615V7.56018C16.3616 7.52189 16.3674 7.48353 16.381 7.44765C16.3946 7.41177 16.4157 7.37919 16.4428 7.35206C16.4699 7.32493 16.5024 7.30387 16.5383 7.29028C16.5742 7.27669 16.6125 7.27088 16.6508 7.27322Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.36353 5C4.36353 4.44772 4.81125 4 5.36353 4H18.6362C19.1885 4 19.6362 4.44772 19.6362 5V10.6363C19.6362 11.1886 19.1885 11.6363 18.6362 11.6363H5.36353C4.81125 11.6363 4.36353 11.1886 4.36353 10.6363V5ZM5.36353 5H18.6362L18.6362 10.6363L5.36353 10.6363V5Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6986 7.9178C23.694 8.04933 23.65 8.17525 23.5738 8.27509L22.1157 10.0815C22.0255 10.1757 21.9089 10.2315 21.7861 10.2394C21.6633 10.2473 21.5418 10.2068 21.4426 10.1248C21.3551 10.023 21.3066 9.88652 21.3074 9.74479C21.3083 9.60306 21.3585 9.46737 21.4473 9.36688L22.1742 8.43755H19.7061C19.5835 8.43755 19.5864 8.37267 19.4998 8.27509C19.4998 8.10985 19.4998 8.0558 19.4998 7.9178C19.4998 7.7798 19.4998 7.75189 19.4998 7.56224C19.5864 7.46466 19.5835 7.39689 19.7061 7.39689L22.1753 7.39689L21.4508 6.47625C21.3677 6.37199 21.3214 6.23701 21.3208 6.09689C21.3201 5.95677 21.3651 5.82124 21.4473 5.71599C21.546 5.6334 21.6674 5.59269 21.7902 5.60105C21.9129 5.6094 22.0291 5.66628 22.1183 5.76167L23.5707 7.56224C23.6527 7.65801 23.7007 7.78479 23.6986 7.9178Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1963 17.0903H11.7126C11.7509 17.0927 11.7892 17.0869 11.8251 17.0733C11.8609 17.0597 11.8935 17.0386 11.9206 17.0115C11.9477 16.9844 11.9688 16.9518 11.9823 16.9159C11.9959 16.88 12.0017 16.8417 11.9994 16.8034V16.2874C12.0017 16.2491 11.9959 16.2108 11.9823 16.1749C11.9688 16.139 11.9477 16.1064 11.9206 16.0793C11.8935 16.0522 11.8609 16.0311 11.8251 16.0175C11.7892 16.0039 11.7509 15.9981 11.7126 16.0005H11.1963C11.158 15.9981 11.1197 16.0039 11.0838 16.0175C11.048 16.0311 11.0154 16.0522 10.9883 16.0793C10.9612 16.1064 10.9401 16.139 10.9265 16.1749C10.913 16.2108 10.9071 16.2491 10.9095 16.2874V16.8034C10.9639 16.9751 11.0783 17.0903 11.1963 17.0903Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5452 17.0903H9.00023C8.8915 17.0903 8.78277 16.9751 8.72774 16.8034V16.2874C8.72551 16.2491 8.73103 16.2108 8.74394 16.1749C8.75684 16.139 8.77684 16.1064 8.8026 16.0793C8.82836 16.0522 8.8593 16.0311 8.89337 16.0175C8.92744 16.0039 8.96386 15.9981 9.00023 16.0005H9.5452C9.58156 15.9981 9.61798 16.0039 9.65205 16.0175C9.68612 16.0311 9.71706 16.0522 9.74282 16.0793C9.76858 16.1064 9.78858 16.139 9.80148 16.1749C9.81439 16.2108 9.81991 16.2491 9.81768 16.2874V16.8034C9.81991 16.8417 9.81439 16.88 9.80148 16.9159C9.78858 16.9518 9.76858 16.9844 9.74282 17.0115C9.71706 17.0386 9.68612 17.0597 9.65205 17.0733C9.61798 17.0869 9.58156 17.0927 9.5452 17.0903Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.83256 17.0903H7.3489C7.38717 17.0927 7.4255 17.0869 7.46136 17.0733C7.49721 17.0597 7.52978 17.0386 7.55689 17.0115C7.584 16.9844 7.60504 16.9518 7.61863 16.9159C7.63221 16.88 7.63802 16.8417 7.63568 16.8034V16.2874C7.63802 16.2491 7.63221 16.2108 7.61863 16.1749C7.60504 16.139 7.584 16.1064 7.55689 16.0793C7.52978 16.0522 7.49721 16.0311 7.46136 16.0175C7.4255 16.0039 7.38717 15.9981 7.3489 16.0005H6.83256C6.79429 15.9981 6.75596 16.0039 6.7201 16.0175C6.68425 16.0311 6.65168 16.0522 6.62457 16.0793C6.59746 16.1064 6.57641 16.139 6.56283 16.1749C6.54925 16.2108 6.54344 16.2491 6.54578 16.2874V16.8034C6.6037 16.9751 6.71813 17.0903 6.83256 17.0903Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.6361 20.3636C19.1884 20.3636 19.6361 19.9159 19.6361 19.3636V13.7272C19.6361 13.175 19.1884 12.7272 18.6361 12.7272L5.36344 12.7272C4.81115 12.7272 4.36344 13.175 4.36344 13.7272V16.0497C4.3454 16.0425 4.32305 16.0387 4.29331 16.0387L1.82516 16.0387L2.55215 15.1094C2.64091 15.0089 2.69112 14.8732 2.69198 14.7315C2.69285 14.5897 2.6443 14.4533 2.55677 14.3514C2.45759 14.2694 2.33614 14.2289 2.21331 14.2368C2.09047 14.2447 1.97392 14.3006 1.88369 14.3948L0.425606 16.2012C0.349411 16.301 0.305443 16.4269 0.300848 16.5585C0.298735 16.6915 0.346689 16.8182 0.428686 16.914L1.88112 18.7146C1.97029 18.81 2.08649 18.8668 2.20924 18.8752C2.332 18.8836 2.45343 18.8429 2.55215 18.7603C2.63429 18.655 2.6793 18.5195 2.67864 18.3794C2.67798 18.2392 2.63169 18.1043 2.54856 18L1.82413 17.0794L4.29331 17.0794C4.32305 17.0794 4.3454 17.0754 4.36344 17.0679L4.36344 19.3636C4.36344 19.9159 4.81115 20.3636 5.36344 20.3636L18.6361 20.3636ZM5.36344 19.3636L18.6361 19.3636V13.7272L5.36344 13.7272L5.36344 19.3636Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3
}));
export const CopyIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Copy",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Copy"
}, " Copy"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.88 22.14H16C16.5 22.14 16.98 21.94 17.33 21.59C17.68 21.24 17.88 20.76 17.88 20.26V17.88H20.26C20.76 17.88 21.24 17.68 21.59 17.33C21.94 16.97 22.14 16.5 22.14 16V3.88C22.14 3.38 21.95 2.9 21.59 2.55C21.24 2.2 20.76 2 20.26 2H8.14C7.64 2 7.16 2.19 6.81 2.55C6.46 2.91 6.26 3.38 6.26 3.88V6.26H3.88C3.38 6.26 2.9 6.46 2.55 6.81C2.2 7.16 2 7.65 2 8.14V20.26C2 20.76 2.2 21.24 2.55 21.59C2.91 21.94 3.38 22.14 3.88 22.14ZM3.81 8.07C3.83 8.05 3.88 8.04 3.88 8.04H16C16.03 8.04 16.05 8.05 16.07 8.07C16.09 8.09 16.1 8.14 16.1 8.14V20.26C16.1 20.29 16.09 20.31 16.07 20.33C16.05 20.35 16 20.36 16 20.36H3.88C3.85 20.36 3.83 20.35 3.81 20.33C3.79 20.31 3.78 20.26 3.78 20.26V8.14C3.78 8.11 3.79 8.09 3.81 8.07ZM20.26 16.1H17.88V8.14C17.88 7.64 17.68 7.16 17.33 6.81C16.98 6.46 16.5 6.26 16 6.26H8.04V3.88L8.07 3.81L20.26 3.78L20.33 3.81L20.36 16C20.36 16.026 20.3525 16.037 20.3375 16.0589C20.3352 16.0623 20.3327 16.066 20.33 16.07C20.31 16.1 20.26 16.1 20.26 16.1Z",
  fill: "var(--icon-primary)"
}));
export const CriticalNotificationIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Critical-notification",
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Critical-notification"
}, " Critical notification"), /*#__PURE__*/React.createElement("path", {
  d: "M12.2302 14.52L12.2102 14.46L12.1802 14.3801L12.1602 14.36L12.1202 14.2501L12.0602 14.28L12.0202 14.2501C12.0202 14.2501 12.0101 14.2433 11.9996 14.2357C11.9921 14.2302 11.9844 14.2242 11.9802 14.22L11.8702 14.1301C11.5302 13.91 11.1402 13.78 10.7302 13.7601C10.2502 13.78 9.79022 13.9501 9.42023 14.2501C9.35022 14.3101 9.31021 14.3801 9.28021 14.4401C9.25647 14.4875 9.24329 14.5386 9.23651 14.5869C9.23187 14.6199 9.23022 14.6516 9.23022 14.6801C9.23022 14.7501 9.24023 14.84 9.28021 14.92C9.30023 14.96 9.32022 14.9901 9.34021 15.02C9.35275 15.0388 9.36923 15.0576 9.38715 15.074C9.39038 15.077 9.39368 15.0798 9.397 15.0826C9.40216 15.0869 9.40735 15.0909 9.41257 15.0947L9.42023 15.1C9.80023 15.3901 10.2502 15.5701 10.7202 15.59H10.7402C11.2102 15.5601 11.6702 15.4 12.0402 15.1C12.1102 15.05 12.1602 14.98 12.2002 14.91C12.2402 14.8301 12.2502 14.7401 12.2502 14.66C12.2502 14.61 12.2502 14.5601 12.2302 14.52Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.8703 14.8369L13.8202 14.85C13.8002 14.8101 13.8002 14.7601 13.8002 14.71C13.8002 14.6769 13.8019 14.642 13.8068 14.6069C13.8137 14.5572 13.8268 14.5069 13.8502 14.46C13.8602 14.4401 13.8802 14.41 13.8802 14.41C13.8902 14.4 13.9002 14.3801 13.9002 14.3801C13.9144 14.3612 13.9396 14.3335 13.9623 14.3094C13.9878 14.2825 14.0102 14.2601 14.0102 14.2601C14.3902 13.96 14.8402 13.79 15.3302 13.77C15.8102 13.79 16.2702 13.96 16.6402 14.2601C16.7002 14.3101 16.7502 14.3801 16.7902 14.4501V14.47C16.8202 14.53 16.8402 14.61 16.8402 14.7001C16.8402 14.7237 16.8394 14.7473 16.8371 14.7709C16.8358 14.7852 16.8339 14.7996 16.8314 14.8139C16.824 14.856 16.8112 14.898 16.7902 14.9401C16.7733 14.9851 16.7501 15.027 16.7204 15.064C16.6975 15.0926 16.6708 15.1182 16.6402 15.1401C16.2728 15.438 15.8166 15.5978 15.3402 15.6294L15.3302 15.6301C14.9202 15.61 14.5302 15.48 14.1902 15.2601L14.0802 15.17C14.0702 15.16 14.0402 15.1401 14.0402 15.1401L13.8902 15.02L13.9202 14.98C13.9189 14.9773 13.9173 14.9747 13.9156 14.9723C13.9106 14.9652 13.9047 14.9595 13.8999 14.9547C13.8944 14.9492 13.8902 14.9446 13.8902 14.9401V14.92C13.8802 14.91 13.8802 14.8801 13.8802 14.8801C13.8714 14.8624 13.8704 14.8525 13.8703 14.8369Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0402 9.99005C20.6002 10.29 21.0602 10.71 21.0602 11.3201L21.0202 11.3101C21.0202 11.8101 20.7002 12.1901 20.2802 12.47C19.8502 12.7501 19.2702 12.96 18.6202 13.1301C18.5702 13.1401 18.5102 13.2001 18.5102 13.2001C18.4999 13.2172 18.4932 13.2391 18.4887 13.2604C18.487 13.2689 18.4856 13.2773 18.4844 13.2853L18.4833 13.2941L18.4821 13.3054C18.4814 13.3133 18.4809 13.3203 18.4807 13.3259C18.4802 13.3347 18.4802 13.34 18.4802 13.34L18.8002 15.77C18.8302 15.96 18.8202 16.15 18.7802 16.3201L18.7796 16.322L18.8102 16.3301V16.34L18.7774 16.3297C18.7272 16.4965 18.648 16.6628 18.5302 16.8101C18.4202 16.9501 18.2802 17.0801 18.1202 17.17C17.9602 17.27 17.7802 17.3301 17.5902 17.35C16.6702 17.46 15.3402 17.55 14.6302 17.5801C14.4002 17.59 14.1802 17.55 13.9702 17.47C13.7602 17.3901 13.5802 17.2601 13.4202 17.1L13.1002 16.77L13.2402 16.6301L13.1002 16.7601C13.088 16.7478 13.0757 16.7355 13.0612 16.7256C13.052 16.7193 13.0418 16.7139 13.0302 16.71C13.0102 16.6901 13.0002 16.6901 12.9802 16.6901H12.9602C12.9226 16.6901 12.885 16.7014 12.8687 16.707L12.8702 16.71C12.8402 16.72 12.8002 16.77 12.8002 16.77L12.4702 17.1C12.3302 17.2501 12.1602 17.3801 11.9602 17.46C11.7602 17.55 11.5502 17.59 11.3402 17.59H11.2002V17.61L10.9902 17.59H10.8102L10.6702 17.5801C9.97021 17.54 8.97021 17.48 8.22021 17.3801C8.04022 17.35 7.86023 17.29 7.70023 17.2001C7.63516 17.1635 7.57343 17.1202 7.51566 17.0724C7.43134 17.0027 7.3555 16.9231 7.29022 16.84C7.18024 16.7001 7.10022 16.53 7.05023 16.35C7.00021 16.17 6.99023 15.98 7.02023 15.8L7.34021 13.3301C7.35022 13.29 7.34021 13.2401 7.31021 13.2001C7.28021 13.16 7.24023 13.1301 7.19022 13.1201C6.55023 12.9501 5.98022 12.7401 5.56021 12.46C5.14023 12.1901 4.82022 11.8101 4.82022 11.3101C4.82022 10.71 5.29022 10.28 5.85022 9.99005C6.38022 9.72003 7.08023 9.51007 7.83023 9.35004V9.33008L8.04022 9.30005H8.06021C8.06418 9.29608 8.06973 9.2937 8.07498 9.29224C8.08295 9.29004 8.09021 9.29004 8.09021 9.29004C8.09238 9.28784 8.09454 9.28613 8.09662 9.28479C8.09897 9.28333 8.1012 9.28229 8.10315 9.28156C8.10736 9.28003 8.11023 9.28003 8.11023 9.28003L8.12024 9.27002C8.13821 9.25208 8.15259 9.23407 8.16339 9.21393C8.17062 9.2005 8.17624 9.1861 8.18024 9.17004L8.47021 8.03003C8.60022 7.49005 8.94022 7.02002 9.41022 6.72003C9.88022 6.43005 10.4502 6.33008 11.0002 6.46002L11.2002 6.51007L12.1802 6.74005C12.6902 6.86005 13.2202 6.86005 13.7302 6.74005L14.9202 6.46002L14.9602 6.65002V6.63007L14.9202 6.46002C15.1898 6.3902 15.4593 6.38013 15.7388 6.42981L15.7402 6.42004C16.0002 6.47003 16.2702 6.56006 16.5002 6.71002C16.7402 6.85004 16.9402 7.04004 17.1002 7.27002C17.2702 7.50006 17.3802 7.75006 17.4402 8.02002L17.7102 9.16003C17.7146 9.17749 17.7209 9.19305 17.729 9.20752C17.7396 9.22626 17.7533 9.24316 17.7702 9.26007C17.7902 9.28003 17.8202 9.31006 17.8602 9.31006L18.0202 9.35004C18.7902 9.50006 19.5002 9.71002 20.0402 9.99005ZM15.7302 6.48669L15.7102 6.60004V6.62006L15.7302 6.48669ZM11.9302 15.8301C12.0702 15.6801 12.2502 15.5601 12.4402 15.48L12.4302 15.5101C12.6302 15.42 12.8402 15.3801 13.0502 15.3801C13.2602 15.3801 13.4602 15.4301 13.6602 15.5101C13.8602 15.6 14.0302 15.72 14.1802 15.8701L14.3602 16.0601L14.4202 16.1301L14.4902 16.2001L14.5202 16.2501H14.5602C14.5735 16.2545 14.5945 16.257 14.6139 16.2584L14.6226 16.2589L14.6354 16.2595L14.6459 16.2598L14.6602 16.2601H14.6802C15.3802 16.23 16.6702 16.16 17.5302 16.05L17.5502 16.03V16.0001L17.2502 13.6201C17.2502 13.61 17.2402 13.5801 17.2302 13.5601C17.2102 13.53 17.1702 13.4901 17.1702 13.4901C17.1658 13.4857 17.1576 13.4813 17.1497 13.4777L17.1437 13.4752L17.137 13.4725L17.1302 13.47H17.0502C15.7702 13.65 14.4802 13.7501 13.1902 13.7501V13.7601H12.9902C11.6302 13.7601 10.2802 13.67 8.93024 13.48H8.85022C8.84021 13.4901 8.82022 13.4901 8.82022 13.4901L8.80023 13.5101C8.78021 13.52 8.78021 13.53 8.78021 13.53C8.76581 13.5493 8.75833 13.5684 8.75443 13.5832C8.75021 13.5992 8.75021 13.61 8.75021 13.61L8.45023 15.9501V15.9901C8.46024 16.0001 8.47021 16.0101 8.49023 16.02H8.50021C9.15024 16.1201 10.2202 16.2001 11.4402 16.2501C11.4528 16.2501 11.4653 16.2483 11.4778 16.2455C11.4845 16.2441 11.4911 16.2424 11.4978 16.2404C11.5086 16.2372 11.5194 16.2336 11.5302 16.23C11.5379 16.2262 11.547 16.2209 11.5554 16.2158L11.5684 16.2077L11.5802 16.2001L11.6002 16.1801V16.16L11.9302 15.8301ZM18.0302 10.5701L18.0802 10.7601L18.0702 10.7501V10.77C18.0802 10.85 18.0902 10.9301 18.0802 11.02L18.0502 11.1401C18.0458 11.1578 18.0394 11.1755 18.032 11.1923C18.0225 11.2135 18.0114 11.2333 18.0002 11.2501L17.8602 11.17L17.9902 11.2501C17.9657 11.293 17.9374 11.3322 17.903 11.3676C17.8813 11.39 17.8573 11.4108 17.8302 11.4301C17.8254 11.4398 17.8135 11.4494 17.8026 11.4568C17.7909 11.4647 17.7802 11.47 17.7802 11.47C17.7202 11.5001 17.6702 11.52 17.6102 11.54H17.4802C17.4402 11.54 17.3702 11.55 17.3002 11.54C17.2902 11.53 17.2502 11.53 17.2502 11.53C17.2475 11.5287 17.2445 11.5273 17.2412 11.526C17.2355 11.5237 17.2291 11.5215 17.2229 11.5195C17.2152 11.517 17.2077 11.5148 17.2018 11.5131L17.1902 11.5101C17.1402 11.5001 17.0602 11.4501 17.0602 11.4501C16.9902 11.4 16.9202 11.34 16.8702 11.27C16.8465 11.2463 16.8353 11.2226 16.8218 11.194L16.8148 11.1794L16.8102 11.17C16.7902 11.15 16.7902 11.1201 16.7902 11.1201L16.7602 11.1L16.7402 11.03L16.0902 8.27002C16.0702 8.18005 16.0302 8.09003 15.9702 8.00006C15.9102 7.92004 15.8402 7.86005 15.7502 7.80005C15.6702 7.74005 15.5702 7.70007 15.4802 7.69006H15.4402C15.3502 7.69006 15.2702 7.69006 15.1902 7.71002L14.2102 7.95007L14.0102 7.99005L14.0042 7.99261C13.9994 7.99451 13.994 7.99585 13.9886 7.99689L13.9834 7.9978L13.9769 7.9986C13.9728 7.99908 13.9686 7.99939 13.9646 7.99963L13.9527 8L13.9402 8.00006L13.8202 8.02002C13.1702 8.14008 12.5002 8.14008 11.8502 7.99005L10.6702 7.71002C10.6356 7.70233 10.5994 7.69763 10.5623 7.69525L10.5504 7.69464L10.5381 7.69409C10.4865 7.69226 10.4333 7.69476 10.3802 7.70007C10.3664 7.70386 10.353 7.70764 10.3398 7.71143C10.3257 7.71552 10.3119 7.7196 10.2984 7.72382C10.2773 7.73041 10.257 7.73718 10.2374 7.74438C10.1879 7.76263 10.1426 7.78357 10.1002 7.81006C10.0102 7.86005 9.94022 7.93005 9.88022 8.01007C9.82022 8.10004 9.78021 8.19006 9.76022 8.29004L9.12024 11.0101V11.05C9.07022 11.21 8.97021 11.34 8.83023 11.4301C8.70023 11.52 8.54022 11.53 8.41022 11.52H8.31021C8.22021 11.5101 8.14023 11.47 8.07022 11.42C8.00021 11.3801 7.95023 11.3201 7.90024 11.2501C7.88022 11.23 7.85022 11.17 7.85022 11.17C7.84109 11.1518 7.83197 11.1211 7.82474 11.0931L7.819 11.0698L7.81644 11.0588L7.81238 11.0405L7.81021 11.03C7.80103 10.9933 7.79608 10.9566 7.79532 10.9189C7.79443 10.8745 7.79941 10.8287 7.81021 10.78V10.7601H7.78021C7.18024 10.9 6.75021 11.0601 6.47021 11.2001C6.37024 11.2501 6.30023 11.29 6.25021 11.3301C6.30023 11.36 6.37024 11.4 6.46024 11.4501C6.74023 11.5801 7.16022 11.7401 7.74023 11.8801L7.73785 11.8891C8.89774 12.1652 10.6251 12.4 12.9102 12.4C15.2202 12.4 16.9602 12.15 18.1202 11.8701L18.1602 12.05V12.03L18.1202 11.8701C18.7002 11.73 19.1302 11.5701 19.4002 11.4401C19.4902 11.4 19.5502 11.36 19.6002 11.3301C19.5745 11.3094 19.5434 11.2889 19.507 11.2669C19.4728 11.2462 19.4339 11.2243 19.3902 11.2001C19.1102 11.0601 18.6802 10.9 18.0902 10.7601H18.0802V10.7501L18.0302 10.5701ZM19.7902 11.4L19.7402 11.34L19.8202 11.4401L19.7902 11.4Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9302 0.300049C6.47021 0.300049 1.23022 5.54004 1.23022 12.0001C1.23022 18.46 6.47021 23.7001 12.9302 23.7001C19.3902 23.7001 24.6302 18.46 24.6302 12.0001C24.6302 5.54004 19.3902 0.300049 12.9302 0.300049ZM12.9302 22.34C7.22021 22.34 2.59021 17.71 2.59021 12.0001C2.59021 6.29004 7.22021 1.66003 12.9302 1.66003C18.6402 1.66003 23.2702 6.29004 23.2702 12.0001C23.2702 17.71 18.6402 22.34 12.9302 22.34Z",
  fill: "var(--icon-primary)"
}));
export const DeleteDarkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "ic_delete",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "ic_delete"
}, "Delete"), /*#__PURE__*/React.createElement("path", {
  d: "M6.91985 23C6.38366 22.9878 5.8725 22.7709 5.49113 22.3938C5.10977 22.0167 4.88707 21.508 4.86882 20.972L3.93083 5.578H2.08488C1.92609 5.57407 1.77536 5.50734 1.66569 5.39243C1.55603 5.27751 1.49643 5.1238 1.49992 4.965C1.49616 4.80602 1.55576 4.65205 1.66545 4.53693C1.77514 4.4218 1.92592 4.35494 2.08488 4.35101H7.44597V3.151C7.43799 2.87449 7.48496 2.59915 7.58415 2.34091C7.68335 2.08268 7.83281 1.84667 8.02385 1.64661C8.21489 1.44654 8.44356 1.28638 8.69695 1.17538C8.95033 1.06439 9.22334 1.00478 9.49992 1H14.6559C14.9323 1.00516 15.2049 1.0651 15.4579 1.17636C15.7109 1.28762 15.9392 1.44797 16.1298 1.64813C16.3204 1.84829 16.4693 2.08429 16.568 2.34244C16.6668 2.60058 16.7134 2.87576 16.705 3.15201V4.35199H22.069C22.228 4.35592 22.3788 4.42281 22.4884 4.53793C22.5981 4.65306 22.6577 4.80703 22.654 4.966C22.6575 5.12481 22.5979 5.27852 22.4882 5.39343C22.3785 5.50834 22.2278 5.57508 22.069 5.57901H20.2228L19.2858 20.973C19.2676 21.509 19.0451 22.0177 18.6637 22.3948C18.2824 22.7719 17.7712 22.9888 17.235 23.001L6.91985 23ZM6.03996 20.912C6.04743 21.1409 6.14301 21.3581 6.30681 21.5181C6.4706 21.6782 6.68986 21.7688 6.91887 21.771H17.2299C17.4591 21.7691 17.6787 21.6786 17.8427 21.5185C18.0067 21.3584 18.1026 21.1411 18.11 20.912L19.047 5.57901H5.10002L6.03996 20.912ZM8.61882 3.15201V4.35199H15.5339V3.15201C15.5387 3.03317 15.5197 2.91457 15.4777 2.80328C15.4357 2.692 15.3716 2.59028 15.2895 2.50424C15.2074 2.4182 15.1089 2.34958 14.9997 2.30246C14.8905 2.25534 14.7729 2.23072 14.654 2.23001H9.49992C9.38086 2.23045 9.26312 2.2549 9.15373 2.30191C9.04434 2.34892 8.94546 2.41752 8.8632 2.5036C8.78095 2.58968 8.71696 2.69147 8.67497 2.80289C8.63298 2.9143 8.61384 3.03305 8.61882 3.15201ZM13.892 17.839V9.51199C13.8883 9.35302 13.9476 9.19905 14.0573 9.08392C14.167 8.9688 14.318 8.90194 14.477 8.89801C14.5558 8.89983 14.6334 8.91713 14.7055 8.94897C14.7776 8.98082 14.8427 9.02657 14.8971 9.08359C14.9516 9.14061 14.9942 9.2078 15.0226 9.28131C15.0511 9.35482 15.0648 9.4332 15.0629 9.51199V17.839C15.0648 17.9178 15.0511 17.9962 15.0226 18.0697C14.9942 18.1432 14.9516 18.2104 14.8971 18.2674C14.8427 18.3244 14.7776 18.3702 14.7055 18.402C14.6334 18.4339 14.5558 18.4512 14.477 18.453C14.3982 18.4511 14.3205 18.4336 14.2485 18.4016C14.1764 18.3697 14.1114 18.3238 14.0571 18.2667C14.0027 18.2096 13.9601 18.1423 13.9318 18.0688C13.9035 17.9952 13.89 17.9168 13.892 17.838V17.839ZM9.09196 17.839V9.51199C9.0901 9.4332 9.1038 9.35482 9.13225 9.28131C9.16069 9.2078 9.20332 9.14061 9.25774 9.08359C9.31216 9.02657 9.37729 8.98082 9.44939 8.94897C9.52149 8.91713 9.5991 8.89983 9.6779 8.89801C9.83687 8.90194 9.98789 8.9688 10.0976 9.08392C10.2073 9.19905 10.2666 9.35302 10.2629 9.51199V17.839C10.2666 17.998 10.2073 18.1519 10.0976 18.2671C9.98789 18.3822 9.83687 18.4491 9.6779 18.453C9.59868 18.4517 9.52055 18.4347 9.44792 18.403C9.37529 18.3714 9.30966 18.3256 9.25481 18.2685C9.19995 18.2113 9.15698 18.1438 9.12834 18.0699C9.09971 17.996 9.08582 17.9172 9.08781 17.838L9.09196 17.839Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.6
}));
export const DownloadMonochromeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.6121 17.624C12.4394 17.7725 12.2216 17.8581 11.9941 17.867C11.764 17.8712 11.5417 17.7828 11.3761 17.623L6.2821 12.829C6.11668 12.6546 6.01838 12.4273 6.00465 12.1873C5.99093 11.9473 6.06265 11.7102 6.2071 11.518C6.38925 11.3596 6.62305 11.2731 6.86449 11.2749C7.10594 11.2768 7.33839 11.3668 7.5181 11.528L11.0931 14.899V3.01804C11.0931 2.77935 11.1879 2.55043 11.3567 2.38165C11.5255 2.21286 11.7544 2.11804 11.9931 2.11804C12.2318 2.11804 12.4607 2.21286 12.6295 2.38165C12.7983 2.55043 12.8931 2.77935 12.8931 3.01804V14.899L16.4701 11.528C16.644 11.3538 16.8794 11.2551 17.1255 11.2532C17.3717 11.2513 17.6086 11.3465 17.7851 11.518C17.9266 11.7118 17.9962 11.9488 17.9818 12.1883C17.9674 12.4277 17.8699 12.6547 17.7061 12.83L12.6121 17.624Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 20.5C1.94772 20.5 1.5 20.9477 1.5 21.5C1.5 22.0523 1.94772 22.5 2.5 22.5H21.5C22.0523 22.5 22.5 22.0523 22.5 21.5C22.5 20.9477 22.0523 20.5 21.5 20.5H2.5Z",
  fill: "var(--icon-primary)"
}));
export const DropdownArrowDownIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Expand",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Expand"
}, "Expand"), /*#__PURE__*/React.createElement("path", {
  d: "M12.0001 15L6.80396 10.5L17.1963 10.5L12.0001 15Z",
  fill: "var(--icon-primary)"
}));
export const DropdownArrowUpIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Collapse",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Collapse"
}, "Collapse"), /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 9L17.196 13.5L6.80374 13.5L11.9999 9Z",
  fill: "var(--icon-primary)"
}));
export const EditDarkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "ic_edit",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "ic_edit"
}, "Edit"), /*#__PURE__*/React.createElement("path", {
  d: "M17.408 1.00602C17.2221 1.02855 17.0494 1.11352 16.918 1.24702L2.61802 15.547C2.50773 15.6569 2.43047 15.7954 2.39502 15.947L1.02002 21.997C0.989216 22.1331 0.993377 22.2747 1.03212 22.4088C1.07086 22.5428 1.14291 22.6648 1.24156 22.7635C1.34021 22.8621 1.46224 22.9342 1.59627 22.9729C1.7303 23.0117 1.87195 23.0158 2.00802 22.985L8.05802 21.61C8.20985 21.5752 8.34861 21.4979 8.45802 21.387L22.758 7.08702C22.9107 6.93258 22.9963 6.72418 22.9963 6.50702C22.9963 6.28986 22.9107 6.08145 22.758 5.92702L18.083 1.25202C17.9955 1.16298 17.8889 1.09502 17.7713 1.05327C17.6537 1.01151 17.5281 0.997064 17.404 1.01102L17.408 1.00602ZM17.503 2.99102L21.013 6.50602L7.87802 19.637L4.37202 16.131L17.503 2.99102ZM3.67602 17.763L6.23702 20.324L2.92902 21.08L3.67602 17.763Z",
  fill: "var(--icon-primary)"
}));
export const ErrorIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Error",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Error"
}, " Error"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_162_109)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 13.3491L15.3719 16.7201C15.4604 16.8086 15.5655 16.8778 15.6811 16.9257C15.7968 16.9736 15.9207 16.9982 16.0459 16.9982C16.1711 16.9982 16.295 16.9736 16.4107 16.9257C16.5263 16.8778 16.6314 16.8076 16.7199 16.7191C16.8084 16.6305 16.8786 16.5255 16.9265 16.4098C16.9744 16.2942 16.9991 16.1702 16.9991 16.0451C16.9991 15.9199 16.9744 15.7959 16.9265 15.6803C16.8786 15.5646 16.8084 15.4596 16.7199 15.3711L13.3489 11.9991L16.7199 8.62706C16.8084 8.53855 16.8786 8.43347 16.9265 8.31782C16.9744 8.20218 16.9991 8.07823 16.9991 7.95306C16.9991 7.82788 16.9744 7.70394 16.9265 7.58829C16.8786 7.47265 16.8084 7.36757 16.7199 7.27906C16.6314 7.19055 16.5263 7.12034 16.4107 7.07243C16.295 7.02453 16.1711 6.99988 16.0459 6.99988C15.7931 6.99988 15.5507 7.1003 15.3719 7.27906L11.9999 10.6501L8.62791 7.27906C8.5394 7.19055 8.43432 7.12034 8.31868 7.07243C8.20303 7.02453 8.07909 6.99988 7.95391 6.99988C7.82874 6.99988 7.70479 7.02453 7.58915 7.07243C7.4735 7.12034 7.36842 7.19055 7.27991 7.27906C7.1914 7.36757 7.12119 7.47265 7.07329 7.58829C7.02539 7.70394 7.00073 7.82788 7.00073 7.95306C7.00073 8.07823 7.02539 8.20218 7.07329 8.31782C7.12119 8.43347 7.1914 8.53855 7.27991 8.62706L10.6509 11.9991L7.27991 15.3721C7.1914 15.4606 7.12119 15.5656 7.07329 15.6813C7.02539 15.7969 7.00073 15.9209 7.00073 16.0461C7.00073 16.1712 7.02539 16.2952 7.07329 16.4108C7.12119 16.5265 7.1914 16.6315 7.27991 16.7201C7.36842 16.8086 7.4735 16.8788 7.58915 16.9267C7.70479 16.9746 7.82874 16.9992 7.95391 16.9992C8.07909 16.9992 8.20303 16.9746 8.31868 16.9267C8.43432 16.8788 8.5394 16.8086 8.62791 16.7201L11.9999 13.3491Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_162_109"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const ExternalIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-External",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-External"
}, " External"), /*#__PURE__*/React.createElement("path", {
  d: "M13.0152 13.0961C13.0064 14.6889 12.9906 16.3025 12.9817 17.8954L21.8618 11.051L13.0233 4.19617C13.0251 6.0182 13.0222 6.93899 13.024 8.76103C10.7957 8.36247 8.50243 8.70308 6.47324 9.73399C5.16675 10.4549 4.01455 11.4406 3.08563 12.6321C2.15672 13.8236 1.47018 15.1965 1.06714 16.6685C2.48645 14.8523 4.41687 13.536 6.59175 12.9015C8.70427 12.3075 10.9401 12.3752 13.0152 13.0961Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 1.70101,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
export const FeedbackIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Feedback",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Feedback"
}, " Feedback"), /*#__PURE__*/React.createElement("path", {
  d: "M12 1.33301C9.89026 1.33281 7.82781 1.95825 6.0735 3.13024C4.31918 4.30222 2.95181 5.96811 2.1443 7.91723C1.33679 9.86635 1.1254 12.0112 1.53688 14.0804C1.94835 16.1497 2.96421 18.0505 4.45597 19.5424C5.94774 21.0343 7.84842 22.0503 9.91764 22.462C11.9869 22.8736 14.1317 22.6625 16.0809 21.8551C18.0301 21.0478 19.6961 19.6806 20.8683 17.9264C22.0404 16.1722 22.666 14.1098 22.666 12C22.6634 9.17193 21.5388 6.46043 19.5392 4.46058C17.5395 2.46073 14.8281 1.33592 12 1.33301ZM12 2.72401C13.8345 2.72401 15.6277 3.26798 17.1529 4.28713C18.6782 5.30628 19.867 6.75483 20.569 8.44962C21.271 10.1444 21.4547 12.0093 21.0968 13.8085C20.7389 15.6076 19.8556 17.2603 18.5585 18.5574C17.2613 19.8546 15.6087 20.7379 13.8095 21.0958C12.0103 21.4537 10.1454 21.27 8.45065 20.568C6.75586 19.866 5.30731 18.6772 4.28816 17.1519C3.269 15.6267 2.72504 13.8334 2.72504 11.999C2.72372 10.7806 2.96273 9.57395 3.42837 8.44806C3.89402 7.32217 4.57716 6.29918 5.43869 5.43766C6.30021 4.57613 7.3232 3.89299 8.44909 3.42735C9.57498 2.9617 10.7817 2.72269 12 2.72401ZM8.05804 7.59401C7.73704 7.59401 7.42325 7.6892 7.15635 7.86753C6.88944 8.04587 6.68142 8.29935 6.55858 8.59591C6.43574 8.89248 6.4036 9.21881 6.46622 9.53364C6.52885 9.84847 6.68342 10.1377 6.9104 10.3646C7.13738 10.5916 7.42657 10.7462 7.7414 10.8088C8.05624 10.8714 8.38257 10.8393 8.67913 10.7165C8.9757 10.5936 9.22917 10.3856 9.40751 10.1187C9.58585 9.8518 9.68104 9.53801 9.68104 9.21701C9.68104 8.78656 9.51004 8.37374 9.20567 8.06937C8.9013 7.765 8.48848 7.59401 8.05804 7.59401ZM15.942 7.59401C15.621 7.59401 15.3072 7.6892 15.0403 7.86753C14.7734 8.04587 14.5654 8.29935 14.4426 8.59591C14.3197 8.89248 14.2876 9.21881 14.3502 9.53364C14.4128 9.84847 14.5674 10.1377 14.7944 10.3646C15.0214 10.5916 15.3106 10.7462 15.6254 10.8088C15.9402 10.8714 16.2666 10.8393 16.5631 10.7165C16.8597 10.5936 17.1132 10.3856 17.2915 10.1187C17.4698 9.8518 17.565 9.53801 17.565 9.21701C17.565 8.78656 17.394 8.37374 17.0897 8.06937C16.7853 7.765 16.3725 7.59401 15.942 7.59401ZM6.82604 14.087C6.71078 14.0947 6.59947 14.1321 6.50293 14.1955C6.40639 14.259 6.32788 14.3463 6.27504 14.449C6.21676 14.5613 6.18999 14.6872 6.19756 14.8134C6.20513 14.9397 6.24676 15.0615 6.31804 15.166C6.93113 16.1152 7.77229 16.8957 8.76468 17.4361C9.75707 17.9765 10.869 18.2596 11.999 18.2596C13.129 18.2596 14.241 17.9765 15.2334 17.4361C16.2258 16.8957 17.0669 16.1152 17.68 15.166C17.7768 15.0114 17.8112 14.8259 17.7763 14.6469C17.7414 14.4679 17.6398 14.3089 17.492 14.202C17.3362 14.1055 17.1497 14.0713 16.9698 14.1062C16.7898 14.141 16.6296 14.2423 16.521 14.39C16.0362 15.1496 15.3678 15.7748 14.5776 16.2079C13.7873 16.6411 12.9007 16.8681 11.9995 16.8681C11.0984 16.8681 10.2118 16.6411 9.42151 16.2079C8.63126 15.7748 7.96287 15.1496 7.47804 14.39C7.40023 14.2927 7.30076 14.2149 7.18757 14.1628C7.07437 14.1107 6.95057 14.0858 6.82604 14.09V14.087Z",
  fill: "var(--icon-primary)"
}));
export const FileIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-File",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-File"
}, " File"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7335 20.3636C18.7321 20.4634 18.6917 20.5587 18.6207 20.6292C18.5497 20.6997 18.4539 20.7399 18.3535 20.7413H5.64651C5.54614 20.7399 5.45026 20.6997 5.37928 20.6292C5.30831 20.5587 5.26786 20.4634 5.26654 20.3636V10.0973H10.2881C10.7593 10.0867 11.207 9.89113 11.5334 9.55333C11.8598 9.21553 12.0383 8.76301 12.0299 8.29475V3.25976H18.3535C18.4539 3.26106 18.5497 3.30126 18.6207 3.3718C18.6917 3.44234 18.7321 3.53763 18.7335 3.63738V20.3636ZM8.86353 5.43286C9.70857 4.62659 10.3418 4.01937 10.7633 3.6112V8.29475C10.7704 8.42891 10.7249 8.56057 10.6362 8.662C10.5476 8.76343 10.4228 8.82671 10.2881 8.83853H5.33544C5.92515 8.23634 7.65271 6.58487 8.86353 5.43286ZM18.3535 2H10.8556C10.764 2.00041 10.6736 2.0203 10.5904 2.05834C10.5072 2.09638 10.4331 2.15169 10.3733 2.22053C10.2355 2.37762 9.03983 3.51855 7.98404 4.52455C5.41853 6.97558 4.31005 8.04199 4.11956 8.3028C4.04166 8.41009 3.99982 8.53907 4 8.67137V20.3636C4.00027 20.7975 4.17383 21.2136 4.48255 21.5204C4.79127 21.8272 5.20991 21.9997 5.64651 22H18.3535C18.79 21.9995 19.2085 21.8269 19.5172 21.5201C19.8258 21.2134 19.9995 20.7975 20 20.3636V3.63637C19.9995 3.20254 19.8258 2.78664 19.5172 2.47987C19.2085 2.17311 18.79 2.00053 18.3535 2Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.3
}));
export const FolderIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 4.25C2.5 4.11193 2.61193 4 2.75 4H8.7026C8.80425 4 8.89577 4.06154 8.93412 4.15568L9.63459 5.875H2.5V4.25ZM2.75 2.5C1.7835 2.5 1 3.2835 1 4.25V20.046C1 20.5983 1.44772 21.046 2 21.046H22C22.5523 21.046 23 20.5983 23 20.046V7.05005C23 6.49776 22.5523 6.05005 22 6.05005H11.3256L10.3233 3.58973C10.0548 2.9308 9.41412 2.5 8.7026 2.5H2.75ZM2.5 19.546V7.55005H21.5V19.546H2.5Z",
  fill: "var(--icon-primary)"
}));
export const HandShakeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Services",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Services"
}, "Services"), /*#__PURE__*/React.createElement("path", {
  d: "M14.7385 3.43036C13.7204 2.6159 12.267 2.64053 11.2771 3.48901L6.67994 7.42945C5.72156 8.25091 5.58685 9.68421 6.37537 10.6699C7.20848 11.7112 8.74189 11.8475 9.74555 10.9693L11.9851 9.00969L17.4342 14.0695C17.6992 14.3156 17.7069 14.7325 17.4512 14.9882C17.202 15.2374 16.798 15.2374 16.5488 14.9882L14.0303 12.4697L12.9697 13.5304L15.4697 16.0304C15.7291 16.2898 15.7291 16.7103 15.4697 16.9697C15.2103 17.2291 14.7897 17.2291 14.5303 16.9697L12.0303 14.4697L10.9697 15.5304L13.4697 18.0304C13.7291 18.2898 13.7291 18.7103 13.4697 18.9697C13.2103 19.2291 12.7897 19.2291 12.5303 18.9697L12.0316 18.471C12.0311 18.4705 12.0307 18.4701 12.0303 18.4697L10.0303 16.4697L8.96967 17.5304L10.9697 19.5304C11.2291 19.7898 11.2291 20.2103 10.9697 20.4697C10.7103 20.7291 10.2897 20.7291 10.0303 20.4697L7.11612 17.5555C6.60039 17.0398 5.90092 16.7501 5.17157 16.7501H2V18.2501H5.17157C5.50309 18.2501 5.82104 18.3818 6.05546 18.6162L8.96967 21.5304C9.81485 22.3756 11.1852 22.3756 12.0303 21.5304C12.2929 21.2678 12.4739 20.9545 12.5733 20.622C13.2592 20.7593 13.9987 20.5621 14.5303 20.0304C14.9126 19.6481 15.122 19.1584 15.1584 18.6585C15.6584 18.622 16.1481 18.4127 16.5303 18.0304C16.9098 17.6509 17.1189 17.1655 17.1576 16.6693C17.6511 16.6331 18.1345 16.4263 18.5118 16.0489C19.3687 15.192 19.3428 13.7949 18.4548 12.9703L12.0149 6.99043L8.75779 9.84042C8.39711 10.156 7.84606 10.1071 7.54667 9.73282C7.26331 9.37861 7.31172 8.86354 7.65612 8.56834L12.2533 4.6279C12.696 4.24841 13.3461 4.23739 13.8014 4.60166L16.4358 6.70919C17.2781 7.38298 18.3245 7.75006 19.4031 7.75006H22V6.25006H19.4031C18.6651 6.25006 17.9491 5.9989 17.3729 5.53788L14.7385 3.43036Z",
  fill: "var(--icon-primary)"
}));
export const HeaderHelpIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Help",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Help"
}, " Help"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM13.2002 19.0501C13.2002 19.7956 12.5956 20.4 11.8501 20.4V20.4C11.1046 20.4 10.5 19.7956 10.5 19.0501V19.0501C10.5 18.3046 11.1046 17.7002 11.8501 17.7002V17.7002C12.5956 17.7002 13.2002 18.3046 13.2002 19.0501V19.0501ZM14.6042 12.204L15.6842 11.1C16.3682 10.416 16.8002 9.45601 16.8002 8.40001C16.8002 5.74801 14.6522 3.60001 12.0002 3.60001C9.58521 3.60001 7.58816 5.38123 7.25049 7.70222C7.19483 8.08479 7.5136 8.40001 7.9002 8.40001H9.1002C9.37634 8.40001 9.5948 8.17365 9.65219 7.90354C9.88248 6.81963 10.8503 6.00001 12.0002 6.00001C13.3202 6.00001 14.4002 7.08001 14.4002 8.40001C14.4002 9.06001 14.1362 9.66001 13.6922 10.092L12.2042 11.604C11.3402 12.48 10.8002 13.68 10.8002 15V15C10.8002 15.3314 11.0688 15.6 11.4002 15.6H12.7002C12.9763 15.6 13.1977 15.3756 13.2156 15.1C13.3093 13.6572 13.825 12.994 14.6042 12.204Z",
  fill: "var(--icon-primary)"
}));
export const HeaderNotificationsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Notifications",
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 24,
  viewBox: "0 0 20 24",
  fill: "none"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Notifications"
}, " Notifications"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.5643 16.7004C19.5186 16.6509 19.4729 16.5999 19.4229 16.5504C19.4214 16.5459 19.4171 16.5444 19.4171 16.5444C19.3771 16.5009 19.3357 16.4604 19.2929 16.4184C19.2714 16.3973 19.2514 16.3793 19.2314 16.3598C18.6014 15.7658 17.9386 15.2272 17.8086 13.6295C17.22 6.26056 16.6171 3.31419 12.1671 1.67448C11.4786 1.42094 11.2414 1.0639 11.08 0.745858C11.0543 0.694852 11.0314 0.645346 11.0086 0.595839L11.0071 0.594339C10.8757 0.361809 10.6743 0.174286 10.4186 0.0737729C10.28 0.019766 10.14 -0.00273685 10 0.000263531C9.86286 -0.00273685 9.72 0.019766 9.58143 0.0737729C9.32571 0.174286 9.12429 0.361809 8.99286 0.594339L8.99143 0.595839C8.96857 0.645346 8.94571 0.694852 8.92 0.745858C8.76 1.0639 8.52143 1.42094 7.83286 1.67448C3.38286 3.31419 2.78 6.26056 2.19 13.6295C2.06143 15.2272 1.39857 15.7658 0.768571 16.3598C0.748571 16.3793 0.727143 16.3973 0.705714 16.4184C0.661429 16.4604 0.617143 16.5069 0.575714 16.5504V16.5519C0.531429 16.5954 0.491429 16.6374 0.451429 16.6794C0.45 16.6854 0.447143 16.6884 0.445714 16.6899C0.167143 17.0214 0 17.4595 0 17.9395C0 18.8022 0.538571 19.5252 1.27 19.7398C1.35714 19.7593 1.44286 19.7758 1.52857 19.7938C3.23714 20.1403 4.98143 20.3849 6.75143 20.5184C7.82429 20.6024 8.90714 20.6429 10 20.6429H10.0157C11.1029 20.6429 12.1814 20.6024 13.2471 20.5229C15.0714 20.3849 16.8657 20.1298 18.6257 19.7683C19.41 19.5943 20 18.8427 20 17.9395C20 17.464 19.8343 17.0304 19.5643 16.7004ZM12.4613 21.7045C12.4327 21.7075 12.4042 21.7075 12.3756 21.709C11.5942 21.7496 10.807 21.7736 10.017 21.7736H9.99987C9.19701 21.7736 8.39987 21.7496 7.60558 21.7075C7.60558 21.7045 7.60558 21.7045 7.60273 21.7075C7.58701 21.7045 7.56987 21.7045 7.55416 21.703C7.34701 21.7075 7.17844 21.8921 7.17844 22.1171C7.17844 22.1831 7.19273 22.2431 7.21844 22.2986C7.2313 22.3241 7.24701 22.3466 7.25987 22.3721C7.25987 22.3751 7.26273 22.3766 7.26273 22.3766C7.68558 23.0922 8.33987 23.6323 9.1113 23.8693C9.39416 23.9548 9.69273 23.9998 9.99987 23.9998C10.3084 23.9998 10.607 23.9548 10.8899 23.8693C11.6627 23.6278 12.3213 23.0877 12.7442 22.3676C12.757 22.3436 12.7699 22.3211 12.7813 22.2986C12.8056 22.2431 12.8199 22.1831 12.8199 22.1171C12.8213 21.8966 12.6627 21.718 12.4613 21.7045Z",
  fill: "var(--icon-primary)"
}));
export const HeaderSettingsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Settings",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Settings"
}, " Settings"), /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1_5103_50415",
  fill: "var(--icon-primary)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.872 10.6779L21.504 10.2771C21.3582 10.2553 21.2223 10.1902 21.1139 10.0902C21.0055 9.99014 20.9296 9.8598 20.896 9.71603C20.6764 8.88299 20.3426 8.08449 19.904 7.34338C19.8254 7.22156 19.7837 7.07961 19.7837 6.93459C19.7837 6.78956 19.8254 6.64761 19.904 6.52579L21.296 4.55392C21.3167 4.52617 21.328 4.49242 21.328 4.45773C21.328 4.42305 21.3167 4.38929 21.296 4.36154L19.648 2.67825C19.6302 2.67076 19.6112 2.6669 19.592 2.6669C19.5727 2.6669 19.5537 2.67076 19.536 2.67825H19.456L17.504 4.07298C17.3793 4.1512 17.2351 4.19269 17.088 4.19269C16.9408 4.19269 16.7967 4.1512 16.672 4.07298C15.9115 3.63358 15.0927 3.30434 14.24 3.09506C14.0965 3.06137 13.9664 2.98529 13.8666 2.87668C13.7667 2.76806 13.7017 2.63192 13.68 2.48587L13.28 0.129257C13.2801 0.110976 13.2764 0.0928771 13.269 0.0761713C13.2615 0.0594656 13.2507 0.044539 13.237 0.0323939C13.2234 0.0202487 13.2073 0.0111656 13.1899 0.00575202C13.1725 0.000338458 13.1541 -0.00127913 13.136 0.00100654H10.768C10.7499 -0.00127913 10.7315 0.000338458 10.7141 0.00575202C10.6967 0.0111656 10.6806 0.0202487 10.6669 0.0323939C10.6533 0.044539 10.6424 0.0594656 10.635 0.0761713C10.6276 0.0928771 10.6238 0.110976 10.624 0.129257L10.208 2.51794C10.1918 2.6823 10.1244 2.83737 10.0152 2.96112C9.90609 3.08487 9.76079 3.171 9.59999 3.20727C8.77532 3.43221 7.98434 3.76649 7.24799 4.20123C7.12153 4.2827 6.97434 4.32602 6.82399 4.32602C6.67364 4.32602 6.52646 4.2827 6.39999 4.20123L4.512 2.69427H4.416C4.38521 2.6818 4.35078 2.6818 4.31999 2.69427L2.624 4.40964C2.60323 4.43739 2.592 4.47114 2.592 4.50583C2.592 4.54052 2.60323 4.57427 2.624 4.60202L4.01599 6.57388C4.09406 6.69884 4.13547 6.84327 4.13547 6.99069C4.13547 7.13811 4.09406 7.28255 4.01599 7.4075C3.59642 8.15052 3.28399 8.94934 3.088 9.78015C3.05437 9.92392 2.97844 10.0543 2.87004 10.1543C2.76164 10.2543 2.62576 10.3195 2.48 10.3412L0.128001 10.742C0.0926465 10.746 0.0600067 10.7629 0.0363721 10.7896C0.0127375 10.8162 -0.000217442 10.8507 2.76175e-06 10.8863V13.275C-0.000217442 13.3106 0.0127375 13.3451 0.0363721 13.3717C0.0600067 13.3984 0.0926465 13.4153 0.128001 13.4193L2.512 13.8201C2.67603 13.8363 2.8308 13.9038 2.95431 14.0132C3.07782 14.1225 3.16379 14.2681 3.2 14.4293C3.42315 15.2611 3.7568 16.0591 4.192 16.8019C4.27387 16.9254 4.31754 17.0704 4.31754 17.2187C4.31754 17.367 4.27387 17.512 4.192 17.6355L2.8 19.5914C2.77923 19.6191 2.768 19.6529 2.768 19.6876C2.768 19.7222 2.77923 19.756 2.8 19.7837L4.49599 21.3869C4.52738 21.3958 4.56061 21.3958 4.59199 21.3869H4.68799L6.65599 19.9761C6.78608 19.8812 6.9431 19.8307 7.10399 19.8318C7.24013 19.8313 7.37351 19.8702 7.48799 19.9441C8.21027 20.3613 8.98519 20.6794 9.79199 20.8899C9.93547 20.9236 10.0656 20.9997 10.1654 21.1083C10.2652 21.2169 10.3302 21.3531 10.352 21.4991L10.752 23.8717C10.7559 23.9072 10.7728 23.9399 10.7994 23.9636C10.826 23.9872 10.8604 24.0002 10.896 24H13.184C13.2196 24.0002 13.254 23.9872 13.2805 23.9636C13.3071 23.9399 13.324 23.9072 13.328 23.8717L13.728 21.4991C13.7517 21.3539 13.8174 21.2188 13.917 21.1105C14.0165 21.0022 14.1455 20.9255 14.288 20.8899C15.1204 20.673 15.9178 20.3383 16.656 19.896C16.7807 19.8177 16.9248 19.7762 17.072 19.7762C17.2191 19.7762 17.3633 19.8177 17.488 19.896L19.44 21.2907C19.4763 21.3029 19.5156 21.3029 19.552 21.2907L21.232 19.6074C21.2456 19.5954 21.2565 19.5805 21.264 19.564C21.2714 19.5474 21.2753 19.5294 21.2753 19.5112C21.2753 19.493 21.2714 19.475 21.264 19.4584C21.2565 19.4419 21.2456 19.427 21.232 19.415L19.84 17.4432C19.7619 17.3182 19.7205 17.1738 19.7205 17.0263C19.7205 16.8789 19.7619 16.7345 19.84 16.6095C20.2814 15.8699 20.6154 15.0709 20.832 14.2369C20.8656 14.0931 20.9415 13.9628 21.0499 13.8627C21.1583 13.7627 21.2942 13.6976 21.44 13.6758L23.808 13.275C23.842 13.2918 23.8812 13.2944 23.9171 13.2824C23.953 13.2704 23.9828 13.2447 24 13.2109V10.8382C24.0007 10.8007 23.9883 10.7641 23.9649 10.7348C23.9416 10.7056 23.9087 10.6854 23.872 10.6779ZM12 16.337C11.1442 16.3402 10.3068 16.0886 9.59392 15.6142C8.88105 15.1398 8.32488 14.4639 7.99592 13.6724C7.66697 12.8808 7.58007 12.0092 7.74625 11.168C7.91243 10.3269 8.32419 9.55416 8.92932 8.94784C9.53444 8.34153 10.3057 7.92897 11.1451 7.76247C11.9846 7.59596 12.8546 7.68304 13.6446 8.01263C14.4346 8.34223 15.1091 8.8995 15.5826 9.61377C16.0561 10.328 16.3071 11.1671 16.304 12.0246C16.2998 13.167 15.845 14.2614 15.0387 15.0692C14.2325 15.8771 13.1402 16.3328 12 16.337Z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.872 10.6779L21.504 10.2771C21.3582 10.2553 21.2223 10.1902 21.1139 10.0902C21.0055 9.99014 20.9296 9.8598 20.896 9.71603C20.6764 8.88299 20.3426 8.08449 19.904 7.34338C19.8254 7.22156 19.7837 7.07961 19.7837 6.93459C19.7837 6.78956 19.8254 6.64761 19.904 6.52579L21.296 4.55392C21.3167 4.52617 21.328 4.49242 21.328 4.45773C21.328 4.42305 21.3167 4.38929 21.296 4.36154L19.648 2.67825C19.6302 2.67076 19.6112 2.6669 19.592 2.6669C19.5727 2.6669 19.5537 2.67076 19.536 2.67825H19.456L17.504 4.07298C17.3793 4.1512 17.2351 4.19269 17.088 4.19269C16.9408 4.19269 16.7967 4.1512 16.672 4.07298C15.9115 3.63358 15.0927 3.30434 14.24 3.09506C14.0965 3.06137 13.9664 2.98529 13.8666 2.87668C13.7667 2.76806 13.7017 2.63192 13.68 2.48587L13.28 0.129257C13.2801 0.110976 13.2764 0.0928771 13.269 0.0761713C13.2615 0.0594656 13.2507 0.044539 13.237 0.0323939C13.2234 0.0202487 13.2073 0.0111656 13.1899 0.00575202C13.1725 0.000338458 13.1541 -0.00127913 13.136 0.00100654H10.768C10.7499 -0.00127913 10.7315 0.000338458 10.7141 0.00575202C10.6967 0.0111656 10.6806 0.0202487 10.6669 0.0323939C10.6533 0.044539 10.6424 0.0594656 10.635 0.0761713C10.6276 0.0928771 10.6238 0.110976 10.624 0.129257L10.208 2.51794C10.1918 2.6823 10.1244 2.83737 10.0152 2.96112C9.90609 3.08487 9.76079 3.171 9.59999 3.20727C8.77532 3.43221 7.98434 3.76649 7.24799 4.20123C7.12153 4.2827 6.97434 4.32602 6.82399 4.32602C6.67364 4.32602 6.52646 4.2827 6.39999 4.20123L4.512 2.69427H4.416C4.38521 2.6818 4.35078 2.6818 4.31999 2.69427L2.624 4.40964C2.60323 4.43739 2.592 4.47114 2.592 4.50583C2.592 4.54052 2.60323 4.57427 2.624 4.60202L4.01599 6.57388C4.09406 6.69884 4.13547 6.84327 4.13547 6.99069C4.13547 7.13811 4.09406 7.28255 4.01599 7.4075C3.59642 8.15052 3.28399 8.94934 3.088 9.78015C3.05437 9.92392 2.97844 10.0543 2.87004 10.1543C2.76164 10.2543 2.62576 10.3195 2.48 10.3412L0.128001 10.742C0.0926465 10.746 0.0600067 10.7629 0.0363721 10.7896C0.0127375 10.8162 -0.000217442 10.8507 2.76175e-06 10.8863V13.275C-0.000217442 13.3106 0.0127375 13.3451 0.0363721 13.3717C0.0600067 13.3984 0.0926465 13.4153 0.128001 13.4193L2.512 13.8201C2.67603 13.8363 2.8308 13.9038 2.95431 14.0132C3.07782 14.1225 3.16379 14.2681 3.2 14.4293C3.42315 15.2611 3.7568 16.0591 4.192 16.8019C4.27387 16.9254 4.31754 17.0704 4.31754 17.2187C4.31754 17.367 4.27387 17.512 4.192 17.6355L2.8 19.5914C2.77923 19.6191 2.768 19.6529 2.768 19.6876C2.768 19.7222 2.77923 19.756 2.8 19.7837L4.49599 21.3869C4.52738 21.3958 4.56061 21.3958 4.59199 21.3869H4.68799L6.65599 19.9761C6.78608 19.8812 6.9431 19.8307 7.10399 19.8318C7.24013 19.8313 7.37351 19.8702 7.48799 19.9441C8.21027 20.3613 8.98519 20.6794 9.79199 20.8899C9.93547 20.9236 10.0656 20.9997 10.1654 21.1083C10.2652 21.2169 10.3302 21.3531 10.352 21.4991L10.752 23.8717C10.7559 23.9072 10.7728 23.9399 10.7994 23.9636C10.826 23.9872 10.8604 24.0002 10.896 24H13.184C13.2196 24.0002 13.254 23.9872 13.2805 23.9636C13.3071 23.9399 13.324 23.9072 13.328 23.8717L13.728 21.4991C13.7517 21.3539 13.8174 21.2188 13.917 21.1105C14.0165 21.0022 14.1455 20.9255 14.288 20.8899C15.1204 20.673 15.9178 20.3383 16.656 19.896C16.7807 19.8177 16.9248 19.7762 17.072 19.7762C17.2191 19.7762 17.3633 19.8177 17.488 19.896L19.44 21.2907C19.4763 21.3029 19.5156 21.3029 19.552 21.2907L21.232 19.6074C21.2456 19.5954 21.2565 19.5805 21.264 19.564C21.2714 19.5474 21.2753 19.5294 21.2753 19.5112C21.2753 19.493 21.2714 19.475 21.264 19.4584C21.2565 19.4419 21.2456 19.427 21.232 19.415L19.84 17.4432C19.7619 17.3182 19.7205 17.1738 19.7205 17.0263C19.7205 16.8789 19.7619 16.7345 19.84 16.6095C20.2814 15.8699 20.6154 15.0709 20.832 14.2369C20.8656 14.0931 20.9415 13.9628 21.0499 13.8627C21.1583 13.7627 21.2942 13.6976 21.44 13.6758L23.808 13.275C23.842 13.2918 23.8812 13.2944 23.9171 13.2824C23.953 13.2704 23.9828 13.2447 24 13.2109V10.8382C24.0007 10.8007 23.9883 10.7641 23.9649 10.7348C23.9416 10.7056 23.9087 10.6854 23.872 10.6779ZM12 16.337C11.1442 16.3402 10.3068 16.0886 9.59392 15.6142C8.88105 15.1398 8.32488 14.4639 7.99592 13.6724C7.66697 12.8808 7.58007 12.0092 7.74625 11.168C7.91243 10.3269 8.32419 9.55416 8.92932 8.94784C9.53444 8.34153 10.3057 7.92897 11.1451 7.76247C11.9846 7.59596 12.8546 7.68304 13.6446 8.01263C14.4346 8.34223 15.1091 8.8995 15.5826 9.61377C16.0561 10.328 16.3071 11.1671 16.304 12.0246C16.2998 13.167 15.845 14.2614 15.0387 15.0692C14.2325 15.8771 13.1402 16.3328 12 16.337Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 2,
  mask: "url(#path-1-inside-1_5103_50415)"
}));
export const HeaderUserIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-User",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-User"
}, " User"), /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1_5103_50419",
  fill: "var(--icon-primary)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM15.2218 12.5411C14.903 12.3604 14.5146 12.4336 14.192 12.6076C13.5469 12.9553 12.7675 13.1161 11.9999 13.1161C11.1433 13.1161 10.4341 12.8306 9.99265 12.5934C9.67442 12.4224 9.28835 12.3559 8.96847 12.5238C7.5046 13.2922 6.67605 14.6157 6.42001 16.5257C6.37744 16.8432 6.5091 17.159 6.7623 17.3553C8.38294 18.6121 10.1536 19.2405 12.0744 19.2405C13.996 19.2405 15.7249 18.6686 17.2612 17.5247C17.5011 17.346 17.6417 17.0613 17.6241 16.7627C17.5677 15.8102 17.2221 13.6749 15.2218 12.5411ZM15.8349 7.76047C15.8349 9.83733 14.1513 11.5209 12.0744 11.5209C9.99758 11.5209 8.31396 9.83733 8.31396 7.76047C8.31396 5.68362 9.99758 4 12.0744 4C14.1513 4 15.8349 5.68362 15.8349 7.76047Z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM15.2218 12.5411C14.903 12.3604 14.5146 12.4336 14.192 12.6076C13.5469 12.9553 12.7675 13.1161 11.9999 13.1161C11.1433 13.1161 10.4341 12.8306 9.99265 12.5934C9.67442 12.4224 9.28835 12.3559 8.96847 12.5238C7.5046 13.2922 6.67605 14.6157 6.42001 16.5257C6.37744 16.8432 6.5091 17.159 6.7623 17.3553C8.38294 18.6121 10.1536 19.2405 12.0744 19.2405C13.996 19.2405 15.7249 18.6686 17.2612 17.5247C17.5011 17.346 17.6417 17.0613 17.6241 16.7627C17.5677 15.8102 17.2221 13.6749 15.2218 12.5411ZM15.8349 7.76047C15.8349 9.83733 14.1513 11.5209 12.0744 11.5209C9.99758 11.5209 8.31396 9.83733 8.31396 7.76047C8.31396 5.68362 9.99758 4 12.0744 4C14.1513 4 15.8349 5.68362 15.8349 7.76047Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.192 12.6076L13.7174 11.7273H13.7174L14.192 12.6076ZM15.2218 12.5411L15.7149 11.6711H15.7149L15.2218 12.5411ZM9.99265 12.5934L9.51927 13.4742H9.51928L9.99265 12.5934ZM8.96847 12.5238L8.5037 11.6384H8.5037L8.96847 12.5238ZM6.42001 16.5257L7.41115 16.6585L6.42001 16.5257ZM6.7623 17.3553L6.14949 18.1455H6.14949L6.7623 17.3553ZM17.2612 17.5247L17.8584 18.3268L17.2612 17.5247ZM17.6241 16.7627L18.6223 16.7037V16.7036L17.6241 16.7627ZM23 12C23 18.0751 18.0751 23 12 23V25C19.1797 25 25 19.1797 25 12H23ZM12 1C18.0751 1 23 5.92487 23 12H25C25 4.8203 19.1797 -1 12 -1V1ZM1 12C1 5.92487 5.92487 1 12 1V-1C4.8203 -1 -1 4.8203 -1 12H1ZM12 23C5.92487 23 1 18.0751 1 12H-1C-1 19.1797 4.8203 25 12 25V23ZM14.6665 13.4878C14.6999 13.4698 14.7304 13.4569 14.7563 13.4484C14.7823 13.4399 14.7991 13.4372 14.8063 13.4365C14.8132 13.4358 14.8073 13.4373 14.7913 13.4344C14.7741 13.4312 14.7516 13.4241 14.7287 13.4111L15.7149 11.6711C14.967 11.2472 14.183 11.4764 13.7174 11.7273L14.6665 13.4878ZM11.9999 14.1161C12.896 14.1161 13.8461 13.9301 14.6665 13.4878L13.7174 11.7273C13.2477 11.9806 12.639 12.1161 11.9999 12.1161V14.1161ZM9.51928 13.4742C10.0504 13.7597 10.9245 14.1161 11.9999 14.1161V12.1161C11.3621 12.1161 10.8179 11.9016 10.466 11.7125L9.51928 13.4742ZM9.43324 13.4093C9.392 13.4309 9.36723 13.4252 9.38518 13.4269C9.39483 13.4278 9.41236 13.4307 9.43703 13.4387C9.46161 13.4466 9.48965 13.4583 9.51927 13.4742L10.466 11.7125C9.98688 11.455 9.22902 11.2577 8.5037 11.6384L9.43324 13.4093ZM7.41115 16.6585C7.63351 14.9998 8.31387 13.9968 9.43324 13.4093L8.5037 11.6384C6.69534 12.5876 5.71859 14.2317 5.42888 16.3928L7.41115 16.6585ZM7.37511 16.5651C7.39933 16.5839 7.4166 16.6178 7.41115 16.6585L5.42888 16.3928C5.33828 17.0686 5.61887 17.7341 6.14949 18.1455L7.37511 16.5651ZM12.0744 18.2405C10.3911 18.2405 8.8331 17.6957 7.37511 16.5651L6.14949 18.1455C7.93278 19.5285 9.91621 20.2405 12.0744 20.2405V18.2405ZM16.664 16.7226C15.3009 17.7375 13.7816 18.2405 12.0744 18.2405V20.2405C14.2104 20.2405 16.149 19.5996 17.8584 18.3268L16.664 16.7226ZM16.6258 16.8217C16.6225 16.7655 16.649 16.7338 16.664 16.7226L17.8584 18.3268C18.3533 17.9583 18.661 17.3571 18.6223 16.7037L16.6258 16.8217ZM14.7287 13.4111C16.2649 14.2818 16.5743 15.9518 16.6258 16.8217L18.6223 16.7036C18.5611 15.6687 18.1794 13.068 15.7149 11.6711L14.7287 13.4111ZM12.0744 12.5209C14.7036 12.5209 16.8349 10.3896 16.8349 7.76047H14.8349C14.8349 9.28504 13.599 10.5209 12.0744 10.5209V12.5209ZM7.31396 7.76047C7.31396 10.3896 9.44529 12.5209 12.0744 12.5209V10.5209C10.5499 10.5209 9.31396 9.28504 9.31396 7.76047H7.31396ZM12.0744 3C9.44529 3 7.31396 5.13134 7.31396 7.76047H9.31396C9.31396 6.2359 10.5499 5 12.0744 5V3ZM16.8349 7.76047C16.8349 5.13133 14.7036 3 12.0744 3V5C13.599 5 14.8349 6.23591 14.8349 7.76047H16.8349Z",
  fill: "var(--icon-primary)",
  mask: "url(#path-1-inside-1_5103_50419)"
}));
export const HelpDarkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "ic_help",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "ic_help"
}, "Help"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_14930_90747)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.3636 12C22.3636 17.7237 17.7237 22.3636 12 22.3636C6.27632 22.3636 1.63636 17.7237 1.63636 12C1.63636 6.27632 6.27632 1.63636 12 1.63636C17.7237 1.63636 22.3636 6.27632 22.3636 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM11.7438 5.50914C10.508 5.50914 9.30098 6.08319 8.53457 7.08096L8.52183 7.09754L8.5108 7.11533C8.26939 7.50479 8.30395 8.04337 8.72754 8.36366L8.73535 8.36928C9.08845 8.62354 9.6741 8.60563 9.969 8.1523C10.365 7.61983 11.0281 7.32336 11.7443 7.32336C12.8659 7.32336 13.8456 8.11823 13.8456 9.20942C13.8456 10.0948 13.1665 10.8201 12.2572 11.0184C11.4007 11.2057 10.8469 11.9599 10.8469 12.8086V14.0126L10.8494 14.0357C10.8948 14.4473 11.2237 14.8964 11.7442 14.8964C12.2708 14.8964 12.6415 14.465 12.6415 13.9891L12.6411 12.7855L12.6426 12.7843C12.6426 12.7843 12.6456 12.7824 12.6488 12.781C14.2833 12.4232 15.6398 11.0142 15.6398 9.20938C15.6398 7.03321 13.7239 5.50914 11.7438 5.50914ZM11.6411 16.1487C11.0048 16.1487 10.5139 16.6898 10.5139 17.3366C10.5139 17.9634 11.0178 18.4909 11.6411 18.4909C12.2652 18.4909 12.7682 17.9625 12.7682 17.3366C12.7682 16.689 12.2765 16.1487 11.6411 16.1487Z",
  fill: "var(--icon-primary)"
})));
export const InfoIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Info",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Info"
}, " Info"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_162_114)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.647 10.75V17.249C10.6808 17.5845 10.8353 17.8963 11.0818 18.1265C11.3283 18.3566 11.65 18.4893 11.987 18.5C12.3299 18.5103 12.6628 18.3847 12.9134 18.1505C13.1641 17.9164 13.312 17.5927 13.325 17.25V10.75C13.2911 10.415 13.1368 10.1037 12.8907 9.8738C12.6447 9.64393 12.3236 9.51111 11.987 9.5C11.6439 9.48919 11.3104 9.61456 11.0593 9.84875C10.8083 10.0829 10.6601 10.4069 10.647 10.75Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.9394 5.43934C10.6581 5.72064 10.5 6.10218 10.5 6.5C10.4917 6.69921 10.5248 6.89798 10.5972 7.08374C10.6697 7.26951 10.7799 7.43822 10.9208 7.5792C11.0618 7.72019 11.2305 7.83038 11.4163 7.90281C11.6021 7.97524 11.8008 8.00834 12 8C12.1992 8.00834 12.398 7.97524 12.5838 7.90281C12.7695 7.83038 12.9383 7.72019 13.0792 7.5792C13.2202 7.43822 13.3304 7.26951 13.4029 7.08374C13.4753 6.89798 13.5084 6.69921 13.5 6.5C13.5 6.10218 13.342 5.72064 13.0607 5.43934C12.7794 5.15804 12.3979 5 12 5C11.6022 5 11.2207 5.15804 10.9394 5.43934Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_162_114"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const KnowledgeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Knowledge",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Knowledge"
}, " Knowledge"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0288 8.12262C12.423 8.90414 14.5655 10.3011 16.2378 12.171C16.3721 12.3059 16.5372 12.4067 16.7191 12.4651C16.9009 12.5234 17.0943 12.5375 17.2828 12.5062C17.4753 12.4749 17.6575 12.3983 17.8141 12.2829C17.9707 12.1675 18.0971 12.0166 18.1828 11.8428C18.569 11.1168 18.7831 10.313 18.809 9.49263C18.8348 8.67222 18.6716 7.85677 18.3318 7.10828C17.9896 6.40646 17.4888 5.79236 16.8682 5.31376C16.2476 4.83516 15.5241 4.50496 14.7538 4.34885C14.3242 4.25118 13.8846 4.20261 13.4438 4.20409C12.1992 4.20895 10.9814 4.56265 9.93082 5.22438C9.27382 5.64082 8.34082 6.7553 8.81782 7.49498C9.11679 7.809 9.50926 8.01991 9.93782 8.09684L10.0288 8.12262ZM9.55782 9.32634C8.82994 9.17925 8.1805 8.77556 7.72982 8.19004C6.76482 6.69581 8.05782 4.89519 9.23582 4.14856C10.0874 3.60166 11.0399 3.22769 12.0382 3.0483C13.0366 2.86891 14.0609 2.88767 15.0518 3.10349C16.0133 3.3018 16.9156 3.71751 17.6885 4.31824C18.4614 4.91897 19.084 5.68851 19.5078 6.56691C19.9311 7.49003 20.1366 8.49668 20.1087 9.51036C20.0808 10.524 19.8203 11.5181 19.3468 12.4169C19.1698 12.7741 18.9086 13.0837 18.5853 13.3196C18.2621 13.5555 17.8864 13.7108 17.4898 13.7724C17.3536 13.7944 17.2158 13.8057 17.0778 13.8061C16.7508 13.8061 16.427 13.7418 16.1253 13.6168C15.8235 13.4919 15.5497 13.3089 15.3198 13.0783C13.7948 11.3534 11.8318 10.0648 9.63482 9.34617L9.55782 9.32634ZM2.65282 12.6747C3.23182 11.0328 4.25882 8.09981 4.62782 6.89312C5.25924 4.79675 6.61092 2.98571 8.44831 1.77423C10.2857 0.562755 12.4929 0.0272993 14.6868 0.260773C16.3966 0.449548 18.0176 1.11418 19.3625 2.17785C20.7074 3.24153 21.7213 4.66083 22.287 6.27174C22.8527 7.88264 22.9471 9.61939 22.5594 11.2813C22.1717 12.9431 21.3176 14.4623 20.0958 15.6632C18.8817 16.8841 18.2053 18.5325 18.2148 20.2471V22.3947C18.2148 22.5656 18.1463 22.7296 18.0244 22.8504C17.9025 22.9713 17.7372 23.0392 17.5648 23.0392C17.3924 23.0392 17.2271 22.9713 17.1052 22.8504C16.9833 22.7296 16.9148 22.5656 16.9148 22.3947V20.248C16.9068 18.1915 17.7217 16.2157 19.1808 14.754C20.2293 13.7235 20.9624 12.42 21.2953 10.9939C21.6281 9.56783 21.5473 8.07747 21.062 6.69505C20.5767 5.31262 19.7068 4.09456 18.5529 3.18162C17.3989 2.26868 16.008 1.69812 14.5408 1.53588C12.6518 1.35629 10.758 1.82754 9.17828 2.8703C7.59861 3.91306 6.42951 5.46363 5.86782 7.26098C5.49182 8.48849 4.45782 11.4413 3.86182 13.0733H6.84782V17.8327C6.84861 18.1543 6.97803 18.4625 7.20767 18.6896C7.43732 18.9168 7.74845 19.0443 8.07282 19.0443H10.5808V22.3947C10.5808 22.5656 10.5123 22.7296 10.3904 22.8504C10.2685 22.9713 10.1032 23.0392 9.93082 23.0392C9.75843 23.0392 9.5931 22.9713 9.4712 22.8504C9.3493 22.7296 9.28082 22.5656 9.28082 22.3947V20.3323H8.07482C7.4069 20.3326 6.76617 20.07 6.29332 19.6023C5.82047 19.1346 5.55414 18.4999 5.55282 17.8376V14.3574H3.86282C3.65849 14.3577 3.45705 14.3095 3.27536 14.2168C3.09367 14.1241 2.93702 13.9896 2.81854 13.8246C2.70005 13.6595 2.62317 13.4687 2.59434 13.2681C2.56551 13.0676 2.58556 12.8631 2.65282 12.6718V12.6747Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.4
}));
export const LicenseIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-License",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-License"
}, " License"), /*#__PURE__*/React.createElement("path", {
  d: "M20.3939 1H3.78694C3.68358 0.999748 3.5812 1.02004 3.48575 1.05969C3.3903 1.09935 3.30369 1.15758 3.23094 1.231C3.08437 1.3809 3.00249 1.58235 3.00294 1.792V22.208C3.00187 22.4165 3.08347 22.6169 3.22985 22.7653C3.37623 22.9138 3.57547 22.9982 3.78394 23H20.3899C20.4934 22.9995 20.5958 22.9786 20.6912 22.9385C20.7866 22.8984 20.8732 22.8399 20.946 22.7664C21.0188 22.6928 21.0764 22.6057 21.1155 22.5099C21.1546 22.4141 21.1745 22.3115 21.1739 22.208V1.792C21.175 1.5837 21.0936 1.38345 20.9474 1.23503C20.8012 1.08662 20.6022 1.00211 20.3939 1ZM19.6109 21.413H4.56994V2.583H11.7799V8.783C11.7796 8.93167 11.821 9.07744 11.8995 9.20369C11.978 9.32994 12.0904 9.43157 12.2239 9.497C12.3571 9.56126 12.5057 9.58626 12.6525 9.56908C12.7994 9.5519 12.9382 9.49325 13.0529 9.4L15.0119 7.819L16.8379 9.375C16.9512 9.47258 17.0903 9.53535 17.2385 9.55575C17.3866 9.57615 17.5375 9.55332 17.6729 9.49C17.8088 9.42604 17.9236 9.32475 18.004 9.19796C18.0844 9.07118 18.127 8.92413 18.1269 8.774V2.587H19.6269L19.6109 21.413ZM16.5439 7.075L15.5159 6.2C15.3761 6.08396 15.2001 6.02045 15.0184 6.02045C14.8367 6.02045 14.6608 6.08396 14.5209 6.2L13.3449 7.154V2.587H16.5449L16.5439 7.075Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.8349 18.788H6.05694C5.86035 18.811 5.66242 18.7577 5.50404 18.6389C5.34567 18.5202 5.23895 18.3452 5.20594 18.15C5.23918 17.9549 5.34595 17.7801 5.50427 17.6614C5.66259 17.5427 5.86039 17.4892 6.05694 17.512H17.8349C18.0317 17.4887 18.2299 17.5419 18.3885 17.6607C18.5471 17.7795 18.6539 17.9546 18.6869 18.15C18.6569 18.3335 18.5611 18.4998 18.4173 18.6178C18.2736 18.7358 18.0918 18.7973 17.9059 18.791L17.8349 18.788ZM17.8349 15.888H6.05694C5.8602 15.911 5.66214 15.8575 5.50374 15.7386C5.34535 15.6196 5.23873 15.4444 5.20594 15.249C5.23941 15.0541 5.34628 14.8795 5.50457 14.761C5.66286 14.6425 5.86054 14.5892 6.05694 14.612H17.8349C18.0315 14.5887 18.2296 14.6418 18.3882 14.7603C18.5467 14.8789 18.6537 15.0538 18.6869 15.249C18.6569 15.4325 18.5611 15.5988 18.4173 15.7168C18.2736 15.8348 18.0918 15.8963 17.9059 15.89L17.8349 15.888ZM5.20594 12.346C5.23827 12.1503 5.3447 11.9745 5.50314 11.8552C5.66159 11.7358 5.8599 11.6821 6.05694 11.705H17.8319C18.0285 11.682 18.2265 11.7353 18.3848 11.8541C18.5432 11.9728 18.6499 12.1478 18.6829 12.343C18.6499 12.5378 18.5435 12.7125 18.3856 12.8312C18.2276 12.9499 18.0302 13.0035 17.8339 12.981H5.98694C5.80197 12.9875 5.6209 12.9268 5.47729 12.81C5.33368 12.6933 5.23728 12.5284 5.20594 12.346Z",
  fill: "var(--icon-primary)"
}));
export const LicensedCapacityIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Licensed-capacity",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Licensed-capacity"
}, " Licensed capacity"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 2.5H8V8.5C8 8.72033 8.14423 8.9147 8.35511 8.97855C8.56599 9.04239 8.79381 8.96068 8.91603 8.77735L10.5 6.40139L12.084 8.77735C12.2062 8.96068 12.434 9.04239 12.6449 8.97855C12.8558 8.9147 13 8.72033 13 8.5V2.5H15C15.2761 2.5 15.5 2.72386 15.5 3V9.01062C15.669 9.00359 15.8399 9 16.0125 9C16.349 9 16.6789 9.01363 17 9.03983V3C17 1.89543 16.1046 1 15 1H3C1.89543 1 1 1.89543 1 3V19C1 20.1046 1.89543 21 3 21H10.381C10.1455 20.6848 10.012 20.3475 10.0008 20L10 19.9524V19.5H3C2.72386 19.5 2.5 19.2761 2.5 19V3C2.5 2.72386 2.72386 2.5 3 2.5ZM9 6.84861V2.5H12V6.84861L10.916 5.22265C10.8233 5.08355 10.6672 5 10.5 5C10.3328 5 10.1767 5.08355 10.084 5.22265L9 6.84861Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 11C4.22386 11 4 11.2239 4 11.5C4 11.7761 4.22386 12 4.5 12H6.5C6.77614 12 7 11.7761 7 11.5C7 11.2239 6.77614 11 6.5 11H4.5Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 14.5C4 14.2239 4.22386 14 4.5 14H6.5C6.77614 14 7 14.2239 7 14.5C7 14.7761 6.77614 15 6.5 15H4.5C4.22386 15 4 14.7761 4 14.5Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 17C4.22386 17 4 17.2239 4 17.5C4 17.7761 4.22386 18 4.5 18H6.5C6.77614 18 7 17.7761 7 17.5C7 17.2239 6.77614 17 6.5 17H4.5Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0125 8.25C14.2661 8.25 12.6453 8.59672 11.4332 9.19142C10.2706 9.76187 9.25 10.6921 9.25 11.9524C9.25 11.9683 9.25016 11.9842 9.25049 12L9.25 20C9.25 21.2446 10.2672 22.187 11.4258 22.7715C12.6372 23.3827 14.2599 23.75 16.0125 23.75C17.7651 23.75 19.3823 23.3827 20.5883 22.7707C21.7435 22.1845 22.75 21.2415 22.75 20V12C22.7503 11.9842 22.75 11.9683 22.75 11.9524C22.75 10.6952 21.7401 9.76428 20.5808 9.19217C19.3742 8.59674 17.7589 8.25 16.0125 8.25ZM10.75 11.9524C10.75 11.5821 11.0788 11.0362 12.094 10.5381C13.0598 10.0642 14.4452 9.75 16.0125 9.75C17.5798 9.75 18.9583 10.0642 19.917 10.5373C20.923 11.0338 21.25 11.579 21.25 11.9524C21.25 12.3349 20.911 12.9026 19.9053 13.421C18.9469 13.915 17.5718 14.25 16.0125 14.25C14.4531 14.25 13.0711 13.915 12.1057 13.4202C11.0909 12.9001 10.75 12.3318 10.75 11.9524ZM21.25 20V18.3812C21.0397 18.5247 20.8169 18.6547 20.5883 18.7707C19.3823 19.3827 17.7651 19.75 16.0125 19.75C14.2599 19.75 12.6372 19.3827 11.4258 18.7715C11.1924 18.6538 10.9648 18.5215 10.75 18.3752V20C10.75 20.3605 11.0822 20.9181 12.1014 21.4323C13.0679 21.9199 14.4514 22.25 16.0125 22.25C17.5736 22.25 18.9501 21.9199 19.9095 21.4331C20.9196 20.9206 21.25 20.3636 21.25 20ZM12.1014 17.4323C11.0822 16.9181 10.75 16.3605 10.75 16V14.3555C10.9631 14.5027 11.1893 14.6361 11.4215 14.7551C12.6339 15.3765 14.2582 15.75 16.0125 15.75C17.7669 15.75 19.3856 15.3764 20.5925 14.7543C20.82 14.637 21.0413 14.506 21.25 14.3616V16C21.25 16.3636 20.9196 16.9206 19.9095 17.4331C18.9501 17.9199 17.5736 18.25 16.0125 18.25C14.4514 18.25 13.0679 17.9199 12.1014 17.4323Z",
  fill: "var(--icon-primary)"
}));
export const MoveIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Move",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Move"
}, " Move"), /*#__PURE__*/React.createElement("path", {
  d: "M6.39099 21.005L1.29797 16.212C1.13258 16.0377 1.03417 15.8104 1.02026 15.5704C1.00635 15.3305 1.07779 15.0933 1.22192 14.901C1.40405 14.7426 1.63776 14.6561 1.87915 14.6577C2.12053 14.6594 2.35302 14.7491 2.53296 14.91L6.10998 18.281V6.40004C6.10998 6.28185 6.13324 6.16475 6.17846 6.05556C6.22369 5.94636 6.28996 5.84714 6.37353 5.76356C6.45711 5.67999 6.55633 5.61372 6.66553 5.5685C6.77472 5.52327 6.8917 5.50001 7.00989 5.50001C7.12808 5.50001 7.24518 5.52327 7.35437 5.5685C7.46356 5.61372 7.56279 5.67999 7.64636 5.76356C7.72993 5.84714 7.7962 5.94636 7.84143 6.05556C7.88666 6.16475 7.90991 6.28185 7.90991 6.40004V18.282L11.4869 14.911C11.6609 14.7384 11.8956 14.6407 12.1406 14.6391C12.3857 14.6374 12.6217 14.7317 12.798 14.902C12.9398 15.0952 13.0099 15.3318 12.9962 15.5711C12.9825 15.8103 12.8858 16.0373 12.7229 16.213L7.6289 21.006C7.45644 21.1549 7.23866 21.2409 7.01098 21.25C6.89659 21.2521 6.78292 21.2315 6.67651 21.1895C6.5701 21.1474 6.47305 21.0847 6.39099 21.005ZM16.0909 18.35V6.46803L12.5139 9.83803C12.3341 9.99914 12.1016 10.0889 11.8601 10.0906C11.6187 10.0922 11.385 10.0057 11.203 9.84706C11.059 9.65492 10.9875 9.41807 11.0012 9.17836C11.0149 8.93865 11.113 8.71145 11.278 8.537L16.3719 3.74306C16.4549 3.66326 16.5529 3.60068 16.6602 3.55897C16.7674 3.51726 16.8819 3.49721 16.9969 3.50001C17.2245 3.50956 17.4423 3.59553 17.615 3.74403L22.709 8.53798C22.8715 8.71375 22.9678 8.9406 22.9814 9.17958C22.9951 9.41856 22.9253 9.65487 22.7839 9.84804C22.6076 10.0183 22.3717 10.1127 22.1266 10.111C21.8815 10.1093 21.6468 10.0117 21.4729 9.839L17.896 6.46901V18.351C17.896 18.4692 17.8726 18.5863 17.8274 18.6954C17.7822 18.8046 17.7159 18.9039 17.6323 18.9874C17.5487 19.071 17.4495 19.1373 17.3403 19.1825C17.2311 19.2277 17.1142 19.251 16.996 19.251C16.8778 19.2509 16.7608 19.2275 16.6516 19.1821C16.5425 19.1368 16.4433 19.0704 16.3599 18.9867C16.2764 18.903 16.2101 18.8037 16.165 18.6945C16.1199 18.5852 16.0968 18.4682 16.0969 18.35H16.0909Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.1
}));
export const NoticeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Notice",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Notice"
}, " Notice"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_162_124)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.2109 12.695V6.63198C13.2109 6.30537 13.0812 5.99213 12.8502 5.76118C12.6193 5.53023 12.3061 5.40048 11.9794 5.40048C11.6528 5.40048 11.3396 5.53023 11.1086 5.76118C10.8777 5.99213 10.7479 6.30537 10.7479 6.63198V12.695C10.7479 13.0216 10.8777 13.3348 11.1086 13.5658C11.3396 13.7967 11.6528 13.9265 11.9794 13.9265C12.3061 13.9265 12.6193 13.7967 12.8502 13.5658C13.0812 13.3348 13.2109 13.0216 13.2109 12.695Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9186 15.6065C12.6541 15.3891 12.3223 15.2702 11.9799 15.27C11.7855 15.2699 11.593 15.308 11.4134 15.3823C11.2337 15.4566 11.0705 15.5656 10.9329 15.703C10.6907 15.945 10.5399 16.2635 10.5062 16.6042C10.4725 16.9449 10.5579 17.2868 10.748 17.5716C10.9381 17.8564 11.221 18.0665 11.5486 18.166C11.8762 18.2656 12.2282 18.2485 12.5446 18.1176C12.861 17.9868 13.1222 17.7503 13.2838 17.4484C13.4454 17.1465 13.4973 16.798 13.4307 16.4621C13.3641 16.1263 13.1831 15.8239 12.9186 15.6065Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_162_124"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const NoticeTriangleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Notice-triangle",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Notice-triangle"
}, " Notice triangle"), /*#__PURE__*/React.createElement("path", {
  d: "M12.2303 8.07703C11.9108 8.07755 11.6045 8.20609 11.3784 8.43452C11.1522 8.66296 11.0247 8.9727 11.0237 9.29602V14.562C11.0237 14.886 11.1509 15.1967 11.3772 15.4258C11.6036 15.6548 11.9107 15.7835 12.2308 15.7835C12.5509 15.7835 12.858 15.6548 13.0844 15.4258C13.3107 15.1967 13.4379 14.886 13.4379 14.562V9.29602C13.4371 8.97245 13.3096 8.6624 13.0832 8.43388C12.8568 8.20536 12.5501 8.07703 12.2303 8.07703Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3771 16.5687C11.6034 16.3397 11.9103 16.2111 12.2303 16.2111C12.3888 16.2108 12.5468 16.2422 12.6934 16.3035C12.8399 16.3647 12.973 16.4547 13.0851 16.5681C13.1972 16.6815 13.286 16.8162 13.3466 16.9645C13.4071 17.1128 13.4382 17.2716 13.4379 17.4321V17.5011C13.4379 17.825 13.3107 18.1357 13.0844 18.3648C12.858 18.5939 12.5509 18.7226 12.2308 18.7226C11.9107 18.7226 11.6036 18.5939 11.3772 18.3648C11.1509 18.1357 11.0237 17.825 11.0237 17.5011V17.4321C11.0237 17.1082 11.1508 16.7977 11.3771 16.5687Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9686 3.10706C14.6919 2.61743 14.2923 2.21049 13.8102 1.92746C13.3281 1.64443 12.7806 1.49536 12.2233 1.49536C11.6659 1.49536 11.1184 1.64443 10.6363 1.92746C10.1542 2.21049 9.75463 2.61743 9.47798 3.10706L1.16307 17.6901C0.884732 18.1775 0.73814 18.7305 0.738037 19.2935C0.737935 19.8564 0.884325 20.4095 1.16249 20.897C1.44065 21.3846 1.84077 21.7894 2.32262 22.0708C2.80446 22.3522 3.35104 22.5002 3.90737 22.5001H20.55C21.1062 22.4999 21.6525 22.3516 22.1341 22.07C22.6157 21.7885 23.0155 21.3836 23.2934 20.8962C23.5714 20.4087 23.7176 19.8558 23.7174 19.293C23.7172 18.7302 23.5706 18.1773 23.2924 17.6901L14.9686 3.10706ZM21.1944 19.6751C21.1297 19.7918 21.0353 19.8889 20.9209 19.9561C20.8065 20.0233 20.6764 20.0582 20.5441 20.0571H3.91033C3.77802 20.0569 3.64807 20.0215 3.53359 19.9544C3.4191 19.8873 3.32411 19.7908 3.25818 19.6747C3.19226 19.5586 3.15772 19.427 3.15805 19.2931C3.15839 19.1592 3.19358 19.0278 3.26008 18.9121L11.578 4.32906C11.6437 4.21199 11.7389 4.11465 11.8539 4.04693C11.9689 3.97921 12.0996 3.94354 12.2327 3.94354C12.3657 3.94354 12.4964 3.97921 12.6114 4.04693C12.7264 4.11465 12.8216 4.21199 12.8874 4.32906L21.2013 18.9121C21.2688 19.0276 21.3045 19.1593 21.3045 19.2936C21.3045 19.4278 21.2688 19.5595 21.2013 19.6751H21.1944Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2303 8.07703C11.9108 8.07755 11.6045 8.20609 11.3784 8.43452C11.1522 8.66296 11.0247 8.9727 11.0237 9.29602V14.562C11.0237 14.886 11.1509 15.1967 11.3772 15.4258C11.6036 15.6548 11.9107 15.7835 12.2308 15.7835C12.5509 15.7835 12.858 15.6548 13.0844 15.4258C13.3107 15.1967 13.4379 14.886 13.4379 14.562V9.29602C13.4371 8.97245 13.3096 8.6624 13.0832 8.43388C12.8568 8.20536 12.5501 8.07703 12.2303 8.07703Z",
  stroke: "white",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3771 16.5687C11.6034 16.3397 11.9103 16.2111 12.2303 16.2111C12.3888 16.2108 12.5468 16.2422 12.6934 16.3035C12.8399 16.3647 12.973 16.4547 13.0851 16.5681C13.1972 16.6815 13.286 16.8162 13.3466 16.9645C13.4071 17.1128 13.4382 17.2716 13.4379 17.4321V17.5011C13.4379 17.825 13.3107 18.1357 13.0844 18.3648C12.858 18.5939 12.5509 18.7226 12.2308 18.7226C11.9107 18.7226 11.6036 18.5939 11.3772 18.3648C11.1509 18.1357 11.0237 17.825 11.0237 17.5011V17.4321C11.0237 17.1082 11.1508 16.7977 11.3771 16.5687Z",
  stroke: "white",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9686 3.10706C14.6919 2.61743 14.2923 2.21049 13.8102 1.92746C13.3281 1.64443 12.7806 1.49536 12.2233 1.49536C11.6659 1.49536 11.1184 1.64443 10.6363 1.92746C10.1542 2.21049 9.75463 2.61743 9.47798 3.10706L1.16307 17.6901C0.884732 18.1775 0.73814 18.7305 0.738037 19.2935C0.737935 19.8564 0.884325 20.4095 1.16249 20.897C1.44065 21.3846 1.84077 21.7894 2.32262 22.0708C2.80446 22.3522 3.35104 22.5002 3.90737 22.5001H20.55C21.1062 22.4999 21.6525 22.3516 22.1341 22.07C22.6157 21.7885 23.0155 21.3836 23.2934 20.8962C23.5714 20.4087 23.7176 19.8558 23.7174 19.293C23.7172 18.7302 23.5706 18.1773 23.2924 17.6901L14.9686 3.10706ZM21.1944 19.6751C21.1297 19.7918 21.0353 19.8889 20.9209 19.9561C20.8065 20.0233 20.6764 20.0582 20.5441 20.0571H3.91033C3.77802 20.0569 3.64807 20.0215 3.53359 19.9544C3.4191 19.8873 3.32411 19.7908 3.25818 19.6747C3.19226 19.5586 3.15772 19.427 3.15805 19.2931C3.15839 19.1592 3.19358 19.0278 3.26008 18.9121L11.578 4.32906C11.6437 4.21199 11.7389 4.11465 11.8539 4.04693C11.9689 3.97921 12.0996 3.94354 12.2327 3.94354C12.3657 3.94354 12.4964 3.97921 12.6114 4.04693C12.7264 4.11465 12.8216 4.21199 12.8874 4.32906L21.2013 18.9121C21.2688 19.0276 21.3045 19.1593 21.3045 19.2936C21.3045 19.4278 21.2688 19.5595 21.2013 19.6751H21.1944Z",
  stroke: "white",
  strokeWidth: 0.5
}));
export const PaygoIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Pay-as-you-go",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pay-as-you-go"
}, " Pay as you go"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 2.5H8V8.5C8 8.72033 8.14423 8.9147 8.35511 8.97855C8.56599 9.04239 8.79381 8.96068 8.91603 8.77735L10.5 6.40139L12.084 8.77735C12.2062 8.96068 12.434 9.04239 12.6449 8.97855C12.8558 8.9147 13 8.72033 13 8.5V2.5H15C15.2761 2.5 15.5 2.72386 15.5 3V9.01758C15.6652 9.00593 15.8319 9 16 9C16.3395 9 16.6734 9.02417 17 9.07089V3C17 1.89543 16.1046 1 15 1H3C1.89543 1 1 1.89543 1 3V19C1 20.1046 1.89543 21 3 21H11.101C10.6485 20.5565 10.2558 20.0521 9.93647 19.5H3C2.72386 19.5 2.5 19.2761 2.5 19V3C2.5 2.72386 2.72386 2.5 3 2.5ZM9 6.84861V2.5H12V6.84861L10.916 5.22265C10.8233 5.08355 10.6672 5 10.5 5C10.3328 5 10.1767 5.08355 10.084 5.22265L9 6.84861Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 11C4.22386 11 4 11.2239 4 11.5C4 11.7761 4.22386 12 4.5 12H7.5C7.77614 12 8 11.7761 8 11.5C8 11.2239 7.77614 11 7.5 11H4.5Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 14.5C4 14.2239 4.22386 14 4.5 14H7.5C7.77614 14 8 14.2239 8 14.5C8 14.7761 7.77614 15 7.5 15H4.5C4.22386 15 4 14.7761 4 14.5Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 17C4.22386 17 4 17.2239 4 17.5C4 17.7761 4.22386 18 4.5 18H7.5C7.77614 18 8 17.7761 8 17.5C8 17.2239 7.77614 17 7.5 17H4.5Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 12.6651V12.5C17 12.2239 16.7761 12 16.5 12H15.5C15.2239 12 15 12.2239 15 12.5V12.698C14.1475 13.0172 13.5 13.7127 13.5 14.7143C13.5 15.4664 13.949 15.9555 14.4751 16.2292C14.9824 16.4933 15.5994 16.5857 16.1176 16.5857C16.5053 16.5857 16.8757 16.6932 17.1341 16.8658C17.3857 17.0338 17.5 17.2362 17.5 17.4571C17.5 17.746 17.3884 17.9922 17.1808 18.1726C16.9693 18.3563 16.6235 18.5 16.1176 18.5C15.6225 18.5 15.1991 18.355 14.912 18.1459C14.6254 17.937 14.5 17.6886 14.5 17.4572C14.5 17.181 14.2762 16.9572 14 16.9571C13.7239 16.9571 13.5 17.181 13.5 17.4571C13.5 18.0828 13.8451 18.6058 14.3232 18.9541C14.5237 19.1002 14.7521 19.2199 15 19.3095V19.5549C15 19.8311 15.2239 20.0549 15.5 20.0549H16.5C16.7761 20.0549 17 19.8311 17 19.5549V19.3778C17.3206 19.2818 17.6031 19.1304 17.8367 18.9274C18.2703 18.5506 18.5 18.0255 18.5 17.4571C18.5 16.8209 18.1437 16.3376 17.6895 16.0342C17.242 15.7354 16.6712 15.5857 16.1176 15.5857C15.6947 15.5857 15.2529 15.5067 14.9367 15.3422C14.6392 15.1874 14.5 14.9907 14.5 14.7143C14.5 14.068 15.0975 13.5 16.1176 13.5C16.5513 13.5 16.9004 13.6877 17.1476 13.9333C17.4156 14.1995 17.5 14.4653 17.5 14.5429C17.5 14.8191 17.7239 15.0429 18.0001 15.0429C18.2762 15.0428 18.5 14.8189 18.5 14.5428C18.4999 14.1062 18.2315 13.6005 17.8524 13.2239C17.6269 12.9998 17.3403 12.7983 17 12.6651Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 16C9 12.134 12.134 9 16 9C19.866 9 23 12.134 23 16C23 19.866 19.866 23 16 23C12.134 23 9 19.866 9 16ZM16 21.5C12.9624 21.5 10.5 19.0376 10.5 16C10.5 12.9624 12.9624 10.5 16 10.5C19.0376 10.5 21.5 12.9624 21.5 16C21.5 19.0376 19.0376 21.5 16 21.5Z",
  fill: "var(--icon-primary)"
}));
export const PinIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Pin",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pin"
}, " Pin"), /*#__PURE__*/React.createElement("path", {
  d: "M2.64202 22.358C2.59694 22.3132 2.56116 22.2601 2.53675 22.2014C2.51233 22.1428 2.49976 22.08 2.49976 22.0165C2.49976 21.953 2.51233 21.8901 2.53675 21.8315C2.56116 21.7729 2.59694 21.7197 2.64202 21.675L8.26702 16.05L4.48302 12.265C4.40321 12.1846 4.34181 12.0878 4.30308 11.9813C4.26435 11.8749 4.24922 11.7612 4.25873 11.6484C4.26824 11.5355 4.30217 11.426 4.35816 11.3275C4.41416 11.229 4.49088 11.1439 4.58302 11.078C5.3594 10.5746 6.24074 10.2558 7.15945 10.1459C8.07816 10.036 9.00983 10.1379 9.88302 10.444L15.252 5.71396C15.0825 4.81035 15.1591 3.87775 15.474 3.01396C15.5188 2.891 15.5939 2.78129 15.6923 2.69499C15.7906 2.60868 15.9092 2.54855 16.0369 2.52015C16.1647 2.49175 16.2975 2.49599 16.4232 2.53249C16.5489 2.56898 16.6634 2.63656 16.756 2.72896L22.271 8.24496C22.3633 8.33741 22.4309 8.45154 22.4675 8.57689C22.5042 8.70224 22.5088 8.8348 22.481 8.9624C22.4531 9.08999 22.3936 9.20855 22.308 9.3072C22.2224 9.40584 22.1134 9.4814 21.991 9.52696C21.1274 9.84267 20.1947 9.91971 19.291 9.74996L14.561 15.119C14.9745 16.2769 15.0199 17.5343 14.691 18.719C14.5314 19.3237 14.2732 19.8981 13.927 20.419C13.8609 20.5113 13.7755 20.588 13.6767 20.644C13.5779 20.6999 13.4682 20.7337 13.355 20.743C13.333 20.7443 13.311 20.7443 13.289 20.743C13.0826 20.7424 12.8848 20.6601 12.739 20.514L8.82102 16.593L3.20002 22.218C3.15526 22.2631 3.10198 22.2989 3.04327 22.3233C2.98456 22.3476 2.92159 22.3601 2.85802 22.36C2.77702 22.36 2.75202 22.4 2.71702 22.4C2.69502 22.4 2.67402 22.39 2.64202 22.358Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 1.8
}));
export const PlayIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Play",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Play"
}, " Play"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_146_4033)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.60006 7.69799C9.59726 7.58108 9.62315 7.46527 9.67544 7.36068C9.72774 7.25609 9.80486 7.16589 9.90006 7.09799C9.98886 7.03797 10.0938 7.0064 10.201 7.00747C10.3082 7.00854 10.4125 7.04221 10.5001 7.10399L16.8361 11.328C16.9297 11.3975 17.0059 11.4879 17.0583 11.5921C17.1108 11.6963 17.1381 11.8113 17.1381 11.928C17.1381 12.0446 17.1108 12.1597 17.0583 12.2638C17.0059 12.368 16.9297 12.4585 16.8361 12.528L13.6691 14.628L10.5021 16.742C10.4138 16.8026 10.3092 16.8351 10.2021 16.8351C10.0949 16.8351 9.99036 16.8026 9.90206 16.742C9.80705 16.6739 9.73007 16.5837 9.6778 16.4791C9.62552 16.3746 9.59953 16.2589 9.60206 16.142L9.60006 7.69799ZM11.1001 9.30706L15.0291 11.9263L12.8401 13.3778L11.1013 14.5385L11.1001 9.30706Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12ZM1.50018 12C1.50018 6.21038 6.21038 1.50018 12 1.50018C17.7896 1.50018 22.4998 6.21038 22.4998 12C22.4998 17.7896 17.7896 22.4998 12 22.4998C6.21038 22.4998 1.50018 17.7896 1.50018 12Z",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_146_4033"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const RemoveDarkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "ic_remove",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "ic_remove"
}, "Remove"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_146_4031)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.61 13.189C16.232 13.189 16.999 12.698 16.999 12.098C16.9548 11.7711 16.7849 11.4743 16.5254 11.2706C16.2658 11.0668 15.9371 10.9723 15.609 11.007H8.38902C7.76702 11.007 7.00002 11.498 7.00002 12.098C7.04425 12.4248 7.21402 12.7215 7.47333 12.9252C7.73264 13.1288 8.06109 13.2235 8.38902 13.189H15.61Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.61095 2.4381C7.50211 1.17446 9.72552 0.5 12 0.5C15.0489 0.503441 17.972 1.71615 20.1279 3.87207C22.2839 6.028 23.4966 8.95107 23.5 12C23.5 14.2745 22.8255 16.4979 21.5619 18.3891C20.2983 20.2802 18.5022 21.7542 16.4009 22.6246C14.2995 23.495 11.9872 23.7228 9.75647 23.279C7.52569 22.8353 5.47658 21.74 3.86828 20.1317C2.25997 18.5234 1.1647 16.4743 0.720975 14.2435C0.277245 12.0128 0.504982 9.70049 1.37539 7.59914C2.2458 5.49779 3.71978 3.70174 5.61095 2.4381ZM17.4063 3.90897C15.806 2.83971 13.9246 2.269 12 2.269C10.7216 2.26702 9.45529 2.51738 8.27378 3.0057C7.09227 3.49403 6.01874 4.21074 5.11474 5.11474C4.21074 6.01874 3.49404 7.09226 3.00571 8.27377C2.51738 9.45528 2.26703 10.7216 2.269 12C2.269 13.9246 2.83972 15.806 3.90897 17.4063C4.97823 19.0065 6.498 20.2538 8.27611 20.9903C10.0542 21.7268 12.0108 21.9195 13.8984 21.544C15.7861 21.1685 17.52 20.2418 18.8809 18.8809C20.2418 17.52 21.1686 15.7861 21.544 13.8984C21.9195 12.0108 21.7268 10.0542 20.9903 8.27611C20.2538 6.498 19.0065 4.97823 17.4063 3.90897Z",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_146_4031"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const RestoreIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Restore",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Restore"
}, " Restore"), /*#__PURE__*/React.createElement("path", {
  d: "M22.7403 14.1775C24.2594 8.50802 20.8865 2.65533 15.2243 1.13814C11.0744 0.0261959 6.83429 1.54245 4.26302 4.66904L3.96345 3.3907C3.88669 3.04518 3.62804 2.76836 3.28754 2.6693C2.95433 2.57219 2.59509 2.65994 2.34473 2.90021C2.09438 3.14049 1.99139 3.4956 2.0754 3.83231L2.93485 7.49252C2.99495 7.7504 3.1568 7.97192 3.38412 8.10624C3.61119 8.24147 3.88351 8.27724 4.13744 8.20629L7.53634 7.26901C7.80388 7.22029 8.0382 7.06187 8.1822 6.83128C8.32688 6.60185 8.36875 6.32139 8.29585 6.06009C8.22412 5.79812 8.04525 5.57792 7.80332 5.45437C7.56139 5.33081 7.27888 5.31482 7.02456 5.40916L5.90943 5.7133C8.02197 3.28312 11.3988 2.11774 14.7231 3.00848C19.3725 4.25429 22.1187 9.01591 20.8699 13.6763C19.6219 18.334 14.8668 21.0847 10.2202 19.8436C9.97092 19.7728 9.70363 19.806 9.47857 19.9336C9.25259 20.061 9.08869 20.2745 9.02163 20.5247C8.95458 20.775 8.98977 21.0418 9.12178 21.2651C9.25263 21.4891 9.46781 21.6505 9.71901 21.7139C15.3787 23.2254 21.2219 19.8442 22.7403 14.1775Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0315 6.20308C12.1361 6.15865 12.2482 6.13585 12.3614 6.13598C12.4746 6.13585 12.5857 6.15865 12.6903 6.20308C12.7949 6.24751 12.89 6.31269 12.97 6.3949C13.0501 6.4771 13.1135 6.57472 13.1568 6.68215C13.2 6.78958 13.2222 6.90473 13.2221 7.02098V12.413L15.8353 14.971C15.9213 15.0511 15.9905 15.1483 16.0387 15.2567C16.087 15.3651 16.1133 15.4825 16.1161 15.6017C16.1188 15.7208 16.098 15.8394 16.0548 15.95C16.0116 16.0607 15.947 16.1612 15.8649 16.2454C15.7827 16.3296 15.6848 16.3958 15.577 16.44C15.4692 16.4842 15.3538 16.5054 15.2377 16.5023C15.1217 16.4993 15.0075 16.4721 14.902 16.4224C14.7965 16.3726 14.702 16.3014 14.6241 16.213C14.0005 15.5719 13.5267 15.1163 13.0352 14.6436C12.6473 14.2706 12.2483 13.8869 11.7558 13.393C11.6752 13.3119 11.611 13.2151 11.5671 13.1083C11.5231 13.0016 11.5002 12.8869 11.4998 12.771V7.02098C11.4996 6.90473 11.5218 6.78958 11.5651 6.68215C11.6083 6.57472 11.6718 6.4771 11.7518 6.3949C11.8319 6.31269 11.9269 6.24751 12.0315 6.20308Z",
  fill: "var(--icon-primary)"
}));
export const SearchIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Search",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Search"
}, " Search"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2795 17.2896C13.7965 18.3656 11.9723 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 12.0966 18.2831 14.0257 17.0811 15.5557L21.9726 20.4472C22.4607 20.9353 22.4607 21.7268 21.9726 22.2149C21.4844 22.7031 20.6929 22.7031 20.2048 22.2149L15.2795 17.2896ZM17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",
  fill: "var(--icon-primary)"
}));
export const SendIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Send",
  width: 22,
  height: 21,
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Send"
}, " Send"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.3506 2.48573L2.9444 7.30737L10.8496 9.78057L18.3506 2.48573ZM11.8593 10.7515L15.1748 18.3163L19.4636 3.35613L11.8593 10.7515ZM21.4491 1.51088C21.6465 0.82204 20.999 0.189901 20.3151 0.403934L1.0013 6.44854C0.159683 6.71194 0.159733 7.90308 1.00139 8.1664L10.5003 11.1382L14.4491 20.148C14.7874 20.92 15.9062 20.845 16.1385 20.0348L21.4491 1.51088Z",
  fill: "var(--icon-primary)"
}));
export const Settings1Icon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_146_4028)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.8834 10.7881L20.7127 10.4207C20.5791 10.4007 20.4545 10.341 20.3552 10.2493C20.2558 10.1576 20.1862 10.0381 20.1554 9.90636C19.9541 9.14274 19.6481 8.41078 19.246 7.73143C19.1741 7.61976 19.1358 7.48964 19.1358 7.3567C19.1358 7.22376 19.1741 7.09364 19.246 6.98197L20.522 5.17443C20.5411 5.14899 20.5514 5.11805 20.5514 5.08625C20.5514 5.05446 20.5411 5.02352 20.522 4.99808L19.0114 3.45506C18.9951 3.44819 18.9777 3.44466 18.96 3.44466C18.9424 3.44466 18.9249 3.44819 18.9087 3.45506H18.8354L17.046 4.73357C16.9317 4.80527 16.7996 4.8433 16.6647 4.8433C16.5298 4.8433 16.3977 4.80527 16.2834 4.73357C15.5862 4.33079 14.8357 4.02897 14.054 3.83714C13.9225 3.80625 13.8033 3.73652 13.7118 3.63695C13.6202 3.53739 13.5606 3.41259 13.5407 3.27871L13.174 1.11849C13.1742 1.10173 13.1707 1.08514 13.1639 1.06982C13.1572 1.05451 13.1472 1.04083 13.1347 1.02969C13.1222 1.01856 13.1074 1.01024 13.0915 1.00527C13.0755 1.00031 13.0586 0.998827 13.0421 1.00092H10.8714C10.8548 0.998827 10.8379 1.00031 10.822 1.00527C10.806 1.01024 10.7913 1.01856 10.7788 1.02969C10.7663 1.04083 10.7563 1.05451 10.7495 1.06982C10.7427 1.08514 10.7393 1.10173 10.7394 1.11849L10.3581 3.30812C10.3432 3.45877 10.2814 3.60092 10.1814 3.71436C10.0813 3.8278 9.94812 3.90675 9.80072 3.94C9.04478 4.14619 8.31971 4.45262 7.64472 4.85113C7.5288 4.92581 7.39388 4.96552 7.25606 4.96552C7.11824 4.96552 6.98332 4.92581 6.86739 4.85113L5.13673 3.46975H5.04873C5.02051 3.45831 4.98895 3.45831 4.96073 3.46975L3.40607 5.04217C3.38702 5.0676 3.37673 5.09855 3.37673 5.13034C3.37673 5.16214 3.38702 5.19308 3.40607 5.21852L4.68206 7.02606C4.75362 7.1406 4.79158 7.273 4.79158 7.40813C4.79158 7.54327 4.75362 7.67567 4.68206 7.79021C4.29745 8.47131 4.01105 9.20356 3.8314 9.96514C3.80057 10.0969 3.73097 10.2164 3.6316 10.3081C3.53223 10.3998 3.40768 10.4595 3.27406 10.4795L1.11807 10.8469C1.08566 10.8505 1.05574 10.866 1.03407 10.8904C1.01241 10.9149 1.00053 10.9465 1.00073 10.9791V13.1687C1.00053 13.2014 1.01241 13.233 1.03407 13.2574C1.05574 13.2819 1.08566 13.2974 1.11807 13.301L3.3034 13.6684C3.45376 13.6832 3.59563 13.7452 3.70885 13.8454C3.82207 13.9457 3.90087 14.0791 3.93406 14.2268C4.13862 14.9893 4.44446 15.7208 4.8434 16.4017C4.91844 16.515 4.95848 16.6479 4.95848 16.7838C4.95848 16.9198 4.91844 17.0527 4.8434 17.1659L3.5674 18.9588C3.54836 18.9842 3.53806 19.0151 3.53806 19.0469C3.53806 19.0787 3.54836 19.1097 3.5674 19.1351L5.12206 20.6046C5.15083 20.6128 5.18129 20.6128 5.21006 20.6046H5.29806L7.10206 19.3114C7.2213 19.2245 7.36524 19.1781 7.51272 19.1792C7.63752 19.1786 7.75978 19.2144 7.86472 19.2821C8.52681 19.6645 9.23716 19.9561 9.97672 20.1491C10.1082 20.18 10.2275 20.2497 10.319 20.3493C10.4105 20.4488 10.4701 20.5736 10.4901 20.7075L10.8567 22.8824C10.8603 22.9149 10.8758 22.9449 10.9002 22.9666C10.9246 22.9883 10.9561 23.0002 10.9887 23H13.086C13.1187 23.0002 13.1502 22.9883 13.1746 22.9666C13.1989 22.9449 13.2144 22.9149 13.218 22.8824L13.5847 20.7075C13.6065 20.5744 13.6667 20.4505 13.7579 20.3513C13.8492 20.2521 13.9674 20.1818 14.098 20.1491C14.8611 19.9502 15.592 19.6434 16.2687 19.238C16.383 19.1663 16.5152 19.1282 16.65 19.1282C16.7849 19.1282 16.9171 19.1663 17.0314 19.238L18.8207 20.5165C18.854 20.5277 18.8901 20.5277 18.9234 20.5165L20.4634 18.9734C20.4759 18.9624 20.4859 18.9488 20.4927 18.9336C20.4995 18.9184 20.5031 18.9019 20.5031 18.8853C20.5031 18.8686 20.4995 18.8521 20.4927 18.8369C20.4859 18.8217 20.4759 18.8081 20.4634 18.7971L19.1874 16.9896C19.1158 16.875 19.0779 16.7426 19.0779 16.6075C19.0779 16.4723 19.1158 16.3399 19.1874 16.2254C19.592 15.5474 19.8982 14.815 20.0967 14.0505C20.1275 13.9187 20.1971 13.7992 20.2965 13.7075C20.3959 13.6158 20.5204 13.5561 20.654 13.5361L22.8247 13.1687C22.8559 13.1841 22.8918 13.1866 22.9247 13.1756C22.9577 13.1646 22.985 13.141 23.0007 13.11V10.935C23.0014 10.9007 22.99 10.8671 22.9686 10.8403C22.9472 10.8134 22.917 10.795 22.8834 10.7881ZM12.0007 15.9756C11.2163 15.9785 10.4486 15.7479 9.79516 15.313C9.1417 14.8781 8.63187 14.2586 8.33033 13.533C8.02879 12.8074 7.94913 12.0084 8.10146 11.2374C8.25379 10.4663 8.63124 9.75798 9.18594 9.20219C9.74063 8.6464 10.4476 8.26822 11.2171 8.11559C11.9866 7.96296 12.7841 8.04278 13.5083 8.34491C14.2324 8.64704 14.8508 9.15788 15.2848 9.81262C15.7188 10.4674 15.9489 11.2365 15.946 12.0225C15.9422 13.0697 15.5253 14.073 14.7862 14.8135C14.0472 15.554 13.0459 15.9717 12.0007 15.9756Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 1.8
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_146_4028"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const ShowIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Show",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Show"
}, " Show"), /*#__PURE__*/React.createElement("path", {
  d: "M22.9569 12.256C22.0934 10.07 20.5795 8.20197 18.6199 6.90428C16.6603 5.60659 14.3495 4.94187 11.9999 4.99997C9.65034 4.94187 7.33955 5.60659 5.37996 6.90428C3.42038 8.20197 1.90648 10.07 1.04293 12.256C0.985689 12.4133 0.985689 12.5857 1.04293 12.743C1.9062 14.9292 3.42 16.7975 5.37963 18.0954C7.33926 19.3933 9.65019 20.0581 11.9999 20C14.3495 20.0581 16.6603 19.3933 18.6199 18.0957C20.5795 16.798 22.0934 14.9299 22.9569 12.744C23.0142 12.5863 23.0142 12.4136 22.9569 12.256ZM11.9999 18.5C10.0164 18.5498 8.06328 18.0051 6.39186 16.9359C4.72044 15.8666 3.40715 14.3217 2.62093 12.5C3.40726 10.6783 4.72058 9.1335 6.39197 8.06426C8.06336 6.99502 10.0164 6.45024 11.9999 6.49997C13.9835 6.4501 15.9366 6.99483 17.608 8.06409C19.2794 9.13334 20.5927 10.6782 21.3789 12.5C20.5926 14.3216 19.2793 15.8664 17.6079 16.9357C15.9365 18.0049 13.9835 18.5497 11.9999 18.5Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 8.15097C10.7973 8.10433 9.83659 8.53555 8.95088 9.35044C8.06517 10.1653 7.76498 11.2976 7.71145 12.5C7.81059 13.6853 8.12448 14.7902 8.99993 15.5955C9.87537 16.4007 10.8099 16.8477 11.9994 16.8477C13.1889 16.8477 14.335 16.4007 15.2104 15.5955C16.0859 14.7902 16.6268 13.6853 16.7259 12.5C16.6724 11.2978 16.1453 10.1657 15.2598 9.3508C14.3744 8.53595 13.2024 8.1046 11.9999 8.15097ZM11.9999 15.399C11.4369 15.352 10.8997 15.142 10.4541 14.7948C10.0084 14.4475 9.67346 13.978 9.4902 13.4436C9.30695 12.9092 9.28329 12.3329 9.42212 11.7852C9.56095 11.2376 9.85626 10.7422 10.272 10.3596C10.6877 9.97699 11.2058 9.72372 11.7631 9.63072C12.3204 9.53773 12.8927 9.60903 13.4101 9.83592C13.9276 10.0628 14.3677 10.4355 14.6769 10.9084C14.986 11.3813 15.1507 11.934 15.1509 12.499C15.1156 13.3007 14.7643 14.0557 14.1738 14.5992C13.5834 15.1426 12.8018 15.4301 11.9999 15.399Z",
  fill: "var(--icon-primary)"
}));
export const SourceIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Source",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Source"
}, " Source"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_146_4024)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.22192 19.775C2.159 17.7122 1.00009 14.9143 1 11.9969C0.999915 10.5523 1.28432 9.12172 1.83716 7.78699C2.38999 6.45226 3.20035 5.23955 4.22192 4.21802C6.28475 2.1551 9.08265 0.996064 12 0.995972C14.9162 1.00005 17.7117 2.16022 19.7739 4.22205C21.8364 6.28429 22.9966 9.08035 23 11.9969C22.9999 14.9143 21.841 17.7122 19.7781 19.775C17.7152 21.8379 14.9173 22.9969 12 22.9969C10.5554 22.9973 9.12489 22.7129 7.79028 22.16C6.45568 21.6072 5.2431 20.7968 4.22192 19.775ZM4.73901 4.73706C2.81452 6.66309 1.73323 9.27422 1.73291 11.9969C1.73328 14.7194 2.81458 17.3303 4.73901 19.256C6.66475 21.181 9.27611 22.2626 11.999 22.2629C14.7212 22.2602 17.3312 21.1778 19.2561 19.2531C21.1809 17.3285 22.2635 14.7188 22.2661 11.9969C22.2663 9.27411 21.185 6.66278 19.26 4.73706C17.3343 2.81201 14.7229 1.73035 12 1.72998C9.27665 1.73114 6.66524 2.81384 4.73999 4.73999L4.73901 4.73706ZM10.333 16.037C10.2844 16.0369 10.2363 16.0269 10.1917 16.0077C10.147 15.9884 10.1065 15.9603 10.073 15.925L6.40601 12.2581C6.33749 12.1893 6.29907 12.0961 6.29907 11.999C6.29907 11.9019 6.33749 11.8088 6.40601 11.74L10.073 8.073C10.1419 8.00617 10.2341 7.96875 10.3301 7.96875C10.426 7.96875 10.5181 8.00617 10.5869 8.073C10.6547 8.14125 10.6932 8.23327 10.6941 8.32947C10.695 8.42567 10.6585 8.51846 10.592 8.58801L7.18408 11.995L10.592 15.402C10.6269 15.4358 10.6546 15.4763 10.6738 15.5209C10.693 15.5655 10.7035 15.6134 10.7041 15.662C10.7047 15.7108 10.6953 15.7593 10.6768 15.8044C10.6582 15.8496 10.6307 15.8907 10.5959 15.925C10.5625 15.959 10.5227 15.9859 10.4788 16.0043C10.4348 16.0226 10.3877 16.032 10.3401 16.032L10.333 16.037ZM13.406 15.9301C13.3714 15.8957 13.3441 15.8546 13.3257 15.8094C13.3073 15.7643 13.2983 15.7158 13.2991 15.667C13.2995 15.6184 13.3096 15.5704 13.3289 15.5258C13.3481 15.4811 13.3758 15.4407 13.4109 15.407L16.8181 12L13.4109 8.59302C13.3435 8.52424 13.3059 8.43173 13.3059 8.33545C13.3059 8.23917 13.3435 8.14678 13.4109 8.078C13.4797 8.01117 13.572 7.97375 13.668 7.97375C13.7639 7.97375 13.8562 8.01117 13.925 8.078L17.592 11.745C17.6606 11.8138 17.699 11.9069 17.699 12.004C17.699 12.1011 17.6606 12.1942 17.592 12.2629L13.925 15.9301C13.8914 15.9651 13.8511 15.9931 13.8064 16.0123C13.7617 16.0316 13.7137 16.0416 13.665 16.042C13.6168 16.0416 13.5692 16.0315 13.5249 16.0125C13.4806 15.9934 13.4405 15.9657 13.407 15.931L13.406 15.9301Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.8
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_146_4024"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const SpaceshipIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Spaceship",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Spaceship"
}, " Spaceship"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_146_4022)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.9193 1.34503C22.8996 1.2867 22.8667 1.2337 22.8231 1.19016C22.7796 1.14663 22.7266 1.11373 22.6683 1.09403C21.6434 0.790255 20.5792 0.639958 19.5103 0.648029C18.2218 0.622788 16.9421 0.864878 15.752 1.35902C14.5618 1.85317 13.4869 2.58864 12.5953 3.51903C11.2281 4.98227 9.96374 6.53832 8.81127 8.17603C7.86627 7.67603 5.11127 6.43903 3.76527 8.20803C2.6462 9.76242 1.62104 11.3823 0.695272 13.059C0.660194 13.1246 0.644079 13.1986 0.648734 13.2728C0.65339 13.347 0.678632 13.4184 0.721628 13.4791C0.764623 13.5397 0.823671 13.5872 0.892144 13.6162C0.960617 13.6451 1.03581 13.6544 1.10927 13.643C2.04927 13.487 4.68327 13.194 5.77627 13.663L5.98427 13.871L4.58827 14.662C4.53018 14.689 4.47942 14.7295 4.44025 14.7802C4.40108 14.8309 4.37466 14.8902 4.36319 14.9532C4.35173 15.0162 4.35556 15.0811 4.37437 15.1423C4.39317 15.2035 4.42641 15.2593 4.47127 15.305L5.10527 15.938C4.17849 16.5423 3.70919 17.0786 3.18505 18.0529C2.66092 19.0273 2.38971 20.1176 2.39627 21.224C2.40134 21.3229 2.4429 21.4164 2.5129 21.4864C2.58291 21.5564 2.6764 21.598 2.77527 21.603C2.86727 21.603 2.96027 21.61 3.05127 21.61C4.10959 21.5644 5.14194 21.268 6.06336 20.7454C6.98478 20.2228 7.47793 19.7799 8.06027 18.895L8.69427 19.528C8.73101 19.5652 8.77477 19.5947 8.82302 19.6148C8.87126 19.6348 8.92301 19.6451 8.97527 19.645C8.99944 19.6451 9.02357 19.6428 9.04727 19.638C9.11026 19.6262 9.16948 19.5994 9.21995 19.5599C9.27042 19.5204 9.31065 19.4693 9.33727 19.411L10.1283 18.02L10.3363 18.228C10.8053 19.319 10.5113 21.953 10.3553 22.891C10.3462 22.9479 10.3495 23.0061 10.365 23.0616C10.3805 23.1171 10.4078 23.1685 10.445 23.2125C10.4822 23.2565 10.5285 23.2919 10.5807 23.3163C10.6328 23.3407 10.6897 23.3536 10.7473 23.354C10.8144 23.3544 10.8805 23.3375 10.9393 23.305C12.6171 22.382 14.2384 21.3595 15.7943 20.243C17.5643 18.899 16.3273 16.143 15.8273 15.2C17.4685 14.0487 19.0282 12.7853 20.4953 11.419C24.8453 7.30003 22.9383 1.40703 22.9183 1.34803L22.9193 1.34503ZM1.79027 12.748C2.5816 11.3468 3.45132 9.99132 4.39527 8.68803C5.32727 7.46303 7.48327 8.38803 8.34627 8.83303C7.07327 10.677 6.17427 12.211 5.82027 12.833C4.49156 12.5697 3.1271 12.5403 1.78827 12.746L1.79027 12.748ZM7.49327 18.322C6.99057 19.1055 6.60621 19.4726 5.80992 19.9548C5.01363 20.437 4.11753 20.7306 3.19027 20.813C3.2727 19.8858 3.56626 18.9897 4.04848 18.1934C4.53069 17.3971 4.89776 17.0127 5.68127 16.51L6.58627 17.41L7.49327 18.322ZM8.85727 18.561L5.44227 15.15L6.58627 14.471L9.53427 17.419L8.85727 18.561ZM15.3233 19.606C14.0191 20.5506 12.6626 21.4206 11.2603 22.212C11.4656 20.8738 11.4361 19.5101 11.1733 18.182C11.7973 17.828 13.3313 16.931 15.1733 15.659C15.6113 16.526 16.5293 18.688 15.3203 19.607L15.3233 19.606ZM19.9503 10.839C17.1391 13.3948 14.0537 15.6314 10.7503 17.508L6.49527 13.257C8.37275 9.95532 10.6108 6.87212 13.1683 4.06403C13.987 3.21347 14.973 2.54167 16.0641 2.09092C17.1553 1.64018 18.328 1.42026 19.5083 1.44503C20.423 1.4443 21.3341 1.56058 22.2193 1.79103C22.4893 2.79603 23.4963 7.47703 19.9473 10.838L19.9503 10.839Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6783 4.70903C16.0709 4.70873 15.4823 4.91904 15.0126 5.30413C14.5429 5.68922 14.2213 6.22526 14.1026 6.8209C13.9839 7.41654 14.0754 8.03491 14.3615 8.57065C14.6476 9.10639 15.1107 9.52633 15.6717 9.75892C16.2328 9.99151 16.8571 10.0223 17.4384 9.84618C18.0196 9.67001 18.5218 9.29774 18.8593 8.79281C19.1968 8.28788 19.3488 7.68153 19.2894 7.07709C19.2299 6.47265 18.9627 5.90753 18.5333 5.47803C18.2902 5.23363 18.0011 5.03983 17.6827 4.90784C17.3643 4.77584 17.0229 4.70827 16.6783 4.70903ZM17.9733 8.62603C17.6743 8.92441 17.2812 9.10994 16.8609 9.15102C16.4405 9.1921 16.0189 9.08619 15.6679 8.85134C15.3169 8.61648 15.0581 8.2672 14.9357 7.86297C14.8132 7.45875 14.8347 7.02459 14.9965 6.63443C15.1582 6.24427 15.4502 5.92224 15.8227 5.72319C16.1952 5.52413 16.6252 5.46037 17.0394 5.54275C17.4537 5.62513 17.8266 5.84857 18.0946 6.175C18.3626 6.50143 18.5091 6.91067 18.5093 7.33303C18.5099 7.57329 18.4628 7.81127 18.3708 8.03321C18.2788 8.25516 18.1437 8.45665 17.9733 8.62603Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.9193 1.34503C22.8996 1.2867 22.8667 1.2337 22.8231 1.19016C22.7796 1.14663 22.7266 1.11373 22.6683 1.09403C21.6434 0.790255 20.5792 0.639958 19.5103 0.648029C18.2218 0.622788 16.9421 0.864878 15.752 1.35902C14.5618 1.85317 13.4869 2.58864 12.5953 3.51903C11.2281 4.98227 9.96374 6.53832 8.81127 8.17603C7.86627 7.67603 5.11127 6.43903 3.76527 8.20803C2.6462 9.76242 1.62104 11.3823 0.695272 13.059C0.660194 13.1246 0.644079 13.1986 0.648734 13.2728C0.65339 13.347 0.678632 13.4184 0.721628 13.4791C0.764623 13.5397 0.823671 13.5872 0.892144 13.6162C0.960617 13.6451 1.03581 13.6544 1.10927 13.643C2.04927 13.487 4.68327 13.194 5.77627 13.663L5.98427 13.871L4.58827 14.662C4.53018 14.689 4.47942 14.7295 4.44025 14.7802C4.40108 14.8309 4.37466 14.8902 4.36319 14.9532C4.35173 15.0162 4.35556 15.0811 4.37437 15.1423C4.39317 15.2035 4.42641 15.2593 4.47127 15.305L5.10527 15.938C4.17849 16.5423 3.70919 17.0786 3.18505 18.0529C2.66092 19.0273 2.38971 20.1176 2.39627 21.224C2.40134 21.3229 2.4429 21.4164 2.5129 21.4864C2.58291 21.5564 2.6764 21.598 2.77527 21.603C2.86727 21.603 2.96027 21.61 3.05127 21.61C4.10959 21.5644 5.14194 21.268 6.06336 20.7454C6.98478 20.2228 7.47793 19.7799 8.06027 18.895L8.69427 19.528C8.73101 19.5652 8.77477 19.5947 8.82302 19.6148C8.87126 19.6348 8.92301 19.6451 8.97527 19.645C8.99944 19.6451 9.02357 19.6428 9.04727 19.638C9.11026 19.6262 9.16948 19.5994 9.21995 19.5599C9.27042 19.5204 9.31065 19.4693 9.33727 19.411L10.1283 18.02L10.3363 18.228C10.8053 19.319 10.5113 21.953 10.3553 22.891C10.3462 22.9479 10.3495 23.0061 10.365 23.0616C10.3805 23.1171 10.4078 23.1685 10.445 23.2125C10.4822 23.2565 10.5285 23.2919 10.5807 23.3163C10.6328 23.3407 10.6897 23.3536 10.7473 23.354C10.8144 23.3544 10.8805 23.3375 10.9393 23.305C12.6171 22.382 14.2384 21.3595 15.7943 20.243C17.5643 18.899 16.3273 16.143 15.8273 15.2C17.4685 14.0487 19.0282 12.7853 20.4953 11.419C24.8453 7.30003 22.9383 1.40703 22.9183 1.34803L22.9193 1.34503ZM1.79027 12.748C2.5816 11.3468 3.45132 9.99132 4.39527 8.68803C5.32727 7.46303 7.48327 8.38803 8.34627 8.83303C7.07327 10.677 6.17427 12.211 5.82027 12.833C4.49156 12.5697 3.1271 12.5403 1.78827 12.746L1.79027 12.748ZM7.49327 18.322C6.99057 19.1055 6.60621 19.4726 5.80992 19.9548C5.01363 20.437 4.11753 20.7306 3.19027 20.813C3.2727 19.8858 3.56626 18.9897 4.04848 18.1934C4.53069 17.3971 4.89776 17.0127 5.68127 16.51L6.58627 17.41L7.49327 18.322ZM8.85727 18.561L5.44227 15.15L6.58627 14.471L9.53427 17.419L8.85727 18.561ZM15.3233 19.606C14.0191 20.5506 12.6626 21.4206 11.2603 22.212C11.4656 20.8738 11.4361 19.5101 11.1733 18.182C11.7973 17.828 13.3313 16.931 15.1733 15.659C15.6113 16.526 16.5293 18.688 15.3203 19.607L15.3233 19.606ZM19.9503 10.839C17.1391 13.3948 14.0537 15.6314 10.7503 17.508L6.49527 13.257C8.37275 9.95532 10.6108 6.87212 13.1683 4.06403C13.987 3.21347 14.973 2.54167 16.0641 2.09092C17.1553 1.64018 18.328 1.42026 19.5083 1.44503C20.423 1.4443 21.3341 1.56058 22.2193 1.79103C22.4893 2.79603 23.4963 7.47703 19.9473 10.838L19.9503 10.839Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6783 4.70903C16.0709 4.70873 15.4823 4.91904 15.0126 5.30413C14.5429 5.68922 14.2213 6.22526 14.1026 6.8209C13.9839 7.41654 14.0754 8.03491 14.3615 8.57065C14.6476 9.10639 15.1107 9.52633 15.6717 9.75892C16.2328 9.99151 16.8571 10.0223 17.4384 9.84618C18.0196 9.67001 18.5218 9.29774 18.8593 8.79281C19.1968 8.28788 19.3488 7.68153 19.2894 7.07709C19.2299 6.47265 18.9627 5.90753 18.5333 5.47803C18.2902 5.23363 18.0011 5.03983 17.6827 4.90784C17.3643 4.77584 17.0229 4.70827 16.6783 4.70903ZM17.9733 8.62603C17.6743 8.92441 17.2812 9.10994 16.8609 9.15102C16.4405 9.1921 16.0189 9.08619 15.6679 8.85134C15.3169 8.61648 15.0581 8.2672 14.9357 7.86297C14.8132 7.45875 14.8347 7.02459 14.9965 6.63443C15.1582 6.24427 15.4502 5.92224 15.8227 5.72319C16.1952 5.52413 16.6252 5.46037 17.0394 5.54275C17.4537 5.62513 17.8266 5.84857 18.0946 6.175C18.3626 6.50143 18.5091 6.91067 18.5093 7.33303C18.5099 7.57329 18.4628 7.81127 18.3708 8.03321C18.2788 8.25516 18.1437 8.45665 17.9733 8.62603Z",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.7
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_146_4022"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const SuccessIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Success",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Success"
}, " Success"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2264 8.43934C17.5193 8.73223 17.5193 9.20711 17.2264 9.5L11.2124 15.9051C10.7659 16.3517 10.0289 16.3058 9.64116 15.8073L6.5 12.8399C6.2457 12.5129 6.3046 12.0417 6.63156 11.7874C6.95852 11.5331 7.42973 11.592 7.68403 11.919L10.5122 14.484L16.1658 8.43934C16.4587 8.14645 16.9335 8.14645 17.2264 8.43934Z",
  fill: "var(--icon-primary)"
}));
export const SupportIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Support",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Support"
}, " Support"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_146_4055)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.02587 17.8299H6.72587C6.88143 17.83 7.03094 17.7706 7.14288 17.6644C7.25482 17.5581 7.32043 17.4133 7.32587 17.2604V9.82038C7.32091 9.66862 7.25495 9.52498 7.14247 9.42099C7.03 9.31699 6.88017 9.26112 6.72587 9.26562H4.56087V8.84956C4.53869 6.88458 5.30912 4.99104 6.70342 3.58365C8.09772 2.17626 10.0022 1.36973 11.9999 1.3407C13.9975 1.36973 15.902 2.17626 17.2963 3.58365C18.6906 4.99104 19.4611 6.88458 19.4389 8.84956V9.26562H17.2709C17.1168 9.2619 16.9674 9.31803 16.8551 9.42187C16.7428 9.5257 16.6766 9.66888 16.6709 9.82038V17.2574C16.6763 17.4103 16.7419 17.5552 16.8539 17.6614C16.9658 17.7677 17.1153 17.827 17.2709 17.8269H17.8349V19.7253C17.8341 20.1576 17.6602 20.5723 17.3508 20.8794C17.0414 21.1865 16.6214 21.3613 16.1819 21.366H12.4769C12.3475 20.9462 12.0693 20.5861 11.6928 20.3512C11.3163 20.1162 10.8665 20.0221 10.4254 20.0858C9.98424 20.1495 9.58102 20.367 9.28911 20.6985C8.9972 21.03 8.83601 21.4536 8.83487 21.8922V21.9591C8.8346 22.4458 9.03037 22.9128 9.37934 23.2579C9.7283 23.603 10.202 23.798 10.6969 23.8004C11.0929 23.7952 11.4773 23.6683 11.7965 23.4377C12.1156 23.207 12.3535 22.884 12.4769 22.5138H16.1819C16.9309 22.5091 17.6477 22.2134 18.176 21.691C18.7042 21.1687 19.0011 20.4621 19.0019 19.7253V17.8269H19.9739C20.5145 17.8277 21.0333 17.6175 21.4165 17.2424C21.7998 16.8673 22.016 16.358 22.0179 15.8263V11.2584C22.0203 10.8335 21.8848 10.4189 21.6313 10.0748C21.3777 9.73077 21.0192 9.47522 20.6079 9.34529V8.85349C20.629 6.5845 19.7352 4.39971 18.1223 2.77744C16.5093 1.15517 14.3086 0.227581 12.0019 0.197754C9.69516 0.227581 7.49443 1.15517 5.88148 2.77744C4.26853 4.39971 3.37478 6.5845 3.39587 8.85349V9.34529C2.98454 9.47522 2.62604 9.73077 2.37247 10.0748C2.1189 10.4189 1.98348 10.8335 1.98587 11.2584V15.8253C1.98693 16.3572 2.20257 16.867 2.58543 17.2426C2.9683 17.6183 3.48708 17.8292 4.02787 17.8289L4.02587 17.8299ZM11.4169 21.961C11.4169 22.1449 11.3426 22.3213 11.2104 22.4514C11.0782 22.5814 10.8988 22.6545 10.7119 22.6545C10.5249 22.6545 10.3456 22.5814 10.2134 22.4514C10.0811 22.3213 10.0069 22.1449 10.0069 21.961V21.8941C10.0069 21.7102 10.0811 21.5339 10.2134 21.4038C10.3456 21.2738 10.5249 21.2007 10.7119 21.2007C10.8988 21.2007 11.0782 21.2738 11.2104 21.4038C11.3426 21.5339 11.4169 21.7102 11.4169 21.8941V21.961ZM20.8499 11.2574V15.8243C20.8488 16.0518 20.7561 16.2696 20.5921 16.43C20.4281 16.5904 20.2062 16.6803 19.9749 16.68H17.8349V10.4145H19.9739C20.0877 10.4127 20.2008 10.4331 20.3065 10.4745C20.4123 10.5159 20.5086 10.5776 20.59 10.6559C20.6714 10.7342 20.7361 10.8276 20.7806 10.9307C20.825 11.0337 20.8482 11.1445 20.8489 11.2564L20.8499 11.2574ZM3.14987 11.2574C3.15052 11.1455 3.17373 11.0347 3.21817 10.9316C3.26261 10.8286 3.32738 10.7352 3.40876 10.6569C3.49013 10.5786 3.58648 10.5169 3.69224 10.4755C3.79799 10.434 3.91105 10.4136 4.02487 10.4155H6.16387V16.681H4.02587C3.79459 16.6813 3.57263 16.5914 3.40862 16.431C3.24462 16.2706 3.15193 16.0528 3.15087 15.8253L3.14987 11.2574Z",
  fill: "var(--icon-primary)",
  stroke: "var(--icon-primary)",
  strokeWidth: 0.4
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_146_4055"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const TableActionIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12Z",
  fill: "var(--icon-primary)"
}));
export const TotalConsumedCapacityIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Total-consumed-capacity",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Total-consumed-capacity"
}, " Total consumed capacity"), /*#__PURE__*/React.createElement("path", {
  d: "M17 13V13.6651C17.3403 13.7983 17.6269 13.9998 17.8524 14.2239C18.2315 14.6005 18.4999 15.1062 18.5 15.5428C18.5 15.8189 18.2762 16.0428 18.0001 16.0429C17.7239 16.0429 17.5 15.8191 17.5 15.5429C17.5 15.4653 17.4156 15.1995 17.1476 14.9333C16.9004 14.6877 16.5513 14.5 16.1176 14.5C15.0975 14.5 14.5 15.068 14.5 15.7143C14.5 15.9907 14.6392 16.1874 14.9367 16.3422C15.2529 16.5067 15.6947 16.5857 16.1176 16.5857C16.6712 16.5857 17.242 16.7354 17.6895 17.0342C18.1437 17.3376 18.5 17.8209 18.5 18.4571C18.5 19.0255 18.2703 19.5506 17.8367 19.9274C17.6031 20.1304 17.3206 20.2818 17 20.3778V21.0549H15V20.3095C14.7521 20.2199 14.5237 20.1002 14.3232 19.9541C13.8451 19.6058 13.5 19.0828 13.5 18.4571C13.5 18.181 13.7239 17.9571 14 17.9571C14.2762 17.9572 14.5 18.181 14.5 18.4572C14.5 18.6886 14.6254 18.937 14.912 19.1459C15.1991 19.355 15.6225 19.5 16.1176 19.5C16.6235 19.5 16.9693 19.3563 17.1808 19.1726C17.3884 18.9922 17.5 18.746 17.5 18.4571C17.5 18.2362 17.3857 18.0338 17.1341 17.8658C16.8757 17.6932 16.5053 17.5857 16.1176 17.5857C15.5994 17.5857 14.9824 17.4933 14.4751 17.2292C13.949 16.9555 13.5 16.4664 13.5 15.7143C13.5 14.7127 14.1475 14.0172 15 13.698V13H17Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 2V1H5V2H4C2.34315 2 1 3.34315 1 5V13C1 14.6569 2.34315 16 4 16H9.07089C9.02417 16.3266 9 16.6605 9 17C9 20.866 12.134 24 16 24C19.866 24 23 20.866 23 17C23 13.4735 20.3923 10.5561 17 10.0709V5C17 3.34315 15.6569 2 14 2H13V1H12V2H6ZM15.5 10.0176V8H2.5V13C2.5 13.8284 3.17157 14.5 4 14.5H9.45963C10.4094 12.0168 12.7326 10.2129 15.5 10.0176ZM12 5V3.5H6V5H5V3.5H4C3.17157 3.5 2.5 4.17157 2.5 5V7H15.5V5C15.5 4.17157 14.8284 3.5 14 3.5H13V5H12ZM10.5 17C10.5 20.0376 12.9624 22.5 16 22.5C19.0376 22.5 21.5 20.0376 21.5 17C21.5 13.9624 19.0376 11.5 16 11.5C12.9624 11.5 10.5 13.9624 10.5 17Z",
  fill: "var(--icon-primary)"
}));
export const UploadIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Upload",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Upload"
}, " Upload"), /*#__PURE__*/React.createElement("path", {
  d: "M12.509 3.00001C12.2815 3.00835 12.0637 3.08818 11.891 3.22653L6.79699 7.69548C6.63322 7.85893 6.53573 8.0705 6.52131 8.29375C6.50689 8.51699 6.57645 8.73794 6.71799 8.91852C6.89447 9.07845 7.13142 9.16715 7.37754 9.1654C7.62366 9.16366 7.85914 9.07161 8.03299 8.9092L11.61 5.76677L11.61 16.8422C11.61 17.0647 11.7048 17.2781 11.8736 17.4354C12.0424 17.5928 12.2713 17.6812 12.51 17.6812C12.7487 17.6812 12.9776 17.5928 13.1464 17.4354C13.3152 17.2781 13.41 17.0647 13.41 16.8422L13.41 5.76677L16.985 8.9092C17.1647 9.05952 17.3972 9.14343 17.6386 9.14515C17.88 9.14686 18.1138 9.06627 18.296 8.91852C18.4404 8.73941 18.5122 8.51839 18.4984 8.29467C18.4847 8.07095 18.3864 7.859 18.221 7.69641L13.127 3.22746C12.9613 3.07858 12.7391 2.99617 12.509 3.00001Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.9001 18C4.9001 17.503 4.49715 17.1 4.0001 17.1C3.50304 17.1 3.1001 17.503 3.1001 18V21C3.1001 21.4971 3.50304 21.9 4.0001 21.9H21.0001C21.4972 21.9 21.9001 21.4971 21.9001 21V18C21.9001 17.503 21.4972 17.1 21.0001 17.1C20.503 17.1 20.1001 17.503 20.1001 18V20.1H4.9001V18Z",
  fill: "var(--icon-primary)"
}));
export const UserSettingsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-User-settings",
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-User-settings"
}, " User settings"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.6616 13.5848C8.75695 14.129 8.16227 14.9955 7.91398 16.4185C9.37095 17.4802 10.9096 17.9847 12.5624 17.9847C14.241 17.9847 15.7389 17.5201 17.0956 16.5791C16.9802 15.6861 16.6021 14.3824 15.4847 13.6092C14.5418 14.0914 13.4759 14.29 12.4809 14.29C11.2727 14.29 10.2853 13.908 9.6616 13.5848ZM18.625 16.8028C18.5523 15.7784 18.1481 13.3968 16.002 12.1633C15.6546 11.9637 15.2298 12.044 14.8772 12.2342C14.172 12.6143 13.32 12.79 12.4809 12.79C11.5445 12.79 10.7694 12.478 10.2868 12.2187C9.93891 12.0317 9.5169 11.9591 9.16723 12.1426C7.56705 12.9826 6.66134 14.4293 6.38146 16.5171C6.33492 16.8643 6.47885 17.2094 6.75562 17.424C8.52717 18.7978 10.4628 19.4847 12.5624 19.4847C14.672 19.4847 16.5692 18.8541 18.254 17.5928C18.5032 17.4063 18.647 17.1133 18.625 16.8028Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 10.5362C13.7484 10.5362 14.7605 9.52415 14.7605 8.27573C14.7605 7.02731 13.7484 6.01526 12.5 6.01526C11.2515 6.01526 10.2395 7.0273 10.2395 8.27573C10.2395 9.52416 11.2515 10.5362 12.5 10.5362ZM16.2605 8.27573C16.2605 10.3526 14.5768 12.0362 12.5 12.0362C10.4231 12.0362 8.7395 10.3526 8.7395 8.27573C8.7395 6.19888 10.4231 4.51526 12.5 4.51526C14.5768 4.51526 16.2605 6.19888 16.2605 8.27573Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 22.5C18.299 22.5 23 17.799 23 12C23 6.20101 18.299 1.5 12.5 1.5C6.70101 1.5 2 6.20101 2 12C2 17.799 6.70101 22.5 12.5 22.5ZM12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
  fill: "var(--icon-primary)"
}));
export const VolumeHDDIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume-HDD",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.25 0.2449733018875122 39.99500274658203 40.00907516479492"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume-HDD"
}, " Volume HDD"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M14.416.25a30.951 30.951 0 00-9.713 1.38 10.163 10.163 0 00-3.112 1.6 3.268 3.268 0 00-1.328 2.3v.039c0 .029-.01.06-.013.091V31.5a3.211 3.211 0 001.341 2.435 10.163 10.163 0 003.112 1.6 30.953 30.953 0 009.713 1.38h1.667a30.864 30.864 0 009.7-1.38 10.163 10.163 0 003.112-1.6A3.226 3.226 0 0030.25 31.5V5.589c0-.026-.008-.052-.013-.078a3.3 3.3 0 00-1.341-2.279 10.163 10.163 0 00-3.112-1.6A30.864 30.864 0 0016.083.25zm0 1.667h1.667a29.54 29.54 0 019.167 1.289 8.706 8.706 0 012.591 1.315c.557.454.742.837.742 1.146 0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.302 33.347 33.347 0 01-9.779-1.3 9.6 9.6 0 01-2.774-1.318c-.6-.459-.781-.843-.781-1.133a1.566 1.566 0 01.734-1.145 8.8 8.8 0 012.6-1.315 29.541 29.541 0 019.167-1.289zm14.167 6.354v6.146c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.301 33.348 33.348 0 01-9.779-1.3 9.6 9.6 0 01-2.774-1.316c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078V8.284a11.492 11.492 0 003.047 1.419 34.636 34.636 0 0010.287 1.38 34.54 34.54 0 0010.273-1.38 11.444 11.444 0 003.06-1.432zm0 8.75v5.729c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315A33.252 33.252 0 0115.25 26.5a33.347 33.347 0 01-9.779-1.3 9.6 9.6 0 01-2.773-1.315c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078v-5.64a11.492 11.492 0 003.046 1.416 34.636 34.636 0 0010.287 1.383 34.54 34.54 0 0010.273-1.383 11.444 11.444 0 003.06-1.432zm0 8.333V31.5c0 .309-.186.692-.742 1.146a8.706 8.706 0 01-2.591 1.314 29.541 29.541 0 01-9.167 1.29h-1.667a29.54 29.54 0 01-9.166-1.29 8.8 8.8 0 01-2.6-1.31 1.566 1.566 0 01-.729-1.146v-6.137a11.492 11.492 0 003.047 1.419 34.636 34.636 0 0010.282 1.38 34.54 34.54 0 0010.273-1.38 11.444 11.444 0 003.06-1.432z",
  "data-name": "Subtraction 12"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M15.483 21.917h22.862a1.8 1.8 0 011.9 1.667v15a1.8 1.8 0 01-1.9 1.667H15.483a1.8 1.8 0 01-1.9-1.668v-15a1.8 1.8 0 011.9-1.666z",
  "data-name": "Path 10696"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.311 35.25h1.43v-6.668h-1.43v2.62h-3.15v-2.62h-1.415v6.67h1.42v-2.8h3.15zm2.74 0h2.63a3.261 3.261 0 003.54-3.33 3.268 3.268 0 00-3.54-3.338h-2.635zm1.42-1.25v-4.17h1.21a1.952 1.952 0 012.09 2.09 2 2 0 01-2.09 2.08zm5.76 1.25h2.63a3.261 3.261 0 003.54-3.33 3.268 3.268 0 00-3.54-3.338h-2.63zM32.646 34v-4.17h1.21a1.952 1.952 0 012.09 2.09 2 2 0 01-2.09 2.08z",
  "data-name": "Path 10701"
}));
export const VolumePRMIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume-PRM",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.25 0.2449733018875122 39.99500274658203 40.00907516479492"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume-PRM"
}, " Volume PRM"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M14.416.25a30.951 30.951 0 00-9.713 1.38 10.163 10.163 0 00-3.112 1.6 3.268 3.268 0 00-1.328 2.3v.039c0 .029-.01.06-.013.091V31.5a3.211 3.211 0 001.341 2.435 10.163 10.163 0 003.112 1.6 30.953 30.953 0 009.713 1.38h1.667a30.864 30.864 0 009.7-1.38 10.163 10.163 0 003.112-1.6A3.226 3.226 0 0030.25 31.5V5.589c0-.026-.008-.052-.013-.078a3.3 3.3 0 00-1.341-2.279 10.163 10.163 0 00-3.112-1.6A30.864 30.864 0 0016.083.25zm0 1.667h1.667a29.54 29.54 0 019.167 1.289 8.706 8.706 0 012.591 1.315c.557.454.742.837.742 1.146 0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.302 33.347 33.347 0 01-9.779-1.3 9.6 9.6 0 01-2.774-1.318c-.6-.459-.781-.843-.781-1.133a1.566 1.566 0 01.734-1.145 8.8 8.8 0 012.6-1.315 29.541 29.541 0 019.167-1.289zm14.167 6.354v6.146c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.301 33.348 33.348 0 01-9.779-1.3 9.6 9.6 0 01-2.774-1.316c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078V8.284a11.492 11.492 0 003.047 1.419 34.636 34.636 0 0010.287 1.38 34.54 34.54 0 0010.273-1.38 11.444 11.444 0 003.06-1.432zm0 8.75v5.729c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315A33.252 33.252 0 0115.25 26.5a33.347 33.347 0 01-9.779-1.3 9.6 9.6 0 01-2.773-1.315c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078v-5.64a11.492 11.492 0 003.046 1.416 34.636 34.636 0 0010.287 1.383 34.54 34.54 0 0010.273-1.383 11.444 11.444 0 003.06-1.432zm0 8.333V31.5c0 .309-.186.692-.742 1.146a8.706 8.706 0 01-2.591 1.314 29.541 29.541 0 01-9.167 1.29h-1.667a29.54 29.54 0 01-9.166-1.29 8.8 8.8 0 01-2.6-1.31 1.566 1.566 0 01-.729-1.146v-6.137a11.492 11.492 0 003.047 1.419 34.636 34.636 0 0010.282 1.38 34.54 34.54 0 0010.273-1.38 11.444 11.444 0 003.06-1.432z",
  "data-name": "Subtraction 12"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M15.483 21.917h22.862a1.8 1.8 0 011.9 1.667v15a1.8 1.8 0 01-1.9 1.667H15.483a1.8 1.8 0 01-1.9-1.668v-15a1.8 1.8 0 011.9-1.666z",
  "data-name": "Path 10696"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.131 35.25h1.42v-2.39h1.7a2.077 2.077 0 002.24-2.13 2.081 2.081 0 00-2.24-2.148h-3.12zm3.91-4.53a.909.909 0 01-.98.92h-1.51V29.8h1.51a.915.915 0 01.98.92zm6.1 4.53h1.63l-1.5-2.54a1.914 1.914 0 001.46-1.98 2.077 2.077 0 00-2.24-2.148h-3.12v6.67h1.42V32.86h1.04zm.14-4.53a.921.921 0 01-1 .92h-1.49V29.8h1.49a.921.921 0 011 .92zm8.32 4.53h1.43v-6.668h-2l-1.62 4.158-1.62-4.158h-1.99v6.67h1.42v-4.8l1.88 4.798h.62l1.88-4.8z",
  "data-name": "Path 10700"
}));
export const VolumeSTDIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume-",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.25 0.24495890736579895 39.99500274658203 40.00908660888672"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume-"
}, " Volume "), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M14.417.25a30.952 30.952 0 00-9.714 1.38 10.164 10.164 0 00-3.112 1.6 3.268 3.268 0 00-1.328 2.3v.039c0 .029-.01.06-.013.091V31.5a3.211 3.211 0 001.341 2.435 10.164 10.164 0 003.112 1.6 30.954 30.954 0 009.713 1.38h1.667a30.866 30.866 0 009.7-1.38 10.164 10.164 0 003.112-1.6A3.226 3.226 0 0030.25 31.5V5.589c0-.026-.008-.052-.013-.078a3.3 3.3 0 00-1.341-2.279 10.163 10.163 0 00-3.112-1.6A30.865 30.865 0 0016.083.25zm0 1.667h1.667a29.541 29.541 0 019.166 1.289 8.706 8.706 0 012.591 1.315c.557.454.742.837.742 1.146 0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.253 33.253 0 01-9.766 1.302 33.349 33.349 0 01-9.779-1.3 9.6 9.6 0 01-2.773-1.318c-.6-.459-.781-.843-.781-1.133a1.566 1.566 0 01.733-1.145 8.8 8.8 0 012.6-1.315 29.542 29.542 0 019.167-1.289zm14.167 6.354v6.146c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.253 33.253 0 01-9.767 1.301 33.349 33.349 0 01-9.779-1.3 9.6 9.6 0 01-2.773-1.316c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078V8.284a11.493 11.493 0 003.046 1.419 34.638 34.638 0 0010.287 1.38 34.542 34.542 0 0010.274-1.38 11.445 11.445 0 003.06-1.432zm0 8.75v5.729c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315A33.253 33.253 0 0115.25 26.5a33.349 33.349 0 01-9.779-1.3 9.6 9.6 0 01-2.773-1.315c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078v-5.64a11.493 11.493 0 003.046 1.416 34.638 34.638 0 0010.287 1.383 34.542 34.542 0 0010.274-1.383 11.445 11.445 0 003.06-1.432zm0 8.333V31.5c0 .309-.186.692-.742 1.146a8.706 8.706 0 01-2.592 1.314 29.542 29.542 0 01-9.167 1.29h-1.666a29.541 29.541 0 01-9.167-1.29 8.8 8.8 0 01-2.6-1.31 1.566 1.566 0 01-.729-1.146v-6.137a11.493 11.493 0 003.047 1.419 34.638 34.638 0 0010.282 1.38 34.541 34.541 0 0010.274-1.38 11.444 11.444 0 003.06-1.432z",
  "data-name": "Subtraction 12"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M15.483 21.917h22.862a1.8 1.8 0 011.9 1.667v15a1.8 1.8 0 01-1.9 1.667H15.483a1.8 1.8 0 01-1.9-1.668v-15a1.8 1.8 0 011.9-1.666z",
  "data-name": "Path 10696"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.651 34.31a3.843 3.843 0 002.83 1.06c1.8 0 2.67-.92 2.67-2.14 0-1.48-1.4-1.81-2.5-2.06-.77-.18-1.33-.32-1.33-.77 0-.4.34-.68.98-.68a2.846 2.846 0 011.909.73l.79-1.04a3.71 3.71 0 00-2.6-.93c-1.57 0-2.53.9-2.53 2.01 0 1.49 1.4 1.79 2.49 2.04.77.18 1.35.35 1.35.85 0 .38-.38.75-1.16.75a2.924 2.924 0 01-2.12-.9zm7.93.94h1.429v-5.42h1.94v-1.25h-5.319v1.25h1.95zm4.28 0h2.63a3.261 3.261 0 003.54-3.33 3.268 3.268 0 00-3.54-3.34h-2.63zm1.42-1.25v-4.17h1.21a1.952 1.952 0 012.09 2.09 2 2 0 01-2.09 2.08z",
  "data-name": "Path 10698"
}));
export const VolumeBalancedIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Volume-balanced",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.25 0.2449733018875122 39.99400329589844 40.00907516479492"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Volume-balanced"
}, " Volume balanced"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  strokeWidth: 0.5,
  d: "M14.416.25a30.951 30.951 0 00-9.713 1.38 10.163 10.163 0 00-3.112 1.6 3.268 3.268 0 00-1.328 2.3v.039c0 .029-.01.06-.013.091V31.5a3.211 3.211 0 001.341 2.435 10.163 10.163 0 003.112 1.6 30.953 30.953 0 009.713 1.38h1.667a30.864 30.864 0 009.7-1.38 10.163 10.163 0 003.112-1.6A3.226 3.226 0 0030.25 31.5V5.589c0-.026-.008-.052-.013-.078a3.3 3.3 0 00-1.341-2.279 10.163 10.163 0 00-3.112-1.6A30.864 30.864 0 0016.083.25zm0 1.667h1.667a29.54 29.54 0 019.167 1.289 8.706 8.706 0 012.591 1.315c.557.454.742.837.742 1.146 0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.302 33.347 33.347 0 01-9.779-1.3 9.6 9.6 0 01-2.774-1.318c-.6-.459-.781-.843-.781-1.133a1.566 1.566 0 01.734-1.145 8.8 8.8 0 012.6-1.315 29.541 29.541 0 019.167-1.289zm14.167 6.354v6.146c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315 33.252 33.252 0 01-9.766 1.301 33.348 33.348 0 01-9.779-1.3 9.6 9.6 0 01-2.774-1.316c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078V8.284a11.492 11.492 0 003.047 1.419 34.636 34.636 0 0010.287 1.38 34.54 34.54 0 0010.273-1.38 11.444 11.444 0 003.06-1.432zm0 8.75v5.729c0 .29-.2.674-.794 1.133a9.6 9.6 0 01-2.773 1.315A33.252 33.252 0 0115.25 26.5a33.347 33.347 0 01-9.779-1.3 9.6 9.6 0 01-2.773-1.315c-.6-.459-.781-.843-.781-1.133a.626.626 0 000-.078v-5.64a11.492 11.492 0 003.046 1.416 34.636 34.636 0 0010.287 1.383 34.54 34.54 0 0010.273-1.383 11.444 11.444 0 003.06-1.432zm0 8.333V31.5c0 .309-.186.692-.742 1.146a8.706 8.706 0 01-2.591 1.314 29.541 29.541 0 01-9.167 1.29h-1.667a29.54 29.54 0 01-9.166-1.29 8.8 8.8 0 01-2.6-1.31 1.566 1.566 0 01-.729-1.146v-6.137a11.492 11.492 0 003.047 1.419 34.636 34.636 0 0010.282 1.38 34.54 34.54 0 0010.273-1.38 11.444 11.444 0 003.06-1.432z",
  "data-name": "Subtraction 12"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M15.482 21.917h22.862a1.8 1.8 0 011.9 1.667v15a1.8 1.8 0 01-1.9 1.667H15.482a1.8 1.8 0 01-1.9-1.668v-15a1.8 1.8 0 011.9-1.666z",
  "data-name": "Path 10696"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.225 35.25h3.62a1.756 1.756 0 001.94-1.8 1.616 1.616 0 00-1.28-1.64 1.482 1.482 0 001.15-1.528 1.725 1.725 0 00-1.916-1.7h-3.51zm1.42-3.99v-1.47h1.78a.723.723 0 01.78.73.72.72 0 01-.78.74zm0 2.78v-1.57h1.83a.779.779 0 01.86.78.766.766 0 01-.86.79zm9.88 1.21h1.55l-2.57-6.668h-1.78l-2.58 6.668h1.56l.42-1.15h2.98zm-1.91-5.44l1.1 3.06h-2.21zm4.08 5.44h4.244V34h-2.824v-5.418h-1.42z",
  "data-name": "Path 10699"
}));
export const VolumeIO1Icon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Volume-IO",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Volume-IO"
}, "Volume IO"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.1498 9.61999C12.5897 9.61999 12.0597 9.46001 11.5997 9.16003C11.1398 8.86004 10.7898 8.42999 10.5797 7.92004C10.3698 7.41003 10.3197 6.86004 10.4198 6.32C10.5298 5.78002 10.7898 5.29003 11.1798 4.90002C11.5697 4.51 12.0597 4.24999 12.5997 4.14001C13.1398 4.03002 13.6997 4.09002 14.1997 4.29998C14.7097 4.51 15.1398 4.86999 15.4397 5.33001C15.7397 5.78002 15.8998 6.32 15.8998 6.86999C15.8998 7.60003 15.6097 8.29998 15.0897 8.82C14.5697 9.34002 13.8798 9.63 13.1498 9.63V9.61999ZM13.1398 5.23998C13.114 5.23998 13.0875 5.23998 13.0608 5.24053C12.9838 5.242 12.9039 5.24773 12.8297 5.27001C12.5198 5.33001 12.2397 5.48003 11.9998 5.71001C11.7698 5.93999 11.6198 6.23003 11.5597 6.54003C11.4998 6.86004 11.5298 7.17999 11.6598 7.48003C11.7898 7.78002 11.9897 8.03002 12.2598 8.2C12.8998 8.63 13.7698 8.52001 14.2998 7.99999C14.5997 7.7 14.7698 7.29998 14.7698 6.86999C14.7698 6.54003 14.6798 6.23003 14.4998 5.97002C14.3197 5.7 14.0697 5.49999 13.7698 5.36999C13.5697 5.29003 13.3597 5.24999 13.1498 5.24999L13.1398 5.23998Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5797 13.61H13.7397L13.7598 13.6H14.0198L13.9897 13.55C14.2097 13.46 14.3698 13.27 14.3898 13.05L14.5597 11.98C14.9897 11.86 15.3698 11.69 15.6897 11.48L16.5997 12.13C16.6398 12.16 16.6897 12.19 16.7397 12.2C16.8698 12.24 17.0198 12.24 17.1498 12.2C17.2467 12.171 17.3156 12.1136 17.3743 12.0646L17.3798 12.06L18.1997 11.23C18.3297 11.11 18.4097 10.93 18.4097 10.75C18.4097 10.61 18.3397 10.46 18.2798 10.37L17.6498 9.49004C17.8698 9.10003 18.0298 8.72002 18.1198 8.35003L19.1097 8.18005H19.1298C19.3898 8.18005 19.6198 8.04003 19.7297 7.82C19.7698 7.74004 19.7897 7.65002 19.7897 7.57V6.36999C19.7897 6.22002 19.7397 6.07 19.6498 5.96001C19.5963 5.88879 19.5111 5.82806 19.4214 5.78423C19.3601 5.75426 19.2966 5.73217 19.2397 5.72002L18.1597 5.55004C18.0298 5.11999 17.8698 4.74004 17.6597 4.42004L18.2997 3.52001C18.3798 3.41003 18.4197 3.27001 18.4197 3.13C18.4197 3.01 18.3698 2.84002 18.2997 2.74004L18.2397 2.68005L17.4097 1.83001C17.3597 1.77001 17.2997 1.73003 17.2197 1.68999C17.0397 1.61004 16.8798 1.64001 16.8998 1.64001C16.7798 1.64001 16.6597 1.68005 16.5597 1.74999L15.6797 2.38C15.2897 2.17004 14.8898 2.01 14.5098 1.92004L14.3297 0.850029C14.3097 0.700005 14.2397 0.55999 14.1198 0.450005C13.9998 0.350029 13.7997 0.290031 13.6797 0.290031H12.5497C12.3698 0.270012 12.1897 0.32 12.0397 0.450005C11.9497 0.540031 11.8698 0.689995 11.8397 0.830009L11.6398 1.96001C11.2197 2.09002 10.8397 2.26 10.5298 2.47002L9.66968 1.78002C9.55969 1.7 9.44971 1.66003 9.29968 1.66003L9.27698 1.65978C9.21228 1.65862 9.10498 1.65685 8.98975 1.71001C8.91968 1.74004 8.84973 1.79003 8.79968 1.84002L7.96973 2.68999C7.92969 2.71001 7.89978 2.74999 7.88977 2.77001C7.72974 2.99999 7.72974 3.32 7.88977 3.54003L8.51978 4.43999C8.3197 4.80999 8.16968 5.2 8.08972 5.57L7.03967 5.74999C6.71973 5.79003 6.46973 6.07 6.46973 6.40002V7.61004C6.46973 7.93999 6.70972 8.22002 7.00977 8.24999L8.13977 8.43999C8.25977 8.86004 8.42969 9.24004 8.63977 9.57L7.99976 10.46C7.82971 10.69 7.82971 11.01 7.99976 11.24C8.01978 11.27 8.0697 11.32 8.0697 11.32L8.92969 12.14C8.98975 12.2 9.07971 12.25 9.15967 12.27C9.22974 12.29 9.29968 12.29 9.34973 12.29C9.52979 12.29 9.63977 12.26 9.75977 12.18L10.6498 11.53C11.0098 11.73 11.3798 11.88 11.7498 11.97L11.9297 13.03C11.9697 13.36 12.2498 13.61 12.5797 13.61ZM13.3197 12.47H13.0298V12.44L12.8998 11.66C12.8798 11.48 12.7897 11.31 12.6597 11.16C12.5298 11.02 12.3597 10.92 12.1897 10.88C11.8397 10.8 11.4998 10.66 11.1897 10.48C11.0397 10.38 10.8698 10.33 10.6897 10.33C10.4797 10.32 10.2798 10.39 10.1198 10.51L9.44971 10.99L9.21973 10.77L9.6897 10.11C9.74731 10.0179 9.79163 9.91912 9.81885 9.81567C9.83887 9.73943 9.84973 9.66064 9.84973 9.58001C9.84973 9.39001 9.79968 9.21001 9.70972 9.08001C9.51978 8.74999 9.35974 8.39001 9.26978 8.04003C9.22974 7.84002 9.11975 7.66003 8.96973 7.53002C8.82971 7.40002 8.63977 7.30999 8.45972 7.29003L7.65967 7.16003V6.79003L8.41968 6.66003C8.61975 6.63 8.79968 6.55004 8.92969 6.42004C9.0697 6.29003 9.16968 6.11999 9.20972 5.93999C9.29968 5.57 9.4397 5.21001 9.60974 4.90002C9.69971 4.74004 9.74976 4.57 9.74976 4.39001C9.74976 4.21001 9.6897 4.03002 9.57971 3.85003L9.10974 3.18999L9.34973 2.95L9.99976 3.47002C10.2997 3.66003 10.7397 3.67004 11.0298 3.48003C11.3597 3.29003 11.7097 3.14001 12.0597 3.04003C12.2598 2.99999 12.4397 2.89001 12.5797 2.74004C12.7097 2.59002 12.7997 2.40002 12.8097 2.24004L12.9497 1.43999H13.3097L13.4397 2.21001C13.4697 2.40002 13.5497 2.58001 13.6797 2.72002C13.7997 2.86004 13.9697 2.96001 14.1498 2.99999C14.5098 3.09002 14.8798 3.23003 15.2097 3.42004C15.5298 3.61999 15.9297 3.61999 16.2698 3.40002L16.9197 2.93999L17.1597 3.18005L16.6797 3.86004C16.5797 4.02001 16.5298 4.2 16.5298 4.38C16.5298 4.55999 16.5797 4.74004 16.6697 4.88C16.8597 5.21001 17.0098 5.57 17.1097 5.93005C17.1597 6.11999 17.2598 6.29003 17.3898 6.41003C17.5298 6.54003 17.7097 6.61999 17.8798 6.65002L18.6597 6.78002V7.10003L17.8497 7.24004C17.7415 7.2514 17.6396 7.28551 17.5444 7.33685C17.4725 7.3756 17.4043 7.42413 17.3397 7.48003C17.1997 7.61004 17.0997 7.78002 17.0597 7.95C16.9597 8.32 16.8197 8.67004 16.6198 8.99999C16.5298 9.16003 16.4797 9.33001 16.4797 9.51C16.4797 9.68999 16.5397 9.86999 16.6498 10.05L17.1198 10.71L16.8898 10.94L16.2297 10.47C15.9297 10.28 15.4998 10.28 15.2097 10.47C14.8798 10.67 14.5198 10.82 14.1597 10.91C13.9697 10.96 13.8097 11.06 13.6897 11.19C13.5597 11.33 13.4797 11.51 13.4497 11.68L13.3197 12.47Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.54005 23.71C4.40005 23.71 4.25005 23.68 4.12005 23.62C3.99005 23.56 3.87005 23.47 3.78005 23.36L0.730055 19.89C0.560055 19.69 0.470055 19.44 0.490055 19.18C0.510055 18.92 0.620055 18.68 0.820055 18.51L3.06005 16.52C3.99005 15.47 5.21005 14.64 6.55006 14.13C7.72006 13.78 8.98006 13.84 10.1001 14.29C10.3001 14.35 10.5201 14.41 10.7501 14.47C11.7901 14.68 12.8601 14.75 13.9201 14.68H14.1001C14.2601 14.68 14.4201 14.67 14.5701 14.67C14.7401 14.67 15.1801 14.69 15.5701 14.7H15.8101C16.0101 14.72 16.1501 14.72 16.1701 14.72C16.4401 14.72 16.7101 14.79 16.9501 14.9L19.5001 12.41C19.8501 12.06 20.3201 11.85 20.8201 11.81C21.3301 11.78 21.8101 11.92 22.2101 12.23C22.4201 12.4 22.6001 12.62 22.7201 12.86C22.8401 13.1 22.9101 13.36 22.9301 13.64C22.9401 13.91 22.9001 14.18 22.8001 14.43C22.7001 14.68 22.5501 14.91 22.3601 15.1L16.4601 20.87C16.2601 21.07 16.0301 21.24 15.7701 21.37H15.7101C15.5201 21.4 15.3201 21.41 15.1301 21.41H8.00005L5.16005 23.53C4.98005 23.67 4.77005 23.74 4.55006 23.74L4.54005 23.71ZM1.60005 19.25L4.55006 22.6L7.55006 20.36C7.61005 20.32 7.69006 20.26 15.0101 20.31H15.1301C15.3201 20.28 15.5201 20.19 15.7001 20.07L21.5801 14.32C21.6701 14.24 21.7301 14.13 21.7801 14.02C21.8201 13.91 21.8401 13.79 21.8401 13.67C21.8401 13.55 21.8001 13.44 21.7501 13.33C21.7001 13.22 21.6201 13.13 21.5201 13.05C21.3401 12.92 21.1101 12.86 20.8801 12.87C20.6501 12.89 20.4401 12.99 20.2801 13.15L17.7401 15.63C17.8801 15.89 17.9601 16.18 17.9601 16.47C17.9601 16.94 17.7701 17.39 17.4301 17.72C17.0901 18.05 16.6401 18.24 16.1501 18.24H10.6801C10.3001 18.27 9.87006 18.17 9.81006 17.79C9.81006 17.61 9.87006 17.46 9.98005 17.35C10.0901 17.24 10.2301 17.17 10.3901 17.16H16.1501C16.3401 17.16 16.5201 17.09 16.6501 16.95C16.7801 16.82 16.8601 16.65 16.8601 16.46C16.8601 16.28 16.7801 16.1 16.6501 15.97C16.5201 15.84 16.3401 15.77 16.1501 15.76C15.6301 15.74 14.7801 15.71 14.5801 15.71C14.5101 15.71 14.4401 15.71 14.3701 15.71H14.2101C14.1201 15.71 14.0301 15.71 13.9501 15.71C12.8001 15.78 11.6301 15.71 10.4801 15.47C10.2301 15.41 10.0001 15.34 9.78006 15.28C8.86005 14.9 7.84005 14.84 6.90005 15.11C5.73005 15.56 4.66005 16.3 3.83005 17.24L3.80005 17.27L1.61005 19.21L1.60005 19.25Z",
  fill: "var(--icon-primary)"
}));
export const VolumeStdClearIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "ic_volume_std",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "ic_volume_std"
}, " Volume STD"), /*#__PURE__*/React.createElement("path", {
  d: "M20.8422 18.5498C20.8422 17.4766 20.3682 16.9399 19.4203 16.9399H18.8564V20.1938H19.311C20.3318 20.1938 20.8422 19.6458 20.8422 18.5498Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 18.6657C0 21.3753 5.46683 21.8887 8 21.9808V23C8 23.5523 8.44771 24 9 24H23C23.5523 24 24 23.5523 24 23V14C24 13.4477 23.5523 13 23 13H18V3.4375C18 1.1825 13.471 0 9 0C4.52901 0 0 1.1825 0 3.4375V18.6657ZM16.7143 13V10.2231C14.5061 11.5947 10.1154 11.6875 9 11.6875C7.88791 11.6875 3.49385 11.5947 1.28571 10.2231V13.75C1.28571 14.6529 3.99442 15.65 8 15.7946V14C8 13.4477 8.44771 13 9 13H16.7143ZM8 17.1679C6.23853 17.1021 3.05803 16.8267 1.28571 15.7231V18.6656C1.28571 19.4111 3.66628 20.4662 8 20.6088V17.1679ZM16.7143 8.25C16.7143 9.22625 13.5451 10.3125 9 10.3125C4.45186 10.3125 1.28571 9.22625 1.28571 8.25V5.29716C2.94749 6.32841 5.98505 6.87498 9 6.87498C12.0149 6.87498 15.0525 6.33873 16.7143 5.29716V8.25ZM9 1.375C13.7861 1.375 16.7143 2.70875 16.7143 3.4375C16.7143 4.16625 13.7861 5.5 9 5.5C4.21385 5.5 1.28571 4.16625 1.28571 3.4375C1.28571 2.70875 4.21385 1.375 9 1.375ZM12.7686 20.7476C13.0944 20.4878 13.2573 20.1323 13.2573 19.6812C13.2573 19.3553 13.1707 19.0807 12.9976 18.8574C12.8244 18.6318 12.5042 18.4074 12.0371 18.1841C11.6839 18.0155 11.4595 17.8993 11.3638 17.8354C11.2703 17.7694 11.202 17.7021 11.1587 17.6338C11.1154 17.5632 11.0938 17.4811 11.0938 17.3877C11.0938 17.2373 11.1473 17.1154 11.2544 17.022C11.3615 16.9285 11.5153 16.8818 11.7158 16.8818C11.8844 16.8818 12.0553 16.9035 12.2285 16.9468C12.404 16.9901 12.625 17.0664 12.8916 17.1758L13.2334 16.3521C12.9759 16.2404 12.7287 16.1538 12.4917 16.0923C12.257 16.0308 12.0098 16 11.75 16C11.2214 16 10.8066 16.1265 10.5059 16.3794C10.2074 16.6323 10.0581 16.9798 10.0581 17.4219C10.0581 17.6566 10.1037 17.8617 10.1948 18.0371C10.286 18.2126 10.4079 18.3664 10.5605 18.4985C10.7132 18.6307 10.9422 18.7686 11.2476 18.9121C11.5734 19.0671 11.7887 19.1798 11.8936 19.2505C12.0007 19.3211 12.0815 19.3952 12.1362 19.4727C12.1909 19.5479 12.2183 19.6344 12.2183 19.7324C12.2183 19.9079 12.1556 20.04 12.0303 20.1289C11.9072 20.2178 11.7295 20.2622 11.4971 20.2622C11.3034 20.2622 11.0892 20.2314 10.8545 20.1699C10.6221 20.1084 10.3372 20.0024 10 19.8521V20.8364C10.4102 21.0369 10.8818 21.1372 11.415 21.1372C11.9938 21.1372 12.445 21.0073 12.7686 20.7476ZM14.8212 21.0688H15.8808V16.9536H17.2378V16.0718H13.4643V16.9536H14.8212V21.0688ZM21.9428 18.5225C21.9428 19.3451 21.7081 19.9751 21.2387 20.4126C20.7716 20.8501 20.096 21.0688 19.2118 21.0688H17.7968V16.0718H19.3656C20.1814 16.0718 20.8149 16.2871 21.266 16.7178C21.7172 17.1484 21.9428 17.75 21.9428 18.5225Z",
  fill: "var(--icon-primary)"
}));
export const LockMonochromeIconsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 23,
  viewBox: "0 0 18 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-primary)",
  d: "M9.0421 11.3512C8.40486 11.351 7.78845 11.5782 7.30377 11.9919C6.81909 12.4056 6.49795 12.9787 6.39814 13.6081C6.29833 14.2375 6.42639 14.8818 6.75928 15.4252C7.09218 15.9686 7.60805 16.3753 8.2141 16.5722V18.9722C8.2141 19.1742 8.29433 19.3679 8.43713 19.5107C8.57994 19.6535 8.77364 19.7337 8.9756 19.7337C9.17756 19.7337 9.37125 19.6535 9.51406 19.5107C9.65687 19.3679 9.7371 19.1742 9.7371 18.9722V16.6092C10.3634 16.4406 10.9072 16.0501 11.2671 15.5105C11.627 14.9708 11.7785 14.3188 11.6935 13.6757C11.6085 13.0327 11.2928 12.4424 10.805 12.0148C10.3173 11.5872 9.69075 11.3514 9.0421 11.3512ZM9.0421 15.1822C8.81386 15.1822 8.59075 15.1146 8.40097 14.9878C8.2112 14.861 8.06329 14.6807 7.97594 14.4699C7.8886 14.259 7.86574 14.027 7.91027 13.8031C7.9548 13.5793 8.06471 13.3736 8.2261 13.2122C8.38749 13.0509 8.59311 12.9409 8.81696 12.8964C9.04082 12.8519 9.27285 12.8747 9.48372 12.9621C9.69458 13.0494 9.87481 13.1973 10.0016 13.3871C10.1284 13.5769 10.1961 13.8 10.1961 14.0282C10.1956 14.334 10.0738 14.6272 9.85745 14.8433C9.64112 15.0594 9.34791 15.181 9.0421 15.1812V15.1822Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--icon-primary)",
  d: "M2.9611 7.03624V8.48024H1.6111C1.40927 8.48024 1.21571 8.56042 1.07299 8.70314C0.930275 8.84585 0.850098 9.03941 0.850098 9.24124V22.2082C0.850098 22.4101 0.930275 22.6036 1.07299 22.7464C1.21571 22.8891 1.40927 22.9692 1.6111 22.9692H16.3811C16.481 22.9692 16.58 22.9496 16.6723 22.9113C16.7646 22.8731 16.8485 22.817 16.9192 22.7464C16.9899 22.6757 17.0459 22.5918 17.0842 22.4995C17.1224 22.4071 17.1421 22.3082 17.1421 22.2082V9.24124C17.1421 9.14131 17.1224 9.04235 17.0842 8.95002C17.0459 8.85769 16.9899 8.7738 16.9192 8.70314C16.8485 8.63247 16.7646 8.57641 16.6723 8.53817C16.58 8.49993 16.481 8.48024 16.3811 8.48024H14.9171V7.03624C14.9273 6.24489 14.7803 5.45939 14.4846 4.72531C14.1888 3.99124 13.7502 3.3232 13.1942 2.75998C12.6382 2.19675 11.9759 1.74956 11.2457 1.44433C10.5156 1.13911 9.73201 0.981934 8.9406 0.981934C8.14918 0.981934 7.36564 1.13911 6.63545 1.44433C5.90526 1.74956 5.24296 2.19675 4.68698 2.75998C4.13099 3.3232 3.6924 3.99124 3.39664 4.72531C3.10089 5.45939 2.95386 6.24489 2.9641 7.03624H2.9611ZM15.6221 21.4442H2.3761V10.0032H3.5761C3.62414 10.013 3.67307 10.0177 3.7221 10.0172C3.77109 10.0171 3.81997 10.0124 3.8681 10.0032H14.0111C14.0591 10.013 14.1081 10.0177 14.1571 10.0172C14.2061 10.0171 14.255 10.0124 14.3031 10.0032H15.6221V21.4442ZM13.3951 7.03624V8.48024H4.4881V7.03624C4.47925 6.44579 4.5879 5.85946 4.80774 5.31139C5.02758 4.76331 5.35421 4.26442 5.76864 3.84374C6.18306 3.42306 6.677 3.08899 7.22172 2.86096C7.76645 2.63294 8.35108 2.51551 8.9416 2.51551C9.53212 2.51551 10.1167 2.63294 10.6615 2.86096C11.2062 3.08899 11.7001 3.42306 12.1146 3.84374C12.529 4.26442 12.8556 4.76331 13.0755 5.31139C13.2953 5.85946 13.4039 6.44579 13.3951 7.03624Z"
}));
export const LockIcIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Lock",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-1.1260000724792478 -1.1880591173171995 26.964000991821287 31.58605986022949"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Lock"
}, " Lock"), /*#__PURE__*/React.createElement("g", {
  className: "primary-stroke",
  fill: "none",
  strokeWidth: 2.252
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.34 12.385H3.372a2.256 2.256 0 00-2.246 2.252v11.259a2.256 2.256 0 002.246 2.25H21.34a2.256 2.256 0 002.246-2.25V14.637a2.256 2.256 0 00-2.246-2.252z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.356 23.645v-6.756",
  "data-name": "Path"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.618 12.385v-4.5a6.739 6.739 0 1113.477 0v4.5",
  "data-name": "Path"
})));
export const MountArrowIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Arrow-",
  width: "35px",
  height: "35px",
  viewBox: "0 0 35 35",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Arrow-"
}, "Arrow "), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-4.2%",
  y: "-9.3%",
  width: "109.0%",
  height: "120.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "011---ANF-Volumes-Cards-Hover",
  transform: "translate(-374.000000, -442.000000)",
  stroke: "#006DC9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Add-Volume-+-search",
  transform: "translate(339.000000, 343.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "vol-min",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mount",
  transform: "translate(40.000000, 102.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "noun_forward_319479",
  transform: "translate(6.000000, 6.000000)",
  fill: "#006DC9",
  fillRule: "nonzero",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.783923077,12.8359771 L0.651230769,12.1773229 C0.643269231,12.1363171 -0.136961538,8.01268 3.53065385,5.06539429 C3.58373077,5.0167 5.15480769,3.63532 8.48538462,3.63532 C8.51192308,3.63532 8.53846154,3.63532 8.565,3.63532 L8.565,0.185714286 L14.5043077,5.95214286 L8.565,11.7185714 L8.565,8.22539714 C8.38984615,8.19976857 8.10853846,8.17157714 7.75026923,8.17157714 C6.22165385,8.17157714 3.32896154,8.70208857 1.13688462,12.2593343 L0.783923077,12.8359771 Z M8.48803846,4.14532857 C5.36180769,4.14532857 3.89688462,5.43444571 3.88361538,5.44726 C1.34919231,7.48473143 1.07584615,10.1065343 1.10769231,11.3546457 C4.38784615,6.72612571 8.83569231,7.74870571 8.89407692,7.76152 L9.09576923,7.80765143 L9.09576923,10.4755857 L13.7585769,5.95214286 L9.09842308,1.4287 L9.09842308,4.15814286 L8.82507692,4.15045429 C8.71096154,4.14789143 8.5995,4.14532857 8.48803846,4.14532857 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  strokeWidth: 1.07,
  cx: 12.5,
  cy: 12.5,
  r: 12.5
}))))))));
export const NoDataIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Data",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  style: {
    enableBackground: "new 0 0 100 100"
  }
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Data"
}, " Data"), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M68.2,35.2c-5.7,0-10.2,5.6-10.2,12.5s4.5,12.5,10.2,12.5s10.2-5.6,10.2-12.5S73.9,35.2,68.2,35.2z M68.2,58 c-4.3,0-8-4.5-8-10.2c0-5.7,3.6-10.2,8-10.2s8,4.5,8,10.2C76.1,53.4,72.5,58,68.2,58z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "primary-fill",
  cx: 68.2,
  cy: 47.7,
  rx: 4.5,
  ry: 6.8
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M31.8,35.2c-5.7,0-10.2,5.6-10.2,12.5s4.5,12.5,10.2,12.5S42,54.6,42,47.7S37.5,35.2,31.8,35.2z M31.8,58 c-4.3,0-8-4.5-8-10.2c0-5.7,3.6-10.2,8-10.2s8,4.5,8,10.2C39.8,53.4,36.1,58,31.8,58z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "primary-fill",
  cx: 31.8,
  cy: 47.7,
  rx: 4.5,
  ry: 6.8
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M61.4,79.5c1.3,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3H38.6c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3H61.4z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-192.000000, -528.000000)"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  d: "M194.2,625.7h95.5c1.2,0,2.2-1,2.2-2.3v-69.5c0-0.5-0.3-1.2-0.7-1.6l-21.4-21.4 c-0.4-0.4-1.1-0.7-1.6-0.7h-74.1c-1.3,0-2.3,1-2.3,2.2v91C192,624.7,193,625.7,194.2,625.7z M287.5,621.2h-90.9v-86.4h68.2v20.5 c0,1.2,1,2.2,2.2,2.2h20.5V621.2z M269.3,536.7V553h16.3L269.3,536.7z"
})));
export const NodeIcIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Node",
  xmlns: "http://www.w3.org/2000/svg",
  width: 34.05,
  height: 32,
  viewBox: "0 0 34.05 32"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Node"
}, " Node"), /*#__PURE__*/React.createElement("g", {
  id: "node_ic",
  transform: "translate(-0.231 -0.462)"
}, /*#__PURE__*/React.createElement("g", {
  id: "_031---GCP-HA",
  "data-name": "031---GCP-HA",
  transform: "translate(0.231 0.462)"
}, /*#__PURE__*/React.createElement("g", {
  id: "CARD-INFO",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Card-Header",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "node1",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M2.281,10.98H27.15A2.073,2.073,0,0,0,29.2,8.93V2.512A2.073,2.073,0,0,0,27.15.462H2.281a2.073,2.073,0,0,0-2.05,2.05V8.93A2.017,2.017,0,0,0,2.281,10.98ZM1.3,2.512a.989.989,0,0,1,.981-.981H27.15a.916.916,0,0,1,.891.981V8.93a.989.989,0,0,1-.981.981H2.192a.989.989,0,0,1-.981-.981V2.512Z",
  transform: "translate(-0.231 -0.462)",
  fill: "#006dc9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M6.981,8.076A.981.981,0,1,0,6,7.1.935.935,0,0,0,6.981,8.076Z",
  transform: "translate(-1.543 -1.748)",
  fill: "#006dc9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M12.981,8.076A.981.981,0,1,0,12,7.1.989.989,0,0,0,12.981,8.076Z",
  transform: "translate(-2.908 -1.748)",
  fill: "#006dc9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M6.981,22.154a.981.981,0,1,0,.981.981A.989.989,0,0,0,6.981,22.154Z",
  transform: "translate(-1.543 -5.396)",
  fill: "#006dc9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-4",
  "data-name": "Path",
  d: "M12.981,22.154a.981.981,0,1,0,.981.981A.935.935,0,0,0,12.981,22.154Z",
  transform: "translate(-2.908 -5.396)",
  fill: "#006dc9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M29.2,20.653V18.781a2.073,2.073,0,0,0-2.05-2.05H2.281a2.073,2.073,0,0,0-2.05,2.05V25.2a2.073,2.073,0,0,0,2.05,2.05H18.325c0,.267-.089.624-.089.891A8.022,8.022,0,1,0,29.2,20.653ZM2.281,26.09a.989.989,0,0,1-.981-.98V18.692a.989.989,0,0,1,.981-.981H27.15a.916.916,0,0,1,.891.981v1.6a6.065,6.065,0,0,0-1.783-.178A8.026,8.026,0,0,0,18.5,26.179L2.281,26.09Zm23.978,9.181A7.131,7.131,0,1,1,33.39,28.14,7.152,7.152,0,0,1,26.259,35.271Z",
  transform: "translate(-0.231 -4.163)",
  fill: "#006dc9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-3",
  "data-name": "Shape",
  d: "M35.321,28.909a2.854,2.854,0,0,0-5.526,0,2.289,2.289,0,0,0-1.872,2.228,2.36,2.36,0,0,0,2.318,2.318h4.546A2.36,2.36,0,0,0,37.1,31.137,2.211,2.211,0,0,0,35.321,28.909Zm-.446,3.744H30.33a1.562,1.562,0,0,1-1.515-1.515,1.546,1.546,0,0,1,1.426-1.515.383.383,0,0,0,.357-.357,2.07,2.07,0,0,1,4.1,0,.383.383,0,0,0,.357.357,1.546,1.546,0,0,1,1.426,1.515A1.793,1.793,0,0,1,34.876,32.652Z",
  transform: "translate(-6.53 -6.446)",
  fill: "#006dc9"
})))))));
export const NotifyIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Notify",
  width: 34,
  height: 39,
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Notify"
}, " Notify"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fill: "#2C5E9C",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.888 37.882C5.314 31.21.204 19.986 1.1 7.566a.852.852 0 0 1 .724-.785C7.041 5.987 14.417 1.029 17.322 1c3.122-.026 10.273 4.982 15.502 5.78a.855.855 0 0 1 .724.822c.426 5.834-.487 12.033-3.424 17.67-2.512 4.827-6.501 9.226-12.38 12.613a.848.848 0 0 1-.856-.004zM6.026 24.484c2.307 4.432 5.949 8.49 11.296 11.667 10.466-6.22 15.195-16.424 14.565-27.8-4.84-1.011-12.818-5.822-14.442-5.64a.995.995 0 0 1-.192.003C15.71 2.587 7.622 7.34 2.757 8.351c-.299 5.361.601 11.006 3.269 16.133z",
  className: "primary-stroke",
  stroke: "#2C5E9C",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.739 21.715h-2.003L16.138 10h3.188l-.587 11.715zM16 25.385c0-.567.15-.999.449-1.294.299-.296.725-.443 1.277-.443.545 0 .963.153 1.254.46.292.307.438.733.438 1.277 0 .545-.148.977-.443 1.295-.296.318-.712.478-1.249.478-.545 0-.968-.154-1.271-.46-.303-.308-.455-.745-.455-1.313z"
})));
export const OccmVolumeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Volume",
  width: 28,
  height: 38,
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Volume"
}, "Volume"), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1)",
  fill: "#006DC9"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 14,
  cy: 2.597,
  rx: 14,
  ry: 3.597
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 7.884c-7.933 0-14-1.742-14-3.773v8.706c0 2.031 6.222 3.627 14 3.627s14-1.596 14-3.627v-8.56c0 2.03-6.067 3.627-14 3.627z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 18.016c-7.933 0-14-1.596-14-3.627v8.706c0 2.031 6.222 3.627 14 3.627s14-1.596 14-3.627v-8.706c0 2.031-6.067 3.627-14 3.627z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 28.294c-7.933 0-14-1.596-14-3.627v8.706C0 35.403 6.222 37 14 37s14-1.596 14-3.627v-8.706c0 2.031-6.067 3.627-14 3.627z"
})));
export const OopsCloudIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 130 80"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.4 15.6c-4.6 0-9 .9-13 2.7C78.5 7.8 67.2.2 54.6.2 37.7.2 23.6 12.4 20.8 29c-.3 2-.6 3.8-.6 5.9l.2 1.9C9.1 36.8-.1 47.3-.1 58.5c0 9.8 7.1 19.1 16.5 21.2 1.3.3 2.6.5 4 .5h46.1l30.8-.2c16.5 0 30.2-12.2 32.3-28 .2-1.4.3-2.8.3-4.3 0-17.7-14.5-32.1-32.5-32.1zM44.5 35.5c0-2.6 2.2-4.8 4.8-4.8h1.6c2.7 0 4.8 2.1 4.8 4.8V37c0 2.6-2.2 4.8-4.8 4.8h-1.6c-2.7 0-4.8-2.1-4.8-4.8v-1.5zM77 68.6c-2.7-4.3-7.6-7.2-13.1-7.2s-10.4 2.9-13.1 7.2L45.1 63c4.3-5.7 11.1-9.3 18.8-9.3 7.7 0 14.5 3.7 18.8 9.3L77 68.6zm6.6-31.5c0 2.6-2.2 4.8-4.8 4.8h-1.6c-2.7 0-4.8-2.1-4.8-4.8v-1.5c0-2.6 2.2-4.8 4.8-4.8h1.6c2.7 0 4.8 2.1 4.8 4.8v1.5z",
  className: "primary-fill",
  fill: "#003eae"
}));
export const ProtectionIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Protection",
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 39,
  viewBox: "0 0 34 39"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Protection"
}, " Protection"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fill: "#FFF",
  fillRule: "evenodd",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#00AFC5",
  strokeWidth: 0.878,
  d: "M13.812 17.726a1.616 1.616 0 0 0-2.33 0 1.725 1.725 0 0 0 0 2.394l3.295 3.384c.643.661 1.686.661 2.329 0l7.412-7.615a1.725 1.725 0 0 0 0-2.393 1.616 1.616 0 0 0-2.33 0l-6.247 6.418-2.13-2.188z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 0.5,
  d: "M16.888 37.882C5.314 31.21.204 19.986 1.1 7.566a.852.852 0 0 1 .724-.785C7.041 5.987 14.417 1.029 17.322 1c3.122-.026 10.273 4.982 15.502 5.78a.855.855 0 0 1 .724.822c.426 5.834-.487 12.033-3.424 17.67-2.512 4.827-6.501 9.226-12.38 12.613a.848.848 0 0 1-.856-.004zM6.026 24.484c2.307 4.432 5.949 8.49 11.296 11.667 10.466-6.22 15.195-16.424 14.565-27.8-4.84-1.011-12.818-5.822-14.442-5.64a.995.995 0 0 1-.192.003C15.71 2.587 7.622 7.34 2.757 8.351c-.299 5.361.601 11.006 3.269 16.133z"
})));
export const SavingsIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Savings",
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Savings"
}, " Savings"), /*#__PURE__*/React.createElement("g", {
  className: "primary-fill",
  fill: "#FFF",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  stroke: "#FFF",
  strokeWidth: 0.557,
  d: "M19.48 30.6c.483 0 .878-.393.878-.874v-2.01h.176c2.374 0 4.352-1.921 4.352-4.28s-1.934-4.281-4.352-4.281h-2.11c-1.406 0-2.593-1.136-2.593-2.534s1.143-2.533 2.593-2.533H22.6c.484 0 .88-.394.88-.874a.879.879 0 0 0-.88-.874h-2.286v-2.01a.879.879 0 0 0-1.758 0v2.01h-.176c-2.373 0-4.351 1.922-4.351 4.281 0 2.36 1.934 4.281 4.351 4.281h2.11c1.407 0 2.594 1.136 2.594 2.534S21.94 25.97 20.49 25.97h-4.176a.879.879 0 0 0-.879.873c0 .48.396.874.88.874H18.6v2.01c0 .48.396.873.88.873z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.317 32.324l5.77 5.65a.561.561 0 0 0 .8 0l5.77-5.65a.534.534 0 0 0 0-.785l-.621-.608a.561.561 0 0 0-.801 0l-3.71 3.634V23.503a.573.573 0 0 0-.572-.56h-.867a.573.573 0 0 0-.572.56v11.142l-3.792-3.714a.561.561 0 0 0-.8 0l-.622.608a.547.547 0 0 0 .017.785z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  stroke: "#FFF",
  strokeWidth: 0.557,
  d: "M25.663 36.522c-1.817.63-3.71.944-5.644.944-9.625 0-17.473-7.828-17.473-17.427 0-9.598 7.809-17.466 17.473-17.466 9.626 0 17.435 7.829 17.435 17.427 0 1.416-.194 2.872-.503 4.248-.116.433.155.866.541.945.426.118.85-.158.928-.551.387-1.495.58-3.069.58-4.642C39 9.536 30.495 1 20.02 1 9.542 1 1 9.536 1 20c0 10.503 8.543 19 19.02 19 2.087 0 4.174-.354 6.146-1.023.386-.157.618-.59.502-.983-.154-.394-.618-.59-1.005-.472z"
})));
export const ShowPasswordIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Show-password",
  width: 23,
  height: 19,
  viewBox: "0 0 23 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Show-password"
}, " Show password"), /*#__PURE__*/React.createElement("path", {
  d: "M16.4679 3.23425C14.7815 2.38028 12.9034 1.95295 10.9999 2.00001C8.65034 1.94192 6.33955 2.60664 4.37996 3.90433C2.42038 5.20202 0.906481 7.07009 0.0429322 9.25601C-0.0143107 9.4133 -0.0143107 9.58573 0.0429322 9.74301C0.713318 11.4407 1.77601 12.9468 3.13514 14.1429L4.33757 13.1591C3.16548 12.17 2.23332 10.919 1.62093 9.50001C2.40726 7.67834 3.72058 6.13354 5.39197 5.06431C7.06336 3.99507 9.01641 3.45028 10.9999 3.50001C12.4361 3.46391 13.8562 3.7395 15.1651 4.30018L16.4679 3.23425Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.412 5.73452C12.6833 5.32383 11.8492 5.11826 10.9999 5.15101C9.7973 5.10437 8.83659 5.5356 7.95088 6.35048C7.06517 7.16536 6.76498 8.29766 6.71145 9.50001C6.75469 10.017 6.83878 10.5187 6.99249 10.9869L8.35664 9.87074C8.31027 9.50974 8.33183 9.14148 8.42212 8.78529C8.56095 8.23763 8.85626 7.74224 9.27198 7.35964C9.6877 6.97703 10.2058 6.72377 10.7631 6.63077C11.2378 6.55156 11.7233 6.59155 12.1766 6.74533L13.412 5.73452Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.1121 7.27195L14.2495 6.34136C14.253 6.34452 14.2564 6.34768 14.2598 6.35084C14.6304 6.69184 14.9382 7.08841 15.1748 7.52241L13.9751 8.50399C13.8992 8.29574 13.7994 8.09581 13.6769 7.90842C13.52 7.66847 13.3294 7.45433 13.1121 7.27195Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.68757 10.892L7.43106 11.9201C7.58761 12.1625 7.77528 12.3889 7.99993 12.5955C8.15861 12.7415 8.31923 12.8757 8.48296 12.9975L9.72434 11.9819C9.6311 11.9249 9.54085 11.8624 9.45406 11.7948C9.138 11.5486 8.87764 11.2408 8.68757 10.892Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8191 12.3782L9.40639 13.5341C9.89128 13.7397 10.4145 13.8477 10.9994 13.8477C12.1889 13.8477 13.335 13.4008 14.2104 12.5955C15.0859 11.7902 15.6268 10.6854 15.7259 9.50001C15.7107 9.15689 15.6568 8.81948 15.567 8.49353L14.1394 9.66162C14.0668 10.4023 13.7242 11.0927 13.1738 11.5992C12.5834 12.1426 11.8018 12.4302 10.9999 12.399C10.9393 12.394 10.879 12.387 10.8191 12.3782Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2055 6.33481C19.1241 7.23415 19.8644 8.30779 20.3789 9.50001C19.5926 11.3217 18.2793 12.8665 16.6079 13.9357C14.9365 15.005 12.9835 15.5497 10.9999 15.5C9.84592 15.529 8.70221 15.3568 7.61828 14.9971L6.26432 16.1049C7.75431 16.732 9.36776 17.0404 10.9999 17C13.3495 17.0581 15.6603 16.3934 17.6199 15.0957C19.5795 13.798 21.0934 11.9299 21.9569 9.74401C22.0142 9.58638 22.0142 9.41365 21.9569 9.25601C21.377 7.78791 20.5036 6.46318 19.399 5.35833L18.2055 6.33481Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.401 3.7629L16.1487 4.78747C16.304 4.87538 16.4571 4.96762 16.608 5.06413C16.8986 5.25002 17.1783 5.45027 17.4463 5.66386L18.6538 4.67595C18.3251 4.40053 17.98 4.1428 17.6199 3.90433C17.5474 3.85632 17.4744 3.80917 17.401 3.7629Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.26811 15.6279L6.55508 14.5749C6.15508 14.3888 5.7664 14.1755 5.39186 13.9359C5.31271 13.8853 5.23437 13.8336 5.15684 13.7808L3.93169 14.7832C4.07825 14.8907 4.2276 14.9948 4.37963 15.0955C4.66849 15.2868 4.96499 15.4644 5.26811 15.6279Z",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.4749 0.580514C22.7372 0.901098 22.69 1.37361 22.3694 1.63591L1.53032 18.6861C1.20974 18.9483 0.737223 18.9011 0.474927 18.5805C0.212631 18.2599 0.259883 17.7874 0.580467 17.5251L21.4195 0.474975C21.7401 0.212679 22.2126 0.259931 22.4749 0.580514Z",
  fill: "var(--icon-primary)"
}));
export const SupportIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "-Support",
  xmlns: "http://www.w3.org/2000/svg",
  width: 31,
  height: 28,
  viewBox: "0 0 31 28"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Support"
}, " Support"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3D84FF",
  fillRule: "nonzero",
  d: "M27.854 19.056a13.52 13.52 0 0 1-3.448 6.362c.022.106.035.217.035.33 0 .787-.59 1.425-1.317 1.425s-1.316-.638-1.316-1.425c0-.786.59-1.424 1.316-1.424.291 0 .56.102.778.274a12.539 12.539 0 0 0 3.017-5.542h-1.898v-7.664h1.42C25.588 5.492 20.802.959 15.037.959c-5.765 0-10.55 4.534-11.403 10.435H4.98v7.663H1.897c-1.23 0-1.862-.578-1.896-1.732V13.31c0-1.277.476-1.916 1.428-1.916h1.29C3.58 4.961 8.774 0 15.039 0c6.264 0 11.458 4.961 12.318 11.393h1.216c.953 0 1.428.638 1.428 1.916v4.016c-.035 1.155-.668 1.732-1.898 1.732h-.248v-.001zm-24.048-.983v-5.697H1.928c-.504 0-.755.475-.755 1.424v2.985c.018.859.353 1.288 1.003 1.288h1.63zm22.388 0h1.63c.65 0 .985-.43 1.003-1.287V13.8c0-.95-.251-1.425-.755-1.425h-1.878v5.697z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3D84FF",
  d: "M19.045 19.205l.843-.89c.34-.357.37-.845.074-1.246l-.427-.582c.087-.188.163-.381.227-.579l.72-.108c.46-.07.768-.439.768-.918v-1.298c0-.48-.31-.848-.77-.917l-.718-.109a5.064 5.064 0 0 0-.273-.671l.419-.594c.289-.405.248-.894-.104-1.244-.284-.291-.574-.585-.865-.88a.876.876 0 0 0-1.197-.073l-.565.444a4.687 4.687 0 0 0-.558-.236l-.105-.741c-.067-.479-.424-.8-.89-.8h-1.248c-.463 0-.82.318-.89.79l-.104.75c-.224.078-.44.172-.65.282a86.736 86.736 0 0 0-.577-.435.874.874 0 0 0-1.181.093c-.201.21-.863.91-.863.91-.338.357-.367.845-.073 1.244l.428.583a5.044 5.044 0 0 0-.228.577l-.72.11c-.459.069-.768.44-.768.925v1.283c0 .486.31.857.773.925l.715.108c.074.228.165.454.273.671-.095.133-.419.595-.419.595-.291.407-.253.883.099 1.24l.87.883a.886.886 0 0 0 .635.282c.2 0 .39-.07.564-.21l.563-.443c.181.092.369.171.56.237.022.172.103.739.103.739.069.48.427.801.89.801h1.248c.463 0 .82-.317.889-.79l.105-.75c.218-.076.436-.17.65-.282l.569.43a.874.874 0 0 0 1.207-.106zM15 16.821c-1.379 0-2.5-1.161-2.5-2.588s1.121-2.587 2.5-2.587c1.378 0 2.5 1.16 2.5 2.587 0 1.427-1.122 2.588-2.5 2.588z"
})));
export const UpArrowRoundIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Collapse",
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Collapse"
}, "Collapse"), /*#__PURE__*/React.createElement("title", null, "Back_ic"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "022---ANF-Create-Volume-Go",
  transform: "translate(-152.000000, -250.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Back",
  transform: "translate(52.000000, 250.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Back_ic",
  transform: "translate(100.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#C2C2C2",
  cx: 15,
  cy: 15,
  r: 15
}), /*#__PURE__*/React.createElement("g", {
  id: "noun_Arrow_1440520_000000-(1)",
  transform: "translate(15.000000, 13.500000) rotate(90.000000) translate(-15.000000, -13.500000) translate(11.000000, 6.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.77142857,0.0857142857 C7.66033043,-0.0231836789 7.48252672,-0.0231836789 7.37142857,0.0857142857 L0.228571429,7.22857143 C0.119673464,7.33966957 0.119673464,7.51747328 0.228571429,7.62857143 L7.37142857,14.7714286 C7.48517723,14.8567401 7.64434709,14.8454282 7.74488765,14.7448877 C7.84542821,14.6443471 7.85674006,14.4851772 7.77142857,14.3714286 L0.828571429,7.42857143 L7.77142857,0.485714286 C7.88032654,0.37461614 7.88032654,0.196812431 7.77142857,0.0857142857 Z",
  id: "Path"
}))))))));
export const ViHoverIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(.5 -52.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#f5f5f5",
  stroke: "#c8c8c8",
  transform: "translate(0 53)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006dc9",
  d: "M18.475 61.291a1.419 1.419 0 00-2 0l-5.093 5.088-2.2-2.2a1.414 1.414 0 10-2 2l3.2 3.2a1.416 1.416 0 002 0l6.091-6.093a1.416 1.416 0 000-2z"
})));
export const XCircleIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Close",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 25 25",
  style: {
    enableBackground: "new 0 0 25 25"
  }
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Close"
}, "Close"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "primary-fill st0",
  points: "12.8,13.3 16.8,17.3 17.7,16.3 13.8,12.3 17.7,8.3 16.8,7.4 12.8,11.4 8.8,7.4 7.9,8.3 11.9,12.3 7.9,16.3 8.8,17.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill st0",
  d: "M12.8,23.5c-6.2,0-11.2-5-11.2-11.2s5-11.2,11.2-11.2S24,6.1,24,12.3S19,23.5,12.8,23.5z M12.8,2.2 C7.2,2.2,2.7,6.8,2.7,12.3c0,5.6,4.5,10.1,10.1,10.1s10.1-4.5,10.1-10.1C22.9,6.8,18.4,2.2,12.8,2.2z"
})));
export const XIconIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Close",
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Close"
}, "Close"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-0.7%",
  y: "-1.6%",
  width: "102.0%",
  height: "104.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.390013818   0 0 0 0 0.390013818   0 0 0 0 0.390013818  0 0 0 0.5 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1739.000000, -416.000000)",
  className: "primary-stroke",
  stroke: "#434957"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter-1)",
  transform: "translate(1076.000000, 393.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(665.000000, 25.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.104645361,0.104645361 L9.91045212,9.91045212"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.91045212,0.104645361 L0.104645361,9.91045212"
}))))));